export const tr = {
  common: {
    appName: '你好 Ni hao',
    action: {
      save: 'Kaydet',
      cancel: 'İptal',
      delete: 'Sil',
      edit: 'Düzenle',
      create: 'Yeni',
      search: 'Ara',
      filter: 'Filtrele',
      clear: 'Temizle',
      export: 'Dışa Aktar',
      close: 'Kapat',
      download: 'İndir',
      back: 'Geri',
      next: 'İleri',
      retry: 'Tekrar Dene',
      yes: 'Evet',
    },
    tab: {
      all: 'Tümü',
    },
    state: {
      loading: 'Yükleniyor…',
      empty: 'Kayıt bulunamadı',
      error: 'Bir hata oluştu',
      noResults: 'Arama sonucu bulunamadı',
    },
    environment: {
      test: 'TEST ORTAMI · Buradaki kayıtlar gerçek değildir',
    },
  },
  generatedFile: {
    title: 'Dosyalarım',
    subtitle:
      'İstediğiniz dışa aktarmalar burada hazırlanır. Bir dosya yalnızca onu isteyen kişiye açılır ve 72 saat sonra silinir.',
    kind: 'Dosya',
    status: 'Durum',
    rowCount: 'Satır',
    fileSize: 'Boyut',
    requestedAt: 'İstek',
    expiresAt: 'Silinme',
    noFileYet: 'Hazırlanıyor…',
    downloadHint: 'Bağlantı 60 saniye geçerlidir ve yalnızca size açılır.',
    empty: 'Dosya isteğiniz yok',
    emptyHint: 'Bir listenin filtresini dışa aktardığınızda dosyanız burada belirir.',
    kinds: {
      donation_export: 'Bağış listesi',
      reconciliation_shortfall_export: 'Eksik tahsilat listesi',
      refund_export: 'İade listesi',
      fund_transfer_export: 'Fon transferi listesi',
      donation_printout: 'Bağış çıktıları',
      printout_template_preview: 'PDF şablonu test çıktısı',
      queue_sheet: 'Grup çizelgesi',
      queue_export: 'Kesim raporu (Excel)',
      reconciliation_history_export: 'Tamamlanan eşleştirmeler listesi',
      donation_import_template: 'Bağış aktarım şablonu (Excel)',
      bulk_user_template: 'Kullanıcı toplu işlem şablonu (Excel)',
      bulk_institution_template: 'Kurum toplu işlem şablonu (Excel)',
      bulk_donation_template: 'Bağış toplu güncelleme şablonu (Excel)',
      donation_totals_export: 'Bağış toplamları raporu',
      campaign_performance_export: 'Kampanya performansı raporu',
      donor_segment_export: 'Bağışçı segmentleri raporu',
      season_comparison_export: 'Sezon karşılaştırması raporu',
      audit_log_export: 'Denetim izi dışa aktarımı',
      donor_data_export: 'Bağışçı veri örneği (KVKK)',
    },
    statuses: {
      pending: 'Hazırlanıyor',
      ready: 'Hazır',
      failed: 'Hazırlanamadı',
      expired: 'Süresi doldu',
    },
    export: {
      requested: 'Dosya hazırlanıyor. Hazır olduğunda Dosyalarım ekranında indirebilirsiniz.',
    },
  },
  phoneInput: {
    placeholder: 'Telefon numarası',
    searchCountry: 'Ülke ara: ad, kod ya da +90',
    clearSearch: 'Aramayı temizle',
    noCountry: '“{{query}}” ile eşleşen ülke yok',
    chooseCountry: 'Ülke: {{country}}. Değiştirmek için seçin',
    clear: 'Numarayı temizle',
    storedAsTyped: 'Kayıtlı numara okunamadı: “{{value}}”. Ülkeyi seçip numarayı yeniden girin.',
    storedAsTypedKept:
      'Kayıtlı numara okunamadı: “{{value}}”. Ülkeyi seçip numarayı yeniden girin; boş bırakırsanız kayıtlı değer korunur.',
  },
  filters: {
    dateFrom: 'Başlangıç tarihi',
    dateTo: 'Bitiş tarihi',
    dateRangeReversed: 'Bitiş tarihi başlangıçtan sonra olmalı',
    amountMin: 'En az tutar',
    amountMax: 'En çok tutar',
    amountRangeReversed: 'En çok tutar en azdan büyük olmalı',
    dateRange: 'Tarih aralığı',
    amountRange: 'Tutar aralığı',
    columns: 'Sütunlar',
    columnsHint: 'Görünen sütunları ve sıralarını seçin',
    resetColumns: 'Sütunları sıfırla',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
  },
  views: {
    title: 'Görünümler',
    saved: 'Kayıtlı görünümler',
    none: 'Henüz kayıtlı görünüm yok',
    save: 'Görünümü kaydet',
    saveHint: 'Geçerli filtreler, sıralama ve sütunlar bu adla kaydedilir',
    nameLabel: 'Görünüm adı',
    rename: 'Yeniden adlandır',
    makeDefault: 'Varsayılan yap',
    isDefault: 'Varsayılan',
    applied: '“{{name}}” görünümü uygulandı',
    savedToast: '“{{name}}” görünümü kaydedildi',
    deletedToast: 'Görünüm silindi',
    deleteTitle: 'Görünümü sil',
    deleteBody: '“{{name}}” görünümü silinecek.',
  },
  table: {
    selectAll: 'Tüm satırları seç',
    deselectAll: 'Seçimi kaldır',
    selected_one: '{{count}} kayıt seçildi',
    selected_other: '{{count}} kayıt seçildi',
    selectedTotal: '{{count}} seçili',
    selectedOnPage: 'bu sayfada {{count}}',
    clearSelection: 'Seçimi temizle',
    resultsFound: 'sonuç bulundu',
    dense: 'Sık',
    sortedAsc: 'artan sıralı',
    sortedDesc: 'azalan sıralı',
    rowActions: 'Satır işlemleri',
    moreActions: 'Diğer işlemler',
    exportCsv: 'CSV indir',
    exportFilter: 'Filtrenin tamamını dışa aktar',
    exportSelected: 'Seçimi CSV indir',
    noResults: 'Sonuç bulunamadı',
    noResultsHint: 'Arama terimini veya filtreleri değiştirmeyi deneyin.',
    searchPlaceholder: 'Ara…',
  },
  auth: {
    login: {
      title: '{{appName}} — giriş yapın',
      subtitle: 'Devam etmek için hesap bilgilerinizi girin',
      email: 'E-posta',
      password: 'Parola',
      submit: 'Giriş Yap',
      submitting: 'Giriş yapılıyor…',
      showPassword: 'Parolayı göster',
      hidePassword: 'Parolayı gizle',
    },
    twoFactor: {
      title: 'İki adımlı doğrulama',
      subtitle: 'Doğrulama uygulamanızdaki 6 haneli kodu girin',
      code: 'Doğrulama kodu',
      submit: 'Doğrula',
      useRecovery: 'Kurtarma kodu kullan',
      recoveryHint: 'Kurtarma kodlarınızdan birini girin (ABCDE-FGHJK)',
      back: 'Girişe dön',
    },
    setup: {
      title: 'İki adımlı doğrulamayı kurun',
      required: 'Rolünüz iki adımlı doğrulama gerektiriyor. Devam etmek için kurulumu tamamlayın.',
      reset:
        'İki adımlı doğrulamanız bir yönetici tarafından sıfırlandı. Devam etmek için yeniden kurun.',
      step1: 'Doğrulama uygulamanızla QR kodu tarayın',
      step2: 'Uygulamadaki 6 haneli kodu girin',
      manualEntry: 'QR kodu tarayamıyorsanız bu anahtarı elle girin:',
      code: 'Doğrulama kodu',
      submit: 'Etkinleştir',
      recoveryTitle: 'Kurtarma kodlarınız',
      recoveryIntro:
        'Telefonunuza erişemezseniz bu kodlarla giriş yapabilirsiniz. Her kod yalnızca bir kez kullanılabilir.',
      recoveryWarning: 'Bu kodlar bir daha gösterilmeyecek. Güvenli bir yere kaydedin.',
      copyCodes: 'Kodları kopyala',
      copied: 'Kodlar panoya kopyalandı',
      downloadCodes: 'Kodları indir',
      done: 'Tamamla',
      enabled: 'İki adımlı doğrulama etkinleştirildi',
    },
    forgot: {
      link: 'Parolamı unuttum',
      title: 'Parolanızı mı unuttunuz?',
      subtitle: 'E-posta adresinizi girin, sıfırlama bağlantısı gönderelim.',
      submit: 'Bağlantı gönder',
      sent: 'E-posta adresiniz kayıtlıysa sıfırlama bağlantısı gönderildi.',
      backToLogin: 'Girişe dön',
    },
    reset: {
      title: 'Yeni parola belirleyin',
      subtitle: 'Yeni parolanız en az 12 karakter olmalıdır.',
      password: 'Yeni parola',
      confirm: 'Yeni parola (tekrar)',
      submit: 'Parolayı güncelle',
      success: 'Parolanız güncellendi. Şimdi giriş yapabilirsiniz.',
      mismatch: 'Parolalar eşleşmiyor',
      invalidLink: 'Bu bağlantı geçersiz veya süresi dolmuş.',
    },
    logout: 'Çıkış Yap',
    profile: 'Profilim',
    mail: {
      twoFactorReset: {
        subject: 'BTSis — İki adımlı doğrulamanız sıfırlandı',
        greeting: 'Merhaba {{name}},',
        reset:
          'BTSis hesabınızın iki adımlı doğrulaması {{admin}} tarafından sıfırlandı. Açık olan tüm oturumlarınız sonlandırıldı ve eski kurtarma kodlarınız artık geçerli değil.',
        nextSignIn:
          'Bir sonraki girişinizde iki adımlı doğrulamayı yeniden kurmanız istenecek. Doğrulama uygulamanızla yeni QR kodu taranıp yeni kurtarma kodlarını kaydetmeniz yeterli.',
        notExpected: 'Bunu beklemiyorsanız hemen yöneticinize haber verin.',
      },
    },
  },
  profile: {
    title: 'Profilim',
    confirmEmail: {
      title: 'Yeni e-posta adresinizi onaylayın',
      intro: 'Giriş yaptığınız adres {{email}} olarak değişecek.',
      noPending: 'Bekleyen bir e-posta değişikliğiniz yok.',
      submit: 'Adresi değiştir',
      success: 'E-posta adresiniz {{email}} olarak değiştirildi.',
      toProfile: 'Profilime dön',
      signInFirst:
        'Değişikliği onaylamak için önce mevcut adresinizle giriş yapın, ardından bağlantıyı yeniden açın.',
      signIn: 'Giriş yap',
      invalidLink: 'Bu bağlantı eksik ya da bozuk.',
    },
    account: {
      title: 'Hesap bilgileri',
      subtitle: 'Adınız ve giriş yaptığınız e-posta adresi',
      name: 'Ad Soyad',
      email: 'E-posta',
      newEmail: 'Yeni e-posta adresi',
      changeEmail: 'E-postayı değiştir',
      emailHint:
        'Yeni adrese bir onay bağlantısı, mevcut adresinize bir bilgilendirme gönderilir. Bağlantı açılana kadar mevcut adresinizle giriş yapmaya devam edersiniz. Değiştirmek için mevcut parolanızı girin.',
      emailInvalid: 'Geçerli bir e-posta adresi girin',
      emailRequested: 'Onay bağlantısı yeni adrese gönderildi',
      emailSubmit: 'Onay bağlantısı gönder',
      emailPending:
        '{{email}} adresine bir onay bağlantısı gönderildi. Bağlantı {{expiresAt}} tarihine kadar geçerli; açılana kadar mevcut adresiniz kullanılır.',
      emailResend: 'Yeniden gönder',
      institution: 'Kurum: {{name}}',
      saved: 'Hesap bilgileriniz kaydedildi',
    },
    password: {
      title: 'Parola',
      subtitle: 'Parolanızı değiştirdiğinizde diğer cihazlardaki bütün oturumlarınız kapatılır.',
      current: 'Mevcut parola',
      currentRequired: 'Mevcut parolanızı girin',
      tooShort: 'En az 12 karakter olmalıdır',
      submit: 'Parolayı değiştir',
      changed_one: 'Parolanız değiştirildi; {{count}} diğer oturum kapatıldı.',
      changed_other: 'Parolanız değiştirildi; {{count}} diğer oturum kapatıldı.',
    },
    twoFactor: {
      title: 'İki adımlı doğrulama',
      intro: 'Girişte parolanızın yanında doğrulama uygulamanızdaki kod da istenir.',
      enrol: 'İki adımlı doğrulamayı aç',
      disable: 'İki adımlı doğrulamayı kapat',
      disableHint: 'Kapatmak için mevcut parolanızı girin.',
      disabled: 'İki adımlı doğrulama kapatıldı',
      requiredByRole: 'Rolünüz iki adımlı doğrulama gerektirdiği için kapatılamaz.',
      reenrol: {
        action: 'İki adımlı doğrulamayı yeniden kur',
        title: 'İki adımlı doğrulamayı yeniden kurun',
        intro:
          'Yeni bir QR kod ve yeni kurtarma kodları oluşturulur. Başlamak için parolanızı ve doğrulama uygulamanızdaki güncel kodu ya da kullanılmamış bir kurtarma kodunu girin. Yeni kodu doğrulayana kadar eski uygulamanız ve kodlarınız çalışmaya devam eder.',
        currentCode: 'Güncel doğrulama kodu veya kurtarma kodu',
        currentCodeHint: '6 haneli kod ya da kurtarma kodlarınızdan biri (ABCDE-FGHJK)',
        start: 'Yeni QR kodu oluştur',
        scanHint:
          'Yeni QR kodu uygulamanızla tarayın ve yeni koddan bir doğrulama kodu girin. Onayladığınızda eski kurtarma kodlarınız geçersiz olur ve diğer oturumlarınız kapatılır.',
        confirm: 'Yeni kurulumu onayla',
        done: 'İki adımlı doğrulama yeniden kuruldu',
      },
    },
  },
  pseudonym: {
    chip: {
      masked: 'Rumuzlu görünüm',
      maskedHint:
        'Adlar rumuzlu gösteriliyor. Gerçek adlar için Profil menüsünden “Rumuzları Çöz”ü kullanın.',
      revealed: 'Gerçek adlar',
      revealedHint:
        'Gerçek adlar bu oturum için açık. Oturum kapanınca ya da “Rumuzları Gizle” ile yeniden gizlenir.',
    },
    menu: {
      reveal: 'Rumuzları Çöz',
      hide: 'Rumuzları Gizle',
      needsTwoFactor: 'Rumuzları çözmek için önce iki adımlı doğrulamayı kurun',
    },
    dialog: {
      title: 'Rumuzları Çöz',
      description:
        'Doğrulama uygulamanızdaki altı haneli kodu girin. Gerçek adlar yalnızca bu oturum için açılır; kurtarma kodu kabul edilmez.',
      code: 'Doğrulama kodu',
      submit: 'Çöz',
      submitting: 'Çözülüyor…',
      revealed: 'Rumuzlar çözüldü. Gerçek adlar bu oturum için açık.',
      hidden: 'Adlar yeniden rumuzlu gösteriliyor.',
    },
    field: {
      label: 'Rumuz',
      hint: 'Adlar rumuzlu görünürken bu rumuzla gösterilir. Boş bırakırsanız kod gösterilir.',
    },
    readOnlyHint:
      'Rumuzlar çözülmeden değiştirilemez. Profil menüsünden “Rumuzları Çöz”ü kullanın.',
  },
  orgUnit: {
    title: 'Organizasyon',
    tree: 'Hiyerarşi',
    institutions: 'Kurumlar',
    region: 'Bölge',
    zone: 'Mıntıka',
    country: 'Ülke',
    institution: 'Kurum',
    regions: 'Bölgeler',
    zones: 'Mıntıkalar',
    countries: 'Ülkeler',
    name: 'Ad',
    code: 'Kod',
    isoCode: 'Ülke Kodu',
    organization: 'Kuruluş',
    institutionCount_one: '{{count}} kurum',
    institutionCount_other: '{{count}} kurum',
    showInactive: 'Pasifleri göster',
    active: 'Aktif',
    inactive: 'Pasif',
    searchPlaceholder: 'Kurum adı veya kodu ara',
    newInstitution: 'Yeni Kurum',
    editInstitution: 'Kurumu Düzenle',
    emptyTree: 'Veri kapsamınızda organizasyon bulunmuyor',
    emptyInstitutions: 'Kurum bulunamadı',
    emptyInstitutionsHint: 'Filtreleri değiştirmeyi veya arama terimini temizlemeyi deneyin.',
    created: 'Kurum oluşturuldu',
    updated: 'Kurum güncellendi',
    noOrganization: 'Kuruluş atanmadı',
    organizations: 'Kuruluşlar',
    primaryOrganization: 'Birincil',
    organizationsHint:
      'Birincil kuruluş ilk sırada yer alır. Bağlantılar kuruluşun sayfasından yönetilir.',
    openOrganization: 'Kuruluşu aç',
    codeHint: 'Kod oluşturulduktan sonra değiştirilemez',
    scopeNotice: 'Yalnızca veri kapsamınızdaki kayıtlar listelenir.',
    deactivate: 'Pasife al',
    reactivate: 'Aktifleştir',
    institutionDeleted: 'Kurum silindi',
    institutionDeactivated: 'Kurum pasife alındı',
    institutionReactivated: 'Kurum aktifleştirildi',
    confirmDeleteInstitution:
      '“{{name}}” silinsin mi? Kullanıcısı, bağışı ya da başka bir kaydı olan kurum silinemez; onu pasife alın.',
    levels: {
      status: 'Durum',
      sortOrder: 'Sıra',
      sortOrderHint: 'Listelerde ve hiyerarşide küçük sıra önce gelir.',
      sortOrderInvalid: 'Sıra bir tam sayı olmalıdır',
      isoCodeInvalid: 'İki büyük harfli ülke kodu girin (ör. DE)',
      parentFixed: 'Üst birim oluşturulduktan sonra değiştirilemez.',
      allRegions: 'Tüm bölgeler',
      allZones: 'Tüm mıntıkalar',
      deactivate: 'Pasife al',
      reactivate: 'Aktifleştir',
      confirmDeactivate:
        '“{{name}}” pasife alınsın mı? Altındaki kayıtlar okunmaya devam eder, ancak altında yeni işlem yapılamaz. Altında aktif bir birim varsa önce onu pasife alın.',
      confirmReactivate:
        '“{{name}}” yeniden aktifleştirilsin mi? Üst birimi pasifse önce onu aktifleştirin.',
      confirmDelete:
        '“{{name}}” silinsin mi? Yalnızca hiçbir kaydın bağlı olmadığı bir birim silinebilir; bağlı kayıtları olan birimi pasife alın.',
      readOnlyNotice:
        'Yalnızca veri kapsamınızdaki birimler listelenir. Hiyerarşiyi yalnızca global kapsamdaki kullanıcılar değiştirebilir.',
      tab: {
        all: 'Tümü',
        active: 'Aktif',
        inactive: 'Pasif',
      },
      region: {
        title: 'Bölgeler',
        new: 'Yeni Bölge',
        edit: 'Bölgeyi Düzenle',
        deleteTitle: 'Bölgeyi sil',
        empty: 'Bölge bulunamadı',
        searchPlaceholder: 'Bölge adı veya kodu ara',
        children: 'Mıntıkalar',
        childCount_one: '{{count}} mıntıka · {{active}} aktif',
        childCount_other: '{{count}} mıntıka · {{active}} aktif',
        parent: 'Üst birim',
        parentPlaceholder: 'Seçin',
        parentRequired: 'Üst birim seçin',
        csvFile: 'bolgeler.csv',
        created: 'Bölge oluşturuldu',
        updated: 'Bölge güncellendi',
        deleted: 'Bölge silindi',
        deactivated: 'Bölge pasife alındı',
        reactivated: 'Bölge aktifleştirildi',
      },
      zone: {
        title: 'Mıntıkalar',
        new: 'Yeni Mıntıka',
        edit: 'Mıntıkayı Düzenle',
        deleteTitle: 'Mıntıkayı sil',
        empty: 'Mıntıka bulunamadı',
        searchPlaceholder: 'Mıntıka adı veya kodu ara',
        children: 'Ülkeler',
        childCount_one: '{{count}} ülke · {{active}} aktif',
        childCount_other: '{{count}} ülke · {{active}} aktif',
        parent: 'Bölge',
        parentPlaceholder: 'Bölge seçin',
        parentRequired: 'Bölge seçin',
        csvFile: 'mintikalar.csv',
        created: 'Mıntıka oluşturuldu',
        updated: 'Mıntıka güncellendi',
        deleted: 'Mıntıka silindi',
        deactivated: 'Mıntıka pasife alındı',
        reactivated: 'Mıntıka aktifleştirildi',
      },
      country: {
        title: 'Ülkeler',
        new: 'Yeni Ülke',
        edit: 'Ülkeyi Düzenle',
        deleteTitle: 'Ülkeyi sil',
        empty: 'Ülke bulunamadı',
        searchPlaceholder: 'Ülke adı veya kodu ara',
        children: 'Kurumlar',
        childCount_one: '{{count}} kurum · {{active}} aktif',
        childCount_other: '{{count}} kurum · {{active}} aktif',
        parent: 'Mıntıka',
        parentPlaceholder: 'Mıntıka seçin',
        parentRequired: 'Mıntıka seçin',
        csvFile: 'ulkeler.csv',
        created: 'Ülke oluşturuldu',
        updated: 'Ülke güncellendi',
        deleted: 'Ülke silindi',
        deactivated: 'Ülke pasife alındı',
        reactivated: 'Ülke aktifleştirildi',
      },
    },
  },
  integration: {
    title: 'Entegrasyonlar',
    subtitle:
      'İmzalı bir webhook üzerinden sisteme yazabilen makineler. WhatsApp’tan dikte edilen bağışı giren n8n akışı buradan tanımlanır.',
    new: 'Yeni Entegrasyon',
    createAction: 'Oluştur ve anahtarı göster',
    name: 'Ad',
    nameHint: 'Örneğin: n8n WhatsApp',
    clientRef: 'İstemci Kodu',
    fingerprint: 'Anahtar İzi',
    fingerprintHint: 'İmza anahtarının son dört karakteri (anahtar halkası: {{keyId}})',
    configuredBy: 'Tanımlayan',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Kapalı',
    rotate: 'Anahtarı Yenile',
    rotateTitle: 'İmza anahtarını yenile',
    rotateWarning:
      '{{name}} için yeni bir imza anahtarı üretilecek. Eski anahtar bu işlemden sonra kabul edilmez; yeni anahtarı n8n’e yapıştırmadan akış çalışmaz.',
    deactivate: 'Kapat',
    reactivate: 'Aç',
    deactivated: 'Entegrasyon kapatıldı',
    reactivated: 'Entegrasyon açıldı',
    secretTitle: '{{name}} — imza anahtarı',
    secretOnce:
      'Bu anahtar yalnızca şimdi görünür. Kapattıktan sonra hiçbir ekran ve hiçbir servis onu geri vermez; kaybederseniz yenisini üretmeniz gerekir.',
    secretHint:
      'Anahtarı n8n’in kimlik bilgisi deposuna ya da ortam değişkenine koyun; workflow JSON’unun içine yazmayın.',
    secretSaved: 'Kaydettim',
    signingSecret: 'İmza Anahtarı',
    endpoint: 'Adres',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    copyFailed: 'Kopyalanamadı',
    empty: 'Tanımlı entegrasyon yok',
    emptyHint: 'WhatsApp’tan bağış girecek n8n akışı için bir entegrasyon oluşturun.',
  },
  impersonation: {
    start: 'Kullanıcıyı Taklit Et',
    banner: 'Şu anda {{name}} ({{email}}) hesabını görüntülüyorsunuz.',
    return: 'Admin’e Dön',
    hint: 'Hassas hesap işlemleri ve onay işlemleri bu oturumda kapalıdır. Bitiş: {{expiresAt}}',
    expired: 'Taklit oturumunun süresi doldu. Devam etmek için admin hesabınıza dönün.',
    attribution: 'Taklit eden yönetici: {{adminId}}',
    adminId: 'Taklit eden yönetici kimliği',
    userId: 'İşlemi yapılan kullanıcı kimliği',
  },
  user: {
    telegramChatId: 'Telegram özel sohbet kimliği',
    telegramChatIdHint:
      'Yalnızca pozitif sayısal özel sohbet kimliği. Medya göndermek için aktif Operasyon Sorumlusu veya yürürlükte bir personel ataması gerekir.',
    title: 'Kullanıcılar',
    subtitle: 'Kuruma bağlı hesaplar, rolleri ve veri kapsamları',
    new: 'Yeni Kullanıcı',
    edit: 'Kullanıcıyı Düzenle',
    name: 'Ad Soyad',
    email: 'E-posta',
    ownEmailHint:
      'Kendi adresinizi Profilim sayfasından değiştirebilirsiniz; değişiklik yeni adrese gönderilen bağlantıyla tamamlanır.',
    phone: 'Telefon',
    phoneHint:
      'Ülkeyi seçip numarayı yazın. WhatsApp’tan bağış dikte eden personel bu numaradan tanınır.',
    institution: 'Kurum',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    twoFactor: 'İki Adımlı',
    on: 'Açık',
    off: 'Kapalı',
    lastLogin: 'Son Giriş',
    neverLoggedIn: 'Hiç giriş yapmadı',
    role: 'Rol',
    roles: 'Roller',
    noRoles: 'Rol atanmamış',
    addRole: 'Rol ekle',
    removeRole: 'Rolü kaldır',
    requiresTwoFactor: 'iki adımlı doğrulama zorunlu',
    scopeLevel: 'Kapsam Düzeyi',
    scopeNode: 'Kapsam',
    scopeNodeGlobal: 'Global kapsam tüm kayıtları içerir',
    scopeNodeSelf: 'Yalnızca kullanıcının girdiği ve kendisine atanan kayıtlar',
    roleManagementDenied: 'Rol ve kapsam atamak için yetkiniz yok.',
    roleNotGrantable: 'Bu rol, sizde olmayan yetkiler içerdiği için atanamaz.',
    automaticRole: 'görevlendirme',
    automaticRoleHint:
      'Kampanya görevlendirmesinden gelir: kişi yürürlükteki bir görevlendirmede oldukça durur, son görevlendirmesi kaldırılınca, pasife alınınca ya da süresi dolunca kalkar. Tek başına yetki vermez; yetki ve kapsam görevlendirmenin kampanyası ve kurumuyla sınırlıdır.',
    automaticRoles: 'Görevlendirmeden gelen roller',
    automaticRolesHint:
      'Kampanya Görevlendirmeleri ekranından yönetilir; burada değiştirilemez ve kaydederken gönderilmez.',
    notManageable:
      'Bu kullanıcı sizde olmayan yetkilere sahip olduğu için üzerinde işlem yapamazsınız.',
    sendInvite: 'Parola belirleme davetini e-posta ile gönder',
    invite: 'Davet gönder',
    resetTwoFactor: {
      action: '2FA’yı sıfırla',
      confirm:
        '{{name}} kullanıcısının iki adımlı doğrulaması ve kurtarma kodları silinir, tüm oturumları kapatılır ve bir sonraki girişinde iki adımlı doğrulamayı yeniden kurması istenir. Kullanıcıya e-posta ile bildirilir.',
      done: '{{name}} için iki adımlı doğrulama sıfırlandı. {{count}} oturum kapatıldı.',
    },
    inviteSent: '{{email}} adresine davet gönderildi',
    inviteNotSent:
      '{{email}} adresine e-posta gönderilemedi. Aşağıdaki davet bağlantısını kullanıcıya kendiniz iletin.',
    invitationLink: {
      title: 'Davet bağlantısı',
      intro:
        '{{email}} için parola belirleme bağlantısı oluşturuldu. Bağlantıyı kullanıcıya kendiniz de iletebilirsiniz.',
      introNotMailed:
        '{{email}} için parola belirleme bağlantısı oluşturuldu. Bağlantıyı kullanıcıya kendiniz iletmeniz gerekiyor.',
      mailFailed:
        'Davet e-postası posta sunucusuna teslim edilemedi; kullanıcının eline hiçbir şey ulaşmadı. Kullanıcı ancak bu bağlantıyla parolasını belirleyebilir.',
      onceOnly:
        'Bu bağlantı yalnızca şimdi, bu pencerede görüntülenir ve yalnızca bir kez kullanılabilir. Kopyalamadan kapatırsanız tekrar görüntülenemez; yeni bir bağlantı için yeniden davet göndermeniz gerekir ve bu eski bağlantıyı geçersiz kılar.',
      expiryHint:
        'Bağlantının süresi dolarsa kullanıcı giriş ekranındaki “Parolamı unuttum” bağlantısını kullanabilir.',
      copy: 'Bağlantıyı kopyala',
      copied: 'Bağlantı kopyalandı',
    },
    created: 'Kullanıcı oluşturuldu',
    createdAndInvited: 'Kullanıcı oluşturuldu ve davet gönderildi',
    createdInviteNotSent:
      'Kullanıcı oluşturuldu, ancak davet e-postası gönderilemedi. Davet bağlantısını kullanıcıya kendiniz iletin.',
    updated: 'Kullanıcı güncellendi',
    deactivate: 'Pasife al',
    reactivate: 'Aktife al',
    deactivated_one: 'Kullanıcı pasife alındı, {{count}} oturum sonlandırıldı',
    deactivated_other: 'Kullanıcı pasife alındı, {{count}} oturum sonlandırıldı',
    reactivated: 'Kullanıcı yeniden aktif edildi',
    confirmDeactivate_one:
      '{{count}} kullanıcı pasife alınacak ve açık oturumları sonlandırılacak. Kayıtlar silinmez.',
    confirmDeactivate_other:
      '{{count}} kullanıcı pasife alınacak ve açık oturumları sonlandırılacak. Kayıtlar silinmez.',
    confirmReactivate_one: '{{count}} kullanıcı yeniden aktif edilecek.',
    confirmReactivate_other: '{{count}} kullanıcı yeniden aktif edilecek.',
    bulkPartial: '{{total}} kayıttan {{failed}} tanesi işlenemedi',
    selected_one: '{{count}} kayıt seçildi',
    selected_other: '{{count}} kayıt seçildi',
    rowActions: 'Satır işlemleri',
    searchPlaceholder: 'Ad veya e-posta ara',
    allInstitutions: 'Tüm kurumlar',
    allRoles: 'Tüm roller',
    empty: 'Kullanıcı bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi veya arama terimini temizlemeyi deneyin.',
    scopeNotice: 'Yalnızca veri kapsamınızdaki kullanıcılar listelenir.',
    tab: {
      all: 'Tümü',
      active: 'Aktif',
      inactive: 'Pasif',
    },
  },
  role: {
    title: 'Roller',
    subtitle: 'Yetki kümeleri ve bunları taşıyan kullanıcı sayısı',
    new: 'Yeni Rol',
    edit: 'Rolü Düzenle',
    code: 'Kod',
    codeHint: 'İngilizce, küçük harf ve alt çizgi. Oluşturulduktan sonra değiştirilemez.',
    name: 'Ad',
    description: 'Açıklama',
    kind: 'Tür',
    system: 'Sistem',
    custom: 'Özel',
    systemNotice: 'Bu bir sistem rolüdür: kodu değiştirilemez ve rol silinemez.',
    requiresTwoFactor: 'İki adımlı doğrulama zorunlu',
    requiresTwoFactorHint:
      'Bu rolü taşıyan kullanıcılar, açık oturumları olsa bile bir sonraki isteklerinde kurulum ekranına yönlendirilir.',
    permissions: 'Yetkiler',
    permissionsHint: 'Yalnızca kendinizde olan yetkileri verebilirsiniz.',
    noPermissions: 'Yetki seçilmedi',
    selectedOfTotal: '{{selected}} / {{total}}',
    menu: 'Menü görünürlüğü',
    menuHint:
      'Bir menü başlığının görünmesi için hem buradaki işaret hem de ekranın kendi yetkisi gerekir. İşareti kaldırmak ekranı kapatmaz: adresi bilen ve yetkisi olan kullanıcı ekranı yine açar. Alt başlıklarının hiçbiri görünmeyen bir başlık menüde gösterilmez.',
    users: 'Kullanıcı',
    userCount_one: '{{count}} kullanıcı',
    userCount_other: '{{count}} kullanıcı',
    permissionCount_one: '{{count}} yetki',
    permissionCount_other: '{{count}} yetki',
    lastUpdated: 'Son Güncelleme',
    created: 'Rol oluşturuldu',
    updated: 'Rol güncellendi',
    deleted: 'Rol silindi',
    delete: 'Rolü sil',
    confirmDelete: '“{{name}}” rolü kalıcı olarak silinecek. Bu işlem geri alınamaz.',
    rowActions: 'Satır işlemleri',
    searchPlaceholder: 'Rol adı veya kodu ara',
    empty: 'Rol bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi veya arama terimini temizlemeyi deneyin.',
    tab: {
      all: 'Tümü',
      system: 'Sistem',
      custom: 'Özel',
    },
  },
  donor: {
    channels: {
      title: 'Bildirim kanalları ve izinler',
      subtitle:
        'Bağışçının hangi kanaldan haberdar edileceği. Açmak iletişim iznini kayda geçirir, kapatmak izni geri alır ve o kanaldan başka bir şey gönderilmez. Adresi olmayan bir kanal seçilemez.',
      noAddress: 'Kayıtlı adres yok',
      byDonor: 'bağışçının kendisi',
      consentGranted: 'İzin verildi: {{date}} · {{source}} · {{by}}',
      consentWithdrawn: 'İzin geri alındı: {{date}} · {{source}} · {{by}}',
      granted: 'İletişim izni kaydedildi',
      withdrawn: 'İletişim izni geri alındı',
      source: {
        portal_account: 'bağışçı hesabı',
        admin: 'yönetim paneli',
        public_form: 'bağış formu',
        migrated_blanket_consent: 'devralınan genel izin',
      },
    },
    title: 'Bağışçılar',
    subtitle: 'Bağışçı kayıtları, mükerrer uyarıları ve birleştirme',
    new: 'Yeni Bağışçı',
    edit: 'Bağışçıyı Düzenle',
    detail: 'Bağışçı Kartı',
    name: 'Ad Soyad / Unvan',
    anonymousName: 'Anonim Bağışçı',
    kind: 'Tür',
    email: 'E-posta',
    phone: 'Telefon',
    taxId: 'Vergi No',
    address: 'Adres',
    country: 'Ülke',
    countryIso: 'Ülke Kodu',
    institution: 'Kurum',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    createdAt: 'Kayıt Tarihi',
    isAnonymous: 'Anonim bağışçı',
    isAnonymousHint:
      'Raporlarda ve makbuzlarda “Anonim Bağışçı” olarak görünür; kayıt bağı denetim için korunur.',
    communicationConsent: 'İletişim izni var',
    consentRecordedAt: 'İzin Tarihi',
    consentSource: 'İzin Kaynağı',
    consentIsPerChannel:
      'İletişim izni bu formda değil, bağışçı sayfasındaki “Bildirim Kanalları” kartında kanal kanal verilir ve geri alınır.',
    created: 'Bağışçı oluşturuldu',
    updated: 'Bağışçı güncellendi',
    deactivate: 'Pasife al',
    reactivate: 'Aktife al',
    confirmDeactivate: 'Bağışçı pasife alınacak. Bağışları ve makbuzları silinmez.',
    confirmReactivate: 'Bağışçı yeniden aktif edilecek.',
    searchPlaceholder: 'Ad, e-posta, telefon veya vergi no ara',
    allInstitutions: 'Tüm kurumlar',
    allKinds: 'Tüm türler',
    includeMerged: 'Birleştirilmiş kayıtları göster',
    empty: 'Bağışçı bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi veya arama terimini temizlemeyi deneyin.',
    scopeNotice: 'Yalnızca veri kapsamınızdaki bağışçılar listelenir.',
    notOwned: 'Bu bağışçı başka bir kuruma ait; yalnızca görüntüleyebilirsiniz.',
    tab: {
      all: 'Tümü',
      active: 'Aktif',
      inactive: 'Pasif',
    },
    kinds: {
      individual: 'Kişi',
      organization: 'Kurum',
    },
    rights: {
      title: 'KVKK ve veri hakları',
      subtitle:
        'Bağışçının kendisi hakkında tutulanların bir örneğini isteme ve silinmesini isteme hakkı. Silme, bağış tutarlarını, makbuz numaralarını ve muhasebe kayıtlarını kaldırmaz.',
      requests: 'Bağışçının talepleri',
      noRequests: 'Bu bağışçıdan gelen bir talep yok.',
      kinds: { export: 'Veri örneği', erasure: 'Silme' },
      requestStatuses: { open: 'Açık', completed: 'Karşılandı', refused: 'Reddedildi' },
      export: 'Veri örneği hazırla',
      exportRequested:
        'Belge hazırlanıyor. Hazır olduğunda Dosyalarım ekranından indirebilirsiniz.',
      propose: 'Silme talebi aç',
      erasureProposed: 'Silme talebi açıldı. İkinci bir yetkilinin uygulaması gerekir.',
      withdraw: 'Talebi geri çek',
      erasureWithdrawn: 'Silme talebi geri çekildi.',
      carryOut: 'Silmeyi uygula',
      erasureCarriedOut: 'Bağışçının kişisel bilgileri silindi.',
      waiting: '{{who}} tarafından {{at}} tarihinde açılmış bir silme talebi bekliyor.',
      needsASecondPerson: 'Talebi açan kişi uygulayamaz.',
      erasedAt: 'Bu bağışçının kişisel bilgileri {{at}} tarihinde silindi.',
      carriedOutRecord: 'Silme kaydı',
      carriedOutBy: '{{proposer}} açtı, {{approver}} {{at}} tarihinde uyguladı.',
      confirmTitle: 'Silmeyi uygula',
      confirmWarning:
        'Bu işlem geri alınamaz. Ad, adres, telefon, e-posta, kimlik numarası ve iletişim izinleri kalıcı olarak silinir; bağışlar, makbuzlar ve muhasebe kayıtları olduğu gibi kalır.',
      confirmPrompt: 'Onaylamak için bağışçının adını yazın: {{name}}',
      confirmLabel: 'Bağışçının adı',
    },
    duplicate: {
      title: 'Benzer kayıt bulundu',
      hint: 'Kaydetmeyi engellemez. Aynı kişiyse mevcut kaydı kullanın.',
      decisive: 'Kesin eşleşme',
      weak: 'Zayıf eşleşme',
      open: 'Kaydı aç',
      signal: {
        tax_id: 'Vergi no',
        phone: 'Telefon',
        email: 'E-posta',
        name: 'Ad',
      },
    },
    existsElsewhere: {
      email: 'Bu e-posta başka bir kuruma kayıtlı',
      phone: 'Bu telefon numarası başka bir kuruma kayıtlı',
      hint: 'Kayıt sahibi kurum ve kişi bilgileri paylaşılmaz. Kaydetmeye devam edebilirsiniz.',
      request: 'Bağlantı talep et',
      requested: 'Bağlantı talebi gönderildi',
    },
    partyPicker: {
      phoneOnFile: 'Kayıtlı numara: {{phone}}. Başka bir numara yazarsanız seçim kalkar.',
      phoneMatchHint:
        'Bu numara kayıtlı bağışçı {{name}} ile eşleşiyor — kayıt bu kişiye bağlanacak.',
      phoneMatchAction: 'İsmi {{name}} yap',
      phoneMatchConfirmed: 'Kayıtlı bağışçı: {{name}}',
      phoneAmbiguous:
        'Bu numara birden fazla kayıtlı bağışçıya ait; kaydetmeye çalışıldığında reddedilecek. Doğru numarayı girin veya bağışçı kayıtlarını birleştirin.',
    },
    link: {
      title: 'Bağlantı Talepleri',
      subtitle: 'Başka kurumların bağışçılarınıza erişim talepleri',
      requestingInstitution: 'Talep Eden Kurum',
      matchedSignal: 'Eşleşen Bilgi',
      requestedAt: 'Talep Tarihi',
      expiresAt: 'Son Geçerlilik',
      status: 'Durum',
      accept: 'Onayla',
      decline: 'Reddet',
      accepted: 'Bağlantı talebi onaylandı',
      declined: 'Bağlantı talebi reddedildi',
      granted: 'Erişim Verilen Kurumlar',
      noneGranted: 'Bu bağışçıya başka kurum erişimi verilmemiş',
      empty: 'Bağlantı talebi yok',
      emptyHint: 'Başka bir kurum bağışçılarınızdan birine erişim istediğinde burada görünür.',
      confirmAccept:
        'Talep eden kurum bu bağışçıyı görüntüleyebilecek ve üzerine bağış kaydedebilecek. Bağışçı sizin kurumunuzda kalır.',
      confirmDecline: 'Talep reddedilecek ve talep eden kuruma hiçbir bilgi verilmeyecek.',
      statuses: {
        all: 'Tümü',
        open: 'Bekliyor',
        accepted: 'Onaylandı',
        declined: 'Reddedildi',
        expired: 'Süresi doldu',
      },
    },
    merge: {
      title: 'Bağışçı Birleştir',
      action: 'Birleştir',
      survivor: 'Kalacak kayıt',
      merged: 'Birleştirilecek kayıt',
      reason: 'Gerekçe',
      reasonPlaceholder: 'Aynı kişinin iki kaydı',
      explain:
        'Birleştirilen kayıt pasife alınır ve kalan kayda bağlanır. Hiçbir bağış taşınmaz; makbuzlar ve denetim kaydı olduğu gibi kalır.',
      submit: 'Birleştir',
      done: 'Kayıtlar birleştirildi',
      history: 'Birleştirme Geçmişi',
      mergedInto: 'Bu kayıt {{name}} kaydına birleştirildi',
      reversed: 'Geri alındı',
      undo: 'Birleştirmeyi geri al',
      undone: 'Birleştirme geri alındı',
      confirmUndo: 'Birleştirme geri alınacak ve kayıt yeniden bağımsız hale gelecek.',
      empty: 'Birleştirme kaydı yok',
    },
    report: {
      title: 'Mükerrer Raporu',
      subtitle: 'Aynı değeri taşıyan bağışçı kayıtları',
      value: 'Değer',
      records: 'Kayıtlar',
      signal: 'Eşleşen Bilgi',
      openReport: 'Mükerrer raporu',
      scopeNotice:
        'Bu rapor bölge kapsamı ve üzeri için çalışır. Kurum kapsamındaki bir kullanıcı kendi kurumunun dışındaki kayıtları göremez.',
      empty: 'Mükerrer kayıt bulunamadı',
      emptyHint: 'Kapsamınızdaki bağışçılarda aynı e-posta, telefon veya vergi no yok.',
    },
    crm: {
      title: 'Bağış Geçmişi',
      totalGiven: 'Toplam Bağış',
      donationCount: 'Bağış Sayısı',
      firstGift: 'İlk Bağış',
      lastGift: 'Son Bağış',
      frequency: 'Bağış Sıklığı',
      frequencyValue: 'ortalama {{days}} günde bir',
      frequencyUnknown: 'Tek bağış',
      categories: 'Tercih Edilen Kategoriler',
      noCategories: 'Henüz bir kategoriye bağış yapılmamış',
      history: 'Son Bağışlar',
      historyEmpty: 'Bu bağışçı adına kayıtlı bağış yok',
      historyHidden: 'Bağış satırlarını görmek için bağış listesi yetkisi gerekir.',
      allDonations: 'Tüm bağışları',
      mergeGroup: 'Rakamlar {{count}} kayıtlık birleştirme grubunu kapsar.',
      pledges: 'Düzenli Bağışlar',
      onBehalfOfHistory: 'Adına Yapılan Bağışlar',
      paidBy: 'ödeyen: {{name}}',
    },
    outstanding: {
      title: 'Kalan Borç',
      hint: 'Bu bağışçı kaydının para alan bağışları, para birimine göre. İptal edilen, iade edilen ve ücretsiz bağışlar sayılmaz.',
      pledged: 'Toplam taahhüt',
      collected: 'Tahsil edilen',
      awaitingApproval: 'Onay bekleyen',
      outstanding: 'Kalan borç',
      donations: '{{count}} bağış',
      showOwing: 'Kalan borcu olan {{count}} bağışı gör',
      none: 'Bu bağışçının para alan bir bağışı yok.',
      scopeNote:
        'Yalnızca görme yetkiniz olan bağışlar sayılır; yetki alanınız dışındaki bağışlar bu rakamlara girmez.',
      group: {
        title: 'Birleştirilen kayıtlarla birlikte',
        hint: 'Bu bağışçıya birleştirilen {{merged}} kaydın bağışları da dahil. Birleştirme bağışları taşımaz; her bağış kendi kaydında kalır.',
        showOwing: 'Birlikte kalan borcu olan {{count}} bağışı gör',
      },
    },
  },
  campaignCategory: {
    title: 'Kampanya Kategorileri',
    subtitle: 'Bağış menüsünü oluşturan gruplar. Kategorinin kendi verisi yoktur.',
    new: 'Yeni Kategori',
    edit: 'Kategoriyi Düzenle',
    code: 'Kod',
    codeHint: 'İngilizce, küçük harf ve alt çizgi. Oluşturulduktan sonra değiştirilemez.',
    name: 'Ad',
    slug: 'Kısa Ad',
    slugHint: 'Adreste görünen küçük harfli kısa ad, örneğin “genel-yardim”.',
    icon: 'Simge',
    iconHint: 'Simgeler uygulamayla birlikte gelir; listedekiler dışında bir ad kullanılamaz.',
    iconNone: 'Simge yok',
    sortOrder: 'Sıra',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    campaigns: 'Kampanya',
    campaignCount_one: '{{count}} kampanya',
    campaignCount_other: '{{count}} kampanya',
    showInactive: 'Pasifleri göster',
    searchPlaceholder: 'Kategori adı veya kodu ara',
    reorderHint: 'Sıralamayı değiştirmek için satırları sürükleyin. Yeni sıra anında kaydedilir.',
    reorderDisabled:
      'Sıralama yalnızca filtresiz listede değiştirilebilir: sunucu eksik bir sıralamayı kabul etmez.',
    dragHandle: 'Sıralamak için sürükleyin',
    dnd: {
      instructions:
        'Bir kategoriyi taşımak için boşluk tuşuna basın, ok tuşlarıyla yerini değiştirin, bırakmak için yeniden boşluk tuşuna basın. Vazgeçmek için Esc tuşuna basın.',
      start: '“{{category}}” kategorisi taşınmak üzere alındı.',
      over: '“{{category}}” kategorisi {{position}}. sıranın üzerinde.',
      outside: '“{{category}}” kategorisi listenin dışında.',
      end: '“{{category}}” kategorisi {{position}}. sıraya bırakıldı.',
      cancel: '“{{category}}” kategorisinin taşınmasından vazgeçildi.',
    },
    reordered: 'Sıralama kaydedildi',
    created: 'Kategori oluşturuldu',
    updated: 'Kategori güncellendi',
    rowActions: 'Satır işlemleri',
    empty: 'Kategori bulunamadı',
    emptyHint: 'Yeni bir kategori oluşturun veya arama terimini temizleyin.',
    globalNotice: 'Kategoriler globaldir; veri kapsamına göre filtrelenmez.',
  },
  campaign: {
    title: 'Kampanyalar',
    subtitle: 'Bağış türleri. Her tür bir kampanya kaydıdır, kod değil.',
    new: 'Yeni Kampanya',
    code: 'Kod',
    codeHint: 'İngilizce, küçük harf ve alt çizgi. Oluşturulduktan sonra değiştirilemez.',
    name: 'Ad',
    slug: 'Kısa Ad',
    slugHint: 'Adreste görünen küçük harfli kısa ad, örneğin “vacip-kurban”.',
    category: 'Kategori',
    allCategories: 'Tüm kategoriler',
    pricingMode: 'Fiyatlandırma',
    pricingModeLocked: 'Bir dönem taslaktan çıktığı için fiyatlandırma biçimi kilitlendi.',
    unitLabel: 'Birim Adı',
    unitLabelHint: 'Bağışçının okuduğu kelime: hisse, koli, kuyu, fidan.',
    description: 'Açıklama',
    descriptionHint:
      'Bağış sayfasında okunan tanıtım metni. Bağışçının kararını verdiği yer burasıdır.',
    image: {
      title: 'Kampanya Görseli',
      hint: 'JPEG veya PNG, en çok {{max}}. Bağış sayfasındaki kart ve kapak görseli.',
      choose: 'Görsel seç',
      saved: 'Görsel kaydedildi',
      removed: 'Görsel kaldırıldı',
      tooLarge: 'Seçilen dosya {{max}} sınırının üzerinde.',
      scan: {
        pending: 'Görsel virüs taramasından geçtikten sonra yayınlanacak.',
        infected: 'Görselde zararlı içerik bulundu; yayınlanmayacak.',
        failed: 'Görsel taranamadı; yayınlanmayacak.',
      },
    },
    unitsPerGroup: 'Grup Başına Birim',
    unitsPerGroupHint:
      'Bir grup kaç birimden oluşur; örneğin büyükbaş hissesinde bir hayvan için 7. Boş bırakılırsa hisseler gruplanmaz. Form sekmesindeki Grup büyüklüğü kartında bir cevaba verilen büyüklük (örneğin küçükbaş için 1), o cevabı taşıyan hisselerde bunun yerine geçer.',
    unitsPerGroupLocked:
      'Bu kampanyada sıraya alınmış hisse olduğu için grup başına birim kilitlendi; değiştirmek sahaya verilmiş grupları yeniden böler.',
    unitsPerGroupInvalid: 'Boş bırakın ya da 1 ile 1000 arasında bir tam sayı girin.',
    collectionScope: 'Toplama Kapsamı',
    ownerScope: 'Sahiplik Kapsamı',
    ownerScopeHint:
      'Kampanyayı hangi birimin tanımladığı. Kapsam içindeki her kurum kampanyayı görür.',
    ownerScopeNode: 'Sahiplik Birimi',
    ownerScopeGlobal: 'Global kampanyayı tüm kurumlar görür.',
    activePeriod: 'Aktif Dönem',
    noPeriod: 'Dönem yok',
    seasonYear: 'Sezon',
    allSeasons: 'Tüm sezonlar',
    status: 'Durum',
    allStatuses: 'Tüm durumlar',
    allOwnerScopes: 'Tüm kapsamlar',
    progress: 'İlerleme',
    noGoal: 'Hedef tanımlı değil',
    outOfWindow: 'Takvim dışında',
    showArchived: 'Arşivlenmişleri göster',
    archived: 'Arşivlendi',
    archive: 'Arşivle',
    restore: 'Arşivden çıkar',
    confirmArchive:
      '“{{name}}” arşivlenecek: menüden ve seçim listelerinden kalkar. Dönemleri, bağışları ve raporları olduğu gibi kalır.',
    confirmRestore: '“{{name}}” yeniden listelenecek.',
    archivedToast: 'Kampanya arşivlendi',
    restoredToast: 'Kampanya arşivden çıkarıldı',
    confirmArchiveMany_one:
      '{{count}} kampanya arşivlenecek: menüden ve seçim listelerinden kalkar.',
    confirmArchiveMany_other:
      '{{count}} kampanya arşivlenecek: menüden ve seçim listelerinden kalkar.',
    confirmRestoreMany_one: '{{count}} kampanya yeniden listelenecek.',
    confirmRestoreMany_other: '{{count}} kampanya yeniden listelenecek.',
    archivedManyToast_one: '{{count}} kampanya arşivlendi',
    archivedManyToast_other: '{{count}} kampanya arşivlendi',
    restoredManyToast_one: '{{count}} kampanya arşivden çıkarıldı',
    restoredManyToast_other: '{{count}} kampanya arşivden çıkarıldı',
    bulkPartial: '{{total}} kampanyadan {{failed}} tanesi işlenemedi',
    created: 'Kampanya oluşturuldu',
    createdWithPeriod: 'Kampanya ve {{year}} taslak dönemi oluşturuldu',
    updated: 'Kampanya güncellendi',
    formVersion: 'Form Sürümü',
    formNotPublished: 'Form henüz yayınlanmadı',
    rowActions: 'Satır işlemleri',
    searchPlaceholder: 'Kampanya adı veya kodu ara',
    empty: 'Kampanya bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi veya arama terimini temizlemeyi deneyin.',
    scopeNotice:
      'Global kampanyalar, bağlı olduğunuz bölge, mıntıka, ülke ve kurumun kampanyaları ile veri kapsamınızdaki tüm kampanyalar listelenir.',
    detail: 'Kampanya Detayı',
    readOnly: {
      archived: 'Bu kampanya arşivlendi. Arşivden çıkarılana kadar hiçbir bölümü değiştirilemez.',
      permission:
        'Bu kampanyayı yalnızca görüntüleyebilirsiniz. Değişiklik yapmak için kampanya düzenleme yetkisi gerekir.',
    },
    tab: {
      general: 'Genel',
      form: 'Form',
      periods: 'Dönemler',
      assignments: 'Görevlendirme',
      goal: 'Hedef',
    },
  },
  campaignForm: {
    status: {
      published: 'Yayında: Sürüm {{version}}',
      unpublished: 'Form henüz yayınlanmadı',
      dirty: 'Yayımlanmamış değişiklikler var',
    },
    discard: 'Değişiklikleri geri al',
    discardConfirm:
      'Son yayından sonra yaptığınız tüm değişiklikler silinecek. Bu işlem geri alınamaz.',
    newFieldLabel: 'Yeni {{type}} alanı',
    newOptionLabel: 'Seçenek {{index}}',
    dragHandle: 'Sürükleyerek sırala',
    dnd: {
      instructions:
        'Bir alanı taşımak için boşluk tuşuna basın, ok tuşlarıyla yerini değiştirin, bırakmak için yeniden boşluk tuşuna basın. Vazgeçmek için Esc tuşuna basın.',
      start: '“{{field}}” alanı taşınmak üzere alındı.',
      over: '“{{field}}” alanı {{position}}. sıranın üzerinde.',
      outside: '“{{field}}” alanı listenin dışında.',
      end: '“{{field}}” alanı {{position}}. sıraya bırakıldı.',
      cancel: '“{{field}}” alanının taşınmasından vazgeçildi.',
    },
    fields: {
      title: 'Alanlar',
      subtitle_one: '{{count}} alan · sürükleyerek sıralayın',
      subtitle_other: '{{count}} alan · sürükleyerek sıralayın',
      empty: 'Bu formda henüz alan yok',
      emptyHint: 'Yukarıdaki alan paletinden bir tür seçerek başlayın.',
      untitled: 'Adsız alan',
    },
    palette: {
      open: 'Alan ekle',
      close: 'Paleti kapat',
      title: 'Alan türü seçin',
    },
    type: {
      text: 'Metin',
      textarea: 'Uzun metin',
      number: 'Sayı',
      select: 'Açılır liste',
      multiselect: 'Çoklu seçim',
      date: 'Tarih',
      checkbox: 'Onay kutusu',
      radio: 'Tek seçim',
      file: 'Dosya',
      phone: 'Telefon',
      email: 'E-posta',
    },
    direction: {
      row: 'Yatay (satır)',
      column: 'Dikey (sütun)',
    },
    variant: {
      radio: 'Klasik radyo düğmesi',
      toggle: 'Buton grubu (dokunması kolay)',
    },
    badge: {
      required: 'Zorunlu',
      conditional: 'Koşullu: {{field}}',
      adminOnly: 'Yalnızca yönetim',
      portalHidden: 'Portalda gizli',
      published: 'Yayınlanmış anahtar',
      unrecognised: 'Tanınmayan tür',
      issues_one: '{{count}} hata',
      issues_other: '{{count}} hata',
    },
    panel: {
      title: 'Alan özellikleri',
      none: 'Bir alan seçin',
      noneHint: 'Özelliklerini düzenlemek için soldaki listeden bir alana tıklayın.',
      unrecognised:
        'Bu alanın türü bu sürümde tanınmıyor. Olduğu gibi korunur ve yayında değiştirilmeden gönderilir.',
      remove: 'Alanı kaldır',
      confirmRemove:
        '“{{label}}” formdan kaldırılacak. Yayımlanmış bir alansa bu değişiklik geriye dönük uyumsuzdur.',
      basics: 'Temel bilgiler',
      options: 'Seçenekler',
      layout: 'Görünüm',
      rules: 'Doğrulama kuralları',
      visibility: 'Koşullu görünürlük',
      audience: 'Görünürlük ve hedef kitle',
    },
    property: {
      label: 'Etiket',
      labelHint: 'Bağışçının gördüğü alan adı.',
      key: 'Alan anahtarı',
      keyHint: 'Etiketten otomatik üretilir; yayınlanana kadar değiştirilebilir.',
      keyLocked: 'Yayınlandığı için kilitli.',
      keyLockedTooltip:
        'Bu anahtar yayımlanmış bir sürümde kullanılıyor ve bağışlar bu anahtarla kaydediliyor. Değiştirilirse eski bağışlar okunamaz.',
      type: 'Alan tipi',
      typeHint: 'Tip değişince kurallar, varsayılan değer ve seçenekler yeni tipe göre sıfırlanır.',
      typePublishedHint:
        'Bu alan yayında. Tipini değiştirmek kırıcı bir değişikliktir; onayınız istenir.',
      help: 'Yardım metni',
      placeholder: 'Yer tutucu',
      widthMd: 'Genişlik (masaüstü)',
      default: 'Varsayılan değer',
      noDefault: 'Varsayılan yok',
      required: 'Zorunlu alan',
      portalVisible: 'Portalda göster',
      adminOnly: 'Yalnızca yönetim panelinde',
      direction: 'Seçeneklerin yönü',
      variant: 'Görünüm',
    },
    typeChange: {
      title: 'Alan tipi değişecek',
      warning:
        '“{{key}}” yayımlanmış bir sürümde {{from}} olarak duruyor. {{to}} yapmak kırıcı bir değişikliktir: eski bağışlar kendi sürümlerinde {{from}} olarak okunmaya devam eder, bu alanın kuralları ve varsayılan değeri sıfırlanır. Yayınlamadan önce fark ekranında da uyarılırsınız.',
      confirm: 'Tipi değiştir',
    },
    width: {
      '12': 'Tam satır',
      '9': 'Dörtte üç',
      '8': 'Üçte iki',
      '6': 'Yarım satır',
      '4': 'Üçte bir',
      '3': 'Dörtte bir',
    },
    rule: {
      minLength: 'En az karakter',
      maxLength: 'En çok karakter',
      pattern: 'Desen (düzenli ifade)',
      min: 'En küçük değer',
      max: 'En büyük değer',
      step: 'Adım',
      integer: 'Yalnızca tam sayı',
      minDate: 'En erken tarih',
      maxDate: 'En geç tarih',
      minSelected: 'En az seçim',
      maxSelected: 'En çok seçim',
      accept: 'İzin verilen dosya türleri',
      maxSizeBytes: 'En büyük dosya boyutu (bayt)',
      maxCount: 'En çok dosya sayısı',
      mustBeTrue: 'İşaretlenmesi zorunlu',
      required: 'Zorunluluk',
      portalVisible: 'Portalda gösterim',
      adminOnly: 'Yalnızca yönetim',
    },
    option: {
      label: 'Seçenek etiketi',
      value: 'Kayıt değeri',
      publishedHint: 'Yayınlanmış değer; değiştirmek uyumsuz bir değişikliktir.',
      add: 'Seçenek ekle',
      remove: 'Seçeneği kaldır',
    },
    condition: {
      field: 'Şu alana göre göster',
      always: 'Her zaman göster',
      equals: 'Değeri şuna eşitse',
      checked: 'İşaretli',
      unchecked: 'İşaretsiz',
      noTargets: 'Koşul olarak kullanılabilecek başka bir alan yok.',
      isTarget:
        'Başka bir alanın görünürlüğü bu alana bağlı. Koşullar tek seviyeli olduğu için bu alan koşula bağlanamaz.',
    },
    preview: {
      title: 'Canlı önizleme',
      subtitle: 'Taslak form, doğrulama sunucuyla aynı kurallarla çalışır',
      viewingVersion: 'Sürüm {{version}} · salt okunur',
      backToDraft: 'Taslağa dön',
      mode: 'Önizleme kipi',
      edit: 'Doldur',
      readonly: 'Okuma',
      audience: 'Hedef kitle',
      admin: 'Yönetim',
      portal: 'Portal',
      valid: 'Önizleme formu geçerli',
    },
    history: {
      title: 'Sürüm geçmişi',
      subtitle: 'Her yayın değişmez bir sürüm olarak saklanır',
      version: 'Sürüm {{version}}',
      current: 'Güncel',
      viewing: 'Önizlemede',
      publishedBy: '{{date}} · {{name}}',
      system: 'Sistem',
      open: 'Önizlemede aç',
      noChanges: 'Değişiklik yok',
      empty: 'Henüz yayımlanmış sürüm yok',
      emptyHint: 'İlk yayından sonra sürümler burada listelenir.',
    },
    publish: {
      action: 'Yayınla',
      reviewTitle: 'Yayını gözden geçirin',
      newVersion: 'Bu yayın Sürüm {{previous}} yerine Sürüm {{version}} oluşturacak.',
      inPlace:
        'Kampanyanın tüm dönemleri taslakta olduğu için Sürüm {{version}} yerinde güncellenecek.',
      breakingWarning:
        'Bu yayın geriye dönük uyumsuz değişiklikler içeriyor. Önceki sürümle kaydedilmiş bağışlar kendi sürümleriyle okunmaya devam eder, ancak yeni bağışlar değişen kurallara uymak zorunda kalır.',
      noChanges: 'Yayımlanmış sürüme göre değişiklik yok; yine de yeni bir sürüm oluşturulur.',
      breaking: 'Uyumsuz değişiklikler',
      compatible: 'Uyumlu değişiklikler',
      breakingLabel: 'Uyumsuz',
      compatibleLabel: 'Uyumlu',
      confirm: 'Yayınla',
      confirmBreaking: 'Uyumsuz değişikliklerle yayınla',
      done: 'Form Sürüm {{version}} olarak yayımlandı',
      doneInPlace: 'Sürüm {{version}} yerinde güncellendi',
      rejected_one: 'Form yayımlanamadı: {{count}} alanda hata var',
      rejected_other: 'Form yayımlanamadı: {{count}} hata var',
    },
    stale: {
      title: 'Form siz düzenlerken değişti',
      content:
        'Bu formu açtıktan sonra başka biri yeni bir sürüm yayımladı. Güncel sürümü yükleyip değişikliklerinizi onun üzerinde yeniden yapmanız gerekiyor; yeniden yükleme kaydedilmemiş değişikliklerinizi siler.',
      reload: 'Güncel sürümü yükle',
      keep: 'Şimdilik kal',
    },
    leave: {
      title: 'Yayımlanmamış değişiklikler var',
      content: 'Bu sayfadan ayrılırsanız form üzerindeki değişiklikleriniz kaybolur.',
      confirm: 'Değişiklikleri at ve ayrıl',
      stay: 'Sayfada kal',
    },
    change: {
      field_added_required: '“{{field}}” zorunlu alan olarak eklendi',
      field_added_optional: '“{{field}}” isteğe bağlı alan olarak eklendi',
      field_removed: '“{{field}}” kaldırıldı',
      type_changed: '“{{field}}” türü değişti: {{from}} → {{to}}',
      rule_tightened: '“{{field}}”: {{rule}} sıkılaştırıldı ({{from}} → {{to}})',
      rule_loosened: '“{{field}}”: {{rule}} gevşetildi ({{from}} → {{to}})',
      option_removed: '“{{field}}”: “{{option}}” seçeneği kaldırıldı',
      option_added: '“{{field}}”: “{{option}}” seçeneği eklendi',
      option_label_changed: '“{{field}}”: “{{option}}” etiketi değişti ({{from}} → {{to}})',
      options_reordered: '“{{field}}”: seçeneklerin sırası değişti',
      visibility_changed: '“{{field}}” görünürlük koşulu değişti ({{from}} → {{to}})',
      portal_field_added_required:
        '“{{field}}” artık portalda görünüyor ve zorunlu: portaldan gelen her bağış bu alanı doldurmak zorunda',
      portal_field_added_optional:
        '“{{field}}” artık portalda görünüyor; doldurulması zorunlu değil',
      portal_field_removed:
        '“{{field}}” portalda görünmüyor; portaldan gelen bağışlarda bu alan artık toplanmayacak',
      label_changed: '“{{field}}” etiketi değişti: {{from}} → {{to}}',
      help_changed: '“{{field}}” yardım metni değişti',
      placeholder_changed: '“{{field}}” yer tutucusu değişti',
      width_changed: '“{{field}}” genişliği değişti ({{from}} → {{to}})',
      default_changed: '“{{field}}” varsayılan değeri değişti ({{from}} → {{to}})',
      audience_changed: '“{{field}}”: {{rule}} değişti ({{from}} → {{to}})',
      fields_reordered: 'Alanların sırası değişti',
      direction_changed: '“{{field}}” yönü değişti ({{from}} → {{to}})',
      variant_changed: '“{{field}}” görünümü değişti ({{from}} → {{to}})',
    },
    changeShort: {
      field_added_required: 'Zorunlu alan eklendi: {{field}}',
      field_added_optional: 'Alan eklendi: {{field}}',
      field_removed: 'Alan kaldırıldı: {{field}}',
      type_changed: 'Tür değişti: {{field}}',
      rule_tightened: 'Kural sıkılaştı: {{field}} · {{detail}}',
      rule_loosened: 'Kural gevşedi: {{field}} · {{detail}}',
      option_removed: 'Seçenek kaldırıldı: {{field}} · {{detail}}',
      option_added: 'Seçenek eklendi: {{field}} · {{detail}}',
      option_label_changed: 'Seçenek etiketi: {{field}} · {{detail}}',
      options_reordered: 'Seçenek sırası: {{field}}',
      visibility_changed: 'Görünürlük: {{field}}',
      portal_field_added_required: 'Portalda zorunlu alan: {{field}}',
      portal_field_added_optional: 'Portala açılan alan: {{field}}',
      portal_field_removed: 'Portaldan kaldırılan alan: {{field}}',
      label_changed: 'Etiket: {{field}}',
      help_changed: 'Yardım metni: {{field}}',
      placeholder_changed: 'Yer tutucu: {{field}}',
      width_changed: 'Genişlik: {{field}}',
      default_changed: 'Varsayılan değer: {{field}}',
      audience_changed: 'Hedef kitle: {{field}} · {{detail}}',
      fields_reordered: 'Alan sırası değişti',
      direction_changed: 'Yön: {{field}}',
      variant_changed: 'Görünüm: {{field}}',
    },
  },
  campaignPeriod: {
    title: 'Dönemler',
    subtitle: 'Her sezon kendi takvimi, fiyatları, hedefi ve yaşam döngüsüyle bir dönemdir.',
    picker: 'Dönem',
    season: 'Sezon',
    seasonYear: 'Sezon Yılı',
    noSeason: 'Sezonsuz',
    window: 'Takvim',
    startsAt: 'Başlangıç',
    endsAt: 'Bitiş',
    status: 'Durum',
    goal: 'Hedef',
    noGoal: 'Hedef yok',
    hasGoal: 'Bu dönemin bir bağış hedefi var',
    goalAmount: 'Hedef Tutarı',
    goalCurrency: 'Hedef Para Birimi',
    collected: 'Tahsil edilen',
    nothingCollected: 'Henüz tahsilat yok',
    selected: 'Seçili',
    outOfWindow: 'Takvim dışında',
    overflowPolicy: 'Hedef aşımı',
    portalVisibility: 'Portal görünürlüğü',
    showWhenClosed: 'Kapandıktan sonra portalda göster',
    acceptsBackdatedUntil: 'Geriye dönük kayıt son tarihi',
    new: 'Yeni Dönem',
    edit: 'Dönemi Düzenle',
    created: 'Dönem oluşturuldu',
    updated: 'Dönem güncellendi',
    empty: 'Bu kampanyanın dönemi yok',
    emptyHint: 'Yeni bir dönem oluşturun veya mevcut bir dönemi kopyalayın.',
    lockedFieldsNotice:
      'Dönem “{{status}}” durumunda olduğu için yalnızca açık bırakılan alanlar değiştirilebilir.',
    showPrices: 'Fiyatları göster',
    duplicate: 'Yeni sezona kopyala',
    duplicateTitle: '{{season}} dönemini kopyala',
    duplicateHint:
      'Yeni dönem taslak olarak açılır. Form şeması kopyalanmaz: tüm sezonlar kampanyanın tek formunu kullanır.',
    copyPrices: 'Fiyatları kopyala',
    copyAssignments: 'Görevlendirmeleri kopyala',
    priceIncreasePercent: 'Fiyat artışı (%)',
    priceIncreaseHint: 'Kopyalanan tutarlar bu oranda artırılır ve kuruşa yarım yukarı yuvarlanır.',
    duplicated:
      '{{season}} dönemi taslak olarak oluşturuldu: {{prices}} fiyat, {{assignments}} görevlendirme kopyalandı',
    transition: {
      active: 'Etkinleştir',
      paused: 'Duraklat',
      closed: 'Kapat',
    },
    transitionConfirm: {
      active:
        '“{{season}}” dönemi etkinleştirilecek. Takvimi içindeyse bağış almaya başlar ve menüde görünür.',
      paused: '“{{season}}” dönemi duraklatılacak. Bağış alınmaz, ilerleme görünmeye devam eder.',
      closed:
        '“{{season}}” dönemi kapatılacak. Kapanan dönem yeniden açılamaz; alınmış bağışlar yaşam döngüsüne devam eder.',
    },
    transitioned: 'Dönem durumu güncellendi: {{status}}',
    reopen: 'Yeniden aç',
    closedCannotReopen: 'Kapanan dönem yeniden açılamaz. Yeni sezon için dönemi kopyalayın.',
    backdatedHint: 'Boş bırakılırsa kapanıştan 7 gün sonrası kullanılır.',
    seasonInvalid: 'Sezon yılı 2000 ile 2100 arasında olmalıdır',
    windowInvalid: 'Bitiş, başlangıçtan sonra olmalıdır',
    percentInvalid: 'Oran 0 ile 1000 arasında olmalıdır',
    amountInvalid: 'Sıfırdan büyük bir tutar girin',
  },
  campaignPrice: {
    noCharge: 'Bu kampanya ücret almaz; dönemlerine fiyat tanımlanmaz.',
    title: 'Fiyatlar',
    subtitle: '{{season}} dönemi · {{mode}}',
    overrideTitle: 'Yurda Özel Fiyatlar',
    overrideSubtitle: '{{institution}} · {{season}} dönemi',
    overrideDialogTitle: '{{name}} fiyatları',
    overrideEmpty: 'Bu görevlendirmeye özel fiyat yok.',
    overrideEmptyHint:
      'Fiyat tanımlanmayan para birimlerinde dönemin kendi fiyatı geçerlidir. Yalnızca dönemin fiyatladığı para birimleri eklenebilir.',
    currency: 'Para Birimi',
    unitAmountMinor: 'Birim Fiyatı',
    unitAmountHint: 'Bir {{unit}} için tutar',
    minAmountMinor: 'En Az',
    maxAmountMinor: 'En Çok',
    suggestedAmountsMinor: 'Önerilen Tutarlar',
    suggestedHint: 'Tutarı yazıp Enter’a basın.',
    isDefault: 'Varsayılan',
    makeDefault: 'Varsayılan yap',
    defaultHint: 'Portal bu para birimiyle açılır. Her dönemde tam bir varsayılan fiyat vardır.',
    add: 'Fiyat Ekle',
    edit: 'Fiyatı Düzenle',
    remove: 'Fiyatı kaldır',
    confirmRemove:
      '{{currency}} fiyatı kaldırılacak. Bu dönemde {{currency}} ile bağış alınamayacak.',
    saved: 'Fiyat kaydedildi',
    removed: 'Fiyat kaldırıldı',
    empty: 'Bu dönemde fiyat yok',
    emptyHint: 'Fiyatı olmayan para birimi bağışta sunulmaz.',
    closedNotice: 'Kapanan dönemin fiyatları değiştirilemez.',
    unbounded: 'Sınırsız',
    noPeriod: 'Fiyatlarını görmek için bir dönem seçin.',
    unquoted: 'Kur yok',
    answers: 'Cevaplar',
    everyAnswer: 'Tüm cevaplar',
    addByAnswers: 'Cevaba Göre Fiyat Ekle',
    answerRequired: 'Bir cevap seçin',
    ticked: 'Evet',
    notTicked: 'Hayır',
    confirmRemoveAnswers:
      'Bu cevaplar için girilen {{currency}} fiyatı kaldırılacak. Bu cevapları veren bağışlar dönemin ya da yurdun kendi fiyatını alacak.',
    unquotedHint:
      '{{currency}} son TCMB bülteninde ({{date}}) yer almıyor. Bu para birimindeki bağışlar raporlarda TL’ye ve hedef para birimine çevrilmez.',
  },
  exchangeRateSource: {
    tcmb: 'TCMB',
    manual: 'Elle girilen',
  },
  exchangeRate: {
    title: 'Döviz Kurları',
    currency: 'Para Birimi',
    rateDate: 'Kur Günü',
    rateToBase: 'TL Karşılığı',
    source: 'Kaynak',
    sourceRef: 'Bülten No',
    fetchedAt: 'Kaydedildiği An',
    rateFrom: 'Başlangıç',
    rateTo: 'Bitiş',
    rateRange: 'Kur günü',
    empty: 'Kur kaydı yok',
    emptyHint: 'Filtreleri değiştirin ya da TCMB arşivinden geçmiş bültenleri doldurun.',
    actions: {
      create: 'Kur Gir',
      backfill: 'Arşivden Doldur',
      baseAmountBackfill: 'TL Karşılıklarını Doldur',
      supersede: 'Sonraki gün için düzeltme gir',
    },
    create: {
      title: 'Elle Kur Girişi',
      notice:
        'Yalnızca TCMB bülteni kullanılamadığında kullanın. Girilen kur değiştirilemez; bu güne ve para birimine ikinci bir elle kur girilemez.',
      rateHint: 'Bir birim için TL, en çok 8 ondalık basamak — örneğin 47,1234',
      invalidRate: 'Kur sıfırdan büyük ve en çok 8 ondalık basamaklı olmalı.',
      implausibleHigher:
        'Girdiğiniz kur, {{currency}} için bilinen son kurdan ({{date}}: {{rate}}) %{{percent}} yüksek. Ondalık ayırıcıyı ve günü kontrol edin; doğruysa kaydedebilirsiniz.',
      implausibleLower:
        'Girdiğiniz kur, {{currency}} için bilinen son kurdan ({{date}}: {{rate}}) %{{percent}} düşük. Ondalık ayırıcıyı ve günü kontrol edin; doğruysa kaydedebilirsiniz.',
      submit: 'Kuru Kaydet',
      created: 'Kur kaydedildi',
    },
    backfill: {
      title: 'TCMB Arşivinden Doldur',
      notice:
        'Aralıktaki her iş günü için TCMB arşivindeki bülten arka planda çekilir. Zaten kayıtlı günler atlanır; bülten yayımlanmayan günler boş kalır.',
      fromDate: 'Başlangıç günü',
      toDate: 'Bitiş günü',
      invalidRange: 'Aralık en çok 400 gün olmalı ve bitiş başlangıçtan önce olmamalı.',
      submit: 'Doldurmayı Başlat',
      requested: 'Doldurma isteği alındı; arka planda çalışacak.',
    },
    baseAmountBackfill: {
      title: 'Bağışlara TL Karşılığı İşle',
      notice:
        'Kur bulunmadığı için TL karşılığı boş kalan bağışlara, bağış gününden önceki son kur işlenir. Kuru olmayan para birimleri (PLN, CZK, BGN) boş kalır.',
      currency: 'Para birimi (isteğe bağlı)',
      anyCurrency: 'Tüm para birimleri',
      donatedFrom: 'Bağış günü başlangıç',
      donatedTo: 'Bağış günü bitiş',
      invalidRange: 'Bitiş günü başlangıçtan önce olamaz.',
      submit: 'İşlemeyi Başlat',
      requested: 'İstek alındı; arka planda çalışacak.',
    },
    csvFile: 'doviz-kurlari.csv',
  },
  campaignCapability: {
    title: 'Yurt filtreleme',
    subtitle: 'Bağış formunda hangi cevapların yurt listesini daralttığı',
    fields: 'Filtre alanları',
    fieldsHint:
      'En çok {{max}} alan seçilebilir. Bir yurt, seçilen her alanın cevabını yetkinlikleri arasında taşıyorsa bağış formunda listelenir.',
    noFields:
      'Kampanyanın yayımlanmış bir seçim, radyo veya çok seçimli alanı yok. Formu yayımladıktan sonra buradan filtre alanı seçebilirsiniz.',
    emptyMeansEvery:
      'Hiçbir alan seçilmedi: bağış formu dönemin bütün aktif görevlendirmelerini listeler.',
    staleKeys:
      'Seçili alanlardan biri yayımlanmış formda yok: {{keys}}. Kaydetmek için alanı yayımlayın veya seçimden çıkarın.',
    untaggableField:
      '“{{field}}” ({{fieldKey}}) filtre alanı olarak sunulmuyor: “{{option}}” seçenek değeri bir yetkinlik olamaz. Yetkinlik değerleri küçük harfle başlar ve yalnızca küçük harf, rakam ve alt çizgi içerir; bu alanı kullanmak için seçenek değerlerini form düzenleyicide buna göre değiştirip yayımlayın.',
    saved: 'Filtre alanları kaydedildi',
  },
  campaignGrouping: {
    title: 'Kesim gruplaması',
    subtitle: 'Bir hayvandaki hisselerin hangi cevaplarda aynı olması gerektiği',
    fields: 'Gruplama cevapları',
    fieldsHint:
      'Yurt her zaman aynı olmalıdır. Seçilen her cevap da aynı olmadıkça hisseler aynı hayvana düşmez. En fazla {{max}} alan.',
    noFields:
      'Kampanyanın yayımlanmış bir seçim, seçenek düğmesi veya onay kutusu alanı yok. Formu yayımladıktan sonra buradan seçebilirsiniz.',
    emptyMeansPlain:
      'Cevap seçilmedi: sıra, cevaplara bakılmadan her {{units}} hissede bir hayvan olarak okunur.',
    noUnits:
      'Bu kampanyada grup başına hisse sayısı yok; gruplama cevapları ancak hisse gruplayan bir kampanyada kullanılır.',
    staleKeys:
      'Seçili alanlardan bazıları yayımlanmış formda gruplamaya uygun değil: {{keys}}. Kaydetmek için bunları çıkarın.',
    saved: 'Kesim gruplaması kaydedildi',
  },
  campaignPriceFields: {
    title: 'Fiyatı belirleyen cevaplar',
    subtitle: 'Fiyatın hangi cevaplara göre değiştiği',
    fields: 'Fiyatı belirleyen alanlar',
    fieldsHint:
      'Dönemler sekmesinde bu cevapların her kombinasyonu için, dönemin ya da bir yurdun fiyatı girilebilir. Cevaba göre fiyatı olmayan bağış dönemin veya yurdun kendi fiyatını alır. En fazla {{max}} alan.',
    noFields:
      'Kampanyanın yayımlanmış bir seçim, seçenek düğmesi veya onay kutusu alanı yok. Formu yayımladıktan sonra buradan seçebilirsiniz.',
    emptyMeansUnconditional:
      'Alan seçilmedi: fiyat cevaplara göre değişmez; dönemin ve yurtların kendi fiyatları geçerlidir.',
    staleKeys:
      'Seçili alanlardan bazıları yayımlanmış formda fiyatı belirleyebilecek bir alan değil: {{keys}}. Kaydetmek için bunları çıkarın.',
    saved: 'Fiyatı belirleyen cevaplar kaydedildi',
  },
  campaignGroupSize: {
    title: 'Grup büyüklüğü',
    subtitle: 'Bir hayvanın kaç hisse olduğu, hayvanı belirleyen cevaba göre',
    field: 'Hayvanı belirleyen cevap',
    fieldHint:
      'Yalnızca kesim gruplamasında seçili seçim ve seçenek düğmesi alanları sunulur; böylece bir hayvan iki büyüklükte hisse taşımaz. Büyüklük girilmeyen cevap grup başına {{units}} hisse olarak gruplanır.',
    none: 'Yok: her grup aynı büyüklükte',
    sizeHint:
      'Boş bırakılırsa grup başına {{units}} hisse. Küçükbaş için 1 yazın: her hisse ayrı bir hayvandır.',
    sizeInvalid: '1 ile {{max}} arasında bir tam sayı girin.',
    noUnits:
      'Bu kampanyada grup başına hisse sayısı yok; grup büyüklüğü ancak hisse gruplayan bir kampanyada kullanılır.',
    noFields:
      'Kesim gruplamasında seçili bir seçim veya seçenek düğmesi alanı yok. Önce hayvanı belirleyen cevabı kesim gruplamasına ekleyin.',
    staleField:
      '“{{fieldKey}}” artık kesim gruplamasında seçili bir seçim alanı değil. Grup büyüklüğünü kaldırın veya alanı yeniden gruplamaya ekleyin.',
    saved: 'Grup büyüklüğü kaydedildi',
  },
  campaignReadiness: {
    title: 'Sıraya alma koşulu',
    subtitle: 'Hangi onay kutusu işaretliyse bağış Bekleyenler listesine düşer',
    field: 'Hazırlık alanı',
    none: 'Koşul yok',
    hint: 'Seçilen onay kutusu işaretli bağışlar Bekleyenler listesinde görünür; işaretli olmayan bağış Tümü sekmesinde “Koşul bekleniyor” işaretiyle durur ve gerçekleştirme sırasına alınamaz.',
    noneMeansEvery:
      'Koşul yok: bu kampanyanın bekleyen her bağışı Bekleyenler’de görünür ve sıraya alınabilir.',
    noFields:
      'Kampanyanın yayımlanmış bir onay kutusu yok. Formu yayımladıktan sonra buradan sıraya alma koşulu seçebilirsiniz.',
    staleKey:
      'Seçili alan yayımlanmış formda bir onay kutusu değil: {{fieldKey}}. Kaydetmek için alanı yayımlayın veya koşulu kaldırın.',
    saved: 'Sıraya alma koşulu kaydedildi',
  },
  campaignEntryLabels: {
    title: 'Giriş Formu Etiketleri',
    subtitle: 'Bu kampanyanın giriş formundaki bölüm başlıklarını ve taraf adlarını değiştirin',
    hint: 'Boş bırakılan alan varsayılan metni kullanır.',
    field: {
      sectionCampaign: '“Kampanya Detayları” başlığı',
      sectionParties: '“Taraf Bilgileri” başlığı',
      sectionNotifications: '“Bildirim İşlemleri” başlığı',
      partyPayer: '“Bağış Yapan” etiketi',
      partyOwner: '“Bağış Sahibi” etiketi',
      partyReference: '“Referans” etiketi',
    },
    saved: 'Etiketler kaydedildi',
  },
  /**
   * An organization's library of queue-printout templates and the editor that
   * lays one out — docs/plans/11-test-revisions.md §11.8, docs/decisions/0082.
   */
  campaignStaff: {
    title: 'Kampanya Görevlendirmeleri',
    subtitle: 'Bir kampanyayı hangi kurumda hangi kullanıcıların yürüttüğü',
    new: 'Görevlendirme Ekle',
    empty: 'Görevlendirme yok',
    emptyHint: 'Süzgeçleri değiştirin ya da yeni bir görevlendirme ekleyin.',
    csvFile: 'kampanya-gorevlendirmeleri',
    campaign: 'Kampanya',
    allCampaigns: 'Tüm kampanyalar',
    institution: 'Kurum',
    allInstitutions: 'Tüm kurumlar',
    institutions: 'Kurumlar',
    institutionsHint:
      'Kampanyayı aynı anda birden fazla kuruma görevlendirebilirsiniz. Her kurum için, hangi kuruma bağlı olursa olsun, görebildiğiniz herhangi bir kullanıcı seçilebilir.',
    users: 'Görevliler',
    usersOf: '{{institution}} görevlileri',
    noUsers: 'Görevli seçilmedi',
    status: 'Durum',
    window: 'Geçerlilik',
    startsAt: 'Başlangıç',
    endsAt: 'Bitiş',
    endsAtHint: 'Boş bırakılırsa görevlendirme süresizdir.',
    noEnd: 'Süresiz',
    createdBy: 'Görevlendiren',
    searchPlaceholder: 'Kampanya veya kurum ara',
    all: 'Tümü',
    states: {
      active: 'Aktif',
      scheduled: 'Başlamadı',
      ended: 'Süresi doldu',
      passive: 'Pasif',
    },
    statuses: {
      active: 'Aktif',
      passive: 'Pasif',
    },
    unstaffedTab: 'Görevli yok',
    staffMember: 'Görevli',
    allStaffMembers: 'Tüm görevliler',
    assignGap: 'Görevlendir',
    edit: 'Düzenle',
    activate: 'Aktif yap',
    deactivate: 'Pasife al',
    remove: 'Görevlendirmeyi kaldır',
    createTitle: 'Görevlendirme ekle',
    editTitle: '{{campaign}} — {{institution}}',
    addUser: 'Görevli ekle',
    userSearch: 'Ad veya e-posta yazın',
    notManageable: 'Sizde olmayan yetkilere sahip',
    alreadyChosen: 'Zaten seçildi',
    seatedAt: 'Kullanıcının kendi kurumu',
    inactiveUser: 'Pasif kullanıcı',
    removeUser: 'Görevliyi çıkar',
    roles: {
      primary: 'Birincil',
      backup: 'Yedek',
    },
    makePrimary: 'Birincil görevli yap',
    makeBackup: 'Yedek görevli yap',
    primaryHint:
      'Yıldızlı görevli birincildir: bir dönem, her aktif yurdunda birincil görevli olmadan aktifleştirilemez ve hedefe ulaşıldığında birinciller bilgilendirilir.',
    createdByMigration: 'Dönem sorumlularından aktarıldı',
    campaignRequired: 'Bir kampanya seçin',
    institutionsRequired: 'En az bir kurum seçin',
    institutionSearch: 'Kurum adı veya kodu yazın',
    created_one: '{{count}} görevlendirme eklendi',
    created_other: '{{count}} görevlendirme eklendi',
    updated: 'Görevlendirme güncellendi',
    removed: 'Görevlendirme kaldırıldı',
    removeTitle: 'Görevlendirmeyi kaldır',
    confirmRemove:
      '“{{campaign}}” kampanyasının “{{institution}}” görevlendirmesi kaldırılacak; görevliler bu kampanyadaki görevlerini kaybeder.',
    deactivateTitle: 'Görevlendirmeyi pasife al',
    confirmDeactivate:
      '“{{campaign}}” kampanyasının “{{institution}}” görevlendirmesi pasife alınacak; görevliler yeniden aktif yapılana kadar bu görevi yürütemez.',
    pendingWarning_one:
      'Bu kampanyanın bu kurumda gerçekleştirilmeyi bekleyen {{count}} bağışı var. Görevlendirme sona ererse bu bağışı buradaki görevliler üstlenemez.',
    pendingWarning_other:
      'Bu kampanyanın bu kurumda gerçekleştirilmeyi bekleyen {{count}} bağışı var. Görevlendirme sona ererse bu bağışları buradaki görevliler üstlenemez.',
    confirmPending: 'Bekleyen bağışları gördüm, yine de devam et',
    confirmPendingRequired: 'Devam etmek için bekleyen bağışları gördüğünüzü onaylayın.',
    impactLoading: 'Bekleyen bağışlar sayılıyor…',
  },
  myAssignments: {
    title: 'Görevlerim',
    subtitle: 'Hangi kurumda hangi kampanyada görevli olduğunuz',
    empty: 'Hiçbir kampanyada görevlendirilmediniz',
    emptyHint: 'Bir yönetici sizi bir kampanyada görevlendirdiğinde burada görünür.',
    campaign: 'Kampanya',
    institution: 'Kurum',
    state: 'Durum',
    window: 'Geçerlilik',
    assignedAt: 'Görevlendirildiği tarih',
  },
  printoutTemplate: {
    title: 'PDF Şablonları',
    new: 'Yeni Şablon',
    untitled: 'Adsız şablon',
    caption: 'Sıraya alma çıktısının blok düzeni',
    open: 'Aç',
    name: 'Şablon Adı',
    organization: 'Kuruluş',
    allOrganizations: 'Tüm kuruluşlar',
    organizationHint: 'Şablon yalnızca bu kuruluşun bağışlarının çıktısında kullanılır.',
    organizationFixed: 'Bir şablonun kuruluşu sonradan değiştirilemez.',
    searchPlaceholder: 'Şablon adı ara',
    blocks: 'Blok',
    campaigns: 'Kullanan Kampanya',
    updatedAt: 'Son Güncelleme',
    blockCount_one: '{{count}} blok',
    blockCount_other: '{{count}} blok',
    campaignCount_one: '{{count}} kampanya',
    campaignCount_other: '{{count}} kampanya',
    csvFile: 'pdf-sablonlari',
    empty: 'Şablon bulunamadı',
    emptyHint:
      'Yeni bir şablon oluşturun. Şablon seçilmemiş kampanyalar sabit çıktı düzenini kullanır.',
    notFound: 'Şablon bulunamadı ya da kuruluşu yetki alanınızın dışında.',
    created: 'Şablon oluşturuldu',
    saved: 'Şablon kaydedildi',
    deleted: 'Şablon silindi',
    deleteTitle: 'Şablonu sil',
    deleteConfirm:
      '“{{name}}” şablonu silinecek. Bir kampanya bu şablonu kullanıyorsa silme reddedilir.',
    settingsTitle: 'Şablon',
    settingsSubtitle: 'Adı, kuruluşu ve alan listesini sunan örnek kampanya',
    sampleCampaign: 'Alanların alınacağı kampanya',
    sampleCampaignHint:
      'Yalnızca form alanlarını seçmek içindir; şablonu hangi kampanyanın kullanacağı kampanyanın kendi ayarlarında seçilir.',
    noSampleCampaign: 'Kampanya seçilmedi',
    blocksTitle: 'Bloklar',
    blocksSubtitle_one: '{{count}} blok, yukarıdan aşağıya basılır',
    blocksSubtitle_other: '{{count}} blok, yukarıdan aşağıya basılır',
    blocksEmpty: 'Şablonda blok yok',
    blockLabel: 'Etiket',
    blockSize: 'Boyut',
    remove: 'Bloğu kaldır',
    requiredHint: 'Bağış kodu görünür kalmalıdır; QR kodu isteğe bağlıdır.',
    dragHandle: 'Sıralamak için sürükleyin',
    size: {
      small: 'Küçük',
      normal: 'Normal',
      large: 'Büyük',
    },
    badge: {
      field: 'Form alanı',
      builtIn: 'Hazır blok',
      required: 'Zorunlu',
      notOnSample: 'Bu kampanyanın formunda yok',
      notOnSampleHint:
        'Formunda bu alan olmayan bir bağışın çıktısında blok basılmaz; hata vermez.',
    },
    palette: {
      open: 'Blok ekle',
      close: 'Kapat',
      builtIns: 'Hazır bloklar',
      fields: 'Form alanları',
      allBuiltInsUsed: 'Tüm hazır bloklar şablonda.',
      pickCampaign: 'Form alanı eklemek için yukarıdan bir kampanya seçin.',
      noFields: 'Bu kampanyanın yayınlanmış formunda eklenecek alan kalmadı.',
    },
    builtIn: {
      logo: 'Kuruluş logosu',
      text: 'Serbest metin',
      qrCode: 'QR kodu',
      donationCode: 'Bağış kodu',
      campaign: 'Kampanya',
      season: 'Dönem',
      payer: 'Bağış Yapan',
      payerPhone: 'Bağış Yapan telefonu',
      owner: 'Bağış Sahibi',
      reference: 'Referans',
      yurt: 'Yurt',
      amount: 'Tutar',
      quantity: 'Adet / hisse',
      donatedAt: 'Bağış tarihi',
      queuePosition: 'Sıra no',
    },
    dnd: {
      instructions:
        'Bir bloğu taşımak için boşluk tuşuna basın, ok tuşlarıyla yerini değiştirin, bırakmak için yeniden boşluk tuşuna basın. Vazgeçmek için Esc tuşuna basın.',
      start: '“{{block}}” bloğu taşınmak üzere alındı.',
      over: '“{{block}}” bloğu {{position}}. sıranın üzerinde.',
      outside: '“{{block}}” bloğu listenin dışında.',
      end: '“{{block}}” bloğu {{position}}. sıraya bırakıldı.',
      cancel: '“{{block}}” bloğunun taşınmasından vazgeçildi.',
    },
    controls: {
      pageTitle: 'Sayfa ve Genel Ayarlar',
      pageSize: 'Sayfa boyutu',
      orientation: 'Sayfa yönü',
      widthMm: 'Genişlik (mm)',
      heightMm: 'Yükseklik (mm)',
      margintop: 'Üst kenar boşluğu (mm)',
      marginright: 'Sağ kenar boşluğu (mm)',
      marginbottom: 'Alt kenar boşluğu (mm)',
      marginleft: 'Sol kenar boşluğu (mm)',
      columns: 'Izgara sütun sayısı',
      gap: 'Blok aralığı (pt)',
      backgroundColor: 'Arka plan rengi',
      color: 'Yazı rengi',
      showHeader: 'Anteti göster',
      showSignature: 'İmza alanını göster',
      watermark: 'Filigran / antet görseli',
      watermarkOpacity: 'Filigran opaklığı (0–1)',
      visible: 'Bloğu göster',
      labelVisible: 'Etiketi göster',
      labelPosition: 'Etiket konumu',
      solidBackground: 'Düz arka plan rengi kullan',
      valueStyle: 'Değer biçimi',
      labelStyle: 'Etiket biçimi',
      fontFamily: 'Yazı tipi',
      fontSize: 'Yazı boyutu (pt)',
      fontWeight: 'Yazı kalınlığı',
      lineHeight: 'Satır aralığı',
      align: 'Hizalama',
      keepAspectRatio: 'Görselin en-boy oranını koru',
      text: 'Sabit açıklama metni',
      qrSize: 'QR boyutu (pt)',
      qrEcc: 'QR hata düzeltme seviyesi',
      layout: 'Konum ve Boşluklar',
      position: 'Konumlandırma',
      columnSpan: 'Kapladığı sütun',
      x: 'X konumu (pt)',
      y: 'Y konumu (pt)',
      width: 'Blok genişliği (pt)',
      height: 'Blok yüksekliği (pt)',
      padding: 'İç boşluk',
      margin: 'Dış boşluk',
      spacingUnit: 'Boşluk birimi',
      zIndex: 'Katman sırası',
      edit: 'Biçim ve konum',
      close: 'Ayarları kapat',
      ocrHint:
        'Bağış kodunu en az 18 pt ve 7:1 kontrastla kullanın. Filigran varsa koda düz, yüksek kontrastlı bir arka plan seçin. Fotoğraftan OCR başarısı ayrıca ölçülmelidir.',
    },
    options: {
      A4: 'A4',
      A5: 'A5',
      thermal: 'Termal (80 mm)',
      custom: 'Özel boyut',
      portrait: 'Dikey',
      landscape: 'Yatay',
      sans: 'Noto Sans',
      mono: 'Noto Sans Mono',
      regular: 'Normal',
      medium: 'Orta',
      bold: 'Kalın',
      left: 'Sola',
      center: 'Ortaya',
      right: 'Sağa',
      justify: 'İki yana yasla',
      above: 'Üstte',
      inline: 'Yanda',
      grid: 'Izgara',
      absolute: 'Serbest X/Y',
      pt: 'Punto (pt)',
      '%': 'Yüzde (%)',
      L: 'L · %7',
      M: 'M · %15',
      Q: 'Q · %25',
      H: 'H · %30',
    },
    media: {
      select: 'Medya kütüphanesi',
      none: 'Görsel yok',
      selected: 'Seçili görsel',
      chooseFile: 'Dosya seç',
      upload: 'Görseli yükle',
      hint: 'PNG / JPEG, en fazla 5 MB. Yalnızca güvenlik taraması tamamlanan görseller seçilebilir.',
      empty: 'Bu kuruluşun medya kütüphanesinde görsel yok.',
      failed: 'Medya kütüphanesi yüklenemedi.',
      pickOrganization: 'Görsel seçmek için önce kuruluş seçin.',
      uploaded: 'Görsel yüklendi. Güvenlik taraması tamamlandığında kütüphaneden seçebilirsiniz.',
      status: {
        pending: 'Taranıyor',
        clean: 'Kullanılabilir',
        infected: 'Zararlı dosya',
        failed: 'Tarama başarısız',
      },
    },
    preview: {
      title: 'Önizleme',
      subtitle:
        'Örnek verilerle ölçekli düzen. Kesin yazı ölçüleri ve QR için PDF test çıktısını açın.',
      testPdf: 'PDF Test Çıktısı Al',
      generating: 'Test PDF dosyası hazırlanıyor…',
      failed:
        'Test çıktısı hazırlanamadı. Yeniden deneyin; geciken dosyaları Oluşturulan Dosyalar sayfasından açabilirsiniz.',
      timeout:
        'Test PDF dosyasının hazırlanması uzadı. Dosyalarım sayfasından durumunu izleyebilirsiniz.',
      popupBlocked:
        'Tarayıcı yeni sekmeyi engelledi. Test çıktısını Oluşturulan Dosyalar sayfasından açabilirsiniz.',
      instructions: 'Saha personeli için örnek açıklama',
      organization: 'Kuruluş adı',
      institution: 'Kayıt yeri',
      printedAt: 'Çıktı tarihi: …',
      code: 'BT-7K2M-9QXQ',
      value: 'Örnek değer',
    },
  },
  campaignOwnInstitution: {
    title: 'Kendi Kurumum',
    subtitle: 'Bağış formundaki yurt listesinde kaydı giren kullanıcının kendi kurumu',
    offered: 'Bağış formunda “Kendi Kurumum” seçeneğini göster',
    hintOn:
      'Açıkken yurt listesinin başında, kaydı giren kullanıcının kurumu “Kendi Kurumum” olarak yer alır. Kurum bu dönemde görevlendirilmişse o yurdun fiyatı, değilse dönemin fiyatı uygulanır.',
    hintOff:
      'Kapalıyken “Kendi Kurumum” seçeneği gösterilmez; yalnızca görevlendirilmiş yurtlar seçilebilir.',
    capabilityNote:
      'Bu kampanyada yurt, cevaplara göre seçildiği için kendi kurum yalnızca bu dönemde görevlendirilmişse seçilebilir.',
    saved: '“Kendi Kurumum” ayarı kaydedildi',
  },
  campaignPrintoutTemplate: {
    title: 'Sıraya Alma Çıktısı',
    subtitle: 'Bu kampanyanın bağış çıktısının hangi PDF şablonuyla basılacağı',
    template: 'PDF şablonu',
    hint: 'Şablon yalnızca kendi kuruluşunun bağışlarına uygulanır; diğer bağışlar sabit düzenle basılır.',
    fixedLayout: 'Sabit düzen (varsayılan)',
    outOfReach: 'Yetki alanınız dışındaki bir kuruluşun şablonu',
    option: '{{name}} · {{organization}}',
    manage: 'PDF şablonlarını yönet',
    saved: 'Çıktı şablonu kaydedildi',
  },
  campaignAssignment: {
    title: 'Görevlendirme',
    subtitle: '{{season}} dönemini sahada yürüten yurtlar ve görevlileri',
    noPeriod: 'Görevlendirmeleri görmek için bir dönem seçin.',
    institution: 'Kurum',
    staff: 'Görevliler',
    unstaffed: 'Görevli yok',
    manageStaff: 'Görevlileri yönet',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    override: 'Özel ad',
    noPrimary: 'Birincil görevli yok',
    add: 'Kurum Görevlendir',
    copy: 'Önceki dönemden kopyala',
    empty: 'Bu dönemde görevlendirme yok',
    emptyHint:
      'Görevlendirme yalnızca saha yürütmesini belirler; görevlendirmesi olmayan bir dönem de bağış toplayabilir.',
    gateNotice:
      'Dönem taslaktan çıkmadan önce her aktif yurdun, aktif bir kampanya görevlendirmesinde aktif bir birincil görevlisi olmalıdır. Görevliler kampanyanın tüm dönemleri için Kampanya Görevlendirmeleri ekranında atanır.',
    closedNotice: 'Kapanan dönemin görevlendirmeleri değiştirilemez.',
    displayName: 'Kampanyada görünen ad',
    displayNameHint: 'Boş bırakılırsa kurumun kendi adı görünür.',
    rename: 'Görünen adı düzenle',
    editCapabilities: 'Yetkinlikleri düzenle',
    editPrices: 'Fiyatları düzenle',
    editSettings: 'Form ve birim masraf',
    settingsTitle: '{{name}} — form ve birim masraf',
    formAndCost: 'Form / birim masraf',
    showOnForm: 'Formda göster',
    showOnFormHint:
      'Bağış formları ve içe aktarma şablonu bu yurdu, işin yapılacağı yer olarak listeler.',
    hiddenOnFormHint:
      'Bağış formları ve içe aktarma şablonu bu yurdu listelemez; yurdu zaten seçmiş bağışlar geçerli kalır ve PDF listelerinde yürütücü olarak seçilebilir.',
    shownOnForm: 'Formda görünür',
    hiddenOnForm: 'Formda gizli',
    unitCost: 'Birim masraf',
    unitCostCurrency: 'Para birimi',
    unitCostHint:
      'Bir birim iş (hisse) gerçekleştiğinde bu kuruma hakediş olarak yazılır. Boş bırakılırsa kayıt düşmez.',
    unitCostInvalid: 'Sıfırdan büyük bir tutar girin (en fazla iki ondalık).',
    unitCostValue: 'Birim masraf: {{amount}}',
    noUnitCost: 'Birim masraf yok',
    activate: 'Aktif yap',
    deactivate: 'Pasife al',
    remove: 'Görevlendirmeyi kaldır',
    confirmRemove:
      '“{{name}}” bu dönemin görevlendirmelerinden kaldırılacak. Kampanyanın bu kurumdaki görevlileri kalır.',
    created: 'Kurum görevlendirildi',
    updated: 'Görevlendirme güncellendi',
    removed: 'Görevlendirme kaldırıldı',
    capabilities: 'Yetkinlikler',
    noCapabilities: 'Yetkinlik işaretlenmedi',
    capabilitiesTitle: '{{name}} — yetkinlikler',
    capabilitiesHint:
      'Bu yurdun yürütebildiklerini işaretleyin. Seçenekler kampanyanın kendi form alanlarından gelir; bağış formunda yalnızca cevaplara uyan yurtlar listelenir.',
    capabilitiesSaved: 'Yetkinlikler kaydedildi',
    capabilitiesNoFields:
      'Kampanyanın yayımlanmış bir seçim alanı yok. Önce formu yayımlayın; yetkinlikler o alanların seçeneklerinden gelir.',
    capabilitiesUnused:
      'Bu kampanya hiçbir filtre alanı seçmedi, bu yüzden yetkinlikler bağış formunu daraltmıyor. Kampanya sekmesinden filtre alanlarını seçin.',
    institutionSearch: 'Kurum adı veya kodu yazın',
    alreadyAssigned: 'Zaten görevlendirildi',
    institutionRequired: 'Görevlendirilecek kurumu seçin',
    copyTitle: 'Görevlendirmeleri kopyala',
    copyHint:
      'Seçilen dönemdeki kurumlar görünen adlarıyla bu döneme eklenir; görevliler kampanyaya bağlı olduğu için yeni dönemde de aynen görünür. Bu dönemde zaten görevli olan kurumlar atlanır.',
    sourcePeriod: 'Kaynak dönem',
    copied: '{{assignments}} görevlendirme kopyalandı; {{skipped}} kurum zaten görevliydi.',
    noOtherPeriod: 'Bu kampanyanın kopyalanabilecek başka dönemi yok.',
  },
  campaignGoal: {
    title: 'Hedef',
    subtitle: '{{season}} dönemi',
    progressTitle: 'İlerleme',
    progressSubtitle: 'Tahsil edilen hedefe karşı; girilen açık renkte',
    saved: 'Hedef kaydedildi',
    lockedNotice: 'Dönem “{{status}}” durumunda olduğu için hedef ve hedef aşımı değiştirilemez.',
    thresholdHint: 'Hedefe ulaşma, tahsil edilen değil girilen tutara göre ölçülür.',
    recompute: 'Yeniden hesapla',
    recomputeUnchanged: 'Toplamlar bağış kayıtlarıyla uyumlu; değişiklik yapılmadı.',
    recomputeDrift_one:
      '{{count}} para biriminde sapma bulundu ve düzeltildi. Düzeltme işlem geçmişine yazıldı.',
    recomputeDrift_other:
      '{{count}} para biriminde sapma bulundu ve düzeltildi. Düzeltme işlem geçmişine yazıldı.',
    noPeriod: 'Hedefi görmek için bir dönem seçin.',
  },
  campaignProgress: {
    collectedShare: 'Hedefin tahsil edilen kısmı',
    goal: 'Hedef',
    pledged: 'Girilen',
    collected: 'Tahsil edilen',
    fulfillmentCost: 'Harcanan',
    remaining: 'Kalan',
    overGoal: 'Hedef aşımı',
    reached: 'Hedefe ulaşıldı',
    pledgedHint: 'Açık renkli çubuk girilen tutardır: hedefin {{percent}}',
    donationCount: 'Bağış',
    currency: 'Para birimi',
    byCurrency: 'Para birimine göre',
    noGoal: 'Bu dönemin hedefi yok; tutarlar para birimine göre gösterilir.',
    noTotals: 'Bu dönem için henüz toplam oluşmadı.',
    unconverted:
      '{{currencies}} tutarları hedef para birimine çevrilmedi ve orana dahil değil: kur kaynağı henüz tanımlı değil.',
    convertedAt: '{{date}} tarihli güncel kurla çevrildi',
  },
  campaignOverflowPolicy: {
    allow: 'Toplamaya devam et',
    stop: 'Hedefe ulaşınca duraklat',
    redirect: 'Başka döneme aktar',
    redirectDisabled:
      'Hukuki değerlendirme bekliyor: bağışçının seçmediği bir amaca aktarım için onayı gerekir.',
  },
  campaignPortalVisibility: {
    public: 'Herkese açık',
    unlisted: 'Yalnızca bağlantıyla',
    internal: 'Yalnızca iç kullanım',
  },
  campaignPeriodStatus: {
    draft: 'Taslak',
    active: 'Aktif',
    paused: 'Duraklatıldı',
    closed: 'Kapandı',
  },
  campaignPricingMode: {
    free: 'Serbest tutar',
    suggested: 'Önerilen tutarlar',
    unit: 'Birim fiyatı',
    no_charge: 'Ücret alınmaz',
  },
  campaignCollectionScope: {
    owner_subtree: 'Sahiplik kapsamındaki tüm kurumlar',
    assigned_only: 'Yalnızca görevlendirilen kurumlar',
  },
  permission: {
    title: 'Yetkiler',
    resource: {
      donation: 'Bağışlar',
      donationBox: 'Kumbaralar',
      inboundMedia: 'Gelen Medya',
      donor: 'Bağışçılar',
      campaign: 'Kampanya Yönetimi',
      campaignCategory: 'Kampanya Kategorisi Yönetimi',
      campaignStaff: 'Kampanya Görevlendirmeleri',
      pledge: 'Taahhütler',
      statement: 'Hesap Hareketleri',
      reconciliation: 'Mutabakat',
      manualPayment: 'Elle Ödeme Kaydı',
      receipt: 'Makbuzlar',
      refund: 'İadeler',
      fundTransfer: 'Fon Transferleri',
      institutionVault: 'Kurum Kasaları',
      exchangeRate: 'Döviz Kurları',
      finance: 'Finans',
      organization: 'Kuruluşlar',
      orgUnit: 'Organizasyon Birimleri',
      user: 'Kullanıcılar',
      role: 'Roller',
      pseudonym: 'Rumuzlar',
      report: 'Raporlar',
      auditLog: 'Denetim İzi',
      jobs: 'Arka Plan İşleri',
      notification: 'Bildirimler',
      integration: 'Entegrasyonlar',
      menu: 'Menü Görünürlüğü',
    },
    action: {
      list: 'Listeleme',
      view: 'Görüntüleme',
      create: 'Oluşturma',
      edit: 'Düzenleme',
      editQueued: 'Sıradaki bağışı düzeltme',
      editLocked: 'Kilitli bağışları düzenleme',
      setMainOrganization: 'Bağışın ana kuruluşunu değiştirme',
      settings: 'Ayarları yönetme',
      backdate: 'Geçmiş tarihli giriş',
      recordForOperator: 'Başka operatör adına kayıt',
      lendAccount: 'Hesabını başka kuruluşa açma',
      delete: 'Silme',
      viewDeleted: 'Silinen kayıtları görüntüleme',
      restore: 'Geri alma',
      approve: 'Onaylama',
      queue: 'Sıraya alma',
      fulfill: 'Gerçekleştirme',
      unfulfill: 'Gerçekleşti işaretini geri alma',
      print: 'Yazdırma',
      voidPrintout: 'PDF listesini iptal etme',
      viewAllPrintoutLists: 'Tüm PDF listelerini görüntüleme',
      export: 'Dışa aktarma',
      merge: 'Birleştirme',
      erase: 'Kişisel verileri silme',
      activate: 'Etkinleştirme',
      assign: 'Atama',
      cancel: 'İptal etme',
      collect: 'Boşaltma',
      import: 'İçe aktarma',
      match: 'Eşleştirme',
      unmatch: 'Eşleştirmeyi kaldırma',
      reverse: 'Ters kayıt',
      issue: 'Kesme',
      void: 'İptal etme',
      download: 'İndirme',
      request: 'Talep etme',
      complete: 'Tamamlama',
      backfill: 'Geriye dönük doldurma',
      deactivate: 'Pasife alma',
      manageRoles: 'Rol ve kapsam atama',
      impersonate: 'Kullanıcıyı taklit etme',
      resetTwoFactor: 'İki adımlı doğrulamayı sıfırlama',
      reveal: 'Rumuzları çözme',
      archive: 'Arşivleme',
      manage: 'Yönetme',
      record: 'Kaydetme',
      outflow: 'Kasadan çıkış kaydetme ve geri alma',
      dashboard: 'Genel Bakış menüsü',
      gallery: 'Bileşen Galerisi menüsü',
      operationCampaigns: 'Operasyon kampanyaları menüsü',
      printoutLists: 'PDF Yönetimi menüsü',
      inboundMedia: 'Gelen Medya menüsü',
      donations: 'Bağışlar menüsü',
      donationCampaigns: 'Kampanya bağış listeleri menüsü',
      deletedDonations: 'Silinen Kayıtlar menüsü',
      donationImports: 'Veri Yükleme menüsü',
      donationBoxes: 'Kumbaralar menüsü',
      donors: 'Bağışçılar menüsü',
      campaigns: 'Kampanyalar menüsü',
      campaignCategories: 'Kampanya Kategorileri menüsü',
      printoutTemplates: 'PDF Şablonları menüsü',
      campaignStaff: 'Kampanya Görevlendirmeleri menüsü',
      pledges: 'Düzenli Bağışlar menüsü',
      financeGuide: 'Muhasebe Kılavuzu menüsü',
      statementImports: 'Ekstreler menüsü',
      statementProfiles: 'Ekstre Formatları menüsü',
      accountTransactions: 'Hesap Hareketleri menüsü',
      reconciliation: 'Mutabakat menüsü',
      reconciliationApprovals: 'Onay Bekleyen Eşleştirmeler menüsü',
      shortfalls: 'Eksik Tahsilatlar menüsü',
      payouts: 'Kart Ödemeleri menüsü',
      refunds: 'İadeler menüsü',
      fundTransfers: 'Fon Transferleri menüsü',
      institutionLedger: 'Kurum Cari Hesapları menüsü',
      balances: 'Bakiyeler menüsü',
      consolidation: 'Konsolidasyon menüsü',
      receipts: 'Makbuzlar menüsü',
      annualCertificates: 'Yıllık Bağış Özetleri menüsü',
      exchangeRates: 'Döviz Kurları menüsü',
      regions: 'Bölgeler menüsü',
      zones: 'Mıntıkalar menüsü',
      countries: 'Ülkeler menüsü',
      institutions: 'Kurumlar menüsü',
      organizations: 'Kuruluşlar menüsü',
      users: 'Kullanıcılar menüsü',
      roles: 'Roller menüsü',
      generatedFiles: 'Dosyalarım menüsü',
      reports: 'Raporlar menüsü',
      auditLog: 'Denetim İzi menüsü',
      jobFailures: 'Başarısız İşler menüsü',
      integrations: 'Entegrasyonlar menüsü',
      scheduledRuns: 'Zamanlanmış Çalışmalar menüsü',
      notifications: 'Bildirim Gönderimleri menüsü',
    },
  },
  audit: {
    title: 'Denetim İzi',
    subtitle: 'Kimin neyi ne zaman değiştirdiğinin değiştirilemez kaydı',
    when: 'Zaman',
    who: 'Kullanıcı',
    entity: 'Varlık',
    action: 'İşlem',
    ip: 'IP',
    changes: 'Değişiklikler',
    before: 'Önce',
    after: 'Sonra',
    system: 'Sistem',
    systemActors: {
      jobAttachmentScan: 'Yüklenen dosyanın virüs taraması',
      jobCampaignTotalsRecompute: 'Toplamların gece yeniden hesaplanması',
      jobExchangeRatesFetch: 'TCMB kur bülteninin günlük çekilmesi',
      jobDonationBaseAmountsBackfill: 'Bağışlara TL karşılığının geriye dönük işlenmesi',
      jobReceiptRender: 'Makbuz PDF’inin hazırlanması',
      jobGeneratedFilesExpire: 'Oluşturulan dosyaların saklama süresi sonunda silinmesi',
      jobInboundMediaDecode: 'Gelen medyanın otomatik okunması',
      jobInboundMediaExpire: 'Gelen medya dosyalarının saklama süresi sonunda silinmesi',
      jobProviderMovementsSync: 'Ödeme sağlayıcısı hesap hareketlerinin otomatik aktarılması',
      jobAccountTransactionEquivalentsFill:
        'Hesap hareketlerinin TL, USD ve EUR karşılıklarının işlenmesi',
      jobPaymentCredentialsReseal: 'Ödeme anahtarlarının yeni ana anahtarla yeniden mühürlenmesi',
      jobPaymentLinkExpire: 'Süresi dolmuş ödeme bağlantılarının kapatılması',
      jobCampaignStaffRoleSync: 'Operasyon Sorumlusu rolünün görevlendirmelerle eşitlenmesi',
      jobPaymentChargePledge: 'Düzenli bağışın dönemlik tahsilatı',
      jobPaymentRecordMandate: 'Kayıtlı ödeme yönteminin sağlayıcıdan okunması',
      jobPaymentRevokeMandate: 'Kayıtlı ödeme yönteminin sağlayıcıda iptal edilmesi',
      jobStatementImportExpire: 'Ekstre dosyalarının saklama süresi sonunda silinmesi',
      jobPaymentSlipExpire: 'Ödeme dekontlarının saklama süresi sonunda silinmesi',
      jobDonationAttachmentExpire: 'Bağış eklerinin saklama süresi sonunda silinmesi',
      jobDonationImportExpire:
        'Bağış aktarımı dosyasının ve satır verilerinin saklama süresi sonunda silinmesi',
      jobFormFileExpire: 'Kampanya form dosyalarının saklama süresi sonunda silinmesi',
      jobGeneratedFilesPurge: 'Saklama süresi dolan dosya kayıtlarının silinmesi',
      jobOutboxPurge: 'Saklama süresi dolan yeniden gönderim kayıtlarının silinmesi',
      jobAuditLogExpirePayloads:
        'Denetim kayıtlarındaki verilerin saklama süresi sonunda boşaltılması',
      portalAccount: 'Bağışçı hesabı (bağış sitesi)',
      portalCheckout: 'Bağış sitesi sepeti',
      portalEvidence: 'Bağış sitesi kanıt bağlantısı',
      scriptOrganizationActivation: 'Yetkili kurum aktifleştirme işlemi',
      scriptPhoneBackfill: 'Telefon numaralarının E.164 biçimine geriye dönük işlenmesi',
      webhookNestpay: 'Sanal POS (NestPay) ödeme bildirimi',
      webhookPaypal: 'PayPal ödeme bildirimi',
      webhookStripe: 'Stripe ödeme bildirimi',
      webhookTelegram: 'Telegram medya bildirimi',
      webhookTwilio: 'WhatsApp (Twilio) medya bildirimi',
      migration0110: 'Bağış durumlarının sadeleştirilmesi (veri taşıma)',
      migration0168: 'Onaylı eşleştirmelerin kurum carisine işlenmesi (veri taşıma)',
      migration0169: 'Kuruluşların tek ülkeli kurumlarından konuma yerleştirilmesi (veri taşıma)',
      migration0176: 'Her kuruma nakit kasasının açılması (veri taşıma)',
    },
    entityId: 'Kayıt No',
    allEntities: 'Tüm varlıklar',
    allActions: 'Tüm işlemler',
    empty: 'Denetim kaydı bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi deneyin.',
    immutable: 'Bu kayıtlar değiştirilemez ve silinemez.',
    exportAll: 'Tümünü Dışa Aktar',
    history: 'Değişiklik Geçmişi',
    historyEmpty: 'Bu kayıt için denetim izi yok',
    historyHint: 'Kaydın oluşturulmasından bu yana yapılan her değişiklik burada listelenir.',
    entities: {
      session: 'Oturum',
      user: 'Kullanıcı',
      role: 'Rol',
      authorization: 'Yetkilendirme',
      institution: 'Kurum',
      institutionLedgerPosting: 'Kurumlar arası cari kayıt',
      institutionVault: 'Kurum Kasası',
      institutionVaultOutflow: 'Kasadan Çıkış',
      institutionTransfer: 'Kuruluştan Kuruma Aktarım',
      region: 'Bölge',
      zone: 'Mıntıka',
      country: 'Ülke',
      organization: 'Kuruluş',
      organizationAccount: 'Kuruluş Hesabı',
      organizationNotificationSender: 'Kuruluş Gönderim Hesabı',
      organizationPaymentCredential: 'Kuruluş Ödeme Anahtarı',
      generatedFile: 'Oluşturulan Dosya',
      campaign: 'Kampanya',
      // Bir dönemin hangi yurtta yürütüleceği (0068/0069); kurumun görevlileri
      // `campaignStaffAssignment`'dır — docs/decisions/0089.
      campaignAssignment: 'Dönem Görevlendirmesi',
      campaignStaffAssignment: 'Kampanya Görevlendirmesi',
      campaignCategory: 'Kampanya Kategorisi',
      campaignFormFile: 'Kampanya form dosyası',
      campaignFormSchema: 'Kampanya Formu',
      campaignPeriod: 'Kampanya Dönemi',
      campaignPeriodPrice: 'Dönem Fiyatı',
      donor: 'Bağışçı',
      donorChannelConsent: 'Bağışçı İletişim İzni',
      donorPrivacyRequest: 'Bağışçı Veri Talebi',
      donorErasure: 'Bağışçı Verisi Silme',
      donorSession: 'Bağışçı Oturumu',
      donation: 'Bağış',
      donationBox: 'Kumbara',
      donationBoxSetting: 'Kumbara Kampanyası',
      donationImport: 'Bağış Aktarımı',
      bulkChange: 'Toplu İşlem',
      // These five modules were retired on 2026-09-22 and their tables
      // dropped, but `audit_logs` is append-only, so the trail still names
      // them and `translations.test.ts` still demands their labels —
      // docs/decisions/0066.
      monthlyTarget: 'Aylık Hedef',
      marketingBudget: 'Reklam Bütçesi',
      contactLog: 'Görüşme Kaydı',
      product: 'Ürün',
      merchandiseOrder: 'Ürün Siparişi',
      statementImport: 'Ekstre İçe Aktarımı',
      statementProfile: 'Ekstre Profili',
      accountTransaction: 'Hesap Hareketi',
      reconciliation: 'Mutabakat',
      reconciliationSetting: 'Mutabakat Ayarı',
      receipt: 'Makbuz',
      exchangeRate: 'Döviz Kuru',
      refund: 'İade',
      fundTransfer: 'Fon Transferi',
      paymentLink: 'Ödeme Bağlantısı',
      paymentMandate: 'Kayıtlı Ödeme Yöntemi',
      pledge: 'Düzenli Bağış',
      payoutReconciliation: 'Hakediş Mutabakatı',
      manualPaymentClearing: 'Elle Ödemenin Banka Hareketi',
      portalOrder: 'Bağış Sitesi Siparişi',
      printoutTemplate: 'Çıktı Şablonu',
      printoutTemplateMedia: 'Çıktı şablonu görseli',
      printoutList: 'PDF Listesi',
      inboundMedia: 'Gelen Medya',
      inboundMediaReceipt: 'Gelen Medya Teslimi',
      jobFailure: 'Başarısız İş',
      outboxRedispatch: 'Yeniden Gönderim Kaydı',
      scheduledJob: 'Zamanlanmış İş',
      auditLog: 'Denetim Kaydı',
      integrationClient: 'Entegrasyon İstemcisi',
    },
    actions: {
      retry: 'Yeniden deneme',
      dismiss: 'Kapatma',
      run_now: 'Elle çalıştırma',
      secret_rotated: 'İmza anahtarı yenileme',
      login: 'Giriş',
      logout: 'Çıkış',
      login_failed: 'Başarısız giriş',
      impersonation_request: 'Taklit oturumu işlem isteği',
      impersonation_started: 'Kullanıcı taklidi başlatıldı',
      impersonation_ended: 'Kullanıcı taklidi sonlandırıldı',
      login_blocked_locked: 'Kilitli hesap denemesi',
      permission_denied: 'Yetki reddedildi',
      personal_data_read: 'Kişisel veri okundu',
      collect: 'Boşaltma',
      confirm: 'Bağışa dönüştürme',
      consent_granted: 'İletişim izni verildi',
      consent_withdrawn: 'İletişim izni geri alındı',
      operator_changed: 'Kayıt bilgisi güncellendi',
      password_reset_requested: 'Parola sıfırlama istendi',
      password_reset_completed: 'Parola sıfırlandı',
      password_changed: 'Parola değiştirildi',
      email_change_requested: 'E-posta değişikliği istendi',
      email_changed: 'E-posta adresi değiştirildi',
      reauthentication_failed: 'Hatalı parola doğrulaması',
      two_factor_enabled: 'İki adımlı doğrulama açıldı',
      two_factor_disabled: 'İki adımlı doğrulama kapatıldı',
      two_factor_failed: 'Başarısız iki adımlı doğrulama',
      two_factor_reenrolled: 'İki adımlı doğrulama yeniden kuruldu',
      pseudonyms_revealed: 'Rumuzlar çözüldü',
      pseudonym_reveal_failed: 'Rumuz çözme başarısız',
      pseudonyms_hidden: 'Rumuzlar gizlendi',
      two_factor_reset: 'İki adımlı doğrulama sıfırlandı',
      recovery_code_used: 'Kurtarma kodu kullanıldı',
      roles_changed: 'Rol ve kapsam değişikliği',
      permissions_changed: 'Yetki değişikliği',
      print: 'Çıktı alma',
      listed: 'PDF listesine alındı',
      unlisted: 'PDF listesinden çıktı',
      redraw: 'PDF listesi yeniden oluşturuldu',
      donation_removed: 'Bağış PDF listesinden çıkarıldı',
      invited: 'Davet gönderildi',
      invitation_link_revealed: 'Davet bağlantısı gösterildi',
      deactivate: 'Pasife alma',
      reactivate: 'Aktife alma',
      create: 'Oluşturma',
      update: 'Güncelleme',
      move: 'Taşıma',
      delete: 'Silme',
      duplicate: 'Kopyalama',
      transition: 'Durum değişikliği',
      archive: 'Arşivleme',
      restore: 'Arşivden çıkarma',
      reorder: 'Sıralama değişikliği',
      propose: 'Elle ödeme kaydı (onay bekliyor)',
      clear: 'Elle ödeme banka hareketinde bulundu',
      unclear: 'Elle ödemenin banka hareketi geri alındı',
      publish: 'Yayınlama',
      managers_changed: 'Sorumlu değişikliği',
      capabilities_changed: 'Yetkinlik değişikliği',
      copy_assignments: 'Görevlendirme kopyalama',
      merge: 'Bağışçı birleştirme',
      unmerge: 'Birleştirmeyi geri alma',
      lookup: 'Bağışçı varlık sorgusu',
      link_requested: 'Bağlantı talebi',
      link_accepted: 'Bağlantı onayı',
      link_declined: 'Bağlantı reddi',
      submit: 'Onaya gönderme',
      supersede: 'Yenisiyle değiştirme',
      recompute: 'Toplamlar yeniden hesaplandı',
      import: 'İçe aktarma',
      commit: 'İçe aktarımı kesinleştirme',
      discard: 'İçe aktarımı iptal etme',
      match: 'Eşleştirme',
      unmatch: 'Eşleştirmeyi kaldırma',
      approve: 'Onaylama',
      reject: 'Reddetme',
      render_failed: 'PDF hazırlanamadı',
      render_requested: 'PDF’i yeniden hazırlama isteği',
      reverse: 'Ters kayıt',
      refund: 'İade',
      erase: 'Bağışçı verisi silme',
      evidence_opened: 'Gerçekleştirme kanıtı görüntülendi',
      evidence_shared: 'Gerçekleştirme kanıtı paylaşıldı',
      evidence_resent: 'Kanıt bağlantısı yeniden gönderildi',
      notice_choices_changed: 'Bildirim tercihleri değişikliği',
      exclude: 'Kapsam dışına alma',
      export: 'Kişisel veri dışa aktarma isteği',
      include: 'Kapsama alma',
      issue: 'Makbuz kesme',
      void: 'Makbuz iptali',
      download: 'İndirme',
      backfill: 'Geriye dönük doldurma',
      settle: 'Tahsilat durumu değişikliği',
      request: 'Talep oluşturma',
      complete: 'Tamamlama',
      cancel: 'İptal / vazgeçme',
      cancel_remainder: 'Kesilmeyen hisselerin iptali',
      expire: 'Saklama süresi sonunda dosya silme',
      group_fulfilled: 'Hayvan kesiminin kaydı',
      unfulfill: 'Gerçekleşti işaretinin geri alınması',
      group_unfulfilled: 'Hayvan kesimi kaydının geri alınması',
      headquarters_changed: 'Genel merkez değişikliği',
      organization_changed: 'Kuruluş bağlantısı değişikliği',
      organization_linked: 'Kuruluş bağlama',
      organization_unlinked: 'Kuruluş bağlantısını kaldırma',
      primary_organization_changed: 'Birincil kuruluş değişikliği',
      configure: 'Anahtar tanımlama',
      rotate: 'Anahtar yenileme',
    },
  },
  organization: {
    branding: {
      empty: 'Henüz logo eklenmedi.',
      title: 'Kuruluş logosu',
      adminHost: 'Özel giriş alan adı',
      domainHint:
        'Yalnızca alan adını yazın (ör. btsis.sunrisehelp.org). DNS A kaydını sunucuya yönlendirin; HTTPS sertifikası otomatik alınır.',
      hint: 'PNG veya JPEG, en fazla 5 MB. Logo güvenlik taraması tamamlandığında özel alan adındaki giriş ve bağış sayfalarında görünür.',
      upload: 'Logo yükle',
      remove: 'Logoyu kaldır',
      saved: 'Logo kaydedildi; güvenlik taraması bekleniyor.',
      removed: 'Logo kaldırıldı.',
      pending: 'Güvenlik taraması bekleniyor',
      failed: 'Logo güvenlik taramasını geçemedi',
    },
    location: 'Konum',
    unplaced: 'Konum atanmamış',
    placementReadNotice:
      'Bu kuruluşu, bağlı kurumları değil konumu yetki alanınızın içinde olduğu için görüyorsunuz. Kasa rakamları görünür; kurum ayrıntıları, ödeme anahtarları, bildirim göndericileri ve siteler görünmez.',
    placement: {
      title: 'Konum',
      hint: 'Bölge, mıntıka ve ülke seçilir; kuruluşun bakiyeleri bu konuma göre toplanır. Boş bırakılırsa “Konum atanmamış” görünür.',
      none: 'Seçilmedi',
    },
    figures: {
      title: 'Kasa bakiyeleri ve eşleştirme',
      subheader: 'Kuruluşun hesaplarında ne var, ne kadarı bağışlarla eşleştirildi',
      summary: 'Kuruluş toplamı',
      allAccounts: 'Tüm hesaplar',
      balance: 'Bakiye',
      incoming: 'Gelen para',
      reconciled: 'Eşleştirilen',
      pending: 'Onay bekleyen',
      held: 'Başka işlemde',
      open: 'Eşleşmemiş',
      transferred: 'Kuruma aktarılan',
      hint: {
        balance: 'Silinmemiş hareketlerde girişler eksi çıkışlar',
        incoming: 'Hariç tutulmamış girişler: eşleştirilebilecek para',
        reconciled: 'Onaylanmış eşleştirmelerle bağışlara bağlanan',
        pending: 'İkinci kişinin onayını bekleyen eşleştirmelerle bağlanan',
        held: 'İade, kart ödemesi ya da transfer gibi başka bir işlemin tuttuğu',
        open: 'Henüz hiçbir şeye bağlanmamış',
        transferred: 'Kurumların kasalarına aktarılıp bakiyeden düşülen',
      },
      byInstitution: '{{currency}} — eşleştirilen paranın kurumlara dağılımı',
      otherInstitutions: 'Yetki alanınız dışındaki kurumlar',
      notice:
        'Rakamlar her açılışta hareketlerden yeniden toplanır; para birimleri hiçbir zaman birbiriyle toplanmaz. Gelen para = eşleştirilen + onay bekleyen + başka işlemde + eşleşmemiş. Kuruma aktarılan tutar bakiyeden düşer; eşleştirilen rakamı değişmez.',
    },
    title: 'Kuruluşlar',
    subtitle: 'Banka hesaplarının açıldığı tüzel kişilikler',
    new: 'Yeni Kuruluş',
    createTitle: 'Yeni Kuruluş',
    editTitle: 'Kuruluşu Düzenle',
    view: 'Görüntüle',
    name: 'Ad',
    code: 'Kod',
    codeHint: 'Kod dışa aktarımlarda kuruluşu tanımlar ve oluşturulduktan sonra değiştirilemez.',
    taxNumber: 'Vergi No',
    taxNumberHint: 'Kuruluşun kayıtlı olduğu ülkedeki vergi numarası; boş bırakılabilir.',
    noTaxNumber: 'Girilmedi',
    legalType: 'Tür',
    allLegalTypes: 'Tüm türler',
    baseCurrency: 'Ana Para Birimi',
    institutions: 'Bağlı Kurum',
    accounts: 'Hesaplar',
    noAccounts: 'Hesap tanımlanmamış',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    tab: {
      all: 'Tümü',
      active: 'Aktif',
      inactive: 'Pasif',
    },
    searchPlaceholder: 'Ad, kod veya vergi numarası ara',
    empty: 'Kuruluş bulunamadı',
    emptyHint: 'Filtreleri değiştirmeyi ya da arama terimini temizlemeyi deneyin.',
    csvFile: 'kuruluslar.csv',
    institutionCount_one: '{{count}} kurum',
    institutionCount_other: '{{count}} kurum',
    accountCount_one: '{{count}} hesap',
    accountCount_other: '{{count}} hesap',
    created: 'Kuruluş oluşturuldu',
    updated: 'Kuruluş güncellendi',
    deactivate: 'Pasife al',
    reactivate: 'Aktifleştir',
    deactivated: 'Kuruluş pasife alındı',
    reactivated: 'Kuruluş aktifleştirildi',
    confirmDeactivate:
      '“{{name}}” pasife alınsın mı? Pasif bir kuruluşa yeni kurum bağlanamaz; bağlı kurumları ve hesapları olduğu gibi kalır.',
    confirmReactivate: '“{{name}}” yeniden aktifleştirilsin mi?',
    scopeNotice:
      'Yalnızca bütün kurumları veri kapsamınızda olan kuruluşlar listelenir; kurumlarından biri kapsamınız dışındaysa kuruluş görünmez.',
    readOnlyNotice:
      'Kuruluşları, hesaplarını ve kurum bağlantılarını yalnızca global kapsamdaki kullanıcılar değiştirebilir.',
    details: {
      back: 'Kuruluşlara dön',
      title: 'Kuruluş Bilgileri',
      caption_one: '{{code}} · {{count}} bağlı kurum',
      caption_other: '{{code}} · {{count}} bağlı kurum',
      createdAt: 'Oluşturulma',
      notFound: 'Kuruluş bulunamadı.',
      baseCurrencyHint:
        'Ana para birimi, konsolidasyon raporunun kuruluşun hareketlerini çevirdiği para birimidir.',
    },
    account: {
      title: 'Hesaplar',
      add: 'Hesap Ekle',
      addTitle: 'Yeni Hesap',
      editTitle: 'Hesabı Düzenle',
      kind: 'Tür',
      label: 'Hesap adı',
      iban: 'IBAN',
      currency: 'Para birimi',
      noIban: 'IBAN yok',
      ibanHint:
        'Gruplu ya da bitişik yazabilirsiniz; ülke uzunluğu ve kontrol haneleri doğrulanır.',
      ibanOnlyBank: 'IBAN yalnızca banka hesabına girilir.',
      kindFixed:
        'Hesabın türü ve para birimi, hareketleri o türde ve para biriminde yazıldığı için değiştirilemez. Yanlışsa hesabı pasife alıp yenisini ekleyin.',
      added: 'Hesap eklendi',
      updated: 'Hesap güncellendi',
      deactivated: 'Hesap pasife alındı',
      reactivated: 'Hesap aktifleştirildi',
      confirmDeactivate:
        '“{{label}}” pasife alınsın mı? Hesabın geçmiş hareketleri kalır; yeni işlemlerde seçilemez.',
      confirmReactivate: '“{{label}}” yeniden aktifleştirilsin mi?',
      empty: 'Bu kuruluşun hesabı yok',
      emptyHint: 'Paranın geldiği banka, kasa ya da sanal POS hesaplarını ekleyin.',
    },
    notificationSender: {
      title: 'Gönderim Hesapları',
      subtitle:
        'Bu kuruluşun mesajlarının hangi hesaptan çıkacağı. Kendi hesabı olmayan kanal, kurulumun paylaşılan hesabını kullanır.',
      provider: 'Sağlayıcı',
      fingerprint: 'Anahtar izi',
      keyId: 'Ana anahtar',
      addressing: 'Adresleme',
      configuredAt: 'Tanımlayan',
      configured: 'Tanımlı',
      notConfigured: 'Tanımlı değil',
      clearedLabel: 'Kaldırıldı',
      notOnCurrentKey: 'Eski ana anahtarla mühürlü; gece çalışan taşıma işi yeni anahtara alacak.',
      set: 'Tanımla',
      replace: 'Değiştir',
      clear: 'Kaldır',
      cleared: 'Gönderim hesabı kaldırıldı; bu kanal artık paylaşılan hesabı kullanacak.',
      confirmClear:
        '{{provider}} gönderim hesabı kaldırılsın mı? Bu kanal paylaşılan hesaba döner, kayıt iz için saklanır.',
      setTitle: '{{provider}} gönderim hesabını tanımla',
      replaceTitle: '{{provider}} gönderim hesabını değiştir',
      configuredToast: 'Gönderim hesabı tanımlandı.',
      replaced: 'Gönderim hesabı değiştirildi.',
      neverShown:
        'Kayıtlı bir anahtar hiçbir ekranda gösterilmez ve hiçbir servis tarafından geri döndürülmez; yalnızca yenisiyle değiştirilir.',
      gatewayWarning:
        'Resmî olmayan WhatsApp geçidi: numara her an engellenebilir ve kimlik doğrulayan mesajlar buradan hiç gönderilmez.',
      sealingUnavailable:
        'Şifreleme anahtarı tanımlı olmadığı için gönderim hesabı kaydedilemez. Sunucu ayarlarında PAYMENT_CREDENTIALS_KEY tanımlanmalıdır.',
      plan: {
        organization: 'Kuruluşun kendi hesabı',
        shared: 'Paylaşılan hesaba düşüyor',
        none: 'Tanımlı değil, gönderim yapılmayacak',
        willNotSend: 'Bu kanaldan mesaj gönderilmeyecek',
      },
      field: {
        userCode: 'Netgsm kullanıcı kodu',
        password: 'Netgsm API şifresi',
        msgHeader: 'Mesaj başlığı',
        apiBaseUrl: 'API adresi',
        accountSid: 'Twilio hesap SID',
        authToken: 'Twilio kimlik anahtarı',
        from: 'Gönderen numara',
        phoneNumberId: 'Meta telefon numarası kimliği',
        accessToken: 'Meta erişim anahtarı',
        apiVersion: 'API sürümü',
        languageCode: 'Şablon dili',
        instanceName: 'Geçit oturum adı',
        apiKey: 'Geçit API anahtarı',
      },
    },
    paymentCredential: {
      title: 'Ödeme Anahtarları',
      subtitle: 'Bu kuruluşun Stripe ve PayPal hesaplarının anahtarları',
      account: 'Hesap',
      fingerprint: 'Anahtar izi',
      keyId: 'Ana anahtar',
      configuredAt: 'Tanımlayan',
      webhookUrl: 'Bildirim adresi',
      copyWebhookUrl: 'Adresi kopyala',
      webhookCopied: 'Bildirim adresi kopyalandı',
      webhookCopyFailed: 'Adres kopyalanamadı; elle seçip kopyalayın.',
      webhookUrlFull: 'Tam adres: {{url}}',
      configured: 'Yapılandırıldı',
      notConfigured: 'Yapılandırılmadı',
      notWorking: 'Ödeme alınamıyor',
      notSupported: 'Henüz desteklenmiyor',
      serverMissingWebhookBase:
        'Sunucu yöneticisinin bildirim adresini tanımlaması gerekiyor — bu yapılana kadar ödemeler sisteme işlenmez. Bildirim adresi görünmediği için Stripe ve PayPal’da webhook da oluşturulamaz.',
      serverMissingPaypalGateway:
        'Sunucuda PayPal bağlantısı tanımlı değil. Sunucu yöneticisinin tanımlaması gerekiyor — bu yapılana kadar PayPal anahtarları doğrulanıp kaydedilemez ve PayPal ile ödeme alınamaz.',
      stepWebhook: 'Bildirim adresi',
      stepKeys: 'Anahtarlar',
      webhookIntro: {
        stripe:
          'Stripe panelinde Developers → Webhooks → “Add endpoint” adımına aşağıdaki adresi yapıştırın ve listedeki olayları seçin. Kaydettikten sonra webhook sayfasındaki “Signing secret” (whsec_…) değerini kopyalayın; sonraki adımda istenecek.',
        paypal:
          'PayPal Developer panelinde Apps & Credentials → uygulamanız → Webhooks → “Add Webhook” adımına aşağıdaki adresi yapıştırın ve listedeki olayları seçin. Kaydettikten sonra görünen “Webhook ID” değerini kopyalayın; sonraki adımda istenecek.',
      },
      eventsTitle: 'Abone olunacak olaylar',
      eventsHint: 'Yalnızca bu olaylar işlenir; webhook bunların hepsine abone olmalıdır.',
      webhookUnavailable:
        'Bildirim adresi gösterilemiyor: sunucu yöneticisinin bildirim adresini tanımlaması gerekiyor. Anahtarları yine de kaydedebilirsiniz, ancak bu yapılana kadar ödemeler sisteme işlenmez.',
      verifiedOnSave:
        'Kaydederken anahtarlar ve webhook sağlayıcıya sorularak doğrulanır; geçersiz bir anahtar kaydedilmez.',
      stripeSecretKeyHint:
        'Developers → API keys bölümündeki “Secret key” (sk_live_…). Yayımlanabilir anahtar (pk_…) değil.',
      stripeWebhookSecretHint:
        '1. adımda oluşturduğunuz webhook’un “Signing secret” değeri (whsec_…).',
      paypalClientSecretHint: 'Apps & Credentials → uygulamanız → “Secret”.',
      paypalWebhookIdHint: '1. adımda oluşturduğunuz webhook’un kimliği; adresin kendisi değil.',
      restrictedKeyWarning:
        'Kısıtlı anahtar (rk_…): Checkout oturumu oluşturma ile ödeme ve iade okuma izinleri verilmiş olmalı, yoksa bağış alınamaz.',
      testKeyWarning:
        'Bu bir test anahtarı: bununla gerçek ödeme alınmaz. Canlı bağış için sk_live_ ile başlayan anahtarı kullanın.',
      verifying: 'Doğrulanıyor…',
      deactivatedLabel: 'Pasif',
      notOnCurrentKey: 'Eski ana anahtarla mühürlü; gece yeniden mühürlenecek.',
      set: 'Anahtarları tanımla',
      rotate: 'Anahtarları yenile',
      setTitle: 'Ödeme anahtarlarını tanımla',
      rotateTitle: 'Ödeme anahtarlarını yenile',
      neverShown:
        'Anahtarlar hiçbir ekranda ve hiçbir yanıtta geri gösterilmez; yalnızca değiştirilir. Kaydedilen anahtar şifrelenerek saklanır.',
      stripeSecretKey: 'Stripe gizli anahtarı',
      stripeWebhookSecret: 'Stripe bildirim imza anahtarı',
      paypalClientId: 'PayPal client ID',
      paypalClientIdHint: 'Client ID gizli değildir; imza doğrulamasında kullanılır.',
      paypalClientSecret: 'PayPal client secret',
      paypalWebhookId: 'PayPal webhook ID',
      configured_toast: 'Ödeme anahtarları tanımlandı',
      rotated: 'Ödeme anahtarları yenilendi',
      deactivate: 'Anahtarları pasife al',
      deactivated: 'Ödeme anahtarları pasife alındı',
      confirmDeactivate:
        '“{{label}}” hesabının ödeme anahtarları pasife alınsın mı? Bu hesap üzerinden yeni ödeme bağlantısı oluşturulamaz; anahtarlar denetim izi için saklanır.',
      sealingUnavailable:
        'Sunucuda ödeme anahtarı şifreleme anahtarı (PAYMENT_CREDENTIALS_KEY) tanımlı değil; anahtar kaydedilemez.',
      empty: 'Bu kuruluşun sağlayıcı hesabı yok',
      emptyHint: 'Önce Stripe ya da PayPal türünde bir hesap ekleyin.',
    },
    site: {
      title: 'Bağış Siteleri',
      subtitle: 'Bu kuruluşun bağış sitesinin yanıt verdiği alan adları',
      add: 'Alan Adı Ekle',
      addTitle: 'Yeni alan adı',
      host: 'Alan adı',
      hostHint:
        'Yalnızca alan adını yazın: şema, port ve yol olmadan. Örnek: bagis.ornekdernek.org',
      hostRequired: 'Bir alan adı girin',
      canonical: 'Birincil alan adı',
      canonicalHint:
        'Birincil alan adı sitenin kendi adresi olarak kullanılır; diğer alan adları ona yönlendirilir. Birincil başka bir alan adıysa o bırakılır.',
      canonicalLabel: 'Birincil',
      makeCanonical: 'Birincil yap',
      madeCanonical: '“{{host}}” birincil alan adı yapıldı',
      remove: 'Alan adını kaldır',
      confirmRemove:
        '“{{host}}” kaldırılsın mı? Bu alan adına gelen ziyaretçiler artık bu kuruluşun bağış sitesine ulaşamaz. Bu alan adı üzerinden verilmiş siparişler olduğu gibi kalır.',
      removed: '“{{host}}” kaldırıldı',
      added: 'Alan adı eklendi',
      activated: '“{{host}}” aktifleştirildi',
      deactivated: '“{{host}}” pasife alındı',
      provisioning:
        'Bir alan adının burada eklenmesi tek başına yetmez: alan adının DNS kaydı bu sunucuya yönlendirilmeli ve alan adı için TLS sertifikası alınmalıdır. İkisi tamamlanana kadar ziyaretçi siteye ulaşamaz.',
      noHeadquarters:
        'Bu kuruluşun genel merkezi belirlenmemiş. Sitesi ödeme alabilir, ama alınan ödeme bağışa dönüştürülemez. Genel merkezi aşağıdaki Bağlı Kurumlar kartından belirleyin.',
      siteCount_one: '{{count}} alan adı',
      siteCount_other: '{{count}} alan adı',
      empty: 'Bu kuruluşun bağış sitesi yok',
      emptyHint: 'Bağış sitesinin yanıt vereceği alan adını ekleyin.',
    },
    institution: {
      title: 'Bağlı Kurumlar',
      subtitle: 'Bağışları bu kuruluşun hesaplarındaki parayla eşleşebilen kurumlar',
      link: 'Kurum Bağla',
      linkTitle: 'Kurumu “{{name}}” kuruluşuna bağla',
      linkNote:
        'Bir kurum birden fazla kuruluşa bağlanabilir. Bağışın hangi kuruluşa yazılacağı bağış girilirken değil, ödemesi alınırken belirlenir: ödemeyi hesabına alan kuruluş, bağışın kuruluşu olur.',
      noneToLink: 'Bağlanabilecek başka kurum yok',
      unlink: 'Bağlantıyı kaldır',
      required: 'Bir kurum seçin',
      linked: '{{institution}}, {{organization}} kuruluşuna bağlandı',
      unlinked: '{{institution}} ile {{organization}} arasındaki bağlantı kaldırıldı',
      confirmUnlink:
        '{{institution}} artık {{organization}} kuruluşunun hesaplarındaki parayla eşleştirilemesin mi? Kurumun diğer kuruluş bağlantıları ve bağışları değişmez. Kurumun bu kuruluşa yazılmış bir bağışı ya da bu kuruluşun hesabında etkin bir ödeme bağlantısı varsa bağlantı kaldırılamaz. Birincil kuruluşun bağlantısı, kuruma başka kuruluşlar bağlıyken kaldırılamaz.',
      otherOrganizations: 'Ayrıca: {{names}}',
      noOtherOrganizations: 'Başka kuruluşa bağlı değil',
      primary: 'Birincil',
      setPrimary: 'Birincil kuruluş yap',
      primaryNamed: '{{organization}}, {{institution}} kurumunun birincil kuruluşu oldu',
      primaryNote:
        'Birincil kuruluş, ödemesi henüz alınmamış bir bağış için bildirimleri gönderen ve bağış sayfasının bağlantısını veren kuruluştur.',
      scopeWarning:
        'Bir kurum bağlandığında, bu kuruluşun mutabakatını yalnızca kuruluşun bütün kurumlarını kapsayan kullanıcılar yapabilir; yeni kurumu kapsamayan kullanıcılar kuruluşa erişimini kaybeder.',
      headquarters: 'Genel Merkez',
      headquartersSet: 'Genel merkez yap',
      headquartersClear: 'Genel merkezi kaldır',
      headquartersNamed: '{{institution}}, {{organization}} kuruluşunun genel merkezi oldu',
      headquartersCleared: '{{institution}} artık {{organization}} kuruluşunun genel merkezi değil',
      confirmSetHeadquarters:
        '{{institution}}, {{organization}} kuruluşunun genel merkezi yapılsın mı? Bu kuruluşun bağış sitesinden alınan her bağış bundan sonra bu kurumda doğar. Kuruluşun genel merkezi varsa, merkez oradan alınıp buraya taşınır; daha önce girilmiş bağışlar olduğu kurumda kalır.',
      confirmClearHeadquarters:
        '{{institution}} artık {{organization}} kuruluşunun genel merkezi olmasın mı? Kuruluşun genel merkezi kalmaz: bağış sitesi ödeme almaya devam eder, ama alınan ödeme bağışa dönüştürülemez.',
      empty: 'Bu kuruluşa bağlı kurum yok',
      emptyHint:
        'Kurumu olmayan bir kuruluşun hesaplarında mutabakatı yalnızca global kapsamdaki kullanıcılar yapabilir.',
    },
    legalTypes: {
      association: 'Dernek',
      foundation: 'Vakıf',
      company: 'Şirket',
    },
    accountKinds: {
      bank: 'Banka',
      paypal: 'PayPal',
      pos: 'Sanal POS',
      cash: 'Kasa',
      stripe: 'Stripe',
    },
  },
  receipt: {
    title: 'Makbuzlar',
    subtitle: 'Tahsilatı tamamlanan bağışların kabul bildirimleri ve bağışçıların yıllık özetleri',
    receiptNo: 'Makbuz No',
    kind: 'Tür',
    donor: 'Bağışçı',
    anonymousDonor: 'Anonim Bağışçı',
    amount: 'Tutar',
    currency: 'Para Birimi',
    institution: 'Kurum',
    year: 'Yıl',
    issuedAt: 'Düzenlenme',
    status: 'Durum',
    legalDocument: 'Yasal belge',
    legalDocumentMissing: 'Kaydedilmedi',
    render: 'PDF',
    search: 'Makbuz no veya bağışçı ara',
    reference: 'Bağış {{code}}',
    coversYear: '{{year}} yılı',
    itemCount_one: '{{count}} makbuzu kapsar',
    itemCount_other: '{{count}} makbuzu kapsar',
    replaces: '{{receiptNo}} yerine düzenlendi',
    replaced: 'Yeniden düzenlendi',
    voidReason: 'İptal gerekçesi: {{reason}}',
    empty: 'Makbuz yok',
    emptyHint: 'Makbuzlar, bağışın tahsilatı tamamlandığında kendiliğinden düzenlenir.',
    csvFile: 'makbuzlar',
    kinds: {
      donation: 'Bağış makbuzu',
      annual_certificate: 'Yıllık özet',
    },
    statuses: {
      issued: 'Geçerli',
      voided: 'İptal edildi',
    },
    renderStatuses: {
      pending: 'Hazırlanıyor',
      ready: 'Hazır',
      failed: 'Hazırlanamadı',
      stalled: 'Gecikti',
    },
    renderFailedHint:
      'PDF hazırlanamadı: arka plandaki hazırlama işi bütün denemelerinde başarısız oldu (örneğin dosya deposuna ulaşılamadı). Menüden “PDF’i yeniden hazırla” ile tekrar deneyin; sorun sürerse sistem yöneticinize bildirin.',
    renderStalledHint:
      'PDF beklenenden uzun süredir hazırlanıyor; hazırlama isteği yolda kaybolmuş olabilir. Menüden “PDF’i yeniden hazırla” ile yeniden isteyin.',
    renderFailedCaption: 'PDF hazırlanamadı; menüden yeniden hazırlayın.',
    renderStalledCaption: 'Hazırlama isteği kaybolmuş olabilir; menüden yeniden isteyin.',
    rerenderDone: 'PDF yeniden hazırlanıyor.',
    legalFilter: {
      recorded: 'Yasal belge no kayıtlı',
      missing: 'Yasal belge no kayıtsız',
    },
    actions: {
      download: 'PDF’i aç',
      legalDocument: 'Yasal belge no gir',
      void: 'İptal et',
      reissue: 'Yeniden düzenle',
      rerender: 'PDF’i yeniden hazırla',
      issue: 'Makbuz düzenle',
      annual: 'Yıllık özetler',
    },
    downloadNotReady: 'PDF hazırlanıyor; birkaç saniye sonra tekrar deneyin.',
    voidDialog: {
      title: 'Makbuzu iptal et',
      content:
        'Makbuz silinmez, numarası tekrar kullanılmaz; PDF’e “iptal edildi” basılır. Gerekirse iptal edilen makbuz yeniden düzenlenir.',
      reasonLabel: 'İptal gerekçesi',
      reasonRequired: 'Gerekçe girilmelidir.',
      done: 'Makbuz iptal edildi.',
    },
    reissueDialog: {
      title: 'Makbuzu yeniden düzenle',
      content:
        'Yeni bir numarayla, iptal edilen {{receiptNo}} numaralı makbuzun yerine yeni bir makbuz düzenlenir. Bağış tahsil edilmiş olmalıdır.',
      done: 'Yeni makbuz düzenlendi: {{receiptNo}}',
    },
    legalDialog: {
      title: 'Yasal belge numarası',
      content:
        'Bu makbuz yasal vergi belgesi değildir. Ülkenin gerektirdiği yasal belge ayrıca düzenlendiyse numarasını buraya kaydedin; PDF yeniden hazırlanır ve numara basılır.',
      series: 'Seri (isteğe bağlı)',
      number: 'Belge numarası',
      numberRequired: 'Belge numarası girilmelidir.',
      done: 'Yasal belge numarası kaydedildi; PDF yeniden hazırlanıyor.',
    },
    issueDialog: {
      title: 'Makbuz düzenle',
      content:
        'Bu bağış, makbuzlar sisteme eklenmeden önce tahsil edilmiş. Kurumun bu yılki sırasından yeni bir numarayla makbuz düzenlenir.',
      done: 'Makbuz düzenlendi.',
    },
    panel: {
      title: 'Makbuz',
      subheader: 'Bağış tahsil edildiğinde kendiliğinden düzenlenir; yasal vergi belgesi değildir',
      empty: 'Bu bağış için makbuz düzenlenmemiş.',
      unsettled: 'Makbuz, bağışın tahsilatı tamamlandığında düzenlenir.',
      activeHint:
        'Geçerli makbuzu olan bağışın eşleştirmesi geri alınamaz ve bağış iptal edilemez; önce makbuzu iptal edin.',
    },
    annual: {
      title: 'Yıllık Bağış Özetleri',
      subtitle:
        'Bir yılda düzenlenen geçerli makbuzları olan ve o yıl için özeti olmayan bağışçılar',
      coversYear: 'Kapsadığı yıl',
      organization: 'Kuruluş',
      receiptCount: 'Makbuz',
      totals: 'Toplam',
      lastIssuedAt: 'Son makbuz',
      issue: 'Yıllık özet düzenle',
      issueCount_one: '{{count}} bağışçı için özet düzenle',
      issueCount_other: '{{count}} bağışçı için özet düzenle',
      pickDonors: 'Önce özet düzenlenecek bağışçıları tablodaki kutucuklarla seçin.',
      selectHint: 'Özet düzenlemek için bağışçıları soldaki kutucuklarla seçin.',
      confirmTitle: 'Yıllık özet düzenle',
      confirmContent_one:
        'Seçilen {{count}} bağışçı için {{year}} yılının geçerli makbuzlarını listeleyen bir özet düzenlenir.',
      confirmContent_other:
        'Seçilen {{count}} bağışçının her biri için {{year}} yılının geçerli makbuzlarını listeleyen bir özet düzenlenir.',
      done_one: '{{count}} yıllık özet düzenlendi.',
      done_other: '{{count}} yıllık özet düzenlendi.',
      partial: '{{total}} bağışçıdan {{failed}} tanesi için özet düzenlenemedi: {{reasons}}',
      empty: 'Özet bekleyen bağışçı yok',
      emptyHint: 'Seçilen yılda geçerli makbuzu olan her bağışçının özeti zaten düzenlenmiş.',
    },
    pdf: {
      donationTitle: 'Bağış Kabul Bildirimi',
      certificateTitle: 'Yıllık Bağış Özeti',
      certificateSubtitle: '{{year}} yılında kabul edilen bağışlarınız',
      notice:
        'Bu belge bağışınızın kabul edildiğini bildirir. Vergi mevzuatı kapsamında düzenlenen yasal belge değildir ve onun yerine geçmez.',
      receiptNo: 'Belge No',
      issuedAt: 'Düzenlenme Tarihi',
      issuer: 'Düzenleyen Birim',
      donor: 'Bağışçı',
      anonymousDonor: 'Anonim Bağışçı',
      amount: 'Tutar',
      campaign: 'Bağış Türü',
      referenceCode: 'Bağış Referans Kodu',
      donatedAt: 'Bağış Tarihi',
      legalDocument: 'Yasal Belge No',
      replaces: 'Bu belge {{receiptNo}} numaralı belgenin yerine düzenlenmiştir.',
      voided: 'İPTAL EDİLDİ',
      voidedOn: 'Bu belge {{date}} tarihinde iptal edilmiştir ve geçerli değildir.',
      itemsHeading: 'Kapsanan bağış bildirimleri',
      itemReceiptNo: 'Belge No',
      itemReferenceCode: 'Referans Kodu',
      itemCampaign: 'Bağış Türü',
      itemDate: 'Tarih',
      itemAmount: 'Tutar',
      total: 'Toplam ({{currency}})',
      thanks: 'Bağışınız için teşekkür ederiz.',
    },
  },
  jobs: {
    providerMovementsFailed:
      'Ödeme hesabı hareketleri aktarılamadı. Sağlayıcı erişimini ve hesap anahtarlarını kontrol edin.',
    job: 'İş',
    jobId: 'İş kimliği',
    queue: 'Kuyruk',
    errorCode: 'Hata kodu',
    attempts: 'Deneme',
    failedAt: 'Başarısız olduğu an',
    status: 'Durum',
    resolved: 'Sonuçlandıran',
    payloadIds: 'Kimlikler',
    technicalDetail: 'Teknik ayrıntı',
    runKey: 'Çalışma anahtarı',
    startedAt: 'Başladığı an',
    finishedAt: 'Bittiği an',
    outcome: 'Sonuç',
    from: 'Başlangıç',
    to: 'Bitiş',
    failedRange: 'Başarısızlık günü',
    startedRange: 'Başlangıç günü',
    allJobs: 'Tüm işler',
    allQueues: 'Tüm kuyruklar',
    notRetriable: 'Yeniden denenemez',
    failures: {
      title: 'Başarısız İşler',
      empty: 'Başarısız iş yok',
      emptyHint: 'Deneme hakkını tüketen arka plan işleri burada listelenir.',
      csvFile: 'basarisiz-isler.csv',
    },
    runs: {
      title: 'Zamanlanmış Çalışmalar',
      empty: 'Çalışma kaydı yok',
      emptyHint: 'Zamanlanmış işlerin her çalışması ve her TCMB günü burada kaydedilir.',
      csvFile: 'zamanlanmis-calismalar.csv',
    },
    failureStatus: {
      open: 'Açık',
      retried: 'Yeniden denendi',
      dismissed: 'Kapatıldı',
    },
    runOutcome: {
      succeeded: 'Başarılı',
      failed: 'Başarısız',
      no_bulletin: 'Bülten yok',
      running: 'Sürüyor',
    },
    queues: {
      maintenance: 'Bakım',
      totals: 'Toplamlar',
      rates: 'Kurlar',
      imports: 'İçe aktarımlar',
      files: 'Dosyalar',
      payments: 'Ödemeler',
      'notify-email': 'Bildirim — e-posta',
      'notify-sms': 'Bildirim — SMS',
      'notify-whatsapp': 'Bildirim — WhatsApp',
      'notify-push': 'Bildirim — anlık bildirim',
    },
    retention: {
      title: 'Saklama Süreleri',
      subtitle: 'Her veri türünün ne kadar saklandığı ve bunu hangi işin uyguladığı.',
      data: 'Veri',
      period: 'Süre',
      effect: 'Süre dolunca',
      job: 'Uygulayan iş',
      decision: 'Karar {{number}}',
      units: {
        hours_one: '{{count}} saat',
        hours_other: '{{count}} saat',
        days_one: '{{count}} gün',
        days_other: '{{count}} gün',
        years_one: '{{count}} yıl',
        years_other: '{{count}} yıl',
      },
      effects: {
        object: 'Dosya silinir, kayıt kalır',
        row: 'Kayıt silinir, denetim izi kalır',
        payload: 'Veri boşaltılır, kayıt kalır',
        objectAndPayload: 'Dosya silinir, satırlardaki veriler boşaltılır; kayıt kalır',
      },
      kinds: {
        inboundMediaMatched: 'Bağışla eşleşen gelen medya (eşleşmeden sonra)',
        inboundMediaUnmatched: 'Eşleşmeyen gelen medya (geldiği andan sonra)',
        statementFileCommitted: 'İşlenmiş ekstre dosyası (işlendiği yılın sonundan sonra)',
        statementFileAbandoned: 'İptal edilen veya başarısız ekstre dosyası',
        paymentSlipApproved: 'Elle kaydedilen ödemenin dekontu (onaylandığı yılın sonundan sonra)',
        paymentSlipVoid: 'Reddedilen veya geri alınan ödemenin dekontu',
        donationAttachment: 'Bağış eki — dekont fotoğrafı, teslim fotoğrafı (yüklendikten sonra)',
        campaignFormFile: 'Kampanya form dosyası — formda istenen belge (yüklendikten sonra)',
        donationImport:
          'Bağış aktarımı dosyası ve satırlarındaki veriler (aktarım kaydedildikten, iptal edildikten veya başarısız olduktan sonra)',
        generatedFileObject: 'Oluşturulan dosyanın kendisi (hazırlandıktan sonra)',
        generatedFileRow: 'Oluşturulan dosya kaydı (talep edildikten sonra)',
        outboxRedispatch: 'Kaybolan iş gönderimi kaydı (en son yeniden sorulduktan sonra)',
        auditLogPayload: 'Denetim kaydındaki eski ve yeni değerler (kaydın yazılmasından sonra)',
      },
    },
    names: {
      campaignTotalsSweep: 'Kampanya toplamlarının gece taraması',
      campaignTotalsRecompute: 'Dönem toplamlarının yeniden hesaplanması',
      exchangeRatesFetch: 'TCMB kur bülteninin çekilmesi',
      exchangeRatesBackfill: 'TCMB arşivinden kur doldurma',
      donationBaseAmountsBackfill: 'Bağışlara TL karşılığının işlenmesi',
      statementImportProcess: 'Ekstrenin işlenmesi',
      attachmentScan: 'Dosyanın virüs taraması',
      receiptRender: 'Makbuz PDF’inin hazırlanması',
      inboundMediaFeedback: 'Gelen medya alındı teyidi',
      inboundMediaFetch: 'Gelen medyanın indirilmesi',
      inboundMediaDecode: 'Gelen medyanın okunması',
      inboundMediaExpire: 'Gelen medya dosyalarının saklama süresi sonunda silinmesi',
      statementImportExpire: 'Ekstre dosyalarının saklama süresi sonunda silinmesi',
      paymentSlipExpire: 'Ödeme dekontlarının saklama süresi sonunda silinmesi',
      donationAttachmentExpire: 'Bağış eklerinin saklama süresi sonunda silinmesi',
      formFileExpire: 'Kampanya form dosyalarının saklama süresi sonunda silinmesi',
      generatedFilesPurge: 'Saklama süresi dolan dosya kayıtlarının silinmesi',
      outboxPurge: 'Saklama süresi dolan yeniden gönderim kayıtlarının silinmesi',
      auditLogExpirePayloads:
        'Denetim kayıtlarındaki verilerin saklama süresi sonunda boşaltılması',
      donationExport: 'Bağış listesinin dosyaya aktarılması',
      reconciliationShortfallExport: 'Eksik tahsilat listesinin dosyaya aktarılması',
      reconciliationHistoryExport: 'Tamamlanan eşleştirmelerin dosyaya aktarılması',
      refundExport: 'İade listesinin dosyaya aktarılması',
      fundTransferExport: 'Fon transferi listesinin dosyaya aktarılması',
      printoutRender: 'Bağış çıktılarının hazırlanması',
      documentQueueSheet: 'Grup çizelgesinin hazırlanması',
      donationQueueExport: 'Kesim raporunun Excel dosyasına aktarılması',
      donationImportTemplate: 'Bağış aktarım şablonunun hazırlanması',
      bulkChangeTemplate: 'Toplu işlem şablonunun hazırlanması',
      bulkChangeProcess: 'Toplu işlemin önizlemesi',
      bulkChangeCommit: 'Toplu işlemin uygulanması',
      donationImportProcess: 'Bağış aktarımının önizlemesi',
      donationImportCommit: 'Bağış aktarımının kaydedilmesi',
      donationImportExpire:
        'Bağış aktarımı dosyasının ve satır verilerinin saklama süresi sonunda silinmesi',
      reportDonationTotalsExport: 'Bağış toplamları raporunun hazırlanması',
      reportCampaignPerformanceExport: 'Kampanya performansı raporunun hazırlanması',
      reportDonorSegmentsExport: 'Bağışçı segmentleri raporunun hazırlanması',
      reportSeasonComparisonExport: 'Sezon karşılaştırması raporunun hazırlanması',
      auditExport: 'Denetim izinin dışa aktarılması',
      donorDataExport: 'Bağışçı veri örneğinin hazırlanması',
      reportRollupRefresh: 'Rapor tablosunun yenilenmesi',
      generatedFilesExpire: 'Oluşturulan dosyaların saklama süresi sonunda silinmesi',
      paymentLinkExpire: 'Süresi dolmuş ödeme bağlantılarının kapatılması',
      campaignStaffRoleSync: 'Operasyon Sorumlusu rolünün görevlendirmelerle eşitlenmesi',
      paymentPledgeSweep: 'Düzenli bağışların günlük vade taraması',
      paymentChargePledge: 'Düzenli bağışın dönemlik tahsilatı',
      paymentRecordMandate: 'Kayıtlı ödeme yönteminin sağlayıcıdan okunması',
      paymentRevokeMandate: 'Kayıtlı ödeme yönteminin sağlayıcıda iptal edilmesi',
      alertSend: 'Operasyon uyarısının gönderilmesi',
      scheduledJobsWatchdog: 'Zamanlanmış işlerin denetlenmesi',
      outboxSweep: 'Kaybolan iş gönderimlerinin yeniden gönderilmesi',
      providerMovementsSync: 'Ödeme sağlayıcısı hesap hareketlerinin otomatik aktarılması',
      accountTransactionEquivalentsFill:
        'Hesap hareketlerinin TL, USD ve EUR karşılıklarının işlenmesi',
      paymentCredentialsReseal: 'Ödeme anahtarlarının yeni ana anahtarla mühürlenmesi',
      notificationDeliverEmail: 'Bildirimin e-posta ile gönderilmesi',
      notificationDeliverSms: 'Bildirimin SMS ile gönderilmesi',
      notificationDeliverWhatsapp: 'Bildirimin WhatsApp ile gönderilmesi',
      notificationDeliverPush: 'Bildirimin anlık bildirim olarak gönderilmesi',
    },
    actions: {
      retry: 'Yeniden dene',
      dismiss: 'Kapat',
    },
    schedules: {
      title: 'Zamanlanmış İşler',
      subtitle:
        'Günlük çalışan işler ve her birinin çalışma saati. Bir iş elle başlatıldığında, zamanlayıcının kullanacağı çalışma anahtarıyla kuyruğa alınır.',
      pattern: 'Zamanlama',
      tz: 'Saat dilimi',
      run: 'Şimdi çalıştır',
      runTitle: 'İşi şimdi çalıştır',
      runContent:
        '{{job}} işi bugünün çalışması için kuyruğa alınır. Aynı çalışma zaten sürüyorsa ya da bugün başarıyla tamamlandıysa ikinci kez çalıştırılmaz.',
      done: '{{runDate}} çalışması kuyruğa alındı',
    },
    bulk: {
      partial: '{{done}} kayıt işlendi, {{failed}} kayıt işlenemedi.',
      retry: {
        title: 'Seçili işleri yeniden dene',
        content:
          'Seçili {{count}} başarısız iş, başarısız oldukları kimliklerle yeniden kuyruğa alınır. Yeniden denenemeyen ya da bu arada kapatılmış olanlar tek tek bildirilir.',
      },
      dismiss: {
        title: 'Seçili başarısız işleri kapat',
        content:
          'Seçili {{count}} başarısız iş görüldü olarak kapatılır ve yeniden denenmez. Bu arada başkasının sonuçlandırdığı kayıtlar tek tek bildirilir.',
      },
    },
    retry: {
      title: 'İşi yeniden dene',
      content:
        '{{job}} işi, başarısız olduğu kimliklerle yeniden kuyruğa alınır ve deneme hakları baştan sayılır. İş hâlâ kuyrukta ya da çalışıyorsa ikinci kez eklenmez.',
      done: 'İş yeniden kuyruğa alındı',
    },
    dismiss: {
      title: 'Başarısız işi kapat',
      content:
        '{{job}} işinin bu başarısızlığı görüldü olarak kapatılır ve yeniden denenmez. Aynı iş yeniden başarısız olursa yeni bir kayıt açılır.',
      done: 'Kayıt kapatıldı',
    },
  },
  operationsAlert: {
    subject: 'BTSis operasyon uyarısı: {{title}}',
    code: 'Uyarı kodu',
    firstRaisedAt: 'İlk tespit',
    lastRaisedAt: 'Bu bildirim',
    raiseCount: 'Bildirim sayısı',
    detailsHeading: 'Ayrıntılar',
    repeats:
      'Durum sürdükçe bu uyarı en çok {{hours}} saatte bir yinelenir; durum düzelip yeniden ortaya çıkarsa hemen gönderilir.',
    once: 'Bu uyarı bu olay için yalnızca bir kez gönderilir.',
    footer:
      'Bu e-posta BTSis tarafından otomatik olarak gönderildi ve kişisel veri içermez. Başarısız işleri ve zamanlanmış çalışmaları yönetim panelindeki İşler ekranlarından izleyebilirsiniz.',
    none: '—',
    codes: {
      AUTH_MAIL_UNDELIVERED: {
        title: 'Giriş bilgisi taşıyan bir e-posta gönderilemedi',
        description:
          'Bu e-posta posta sunucusuna hiç teslim edilemedi. Bu e-postalar bir davet bağlantısı, bir parola sıfırlama bağlantısı ya da bir bağışçı giriş bağlantısı taşır; gönderilemediğinde ilgili kişi hesabına hiç giremez. Posta sunucusu ayarlarını ve SMTP kimlik bilgilerini kontrol edin. Bir davet için yönetici, kullanıcı ekranından yeniden davet gönderip bağlantıyı kendisi iletebilir.',
      },
      SCHEDULE_STALE: {
        title: 'Zamanlanmış bir iş aksıyor',
        description:
          'Bu zamanlamanın son iki planlı çalışmasının hiçbiri başarıyla tamamlanmadı. Eksik bir çalışma kendiliğinden yeniden kuyruğa alınır; bu uyarı, o çalışmaların da başarısız olduğu ya da hiç çalışmadığı anlamına gelir. Başarısız işler ve zamanlanmış çalışmalar ekranlarını kontrol edin.',
      },
      RATES_BULLETIN_STALE: {
        title: 'TCMB kur bülteni bir haftadır kaydedilemiyor',
        description:
          'Son kayıtlı TCMB bülteninden bu yana en az beş iş günü için bülten kaydedilmedi. Bağışlar son kayıtlı bültenin kuruyla dondurulmaya devam ediyor. TCMB erişimini ve kur çekme işinin hatalarını kontrol edin.',
      },
      RATES_DAY_START_MISSING: {
        title: 'Bugünün TCMB bülteni gün bitmeden kaydedilmedi',
        description:
          'Bugünün 16:45 kur çekme çalışması başarısız oldu ya da hiç çalışmadı ve bugüne ait bir TCMB bülteni kaydedilmedi. Gece yarısından önce başarısız işi yeniden denemezseniz yarın girilen bağışlar bir önceki bülteni dondurur. Bülten yayımlanmadıysa bir işlem gerekmez.',
      },
      RATES_CURRENCY_MISSING: {
        title: 'TCMB bülteninde bir para birimi eksik',
        description:
          'Kaydedilen TCMB bülteni, bir önceki bültende bulunan para birimlerinden en az birini içermiyor. Bülten yayımlandığı gibi kaydedildi; eksik para birimleri daha önceki bir bültenin kuruyla dönüştürülür.',
      },
      PROVIDER_PARTIAL_REVERSAL: {
        title: 'Kısmi kart iadesi veya itirazı elle işlenmeli',
        description:
          'Ödeme sağlayıcısı bir kart tahsilatı için kısmi bir iade ya da itiraz bildirdi. Kısmi ters kayıt otomatik yapılmaz ve hiçbir kayıt değiştirilmedi; ilgili mutabakatı ve bağışı inceleyip elle işleyin.',
      },
      DONOR_PRIVACY_REQUEST_OPEN: {
        title: 'Bir bağışçı kişisel verileri için başvuruda bulundu',
        description:
          'Bir bağışçı, bağış sitesindeki hesabından kendisi hakkında tutulan verilerin bir kopyasını ya da silinmesini talep etti. Talep kaydedildi; hiçbir kayıt değiştirilmedi. KVKK gereği yasal süre içinde yanıtlanması gerekir. Talebi denetim kayıtlarından bağışçı kimliğiyle inceleyip yanıtlayın.',
      },
      PLEDGE_CHARGE_UNRESOLVED: {
        title: 'Düzenli bir bağış tahsilatının sonucu öğrenilemedi',
        description:
          'Bir düzenli bağış için ödeme sağlayıcısından tahsilat istendi, ancak sonucu bildiren doğrulanmış bir bildirim hiç gelmedi. Para çekilmiş olabilir ve bu dönem için henüz bir bağış kaydı oluşturulmadı. Sistem tahsilatı körlemesine tekrar istemez: önce sağlayıcıya bu dönemin ödemesini sorar, ödeme bulunursa dönemi kendisi kapatır ve yalnızca sağlayıcı hiçbir ödeme olmadığını doğrularsa yeniden tahsilat ister. Sağlayıcı üç gün içinde sonucu söyleyemezse sistem sormayı bırakır; bu durumda sağlayıcının panelinden ilgili ödemeyi kontrol edip elle işleyin.',
      },
      OUTBOX_INTENT_STUCK: {
        title: 'Bekleyen bir iş yeniden gönderilmesine rağmen tamamlanmıyor',
        description:
          'Kaydı işlenmeyi bekleyen bir iş, gönderimi kaybolmuş sayılıp birkaç kez yeniden kuyruğa alındı ve hâlâ tamamlanmadı. Genellikle işin bağlı olduğu bir servis (virüs tarayıcı, dosya deposu, TCMB, e-posta sunucusu) erişilemez durumdadır. Başarısız işler ekranını kontrol edin.',
      },
      MOVEMENT_RATES_OVERDUE: {
        title: 'Hareketlerin döviz karşılıkları günlerdir hesaplanamıyor',
        description:
          'Banka hareketlerinin TRY, USD ve EUR karşılıkları, hareketin kayıt gününden önceki kesinleşmiş TCMB bülteninin kuruyla dondurulur. Listelenen hareketler kayıt gününden en az üç iş günü geçtiği hâlde hâlâ “Kur bekleniyor” durumunda; bu hareketlerle farklı para birimli eşleştirme ve sepet kapatma yapılamaz. Hareketler Hesap Hareketleri ekranında “Kur bekleniyor” süzgeciyle listelenir. Genellikle o günlerden birinin TCMB bülteni kaydedilmemiştir ya da kur çekme işi o gün için başarısız olmuştur. Döviz Kurları ve Zamanlanmış Çalışmalar ekranlarında eksik günü kontrol edin, gerekirse “Arşivden Doldur” ile bülteni çekin ya da “Kur Gir” ile elle kur girin. Kur kaydedildiğinde hareketler 30 dakika içinde kendiliğinden dolar ve bu uyarı kapanır.',
      },
      MOVEMENT_CURRENCY_UNQUOTED: {
        title: 'TCMB’nin kur yayımlamadığı bir para biriminde hareket var',
        description:
          'Bu para birimi son kayıtlı 10 TCMB bülteninin hiçbirinde yer almıyor (PLN, CZK ve BGN gibi). Bu yüzden listelenen hareketlerin döviz karşılıkları hiçbir zaman kendiliğinden hesaplanmaz ve bu hareketlerle farklı para birimli eşleştirme yapılamaz; aynı para birimindeki bağışlarla eşleştirilebilirler. Hareketler Hesap Hareketleri ekranında “Kur bekleniyor” süzgeciyle listelenir. Döviz Kurları ekranında “Kur Gir” ile ilgili günlerin kurunu elle girerseniz hareketler 30 dakika içinde dolar. Bülten bu para birimini normalde yayımlıyorsa son bültenlerin eksik kaydedilmiş olup olmadığını kontrol edin.',
      },
      PROVIDER_CALLBACK_REFUSED: {
        title: 'Doğrulanmış bir ödeme bildirimi reddedildi',
        description:
          'Ödeme sağlayıcısından gelen ve imzası doğrulanmış bir bildirim, bir kural nedeniyle uygulanamadı ve hiçbir kayıt değiştirilmedi. Sağlayıcı bildirimi yeniden gönderse de sonuç değişmez. Aşağıdaki nedeni, ödeme bağlantısını ve bağışı inceleyip elle işleyin. Neden, eşleştirmenin parasının bir kurum kasasına aktarılmış olması ise sağlayıcı parayı geri almıştır; listelenen kurum aktarımlarını iptal edin ya da geri alın, ardından eşleştirmeyi geri alıp makbuzu iptal edin.',
      },
      RECEIPT_VOIDED_ON_CERTIFICATE: {
        title: 'Yıllık belgede listelenen bir makbuz iptal edildi',
        description:
          'Bir sağlayıcı ters kaydı, düzenlenmiş bir yıllık bağış belgesinde listelenen bir bağış makbuzunu iptal etti. Yıllık belgeyi iptal edip yeniden düzenleyin.',
      },
    },
    detailLabels: {
      eventKind: 'Bildirim türü',
      reason: 'Red nedeni',
      paymentLinkId: 'Ödeme bağlantısı',
      organizationAccountId: 'Kuruluş hesabı',
      scheduleId: 'Zamanlama',
      job: 'İş',
      missedRunDates: 'Başarısız ya da eksik çalışma günleri',
      lastSucceededRunDate: 'Son başarılı çalışma günü',
      latestBulletinDate: 'Son kayıtlı bülten günü',
      weekdaysWithoutBulletin: 'Bülten kaydedilmeyen iş günü sayısı',
      rateDate: 'Kur günü',
      afternoonRun: '16:45 çalışmasının durumu',
      currencies: 'Eksik para birimleri',
      provider: 'Sağlayıcı',
      kind: 'Tür',
      reconciliationId: 'Mutabakat kaydı',
      donationId: 'Bağış kaydı',
      providerTransactionId: 'Sağlayıcı işlem numarası',
      providerReversalId: 'Sağlayıcı iade veya itiraz numarası',
      amountMinor: 'Bildirilen tutar',
      pledgeId: 'Düzenli bağış kaydı',
      pledgeChargeId: 'Tahsilat kaydı',
      dueDate: 'Vade günü',
      requestedAt: 'Sağlayıcıya sorulduğu an',
      captureAmountMinor: 'Tahsilat tutarı',
      currency: 'Para birimi',
      receiptId: 'Makbuz kaydı',
      requestId: 'Talep kaydı',
      organizationId: 'Kuruluş',
      certificateIds: 'Yıllık belge kayıtları',
      institutionTransferIds: 'İptal edilecek ya da geri alınacak kurum aktarımları',
      mailKind: 'E-posta türü',
      subjectId: 'İlgili kayıt',
      intentKey: 'Örnek bekleyen kayıt',
      redispatches: 'Bu kaydın yeniden gönderilme sayısı',
      stuckIntents: 'Takılı kalan kayıt sayısı',
      movements: 'Kur bekleyen hareket sayısı',
      oldestBookedOn: 'En eski kayıt günü',
      newestBookedOn: 'En yeni kayıt günü',
      movementIds: 'En eski hareketlerin kayıtları',
      movementCurrencies: 'Kur bekleyen hareketlerin para birimleri',
    },
  },
  notification: {
    title: 'Bildirim Gönderimleri',
    subtitle: 'Kime, hangi kanaldan, ne zaman haber verildiği',
    empty: 'Bildirim gönderimi yok',
    emptyHint: 'Seçtiğiniz süzgeçlere uyan bir bildirim bulunamadı.',
    csvFile: 'bildirim-gonderimleri',
    event: 'Olay',
    channel: 'Kanal',
    audience: 'Alıcı türü',
    recipient: 'Alıcı',
    destination: 'Gönderildiği adres',
    destinationHint: 'Adresin tamamı hiçbir ekranda ve hiçbir günlükte gösterilmez.',
    subjectColumn: 'Konu',
    status: 'Durum',
    queuedAt: 'Sıraya alındı',
    settledAt: 'Sonuçlandı',
    attempts: 'Deneme',
    failureCode: 'Hata kodu',
    suppressionReason: 'Gönderilmeme nedeni',
    cause: 'Kaynak kayıt',
    organization: 'Kuruluş',
    templateVersion: 'Şablon sürümü',
    body: 'Gönderilen metin',
    hiddenWhileMasked:
      'İleti metni rumuzlu görünümde gizlenir; olay başlığı ve kayıt bağlantısı görünür. Metin, gerçek adlar açılınca görünür.',
    detail: 'Bildirim ayrıntısı',
    filterStatus: 'Durum',
    filterChannel: 'Kanal',
    filterEvent: 'Olay',
    all: 'Tümü',
    from: 'Başlangıç',
    to: 'Bitiş',
    deliveriesTab: 'Gönderimler',
    templatesTab: 'Şablonlar',
    templateVariables: 'Şablon değişkenleri',
    whatsappTemplate: 'WhatsApp şablonu',
    centre: {
      title: 'Bildirimler',
      empty: 'Yeni bildiriminiz yok',
      markAllRead: 'Tümünü okundu işaretle',
      markRead: 'Okundu işaretle',
      viewAll: 'Tüm gönderimler',
      openRecord: 'Kaydı aç',
      unread: '{{count}} okunmamış',
    },
    preferences: {
      title: 'Bildirim tercihleri',
      subtitle: 'Hangi olayı hangi kanaldan almak istediğinizi buradan seçersiniz.',
      channelColumn: 'Kanal',
      frequencyColumn: 'Sıklık',
      defaultRow: 'Tüm bildirimler',
      saved: 'Bildirim tercihiniz kaydedildi',
      unavailable: 'Bu kanal için kayıtlı bir adresiniz yok.',
    },
    channels: {
      email: 'E-posta',
      sms: 'SMS',
      whatsapp: 'WhatsApp',
      in_app: 'Uygulama içi',
      push: 'Anlık bildirim',
    },
    audiences: {
      user: 'Kullanıcı',
      donor: 'Bağışçı',
      evidence_recipient: 'Bağışta adı geçen kişi',
    },
    statuses: {
      pending: 'Sırada',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi',
      failed: 'Başarısız',
      delivery_unknown: 'Sonucu bilinmiyor',
      suppressed: 'Gönderilmedi',
    },
    frequencies: {
      immediate: 'Anında',
      off: 'Kapalı',
    },
    suppression: {
      preference_off: 'Alıcı bu kanalı kapatmış',
      no_destination: 'Alıcının bu kanal için adresi yok',
      no_consent: 'Bağışçı iletişim izni vermemiş',
      withdrawn: 'Gönderimden önce kanıt bağlantısı geri alındı',
      donation_deleted: 'Gönderimden önce bağış silindi',
    },
    failure: {
      NOTIFICATION_PROVIDER_UNCONFIGURED:
        'Bu kanalın sağlayıcısı tanımlı değil, bu yüzden gönderim hiç denenmedi.',
      NOTIFICATION_PROVIDER_UNAVAILABLE:
        'Sağlayıcıya ulaşılamadı ya da sağlayıcı geçici bir hata döndürdü.',
      NOTIFICATION_PROVIDER_REFUSED: 'Sağlayıcı gönderimi reddetti.',
      NOTIFICATION_DESTINATION_INVALID:
        'Alıcının adresi ya da numarası bu kanal için geçerli değil.',
      NOTIFICATION_TEMPLATE_UNAPPROVED:
        'WhatsApp şablonu sağlayıcıda onaylı değil, bu yüzden mesaj gönderilemedi.',
      NOTIFICATION_DELIVERY_UNKNOWN:
        'Gönderim sağlayıcıya iletilirken kesildi. Aynı mesaj ikinci kez gönderilmez; gerekiyorsa elle iletin.',
      NOTIFICATION_GATEWAY_INSTANCE_UNKNOWN:
        'WhatsApp geçidinde bu adla tanımlı bir oturum yok. Numaranın geçitte bağlanması gerekiyor.',
      NOTIFICATION_GATEWAY_AWAITING_LINK:
        'WhatsApp geçidi karekodun okutulmasını bekliyor. Numara bağlanana kadar mesaj gönderilemez.',
      NOTIFICATION_GATEWAY_SESSION_CLOSED:
        'WhatsApp geçidinin oturumu kapalı: numara çıkış yapmış ya da engellenmiş olabilir. Geçidi kontrol edin.',
      NOTIFICATION_AUTHENTICATION_NOT_ALLOWED:
        'Kimlik doğrulayan mesajlar resmî olmayan WhatsApp geçidinden gönderilmez; bu mesaj hiç denenmedi.',
      NOTIFICATION_LINK_UNAVAILABLE:
        'Mesajın taşıyacağı kanıt bağlantısı oluşturulamadı: kuruluşun etkin bir bağış sitesi yok. Site tanımlandığında gönderim yeniden denenebilir.',
      NOTIFICATION_SENDER_UNSEALABLE:
        'Kuruluşun kendi gönderim hesabının şifresi çözülemedi; mesaj paylaşılan hesaptan gönderilmedi. Hesabı yeniden tanımlayın.',
    },
    events: {
      receiptIssued: 'Makbuz düzenlendi',
      pledgeChargeFailed: 'Düzenli bağış tahsil edilemedi',
      pledgeCancelled: 'Düzenli bağış sonlandırıldı',
      donationRecorded: 'Bağışınız kaydedildi',
      donationRequestRecorded: 'Talebiniz kaydedildi',
      donationRecordedOwner: 'Adınıza bir bağış kaydedildi',
      donationRecordedReference: 'Referans olduğunuz bağış kaydedildi',
      donationRecordedOperator: 'Girdiğiniz bağış kaydedildi',
      donationFulfilled: 'Bağışınız gerçekleşti',
      donationEvidenceReady: 'Bağışınızın kanıtı hazır',
      donationEvidenceReadyReference: 'Referans olunan bağışın kanıtı hazır',
      donationEvidenceReadyOwner: 'Adınıza yapılan bağışın kanıtı hazır',
      donationEvidenceReadyOperator: 'Girdiğiniz bağışın kanıtı hazır',
      donorPrivacyRequestAnswered: 'Kişisel veri başvurusu yanıtlandı',
      donationAssigned: 'Kurumunuza bir bağış verildi',
      /**
       * Artık hiçbir şey yazmıyor (docs/decisions/0077, 0080); 0077'den önce
       * yazılmış bildirim satırları adıyla okunabilsin diye adı duruyor.
       */
      donationApprovalAdvanced: 'Onay sırası ilerledi',
      reconciliationUnmatched: 'Eşleşmeyen banka hareketi',
      reconciliationAwaitingApproval: 'Onay bekleyen eşleştirme',
      campaignGoalReached: 'Kampanya hedefine ulaşıldı',
      userPermissionsChanged: 'Yetkileriniz değişti',
      campaignStaffAssigned: 'Bir kampanyada görevlendirildiniz',
    },
    /**
     * Bir olayın metni. `version`, gönderilen satırda saklanır: şablon sonradan
     * değişse de bir kişiye tam olarak ne yazıldığı okunabilir kalır.
     */
    templates: {
      receiptIssued: {
        version: 1,
        subject: '{{organizationName}} — Bağış makbuzunuz hazır',
        body: '{{issuedOn}} tarihli {{amount}} tutarındaki bağışınız için {{receiptNo}} numaralı makbuz düzenlendi. Makbuzunuzu bağışçı hesabınızdan görüntüleyebilir ve indirebilirsiniz.',
        short:
          '{{organizationName}}: {{amount}} tutarındaki bağışınız için {{receiptNo}} numaralı makbuz düzenlendi ({{issuedOn}}).',
      },
      pledgeChargeFailed: {
        version: 1,
        subject: '{{organizationName}} — Düzenli bağışınız tahsil edilemedi',
        body: '{{campaignName}} için {{dueDate}} vadeli {{amount}} tutarındaki düzenli bağışınız tahsil edilemedi ve düzenli bağışınız durduruldu. Ödeme yönteminizi güncelleyip bağışçı hesabınızdan yeniden başlatabilirsiniz.',
        short:
          '{{organizationName}}: {{campaignName}} için {{dueDate}} vadeli {{amount}} tutarındaki düzenli bağışınız tahsil edilemedi.',
      },
      pledgeCancelled: {
        version: 1,
        subject: '{{organizationName}} — Düzenli bağışınız sonlandırıldı',
        body: '{{campaignName}} için {{amount}} tutarındaki düzenli bağışınız sonlandırıldı ve bundan sonra hiçbir tahsilat yapılmayacak. Dilediğiniz zaman bağışçı hesabınızdan yeniden başlatabilirsiniz.',
        short:
          '{{organizationName}}: {{campaignName}} için {{amount}} tutarındaki düzenli bağışınız sonlandırıldı.',
      },
      donationRecorded: {
        version: 1,
        subject: '{{organizationName}} — Bağışınız kaydedildi',
        body: '{{campaignName}} kampanyası için {{amount}} tutarındaki bağışınız {{referenceCode}} referans numarasıyla kaydedildi. Allah kabul etsin. Bağışınız gerçekleştiğinde size ayrıca bilgi vereceğiz.',
        short:
          '{{organizationName}}: {{campaignName}} için {{amount}} tutarındaki bağışınız kaydedildi. Referans {{referenceCode}}.',
      },
      donationRequestRecorded: {
        version: 1,
        subject: '{{organizationName}} — Talebiniz kaydedildi',
        body: '{{campaignName}} için talebiniz {{referenceCode}} referans numarasıyla kaydedildi. Bu hizmet için sizden bir ücret alınmaz. Talebiniz yerine getirildiğinde size ayrıca bilgi vereceğiz.',
        short:
          '{{organizationName}}: {{campaignName}} talebiniz kaydedildi, ücret alınmaz. Referans {{referenceCode}}.',
      },
      donationRecordedOwner: {
        version: 1,
        subject: '{{organizationName}} — Adınıza bir bağış kaydedildi',
        body: '{{organizationName}} aracılığıyla adınıza {{campaignName}} kampanyası için yapılan bir bağış {{referenceCode}} referans numarasıyla kaydedildi. Allah kabul etsin.',
        short:
          '{{organizationName}}: adınıza {{campaignName}} bağışı kaydedildi. Referans {{referenceCode}}.',
      },
      donationRecordedReference: {
        version: 1,
        subject: '{{organizationName}} — Referans olduğunuz bağış kaydedildi',
        body: '{{organizationName}} aracılığıyla {{onBehalfOf}} adına {{campaignName}} kampanyası için yapılan ve sizin referans olduğunuz bağış kaydedildi.',
        short:
          '{{organizationName}}: referans olduğunuz {{onBehalfOf}} adına {{campaignName}} bağışı kaydedildi.',
        unnamed: {
          body: '{{organizationName}} aracılığıyla {{campaignName}} kampanyası için yapılan ve sizin referans olduğunuz bağış kaydedildi.',
          short: '{{organizationName}}: referans olduğunuz {{campaignName}} bağışı kaydedildi.',
        },
      },
      donationRecordedOperator: {
        version: 1,
        subject: '{{organizationName}} — Girdiğiniz bağış kaydedildi',
        body: '{{onBehalfOf}} adına {{campaignName}} kampanyası için girdiğiniz bağış {{referenceCode}} referans numarasıyla kaydedildi.',
        short:
          '{{organizationName}}: girdiğiniz {{onBehalfOf}} adına {{campaignName}} bağışı kaydedildi. Referans {{referenceCode}}.',
        unnamed: {
          body: '{{campaignName}} kampanyası için girdiğiniz bağış {{referenceCode}} referans numarasıyla kaydedildi.',
          short:
            '{{organizationName}}: girdiğiniz {{campaignName}} bağışı kaydedildi. Referans {{referenceCode}}.',
        },
      },
      donationFulfilled: {
        version: 1,
        subject: '{{organizationName}} — Bağışınız gerçekleşti',
        body: '{{campaignName}} kampanyası için {{referenceCode}} referans numaralı bağışınız {{fulfilledOn}} tarihinde {{location}} tarafından gerçekleştirildi. Allah kabul etsin.',
        short:
          '{{organizationName}}: {{campaignName}} bağışınız {{fulfilledOn}} tarihinde {{location}} tarafından gerçekleştirildi. Referans {{referenceCode}}.',
      },
      /**
       * `unnamed`, bir bağış kimse adına yapılmadığında ya da anonim olduğunda
       * kullanılan metindir: "… adına" ibaresi hiç yer almaz, yerine bir
       * yer tutucu kelime de yazılmaz.
       */
      donationEvidenceReady: {
        version: 2,
        subject: '{{organizationName}} — Bağışınızın gerçekleştirme kanıtı hazır',
        body: '{{onBehalfOf}} adına {{campaignName}} kampanyası için yaptığınız bağışın gerçekleştirildiğini gösteren fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı size özeldir ve belirli bir süre açık kalır. Allah kabul etsin.',
        short:
          '{{organizationName}}: {{onBehalfOf}} adına {{campaignName}} bağışınızın kanıtı hazır: {{link}}',
        unnamed: {
          body: '{{campaignName}} kampanyası için yaptığınız bağışın gerçekleştirildiğini gösteren fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı size özeldir ve belirli bir süre açık kalır. Allah kabul etsin.',
          short: '{{organizationName}}: {{campaignName}} bağışınızın kanıtı hazır: {{link}}',
        },
      },
      donationEvidenceReadyReference: {
        version: 2,
        subject: '{{organizationName}} — Bir bağışın gerçekleştirme kanıtı',
        body: '{{organizationName}} aracılığıyla {{onBehalfOf}} adına {{campaignName}} kampanyası için yapılan ve sizin referans olduğunuz bağış gerçekleştirildi. Fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı belirli bir süre açık kalır; artık bilgi almak istemiyorsanız aynı sayfadan bildirebilirsiniz.',
        short:
          '{{organizationName}}: referans olduğunuz {{onBehalfOf}} adına {{campaignName}} bağışının kanıtı: {{link}}',
        unnamed: {
          body: '{{organizationName}} aracılığıyla {{campaignName}} kampanyası için yapılan ve sizin referans olduğunuz bağış gerçekleştirildi. Fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı belirli bir süre açık kalır; artık bilgi almak istemiyorsanız aynı sayfadan bildirebilirsiniz.',
          short:
            '{{organizationName}}: referans olduğunuz {{campaignName}} bağışının kanıtı: {{link}}',
        },
      },
      donationEvidenceReadyOwner: {
        version: 1,
        subject: '{{organizationName}} — Adınıza yapılan bağışın gerçekleştirme kanıtı',
        body: '{{organizationName}} aracılığıyla adınıza {{campaignName}} kampanyası için yapılan bağış gerçekleştirildi. Fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı size özeldir ve belirli bir süre açık kalır; artık bilgi almak istemiyorsanız aynı sayfadan bildirebilirsiniz. Allah kabul etsin.',
        short:
          '{{organizationName}}: adınıza yapılan {{campaignName}} bağışının kanıtı hazır: {{link}}',
      },
      donationEvidenceReadyOperator: {
        version: 2,
        subject: '{{organizationName}} — Girdiğiniz bağışın gerçekleştirme kanıtı hazır',
        body: '{{onBehalfOf}} adına {{campaignName}} kampanyası için girdiğiniz bağışın gerçekleştirme kanıtı hazır. Fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı belirli bir süre açık kalır.',
        short: '{{organizationName}}: girdiğiniz {{campaignName}} bağışının kanıtı: {{link}}',
        unnamed: {
          body: '{{campaignName}} kampanyası için girdiğiniz bağışın gerçekleştirme kanıtı hazır. Fotoğraf ve videolara şu bağlantıdan ulaşabilirsiniz: {{link}} Bağlantı belirli bir süre açık kalır.',
          short: '{{organizationName}}: girdiğiniz {{campaignName}} bağışının kanıtı: {{link}}',
        },
      },
      donorPrivacyRequestAnswered: {
        version: 1,
        subject: '{{organizationName}} — Kişisel veri başvurunuz yanıtlandı',
        body: '{{kind}} talebiniz sonuçlandırıldı. Ayrıntıları bağışçı hesabınızdan görebilirsiniz.',
        short: '{{organizationName}}: {{kind}} talebiniz sonuçlandırıldı.',
      },
      donationAssigned: {
        version: 2,
        subject: '{{institutionName}} — {{campaignName}} için yeni bir bağış',
        body: '{{campaignName}} kampanyasının {{referenceCode}} referanslı bağışı gerçekleştirilmek üzere {{institutionName}} kurumuna verildi. Adına yapılan kişi: {{onBehalfOf}}.',
        short: '{{institutionName}}: {{campaignName}} — {{referenceCode}}. Adına: {{onBehalfOf}}.',
        unnamed: {
          body: '{{campaignName}} kampanyasının {{referenceCode}} referanslı bağışı gerçekleştirilmek üzere {{institutionName}} kurumuna verildi. Kanıt görselinde bir isim yer almayacak.',
          short:
            '{{institutionName}}: {{campaignName}} — {{referenceCode}}. Kanıtta isim yer almayacak.',
        },
      },
      reconciliationUnmatched: {
        version: 1,
        subject: 'Eşleşmeyen bir banka hareketi var',
        body: '{{accountName}} hesabına {{bookedOn}} tarihinde geçen {{amount}} tutarındaki hareket hiçbir bağışla eşleşmedi.',
        short: '{{accountName}}: {{bookedOn}} tarihli {{amount}} tutarındaki hareket eşleşmedi.',
      },
      reconciliationAwaitingApproval: {
        version: 1,
        subject: 'Onay bekleyen bir eşleştirme var',
        body: '{{referenceCode}} referanslı bağış ile {{bookedOn}} tarihli {{amount}} tutarındaki hareketin eşleştirilmesi onayınızı bekliyor.',
        short:
          '{{referenceCode}} — {{bookedOn}} tarihli {{amount}} tutarındaki eşleştirme onayınızı bekliyor.',
      },
      campaignGoalReached: {
        version: 1,
        subject: '{{campaignName}} hedefine ulaştı',
        body: '{{campaignName}} kampanyasının {{periodName}} dönemi {{amount}} tutarındaki hedefine ulaştı.',
        short: '{{campaignName}} {{periodName}} dönemi {{amount}} hedefine ulaştı.',
      },
      campaignStaffAssigned: {
        version: 1,
        subject: '{{campaignName}} — {{institutionName}} görevlendirmesi',
        body: '{{assignedBy}} sizi {{institutionName}} kurumunda {{campaignName}} kampanyasında görevlendirdi. Görevlendirmelerinizi Görevlerim ekranında görebilirsiniz.',
        short:
          '{{institutionName}}: {{campaignName}} kampanyasında görevlendirildiniz ({{assignedBy}}).',
      },
      userPermissionsChanged: {
        version: 1,
        subject: 'BTSis — Yetkileriniz değişti',
        body: 'BTSis hesabınızın yetkileri ya da kapsamı {{changedBy}} tarafından değiştirildi. Bir sonraki girişinizde yeni yetkileriniz geçerli olur.',
        short: 'BTSis: hesabınızın yetkileri {{changedBy}} tarafından değiştirildi.',
      },
    },
  },
  report: {
    title: 'Raporlar',
    subtitle: 'PRD §10 — kapsamınıza göre toplamlar, kampanya performansı ve karşılaştırmalar',
    asOf: 'Rakamlar {{at}} itibarıyla',
    asOfNever: 'Rapor tablosu henüz bir kez bile yenilenmedi',
    asOfHint:
      'Raporlar, bağış tablosunun üzerinde tutulan ve beş dakikada bir yenilenen rapor tablosundan okunur.',
    tabs: {
      totals: 'Bağış Toplamları',
      campaigns: 'Kampanya Performansı',
      reconciliation: 'Mutabakat Farkları',
      donors: 'Bağışçı Segmentleri',
      transfers: 'Fon Transferleri',
      seasons: 'Sezon Karşılaştırması',
    },
    level: 'Kırılım',
    levels: {
      region: 'Bölge',
      zone: 'Mıntıka',
      country: 'Ülke',
      institution: 'Kurum',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    compare: 'Önceki dönemle karşılaştır',
    comparePeriod: 'Karşılaştırma dönemi',
    node: 'Birim',
    nodeCode: 'Kod',
    currency: 'Para birimi',
    amount: 'Tutar',
    pledged: 'Taahhüt',
    collected: 'Tahsilat',
    fulfillmentCost: 'Gerçekleştirme maliyeti',
    donationCount: 'Bağış adedi',
    rateDate: 'Kur tarihi',
    unconverted: 'Çevrilemeyen para birimleri',
    unconvertedHint:
      'Şu para birimleri için dönem sonuna kadar yayımlanmış bir kur bulunamadı, bu yüzden toplama katılmadı: {{currencies}}',
    change: 'Değişim',
    campaign: 'Kampanya',
    season: 'Sezon',
    goal: 'Hedef',
    goalProgress: 'Hedefe ulaşma',
    noGoal: 'Hedef yok',
    organization: 'Kuruluş',
    unmatched: 'Eşleşmemiş hareket',
    unsettled: 'Tahsil edilmemiş bağış',
    outgoing: 'Giden',
    incoming: 'Gelen',
    awaitingApproval: 'Onay bekleyen',
    awaitingCompletion: 'Tamamlanmayı bekleyen',
    segment: 'Segment',
    donorCount: 'Bağışçı adedi',
    segments: {
      new: 'Yeni bağışçı',
      repeat: 'Tekrar eden bağışçı',
      sponsor: 'Sponsor',
    },
    segmentOrder:
      'Bir bağışçı tek bir segmentte sayılır: önce sponsor, sonra tekrar eden, sonra yeni.',
    export: 'Dışa Aktar',
    empty: 'Bu aralıkta rapor satırı bulunamadı',
    emptyHint: 'Tarih aralığını genişletmeyi veya filtreleri değiştirmeyi deneyin.',
    total: 'Toplam',
    live: 'Bu rapor canlı okunur, rapor tablosundan değil.',
  },
  nav: {
    dashboard: 'Genel Bakış',
    gallery: 'Bileşen Galerisi',
    donations: 'Bağışlar',
    donationImports: 'Veri Yükleme',
    donationQueue: 'Gerçekleştirme Sırası',
    operations: 'Operasyon İşlemleri',
    operationCampaigns: 'Kampanyalar',
    printoutLists: 'PDF Yönetimi',
    allOperationCampaigns: 'Tüm kampanyalar',
    deletedDonations: 'Silinen Kayıtlar',
    donors: 'Bağışçılar',
    donorLinkRequests: 'Bağlantı Talepleri',
    campaigns: 'Kampanyalar',
    campaignCategories: 'Kampanya Kategorileri',
    printoutTemplates: 'PDF Şablonları',
    campaignManagement: 'Kampanya Yönetimi',
    pledges: 'Düzenli Bağışlar',
    finance: 'Muhasebe',
    institutionLedger: 'Kurum Cari Hesapları',
    financeGuide: 'Muhasebe Kılavuzu',
    reconciliation: 'Mutabakat',
    reconciliationApprovals: 'Onay Bekleyen Eşleştirmeler',
    shortfalls: 'Eksik Tahsilatlar',
    payouts: 'Kart Ödemeleri',
    balances: 'Bakiyeler',
    consolidation: 'Konsolidasyon',
    refunds: 'İadeler',
    fundTransfers: 'Fon Transferleri',
    statements: 'Hesap Hareketleri',
    statementImports: 'Ekstreler',
    statementProfiles: 'Ekstre Formatları',
    receipts: 'Makbuzlar',
    annualCertificates: 'Yıllık Bağış Özetleri',
    organization: 'Organizasyon',
    regions: 'Bölgeler',
    zones: 'Mıntıkalar',
    countries: 'Ülkeler',
    institutions: 'Kurumlar',
    organizations: 'Kuruluşlar',
    system: 'Sistem',
    users: 'Kullanıcılar',
    roles: 'Roller',
    auditLog: 'Denetim İzi',
    generatedFiles: 'Dosyalarım',
    jobFailures: 'Başarısız İşler',
    integrations: 'Entegrasyonlar',
    scheduledRuns: 'Zamanlanmış Çalışmalar',
    notifications: 'Bildirim Gönderimleri',
    reports: 'Raporlar',
    donationBoxes: 'Kumbaralar',
    donationBoxesOut: 'Sahadaki Kumbaralar',
    exchangeRates: 'Döviz Kurları',
    inboundMedia: 'Gelen Medya',
    donationFulfilmentInbox: 'Gerçekleştirme Kutusu',
    assignedWork: 'Görev Kutusu',
    campaignStaff: 'Kampanya Görevlendirmeleri',
    myAssignments: 'Görevlerim',
    donationCampaigns: 'Kampanya bağış listeleri',
  },
  dashboard: {
    welcome: 'Hoş geldiniz, {{name}}',
    subtitle: '{{appName}} yönetim paneline hoş geldiniz.',
    scopeLine: '{{scope}} · {{from}} – {{to}}',
    scope: 'Veri kapsamı',
    institution: 'Kurum',
    roles: 'Roller',
    permissions: 'Yetki sayısı',
    collected: 'Son 30 Gün',
    campaignProgress: 'Kampanya Hedefleri',
    noCampaignGoals: 'Bu aralıkta hedefi olan bir kampanya dönemi yok.',
    noPanels: 'Ana ekranda gösterilecek bir bölüm yetkiniz bulunmuyor.',
    noComparison: 'Önceki dönemde karşılaştırılacak tahsilat yok.',
    changeOnPrevious: 'Önceki döneme göre %{{change}}',
    pending: {
      awaitingFulfilment: 'Gerçekleştirme bekleyen bağış',
      unmatchedTransactions: 'Eşleşmemiş hesap hareketi',
      openJobFailures: 'Açık iş hatası',
    },
  },
  donation: {
    title: 'Bağışlar',
    subtitle: 'Kampanya dönemlerine girilen bağış kayıtları',
    new: 'Yeni Bağış',
    entryTitle: 'Bağış Girişi',
    empty: 'Bağış kaydı yok',
    emptyHint: 'Filtreleri değiştirin veya yeni bir bağış girin.',
    scopeNotice: 'Yalnızca veri kapsamınızdaki bağışlar listelenir.',
    referenceCode: 'Referans Kodu',
    attribution: {
      fulfillmentInstitution: 'Gerçekleştirilecek Kurum',
      ownInstitutionName: '{{name}} (Kendi Kurumu Olarak)',
      recordedBy: 'Kaydı Oluşturan',
      operatorLine: 'Operatör: {{name}}',
      recordingInstitution: 'Kayıt Eden Kurum',
      own: 'Kendi Kurumu Olarak',
      ownYes: 'Evet',
      ownNo: 'Hayır',
      filterByValue: 'Bu değere göre filtrele',
      selectedUser: 'Seçili kullanıcı',
      selectedInstitution: 'Seçili kurum',
      recorderSearch: 'Kaydı oluşturanı arayın',
      noRecorder: 'Eşleşen kullanıcı yok',
    },
    campaign: 'Kampanya',
    selectedCampaign: 'Seçili kampanya',
    category: 'Kategori',
    period: 'Dönem',
    donor: 'Bağışçı',
    selectedDonor: 'Seçili bağışçı',
    anonymousDonor: 'Anonim Bağışçı',
    institution: 'Kurum',
    amount: 'Tutar',
    quantity: 'Adet',
    quantityDecrease: 'Adedi azalt',
    quantityIncrease: 'Adedi artır',
    unitAmount: 'Birim Fiyatı',
    baseAmount: 'TRY Karşılığı',
    baseAmountMissing: 'Kur satırı yok',
    donatedAt: 'Bağış Tarihi',
    paymentMethod: 'Ödeme Şekli',
    paymentReference: 'Ödeme Referansı',
    note: 'Not',
    status: 'Durum',
    paymentStatusLabel: 'Tahsilat',
    currency: 'Para Birimi',
    amountRange: 'Tutar Aralığı',
    dateRange: 'Tarih Aralığı',
    minAmount: 'En az',
    maxAmount: 'En çok',
    from: 'Başlangıç',
    to: 'Bitiş',
    search: 'Referans kodu veya bağışçı adı',
    formTitle: 'Kampanya Formu',
    summaryTitle: 'Tutar',
    selectCampaign: 'Kampanya seçin',
    selectDonor: 'Bağışçı seçin',
    newDonor: 'Yeni bağışçı',
    payerName: 'Bağışçı adı',
    payerNamePlaceholder: 'Ad soyad yazın; kayıtlı bağışçılar listelenir',
    payerPhone: 'Telefon',
    payerHint:
      'Ad ve telefon yeterlidir. Telefon kayıtlı bir bağışçıya aitse bağış o kayda eklenir, değilse yeni bağışçı oluşturulur.',
    payerChosen: 'Kayıtlı bağışçı seçildi: {{name}}',
    payerClear: 'Bağışçı seçimini temizle',
    payerDecisive: 'Telefon eşleşmesi',
    payerLinked: 'Bağlantılı kayıt',
    payerNoCandidates: 'Eşleşen kayıtlı bağışçı yok.',
    onBehalfOfLine: '{{name}} adına',
    saved: 'Bağış kaydedildi: {{code}}',
    quoting: 'Tutar hesaplanıyor…',
    createdBy: 'Kaydeden',
    periodOption: '{{season}} · {{status}}',
    fulfillmentInstitution: 'Kesim Yeri / Yurt',
    selectFulfillmentInstitution: 'Yurt seçin',
    fulfillmentInstitutionHint: 'Yurt seçildiğinde o yurda tanımlı fiyat uygulanır.',
    ownInstitution: 'Kendi Kurumum ({{name}})',
    ownInstitutionPriced: 'Kendi Kurumum ({{name}}) — {{price}}',
    noEligibleAssignments:
      'Bu cevaplara uygun yurt yok. Yurt listesi kampanyanın filtre alanlarına göre daralır; cevapları değiştirin veya görevlendirmelere yetkinlik ekleyin.',
    campaignUnavailable:
      'Bağlantıdaki kampanya sizin için açık değil; lütfen listeden bir kampanya seçin.',
    entry: {
      /**
       * The page's three section headers — GitHub issue #2 §5.1. Kept here, not
       * in the component, so §11.7's configurable labels can override them.
       */
      sections: {
        campaign: 'Kampanya Detayları',
        parties: 'Taraf Bilgileri',
        notifications: 'Bildirim İşlemleri',
      },
      save: 'Kaydet',
      saveAndNew: 'Kaydet ve Yeni Form Aç',
      keeps:
        '«Kaydet ve Yeni Form Aç» kampanyayı, para birimini ve operatörü korur; bağışa ait diğer her şey temizlenir.',
      noActivePeriod:
        'Bu kampanyanın şu an bağış alan bir dönemi yok. Bağış, kampanyanın açık dönemine kaydedilir.',
      noEntryCurrency:
        'Bu kampanyanın dönemi TRY, USD veya EUR ile fiyatlanmamış; bu ekrandan bağış girilemez.',
      noCharge:
        'Bu kampanya ücret almaz: tutar ve para birimi sorulmaz, ödeme beklenmez. Talep kaydedilir, sıraya alınır ve gerçekleştirilir.',
      currencyRequired: 'Para birimi seçin',
      quantityInvalid: 'Adet en az 1 olmalıdır',
      amountRequired: 'Tutarı yazın',
      payerTitle: 'Bağış Yapan',
      ownerTitle: 'Bağış Sahibi',
      referenceTitle: 'Referans',
      partyName: 'Ad Soyad',
      partyPhone: 'Telefon',
      payerPhoneRequired: 'Kayıtlı bir bağışçı seçilmediyse telefonu eksiksiz yazın',
      ownerIsPayer: 'Ödeme yapan ile aynı kişi',
      ownerHint:
        'Kanıt görselinde yer alacak isim; boş bırakılırsa isim yazılmaz. Telefon yazılırsa kişi bağışçı kaydıyla eşleştirilir.',
      ownerChosen: 'Kayıtlı kişi seçildi: {{name}}',
      ownerClear: 'Bağış sahibi seçimini temizle',
      ownerNameRequired: 'Telefon yazıldıysa ya da kişi seçildiyse adı soyadı da yazın',
      referenceHint:
        'Ad tek başına hatırlatma olarak yazılabilir; telefon yazılırsa ad da yazılmalıdır.',
      referenceNameRequired: 'Telefon yazıldıysa referansın adını da yazın',
      operator: 'Operatör',
      operatorHint: 'Bağış, oturumu açık kullanıcı adına kaydedilir.',
      operatorChangeHint:
        'Başka bir kullanıcı adına kaydedebilirsiniz; yalnızca yetkiniz dahilindeki kullanıcılar seçilebilir.',
      operatorLocked: 'Sizde olmayan yetkileri var',
      operatorNoOptions: 'Eşleşen kullanıcı yok.',
      operatorRequired: 'Operatör seçin',
      total: 'Toplam',
      nobody: '—',
    },
    /**
     * The entry form in its second use: correcting a pending or queued donation
     * — docs/plans/11-test-revisions.md §11.9.
     */
    edit: {
      title: 'Bağışı Düzenle',
      action: 'Düzenle',
      save: 'Kaydet',
      cancel: 'Vazgeç',
      saved: 'Bağış güncellendi: {{code}}',
      unchanged: 'Değişiklik yapılmadı',
      campaignFixed: 'Kaydedilmiş bir bağışın kampanyası değiştirilemez.',
      referencePhoneOnFile:
        'Kayıtlı numara: {{phone}}. Değiştirmek için yeni numarayı yazın; boş bırakılırsa kayıtlı numara korunur.',
      operatorFixed:
        'Kaydı gireni değiştirme yetkiniz yok veya bu bağış bir personel tarafından girilmedi.',
      stale:
        'Bu bağış, siz düzenlerken başka biri tarafından değiştirildi. Değişiklikleriniz kaydedilmedi; güncel hâlini yükleyip yeniden düzenleyin.',
      reload: 'Güncel hâlini yükle',
      notEditable:
        'Bu bağış bu durumda düzenlenemez. Bekleyen bir bağış düzenlenebilir; sıradaki bir bağışı yalnızca sıradaki bağışları düzeltme yetkisi olan bir sorumlu düzenleyebilir, gerçekleştirilmiş, iptal edilmiş ya da tahsilatı olan bir bağış düzenlenemez.',
      /** Why the form is read-only, from the server's `editability.reason` — docs/decisions/0118. */
      locked: {
        needs_edit: 'Bu bağışı düzenleme yetkiniz yok. Form salt okunur gösteriliyor.',
        cancelled: 'İptal edilmiş bir bağış düzenlenemez. Form salt okunur gösteriliyor.',
        queued:
          'Bu bağış sıraya alındı. Sıradaki bir bağışı yalnızca sıradaki veya kilitli bağışları düzenleme yetkisi olan bir yönetici düzenleyebilir.',
        listed:
          'Bu bağış bir PDF listesinde. Listedeki bir bağışı yalnızca kilitli bağışları düzenleme yetkisi olan bir yönetici düzenleyebilir.',
        fulfilled:
          'Bu bağış gerçekleşti. Gerçekleşmiş bir bağışı yalnızca kilitli bağışları düzenleme yetkisi olan bir yönetici düzenleyebilir.',
      },
      /** Why some fields are disabled while the rest stay editable. */
      partial: {
        money_received:
          'Bu bağışa ödeme alındı. Tutar, para birimi, adet, yurt ve fiyatı belirleyen cevaplar değiştirilemez; diğer alanları (koşul bilgisi dahil) düzenleyebilirsiniz.',
        fulfilled:
          'Bu bağış gerçekleşti. Tutar, adet, yurt ve gruplamayı ya da fiyatı belirleyen cevaplar değiştirilemez; notu, tarafları ve diğer cevapları düzenleyebilirsiniz.',
      },
      /** What the work done keeps, whoever edits — the server's `editability.holds` (0118 amendment). */
      hold: {
        partly_fulfilled:
          'Bu bağışın bazı hisseleri kesildi. Adet, dönem, yurt ve fiyatı, yurdu ya da gruplamayı belirleyen cevaplar değiştirilemez; notu, tarafları ve diğer cevapları düzenleyebilirsiniz.',
        on_list:
          'Bu bağış etkin bir PDF listesinde. Liste yurdu ve dönemi belirlediği için bunlar değiştirilemez; önce bağışı listeden çıkarın veya listeyi iptal edin.',
        receipt_issued:
          'Bu bağışın geçerli bir makbuzu var ve makbuz bağışçının adını taşıyor. Ödeme yapan kişi değiştirilemez; önce makbuzu iptal edip yeniden düzenleyin.',
      },
      fieldLocked: 'Bu alan bu bağışta değiştirilemez.',
      backToDetail: 'Bağışa dön',
      viewForm: 'Formu görüntüle',
    },
    detailTitle: 'Bağış Detayı',
    notFound: 'Bağış bulunamadı',
    summary: 'Özet',
    answers: 'Form Cevapları',
    answersVersion: 'Form sürümü {{version}}',
    timeline: 'İşlem Geçmişi',
    timelineEmpty: 'Bu kayıt için işlem geçmişi yok.',
    /** The detail page's media and evidence area — docs/decisions/0118. */
    media: {
      title: 'Medya / Kanıt Dosyaları',
      subheader: 'Bu bağışa bağlı tüm görseller, videolar, ses kayıtları ve belgeler',
      empty: 'Bu bağışa bağlı dosya yok.',
      failed: 'Dosyalar alınamadı.',
      count: '{{count}} dosya',
      groups: {
        image: 'Görseller',
        video: 'Videolar',
        audio: 'Ses kayıtları',
        document: 'Belgeler',
      },
      source: {
        evidence: 'Operasyon kanıtı',
        inbound_media: 'Gelen medya',
        form_file: 'Form eki',
        receipt: 'Makbuz',
      },
      availability: {
        available: 'Hazır',
        pending_scan: 'Tarama bekliyor',
        scan_refused: 'Taramadan geçmedi',
        deleted: 'Saklama süresi doldu',
        not_rendered: 'PDF hazırlanıyor',
      },
      preview: 'Önizle',
      download: 'İndir',
      openFailed: 'Dosya açılamadı.',
      noPermission: 'Bu dosyayı açma yetkiniz yok.',
      close: 'Kapat',
      previous: 'Önceki',
      next: 'Sonraki',
      position: '{{index}} / {{total}}',
      linkNote: 'Her önizleme ve indirme işlem geçmişine yazılır; bağlantı bir dakika geçerlidir.',
    },
    submittedAt: 'Kayda Alındı',
    entryChannelLabel: 'Kayıt Kanalı',
    exchangeRateMissing: 'Kur satırı bulunamadı',
    details: {
      back: 'Bağış listesine dön',
      caption: '{{campaign}} · {{date}}',
      recordingInstitution: 'Kayıt kurumu',
      recordingInstitutionEmpty: 'Seçilebilecek kurum bulunamadı.',
      recordingInstitutionHint:
        'Kişiyi değiştirmek kayıt kurumunu değiştirmez. Eski kayıtlar için kurumu ayrıca seçebilirsiniz. Gerçekleşme kaydı varsa önce geri alınmalıdır.',
      changeOperator: 'Kayıt bilgisini düzenle',
      changeOperatorTitle: 'Kayıt bilgisini düzenle',
      changeOperatorHint:
        'Bağış seçtiğiniz kullanıcının adına kaydedilir. Değişiklik, eski ve yeni kullanıcıyla birlikte işlem geçmişine yazılır.',
      changeOperatorConfirm: 'Değiştir',
      changeOperatorDone: 'Kayıt bilgisi güncellendi',
      mainOrganization: {
        label: 'Ana kuruluş',
        none: 'Ana kuruluş yok',
        manual: 'Üst yetkili belirledi',
        automatic: 'Para belirledi',
        entry: 'Kaydı giren kurumun birincil kuruluşu',
        hint: 'Bağışın ana kuruluşu, makbuzun, raporların ve ödeme sayfasının hangi kuruluşa ait olduğunu belirler. Kayıtta kaydı giren kurumun birincil kuruluşudur; para geldikçe bağışı en yüksek tutarla karşılayan hareketin kuruluşuna geçer. Yalnızca üst yetkililer elle değiştirebilir.',
        edit: 'Ana kuruluşu düzenle',
        dialogTitle: 'Ana kuruluşu düzenle',
        organization: 'Ana kuruluş',
        useMoney: 'Parayı karar verici bırak',
        reason: 'Gerekçe',
        reasonRequired: 'Bir gerekçe yazın.',
        save: 'Kaydet',
        done: 'Ana kuruluş güncellendi',
      },
      editLocked: {
        queued: 'Bu bağış sıraya alındığı için düzenlemeye kapalı.',
        listed: 'Bu bağış bir PDF listesinde olduğu için düzenlemeye kapalı.',
        fulfilled: 'Bu bağış gerçekleştiği için düzenlemeye kapalı.',
      },
      transitionsFailed:
        'Bu kayıtta yapılabilecek işlemler alınamadı. Sayfayı yenileyip tekrar deneyin.',
      itemsTitle: 'Bağış',
      season: '{{season}} dönemi · form sürümü {{version}}',
      quantityOf: '{{count}} × {{unit}}',
      total: 'Toplam',
      noDonor: 'Bağışçı kaydı yok (kumbara boşaltması)',
      partiesTitle: 'Taraf Bilgileri',
      onBehalfOf: 'Bağış Sahibi',
      onBehalfOfNone: 'İsim yazılmayacak',
      onBehalfOfPhone: 'Bağış sahibinin telefonu',
      reference: 'Referans',
      referencePhone: 'Referansın telefonu',
      anonymousHint: 'Bağışçı adının gösterilmemesini istedi',
      donorRecord: 'Bağışçı kaydı',
      paymentTitle: 'Ödeme',
      organization: 'Kuruluş',
      organizationPending: 'Ödeme alındığında belirlenecek',
      eligibleOrganizations: 'Bağlı kuruluşlar',
      primaryOrganization: 'Birincil',
      placementTitle: 'Kayıt Yeri',
      fulfillmentTitle: 'Gerçekleştirme',
      animals: 'Hayvanlar',
      attachmentsEvidence:
        'Dekont gibi bir ek ödemenin kanıtıdır, tahsilatı değil: bağış, banka hareketi eşleştirildiğinde tahsil edilmiş sayılır.',
      fileSize: '{{size}} KB',
    },
    history: {
      createdAt: 'Kaydedildi',
      queuedAt: 'Sıraya Alındı',
      fulfilledAt: 'Gerçekleştirildi',
      move: {
        cancel: 'İptal edildi',
        queue: 'Sıraya alındı',
        dequeue: 'Bekleyenlere geri alındı',
        fulfill: 'Gerçekleştirildi',
        /** 0077'den önceki kayıtların geçmişi bu hareketleri de anar. */
        approve: 'Onaylandı',
        reject: 'Reddedildi',
        reopen: 'Taslağa alındı',
        retire_status: 'Durum “Bekliyor” olarak sadeleştirildi',
      },
      action: {
        delete: 'Silinen Kayıtlar’a taşındı',
        restore: 'Silinen Kayıtlar’dan geri alındı',
      },
    },
    cancelRemainder: {
      title: 'Yalnızca kesilmeyen hisseler iptal edilir',
      animals:
        '{{total}} hayvandan {{fulfilled}} kesildi; kalan {{remaining}} hayvanın tutarı ({{amount}}) {{outcome}}.',
      shares:
        '{{total}} hisseden {{recorded}} kesildi; kalan {{remaining}} hissenin tutarı ({{amount}}) {{outcome}}.',
      outcome: {
        cancelled: 'iptal edilecek',
        refunded: 'bağışçıya iade edilecek',
      },
      partlyRefunded:
        'Tahsil edilen paradan kesilen hisselerin tutarını aşan {{refund}} bağışçıya iade edilecek.',
      kept: 'Kesilen hisselerin tutarı ({{kept}}) iptal edilmez ve iade edilmez; bağış gerçekleştirildi olarak kalır.',
      loading: 'İptalin sonucu hesaplanıyor…',
      done: 'Kesilmeyen hisseler iptal edildi; bağış gerçekleştirildi olarak kaldı.',
    },
    cancelOutcome: {
      title: 'Tahsil edilen para ne olacak?',
      hint: 'Bu bağışın tahsilat durumu “{{status}}”. İptal, eşleşmiş tahsilatı aynı işlemde geri alır ve kampanyanın tahsil edilen toplamını düşürür. Geri almanın yolunu seçin; bu seçim sonradan değiştirilemez.',
      required: 'Paranın ne olacağını seçin.',
      refund: {
        label: 'Bağışçıya iade et',
        description:
          'Banka veya kasa hareketi bu bağışa ayrılmış olarak kalır ve bağışçıya ödenmek üzere bekleyen bir iade kaydı açılır. Tahsilat durumu “İade Edildi” olur; para iade ödenene kadar kurumda borç olarak durur.',
      },
      reverse: {
        label: 'Ters kayıtla eşleşmeyi kaldır',
        description:
          'Eşleşme ters kayıtla kapatılır ve hareket eşleşmemiş hareketler arasına döner; başka bir bağışla eşleştirilebilir. Tahsilat durumu “Ters Kayıt” olur ve bağışçıya ödeme yapılmaz.',
      },
      done: {
        refund: 'Bağış iptal edildi; tahsilat bağışçıya iade için ayrıldı.',
        reverse: 'Bağış iptal edildi; tahsilat ters kayıtla geri alındı.',
      },
    },
    action: {
      cancel: 'İptal Et',
      queue: 'Sıraya Al',
      dequeue: 'Bekleyenlere Geri Al',
      fulfill: 'Gerçekleştir',
      delete: 'Sil',
      view: 'Görüntüle',
      none: 'Bu kayıtta yapabileceğiniz bir işlem yok.',
    },
    reasonLabel: 'Gerekçe',
    deletionReasonLabel: 'Silme gerekçesi',
    deletionReasonHint:
      'Zorunlu, en az {{min}} karakter. Silinen Kayıtlar’da ve kaydın geçmişinde görünür.',
    deletionReasonTooShort: 'Silme gerekçesi en az {{min}} karakter olmalıdır.',
    reasonRequired: 'Gerekçe zorunludur.',
    confirm: {
      cancel: 'Bu bağış iptal edilsin mi?',
      queue: 'Bu bağış sıraya alınsın mı?',
      dequeue: 'Bu bağış sıradan çıkarılıp Bekleyenlere geri alınsın mı?',
      fulfill: 'Bu bağış gerçekleştirildi olarak işaretlensin mi?',
      delete:
        'Bu bağış silinsin mi? Silinen bağış bütün listelerden, sıradan ve dönem toplamlarından çıkar; Silinen Kayıtlar ekranından olduğu gibi geri alınabilir.',
    },
    done: {
      cancel: 'Bağış iptal edildi.',
      queue: 'Bağış sıraya alındı.',
      dequeue: 'Bağış Bekleyenlere geri alındı.',
      fulfill: 'Bağış gerçekleştirildi.',
      delete: 'Bağış silindi. Silinen Kayıtlar ekranından geri alınabilir.',
    },
    tab: {
      all: 'Tümü',
      waiting: 'Bekleyenler',
      queued: 'Sıraya Alınanlar',
      fulfilled: 'Gerçekleşenler',
    },
    statusFilter: {
      waiting: 'Bekleyenler (sıraya alınabilir)',
      pending: 'Bekliyor (koşulu eksikler dahil)',
      queued: 'Sıraya Alındı',
      fulfilled: 'Gerçekleştirildi',
      cancelled: 'İptal Edildi',
    },
    readiness: {
      unmet: 'Koşul bekleniyor',
      unmetHint:
        'Kampanyanın sıraya alma koşulu (ör. vekalet alındı) bu bağışta işaretli değil. Koşul işaretlenene kadar Bekleyenler’de görünmez ve sıraya alınamaz.',
    },
    bulk: {
      queue: 'Seçilenleri sıraya al',
      dequeue: 'Seçilenleri Bekleyenlere geri al',
      basket: 'Sepetle Eşleştir',
      basketTooMany:
        'Sepet en fazla {{max}} bağış alır; seçimde {{count}} bağış var. Seçimi daraltın.',
      printout: 'Çıktı Al',
      queueTitle: '{{count}} bağış sıraya alınsın mı?',
      dequeueTitle: '{{count}} bağış sıradan çıkarılıp Bekleyenlere geri alınsın mı?',
      delete: 'Seçilenleri sil',
      deleteTitle:
        '{{count}} bağış silinecek. Silinenler bütün listelerden ve dönem toplamlarından çıkar; Silinen Kayıtlar ekranından geri alınabilir.',
      deleteConfirm: '{{count}} bağışı sil',
      deleteResult: {
        title: 'Silme sonucu',
        summary: '{{total}} kayıttan {{deleted}} tanesi silindi.',
        deleted: 'Silindi',
        kept: 'Silinmedi',
        operation: 'Toplu işlem no:',
      },
      done: '{{count}} bağış işlendi.',
      partial: '{{failed}} / {{total}} kayıt işlenemedi.',
    },
    selection: {
      capReached: 'En fazla {{max}} bağış seçilebilir; {{count}} bağış seçime eklenmedi.',
    },
    evidenceFilter: {
      label: 'Kanıt',
      received: 'Kanıtı gelmiş',
      none: 'Kanıtı gelmemiş',
    },
    awaitingFulfilment: {
      show: 'Yalnızca gerçekleştirme bekleyenler',
      hide: 'Gerçekleştirme bekleyen filtresini kaldır',
      chip: 'Gerçekleştirme bekleyen (bekleyen veya sırada)',
    },
    fulfilment: 'Gerçekleştirme',
    fulfilmentInbox: {
      show: 'Yalnızca kurumuma yönlendirilenler',
      hide: 'Kurumuma yönlendirilenler filtresini kaldır',
      chip: 'Kurumuma yönlendirilenler',
    },
    assignedWork: {
      chip: 'Görevli olduğum kampanyalar',
    },
    evidenceGap: {
      show: 'Yalnızca kanıtı eksik olanlar',
      hide: 'Kanıtı eksik filtresini kaldır',
      chip: 'Kanıtı eksik (gerçekleşmiş, dosyasız)',
    },
    mergeGroupChip: 'Birleştirilen kayıtlarıyla birlikte',
    owing: {
      show: 'Yalnızca kalan borcu olanlar',
      hide: 'Kalan borç filtresini kaldır',
      chip: 'Kalan borcu olan (ödenmemiş, kısmen ödenmiş veya ters kaydı yapılmış)',
    },
    paymentLink: {
      permanentHint: 'Bu kalıcı bağlantıda bağışçı kalan tutarı görür ve ödeme yöntemini seçer.',
      optionalAccountLink: 'Alternatif hesap bağlantısı',
      permanentOrganizationHint:
        'Bu bağlantı bağışın sahibi {{organization}} kuruluşunun alan adında açılır. Giriş yaptığınız kuruluşun alan adı bağışın sahipliğini değiştirmez.',
      permanentUnavailable:
        '{{organization}} kuruluşunun ödeme sayfası için etkin bir alan adı bulunamadı. Kuruluşlar ekranında bu kuruluşun özel giriş veya bağış sitesi alan adını yapılandırın. Giriş yaptığınız alan adı başka bir kuruluşa ait bağış için kullanılamaz.',
      permanentOrganizationMissing:
        'Bu bağışın sahibi olan kuruluş henüz belirlenmemiş. Kurumun kuruluş bağlantısını ve bağışın kuruluş atamasını Kuruluşlar ekranından kontrol edin; ardından ödeme sayfası için bu kuruluşun alan adını yapılandırın.',

      hostedUrl: 'Süreli sağlayıcı bağlantısı',
      hostedHint:
        'Bu doğrudan sağlayıcı bağlantısı sürelidir. Bağışçıya kalıcı ödeme sayfasının bağlantısını gönderin.',
      title: 'Ödeme Bağlantısı',
      subtitle: 'Bağış koduyla açılan kalıcı ödeme sayfası',
      create: 'Bağlantı Oluştur',
      regenerate: 'Bağlantıyı Yenile',
      empty: 'Geçerli bir ödeme bağlantısı yok',
      emptyHint: 'Bağışçı kalıcı ödeme sayfasında kalan tutarı görür ve ödeme yöntemini seçer.',
      lastLink: 'Son bağlantı: {{date}}',
      lentSpent:
        'Bu bağlantı {{organization}} kuruluşunun hesabına oluşturulmuştu ve tahsilat oraya geçti. Bağış, para kendi kuruluşuna aktarılıp orada eşleştirilene kadar ödenmemiş kalır ve makbuzu düzenlenmez.',
      lentTransfer: 'Bu tahsilat için açılan fon transferi',
      url: 'Ödeme bağlantısı',
      copy: 'Kopyala',
      copied: 'Ödeme bağlantısı panoya kopyalandı.',
      copyFailed: 'Ödeme bağlantısı kopyalanamadı.',
      provider: 'Sağlayıcı',
      amount: 'Tutar',
      account: 'Tahsilat hesabı',
      expiresAt: 'Geçerlilik bitişi',
      createdBy: 'Oluşturan',
      statusLabel: 'Durum',
      status: {
        active: 'Geçerli',
        paid: 'Ödendi',
        expired: 'Süresi doldu',
        superseded: 'Yenilendi',
      },
      lentWarning:
        'Bu bağlantı {{organization}} kuruluşunun hesabına çekiliyor. Para o kuruluşun hesabına düşer; bağış, o kuruluş tutarı devredene kadar ödenmemiş kalır ve makbuz düzenlenmez. Bu devir saniyeler değil, günler veya haftalar sürer.',
      created: 'Ödeme bağlantısı oluşturuldu.',
      reused: 'Bu bağışın zaten geçerli bir ödeme bağlantısı vardı; aynı bağlantı gösteriliyor.',
      regenerated: 'Yeni ödeme bağlantısı oluşturuldu; önceki adres artık ödeme almıyor.',
      regenerateConfirm:
        'Yeni bir bağlantı oluşturulacak ve bağışçıya daha önce gönderilen adres artık ödeme almayacak. Devam edilsin mi?',
      readOnly:
        'Ödeme bağlantısı bir ödemeye açılan adrestir; görmek ve oluşturmak için bağış düzenleme yetkisi gerekir.',
      dialog: {
        createTitle: 'Ödeme Bağlantısı Oluştur',
        regenerateTitle: 'Ödeme Bağlantısını Yenile',
        organization: 'Hesabın kuruluşu',
        organizationHint:
          'Başka bir kuruluş seçilirse para o kuruluşun hesabına düşer ve bağışa devir yoluyla döner.',
        ownOrganization: 'Bağışın kendi kuruluşu',
        account: 'Tahsilat hesabı',
        accountHint: 'Bağlantı yalnızca bağışın para birimindeki ({{currency}}) hesaplara çekilir.',
        accountRequired: 'Bir tahsilat hesabı seçin.',
        noAccountsFor: '{{organization}} kuruluşunda kullanılabilir bir sağlayıcı hesabı yok.',
        submit: 'Bağlantı Oluştur',
      },
    },
    notices: {
      title: 'Bildirim İşlemleri',
      subtitle: 'Bağışın kaydı ve gerçekleşmesi kime bildirilir',
      hint: 'İşaretlenen kişilere WhatsApp ile bildirim gönderilir; bağışçının iletişim izni aranmaz. Referans kişiyi işaretlemeniz, onun bildirim almayı kabul ettiğine dair beyanınız olarak kaydedilir.',
      party: 'Kişi',
      kind: {
        registration: 'Kayıt Bildirimi',
        fulfilment: 'Gerçekleşti (Görsel/Kanıt) Bildirimi',
      },
      role: {
        payer: 'Bağış Yapan',
        owner: 'Bağış Sahibi',
        reference: 'Referans',
        operator: 'Kaydı Giren',
      },
      fixedLine:
        'Bu numara sabit hat görünüyor; WhatsApp bildirimi ulaşmayabilir. Kayıt yine de yapılır.',
      unreachable: {
        payer: 'Ödeme yapanın telefonu yok',
        owner: 'Bağış sahibi telefonuyla girilmedi',
        reference: 'Referansın telefonu girilmedi',
        operator: 'Kullanıcının kayıtlı telefonu yok',
      },
      registrationStatus: {
        none: 'Seçilmedi',
        pending: 'Gönderim sırasında',
        sending: 'Gönderim sırasında',
        sent: 'Gönderildi',
        failed: 'Gönderilemedi',
        delivery_unknown: 'Ulaşıp ulaşmadığı bilinmiyor',
        suppressed: 'Gönderilmedi',
      },
      registrationFixed: 'Kayıt bildirimi bağış kaydedilirken gönderilir; sonradan değiştirilmez.',
      offered: 'Bağlantı sunuldu',
      optedOut: 'Vazgeçti',
      cancelled: 'İptal edilmiş bir bağışın bildirimleri değiştirilmez.',
      save: 'Bildirimleri kaydet',
      saved: 'Bildirim seçimi kaydedildi.',
    },
    evidenceRecipients: {
      title: 'Kanıt Alıcıları',
      subtitle:
        'Gerçekleştirme kanıtının bağlantısı kime, hangi kanaldan ve hangi dayanakla gönderilir',
      empty: 'Bu bağış için kanıt gönderilecek kimse seçilmedi.',
      moreActions: 'Kanıt alıcısı işlemleri',
      column: {
        party: 'Kişi',
        channel: 'Kanal',
        basis: 'Dayanak',
        link: 'Bağlantı',
      },
      basis: {
        transactional_notice: 'Personelin seçimi — kendi bağışı hakkında bildirim',
        operator_declaration: 'Operatörün beyanı',
        staff_membership: 'Personel',
      },
      declaredBy: '{{name}} beyan etti · {{date}}',
      declaredAt: 'Beyan: {{date}}',
      optedOut: 'Vazgeçti: {{date}}',
      state: {
        not_offered: 'Henüz sunulmadı',
        unissued: 'Gönderilmedi',
        sent: 'Gönderildi',
        expired: 'Süresi doldu',
        revoked: 'Kapatıldı',
      },
      notOffered: 'Bağış gerçekleşip temiz bir kanıt geldiğinde gönderilir.',
      noMessage: 'Bu kişi için mesaj yazılmadı.',
      inFlight: 'Mesaj gönderim sırasında.',
      withheld: 'Mesaj gönderilmedi: {{reason}}.',
      failed: 'Mesaj gönderilemedi; bağlantı bir sonraki kanıtla yeniden sunulur.',
      sentOn: 'Gönderildi: {{date}} · geçerlilik {{expires}}',
      expiredOn: 'Süresi doldu: {{date}}',
      opened_one: '{{count}} kez açıldı, son {{date}}',
      opened_other: '{{count}} kez açıldı, son {{date}}',
      notOpened: 'Henüz açılmadı.',
      outcomeUnknown:
        'Son mesajın durumu: {{status}}. Ulaşıp ulaşmadığı bilinmiyorsa yeniden gönderin.',
      revokedOn: 'Kapatıldı: {{date}} · {{reason}}',
      revokedReason: {
        opted_out: 'kişi vazgeçti',
        erased: 'bağışçının kişisel verileri silindi',
        recipient_removed: 'kanıt tercihi kaldırıldı',
      },
      resentCount: 'Bağlantı {{count}} kez gönderildi; yalnızca son gönderilen açılır.',
      action: {
        resend: 'Yeniden gönder',
        optOut: 'Vazgeç',
      },
      confirm: {
        resend:
          '{{party}} kişisine kanıt bağlantısı {{channel}} ile yeniden gönderilecek. Daha önce gönderilen bağlantılar hemen açılmaz olur; yeni bağlantı mesaj yola çıkarken oluşturulur.',
        optOut:
          '{{party}} bu bağışın kanıtını artık almayacak. Bağlantısı hemen kapanır ve bu kişiye bir daha gönderilmez. Bu işlem geri alınamaz.',
      },
      done: {
        resend: 'Kanıt bağlantısı yeniden gönderim sırasına alındı.',
        resendWithheld: 'Mesaj yazıldı ancak gönderilmedi; son durum satırda görünür.',
        optOut: 'Kişi kanıt alıcılarından çıkarıldı; bağlantısı kapatıldı.',
      },
    },
  },
  deletedDonation: {
    title: 'Silinen Kayıtlar',
    notice:
      'Silinen bağışlar hiçbir listede, sırada ya da toplamda sayılmaz. Geri Al, bağışı silindiği durumuyla geri getirir; sıradaki bir bağış sıranın sonuna eklenir.',
    search: 'Referans kodu veya bağışçı adı',
    campaign: 'Kampanya',
    column: {
      donation: 'Bağış',
      campaign: 'Kampanya',
      amount: 'Tutar',
      status: 'Geri alınınca',
      deletedAt: 'Silinme',
      reason: 'Gerekçe',
    },
    deletedBy: '{{name}} sildi',
    restore: 'Geri Al',
    restored: 'Bağış geri alındı.',
    operation: 'Toplu işlem',
    details: {
      back: 'Silinen Kayıtlar',
      badge: 'Silindi',
      notFound: 'Silinen kayıt bulunamadı. Geri alınmış ya da veri kapsamınızın dışında olabilir.',
      readOnly:
        'Bu bağış silinmiş; kayıt salt okunur. Geri Al, bağışı silindiği “{{status}}” durumuyla geri getirir.',
      deletionTitle: 'Silme bilgisi',
      deletedBy: 'Silen',
      deletedAt: 'Silinme zamanı',
      reason: 'Gerekçe',
      noReason: 'Gerekçe girilmeden silinmiş',
      operation: 'Toplu işlem',
      singleDeletion: 'Tekil silme',
    },
    empty: 'Silinen kayıt yok',
    emptyHint: 'Silinen bağışlar burada görünür ve tek tıkla geri alınabilir.',
  },
  operations: {
    title: 'Operasyon',
    campaignMissing: 'Bu adres bir kampanyayı göstermiyor.',
    campaignNotOperated:
      'Bu kampanyada sizin yürüttüğünüz bir iş görünmüyor; aşağıdaki liste boş kalabilir.',
    noCampaigns: 'Yürüttüğünüz kampanya yok',
    noCampaignsHint:
      'Bir kampanyanın işini yürüten bir rolünüz ya da yürürlükte bir kampanya görevlendirmeniz olduğunda burada listelenir.',
    staffed: 'Görevli',
    selectAll: 'Bu sayfadakilerin tümünü seç',
    openFromDonation: 'Operasyon sayfasında aç',
    onBehalfOf: '{{name}} adına',
    position: 'Sıra no {{position}}',
    animal: '{{group}}. hayvan ({{shares}}/{{size}})',
    unlisted: 'Listelenmedi',
    listNumber: 'Liste {{number}}',
    printed:
      'Liste {{number}} oluşturuldu. PDF hazırlanıyor; hazır olduğunda PDF Yönetimi’nden indirebilirsiniz.',
    printedNamed:
      '“{{name}}” listesi oluşturuldu. PDF hazırlanıyor; hazır olduğunda PDF Yönetimi’nden indirebilirsiniz.',
    openPrintoutList: 'PDF listesini aç',
    emptyHint: 'Filtreleri değiştirin ya da başka bir sekmeye geçin.',
    count: {
      waiting: '{{count}} bekleyen',
      queued: '{{count}} sırada',
    },
    tab: {
      waiting: 'Bekleyenler',
      queued: 'Sıraya Alınanlar',
      fulfilled: 'Gerçekleşenler',
    },
    view: {
      list: 'Liste',
      order: 'Sıra düzeni',
    },
    empty: {
      waiting: 'Sıraya alınmayı bekleyen bağış yok',
      queued: 'Sırada bağış yok',
      fulfilled: 'Gerçekleşen bağış yok',
    },
    evidence: {
      awaiting: 'Kanıt bekleniyor',
      uploaded: 'Kanıt yüklendi',
      completed: 'Tamamlandı',
    },
    filter: {
      period: 'Dönem',
      institution: 'Kurum',
      evidence: 'Kanıt durumu',
      search: 'Bağış kodu, bağışçı ya da adına olduğu kişi',
      selected: 'Seçili',
      toggle: 'Filtreler',
      toggleApplied: 'Filtreler ({{count}})',
      printoutList: 'PDF listesi',
      printoutListOption: {
        listed: 'Bir listede olanlar',
        unlisted: 'Listelenmeyenler',
      },
    },
    column: {
      donation: 'Bağış',
      workInstitution: 'Yurt / kurum',
      season: 'Dönem',
      quantity: 'Adet',
      animals: 'Hayvan',
      evidence: 'Kanıt',
      printoutList: 'PDF Listesi',
      moment: {
        waiting: 'Bağış tarihi',
        queued: 'Sıraya alınma',
        fulfilled: 'Gerçekleşme',
      },
    },
    action: {
      open: 'Bağışı aç',
      queue: 'Sıraya al',
      dequeue: 'Sıradan çıkar',
      fulfil: 'Gerçekleşti',
      unfulfil: 'Gerçekleşti işaretini geri al',
      print: 'Çıktı al',
      evidence: 'Kanıt ekle',
    },
    capture: {
      title: 'Kanıt ekle',
      neverCompletes:
        'Kanıt eklemek bağışı tamamlamaz ve durumunu değiştirmez; gerçekleşti işareti ayrıca verilir. Dosya virüs taramasından geçtikten sonra görüntülenebilir.',
      photo: 'Fotoğraf çek',
      video: 'Video çek',
      pick: 'Galeriden seç',
      limits:
        'JPEG veya PNG fotoğraf (en çok {{imageMaxSize}}, {{imageMaxSide}} piksel ve {{imageMaxMegapixels}} megapiksel; daha büyüğü gönderilmeden küçültülür) ya da MP4, MOV veya 3GP video (en çok {{videoMaxSize}} ve {{videoMaxMinutes}} dakika).',
      files: 'Yüklenen kanıtlar',
      empty: 'Henüz kanıt yok.',
      view: 'Görüntüle',
      dismiss: 'Kapat',
      received: 'Kanıt alındı; virüs taraması sürüyor.',
      phase: {
        preparing: 'Hazırlanıyor',
        uploading: 'Yükleniyor %{{percent}}',
        verifying: 'Denetleniyor',
        failed: 'Gönderilemedi',
      },
      scan: {
        pending: 'Taranıyor',
        clean: 'Tarandı',
        infected: 'Zararlı içerik',
        failed: 'Taranamadı',
      },
      refused: {
        EVIDENCE_EMPTY: 'Dosya boş.',
        EVIDENCE_NOT_MEDIA: 'Kanıt olarak yalnızca fotoğraf veya video eklenir.',
        EVIDENCE_VIDEO_TOO_LARGE:
          'Video {{videoMaxSize}} sınırının üzerinde. Daha kısa bir video çekin.',
        EVIDENCE_IMAGE_UNREADABLE:
          'Fotoğraf bu tarayıcıda açılamadı. JPEG olarak kaydedip yeniden deneyin.',
      },
    },
    done: {
      queue: '{{count}} bağış sıraya alındı.',
      dequeue: '{{count}} bağış sıradan çıkarıldı.',
      fulfil: '{{count}} bağış gerçekleşti olarak işaretlendi.',
      unfulfil: '{{count}} bağışın gerçekleşti işareti geri alındı.',
    },
    confirm: {
      queue: {
        title: 'Sıraya al',
        body: 'Seçilen {{count}} bağış sıraya alınacak.',
      },
      dequeue: {
        title: 'Sıradan çıkar',
        body: 'Seçilen {{count}} bağış sıradan çıkarılıp Bekleyenlere dönecek.',
      },
      fulfil: {
        title: 'Gerçekleşti',
        body: 'Seçilen {{count}} bağış, planlanan yurtta ve bugünün tarihiyle, maliyet girilmeden gerçekleşti olarak işaretlenecek.',
        animals:
          'Seçilenlerden {{count}} bağış bir hayvanın hissesi. Gerçekleşti, hayvanın tamamını — içindeki başka bağışların hisseleriyle birlikte — gerçekleştirir; bağışın kesilmemiş bütün hayvanları kesilmiş sayılır.',
      },
      unfulfil: {
        title: 'Gerçekleşti işaretini geri al',
        body: 'Seçilen {{count}} bağış sıraya (sırası yoksa Bekleyenlere) geri dönecek; gerçekleşme yeri, tarihi ve maliyeti silinecek. Bağışçıya giden bildirim geri alınmaz.',
        animals:
          'Seçilenlerden {{count}} bağış kesilmiş bir hayvanın hissesi. Geri alma hayvanın kaydını bütünüyle kaldırır; o hayvanla tamamlanan başka bağışlar da sıraya döner.',
        reason: 'Gerekçe',
        reasonHint: 'En az {{count}} karakter; denetim izine yazılır.',
      },
    },
    result: {
      title: 'Sonuç',
      summary: '{{total}} bağıştan {{done}} tanesi işlendi.',
      done: 'Tamam',
      refused: 'Yapılmadı',
      animals: '{{groups}}. hayvan kesildi; {{count}} bağış daha tamamlandı.',
      reverted: '{{groups}}. hayvanın kaydı kaldırıldı; {{count}} bağış daha sıraya döndü.',
    },
  },
  printoutList: {
    title: 'PDF Yönetimi',
    subtitle:
      'Her çıktı bir PDF listesidir. Bir bağış aynı anda tek bir etkin listede bulunur; liste iptal edildiğinde ya da bağış listeden çıkarıldığında yeniden çıktısı alınabilir.',
    name: 'Liste {{number}}',
    createDialog: {
      title: '{{count}} bağış için PDF listesi',
      queueTitle: 'Sıradakiler için PDF listesi',
      hint: 'Liste adı isteğe bağlıdır; boş bırakılırsa liste numarasıyla (Liste N) anılır.',
      confirm: 'PDF oluştur',
    },
    renameDialog: {
      title: 'Liste {{number}} — ad',
      hint: 'Boş bırakılırsa varsayılan ad “Liste {{number}}” görünür.',
    },
    workInstitutionDialog: {
      title: 'Yürütücü kurumu değiştir',
      body: 'Listede kalan {{count}} bağışın planlanan yurdu seçilen kuruma taşınır. Gerçekleşmiş, iptal edilmiş ya da kısmen kesilmiş bir bağış varsa değişiklik yapılmaz.',
      current: '{{name}} (şu anki)',
    },
    empty: 'PDF listesi yok',
    emptyHint:
      'Bir kampanyanın operasyon sayfasında bağışları seçip çıktı aldığınızda listeniz burada belirir.',
    notFound: 'PDF listesi bulunamadı ya da size görünmüyor.',
    status: {
      active: 'Etkin',
      voided: 'İptal edildi',
    },
    source: {
      selection: 'Seçilen bağışlar',
      order: 'Sıradakiler',
    },
    tab: {
      all: 'Tümü',
      active: 'Etkin',
      voided: 'İptal edilen',
    },
    filter: {
      campaign: 'Kampanya',
      creator: 'Oluşturan',
      createdAt: 'Oluşturulma',
      search: 'Liste numarası veya adı',
      status: 'Durum',
    },
    column: {
      list: 'Liste',
      creator: 'Oluşturan',
      donations: 'Bağış',
      file: 'PDF',
      status: 'Durum',
      position: 'Sıra',
      donation: 'Bağış',
      workInstitution: 'Yurt / kurum',
      donationStatus: 'Bağış durumu',
      printedAt: 'Çıktı',
      membership: 'Listede',
    },
    count: '{{active}} / {{total}}',
    field: {
      name: 'Liste adı',
      number: 'Liste numarası',
      campaign: 'Kampanya',
      season: 'Dönem',
      source: 'Kaynak',
      createdBy: 'Oluşturan',
      createdAt: 'Oluşturulma',
      template: 'Şablon',
      templateNone: 'Sabit düzen',
      workInstitution: 'Yurt / kurum',
      workInstitutionMany: 'Birden çok yurt',
      donations: 'Bağış sayısı',
      file: 'PDF dosyası',
      fileExpires: 'Silinme: {{at}}',
      voidedBy: 'İptal eden',
      voidedAt: 'İptal tarihi',
      voidReason: 'İptal gerekçesi',
    },
    details: 'Liste bilgileri',
    donationsCard: 'Listedeki bağışlar',
    fileNotMine:
      'Bu PDF’i başka bir kullanıcı oluşturdu; dosyalar yalnızca isteyene açılır. İndirmek için listeyi yeniden oluşturun.',
    fileExpired: 'PDF’in saklama süresi doldu. İndirmek için listeyi yeniden oluşturun.',
    fileFailed: 'PDF hazırlanamadı. Listeyi yeniden oluşturabilirsiniz.',
    filePending: 'PDF hazırlanıyor…',
    member: {
      onList: 'Listede',
      removed: 'Çıkarıldı',
      voided: 'Liste iptal edildi',
      releasedBy: '{{name}} · {{at}}',
      notPrinted: 'Henüz basılmadı',
    },
    action: {
      open: 'Aç',
      download: 'PDF’i indir',
      redraw: 'Yeniden oluştur',
      void: 'Listeyi iptal et',
      remove: 'Listeden çıkar',
      rename: 'Adı düzenle',
      workInstitution: 'Yürütücü kurum',
    },
    done: {
      rename: 'Liste adı kaydedildi.',
      workInstitution: 'Yürütücü kurum değiştirildi; listedeki bağışların yurdu güncellendi.',
      redraw: 'PDF yeniden hazırlanıyor. Hazır olduğunda buradan indirebilirsiniz.',
      void: 'Liste {{number}} iptal edildi; bağışları yeniden çıktı alınabilir.',
      remove: 'Bağış listeden çıkarıldı.',
    },
    confirm: {
      void: {
        title: 'Liste {{number}} iptal edilsin mi?',
        body: 'Listedeki {{count}} bağış listeden çıkar ve yeniden çıktısı alınabilir. Basılmış sayfalar geri çağrılmaz; bağışların “basıldı” bilgisi korunur.',
      },
      remove: {
        title: 'Bağış listeden çıkarılsın mı?',
        body: '{{code}} bu listeden çıkar ve yeniden çıktısı alınabilir. Basılmış sayfası geri çağrılmaz.',
      },
      reason: 'Gerekçe',
      reasonHint: 'En az {{count}} karakter; denetim izine yazılır.',
    },
  },
  queue: {
    title: 'Gerçekleştirme Sırası',
    subtitle: 'Dönemin sıraya alınmış hisseleri, gruplar okuma anında türetilir',
    selectPeriod: 'Dönem seçin',
    selectCampaign: 'Kampanya seçin',
    empty: 'Bu dönemde sıraya alınmış hisse yok.',
    emptyHint: 'Onaylanmış bağışları bağış listesinden sıraya alın.',
    position: 'Sıra',
    donation: 'Bağış',
    shares: 'Hisse',
    group: 'Grup',
    groupOf: '{{group}}. grup',
    groupStraddle: '{{from}}–{{to}}. gruplar',
    groupShare: '{{group}}. grupta {{shares}}/{{size}} hisse',
    groupShareFulfilled: '{{group}}. grupta {{shares}}/{{size}} hisse · kesildi',
    animalsFulfilled: '{{total}} hayvandan {{fulfilled}} kesildi',
    fulfilledGroupCount: 'Kesilen hayvan: {{count}}',
    plannedPlace: 'Planlanan Yer',
    actualPlace: 'Gerçekleşen Yer',
    fulfilledAt: 'Gerçekleşme',
    cost: 'Maliyet',
    evidence: 'Kanıt',
    evidenceMissing: 'Kanıt yok',
    evidenceCount_one: '{{count}} dosya',
    evidenceCount_other: '{{count}} dosya',
    totalShares: '{{count}} hisse',
    groupCount: '{{count}} grup',
    unitsPerGroup: 'Grup başına {{count}} hisse',
    groupSizeOf: '{{answer}}: grup başına {{count}} hisse',
    noGrouping: 'Bu kampanyada gruplama yok; sıra düz bir liste olarak okunur.',
    dragHint: 'Satırları sürükleyerek sırayı değiştirebilirsiniz.',
    dragDisabled: 'Bu dönemde gerçekleştirilmiş kayıt var; sıra kilitlendi.',
    reordered: 'Sıra güncellendi.',
    sortBy: 'Sıralama ölçütü',
    sort: {
      arrival: 'Giriş sırası',
      fulfillment_institution: 'Planlanan yer',
      country: 'Ülke',
      zone: 'Mıntıka',
      answer: 'Cevap: {{field}}',
    },
    sortHint:
      'Gruplama cevabı seçilmiş bir kampanyada sıralama, aynı cevapları taşıyan hisseleri birlikte taşır; hiçbir hisse hayvanından ayrılmaz.',
    applySort: 'Ölçüte göre sırala',
    compact: 'Grupları sıkıştır',
    sheet: 'Grup Çizelgesi',
    printouts: 'Sıradakilerin Çıktısı',
    printoutsHint:
      'Bu dönemde sıraya alınmış ve henüz bir PDF listesinde olmayan her bağış için QR kodlu bir sayfa; hepsi yeni bir PDF listesi olur. Sahadan gelen fotoğraf bu kodla bağışına eşleşir.',
    compactHint:
      'Hisseleri büyükten küçüğe yerleştirerek iki gruba bölünen kayıtları azaltır. Yalnızca sırayı değiştirir; grup kaydı oluşturmaz.',
    compacted: 'Sıra sıkıştırıldı.',
    fulfillGroup: '{{group}}. grubu gerçekleştir',
    fulfillGroupTitle:
      '{{group}}. gruptaki hayvan kesildi olarak kaydedilsin mi? Başka hayvanlarda da hissesi olan bir bağış, son hayvanı kesilene kadar sırada kalır.',
    groupFulfilled:
      '{{group}}. grup kesildi olarak kaydedildi: {{completed}} bağış tamamlandı, {{waiting}} bağış diğer hayvanlarını bekliyor.',
    fulfillTitle: 'Gerçekleştirme',
    costAmount: 'Maliyet tutarı',
    costCurrency: 'Para birimi',
    fulfilledAtLabel: 'Gerçekleşme tarihi',
    actualPlaceLabel: 'Gerçekleşen kurum',
    actualPlaceHint: 'Boş bırakılırsa planlanan yer kullanılır.',
    fulfilled: 'Gerçekleştirme kaydedildi.',
    grouping: {
      action: 'Grupla',
      hint: 'Aynı yurda ve aynı gruplama cevaplarına sahip hisseleri bir araya getirir, her birini yedişerli hayvanlara yerleştirir ve her gruba bir kesim sıra no verir.',
      unconfigured:
        'Bu kampanya gruplama cevabı seçmemiş. Kampanyanın Form sekmesindeki Kesim gruplaması kartından seçebilirsiniz.',
      confirmTitle: 'Sıra gruplansın mı?',
      confirmBody:
        'Dönemin sırası yeniden düzenlenecek: yurdu ve {{fields}} cevapları aynı olan hisseler bir araya getirilip hayvanlara yerleştirilecek. Sıra numaraları ve kesim sıra no’ları değişir; dağıtılmış bir grup çizelgesi varsa yeniden alınmalıdır. Gerçekleştirilmiş hisse varken sıra değiştirilemez.',
      done: 'Sıra gruplandı; her grubun kesim sıra no’su yenilendi.',
      shortGroups: '{{count}} eksik grup',
      shortGroup: '{{group}}. grup eksik: hayvan dolmadı',
    },
    answerYes: 'Evet',
    answerNo: 'Hayır',
    export: 'Kesim Raporu (Excel)',
    exportHint:
      'Her grubun kesim sıra no’su, hisseleri ve referans kodları, bağışçı, adına bağış yapılan kişi, yurt ve gruplama cevaplarıyla bir Excel dosyası.',
  },
  donationPaymentMethod: {
    bank_transfer: 'Banka Havalesi',
    cash: 'Nakit',
    card: 'Kredi Kartı',
    pos: 'POS',
    paypal: 'PayPal',
    direct_debit: 'Otomatik Ödeme',
    other: 'Diğer',
    // Not "Diğer": the clerk does not know yet, which is a different answer.
    // Reconciliation replaces it when the money is matched to a bank line.
    unspecified: 'Belirtilmedi',
  },
  donationEvidenceRecipientRole: {
    payer: 'Bağışçı',
    owner: 'Bağış sahibi',
    reference: 'Referans',
    operator: 'Kaydı giren operatör',
  },
  donationNoticeKind: {
    registration: 'Kayıt bildirimi',
    fulfilment: 'Gerçekleşti (görsel/kanıt) bildirimi',
  },
  donationEntryChannel: {
    admin: 'Panel',
    portal: 'Web Sitesi',
    field: 'Saha',
    // Historical: donations entered before the contact-log module was retired
    // on 2026-09-22 still carry this channel and still have to render.
    contact_log: 'Çağrı Kaydı',
    donation_box: 'Kumbara',
    pledge: 'Taahhüt',
    import: 'İçe Aktarma',
    whatsapp: 'WhatsApp',
  },
  donationStatus: {
    pending: 'Bekliyor',
    queued: 'Sıraya Alındı',
    fulfilled: 'Gerçekleştirildi',
    cancelled: 'İptal Edildi',
    /**
     * 0077'nin kaldırdığı dört durum. Hiçbir bağış artık bunlarda değil, ama
     * geçmiş kayıtları bunları anar ve bağışın geçmişi hâlâ okur.
     */
    draft: 'Taslak',
    pending_approval: 'Onay Bekliyor',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
  },
  donationBoxStatus: {
    in_stock: 'Depoda',
    placed: 'Teslim Edildi',
    collected: 'Geri Alındı',
    retired: 'Kullanım Dışı',
  },
  donationBox: {
    title: 'Kumbaralar',
    subtitle: 'Kumbaraların nerede olduğu, kimde durduğu ve ne zaman boşaltıldığı',
    new: 'Yeni Kumbara',
    empty: 'Kumbara kaydı yok',
    emptyHint: 'Filtreleri değiştirin veya yeni bir kumbara ekleyin.',
    scopeNotice: 'Yalnızca veri kapsamınızdaki kumbaralar listelenir.',
    detailTitle: 'Kumbara Detayı',
    code: 'Kumbara No',
    status: 'Durum',
    keeper: 'Teslim Alan',
    keeperName: 'Teslim Alanın Adı',
    keeperPhone: 'Telefon',
    placementAddress: 'Adres',
    institution: 'Kurum',
    placedAt: 'Teslim Tarihi',
    lastCollectedAt: 'Son Boşaltma',
    collectionCount: 'Boşaltma Sayısı',
    collectedTotal: 'Toplanan Tutar',
    collectedTotalHint: 'Boşaltma kayıtlarından toplanır; kumbarada saklanan bir bakiye yoktur.',
    daysOut: 'Sahada (gün)',
    daysOutValue: '{{count}} gün',
    search: 'Kumbara no, teslim alan veya adres ara',
    uncollectedFilter: 'Boşaltılmayan (gün)',
    showRetired: 'Kullanım dışı olanları da göster',
    notPlaced: 'Sahada değil',
    actions: {
      place: 'Teslim Et',
      placeAgain: 'Tekrar Teslim Et',
      collect: 'Boşalt',
      retire: 'Kullanım Dışı Bırak',
      edit: 'Düzenle',
      view: 'Detay',
      confirm: 'Bağışa Dönüştür',
    },
    createTitle: 'Yeni Kumbara',
    editTitle: 'Kumbarayı Düzenle',
    placeTitle: 'Kumbarayı Teslim Et',
    placeHint: 'Kumbarayı kimin aldığını ve nereye konduğunu yazın.',
    retireTitle: 'Kumbarayı kullanım dışı bırak',
    retireHint: 'Kayıp veya hurda kumbaralar için. Bu işlem geri alınamaz.',
    bulk: {
      retireTitle: 'Seçilen kumbaralar kullanım dışı bırakılsın mı?',
      retireHint:
        '{{count}} kumbara kullanım dışı bırakılacak. Her kumbara tek tek işlenir; bırakılamayan olursa diğerleri yine de kaydedilir. Bu işlem geri alınamaz.',
      done: '{{count}} kumbara kullanım dışı bırakıldı.',
      partial: '{{failed}} / {{total}} kumbara kullanım dışı bırakılamadı.',
    },
    collectTitle: 'Kumbarayı Boşalt',
    collectHint:
      'Sayılan tutarı girin. Onaylandığında bu tutar, yapılandırılmış kampanya dönemine bağışçısız bir bağış olarak işlenir.',
    collectedAt: 'Boşaltma Tarihi',
    amount: 'Çıkan Tutar',
    currency: 'Para Birimi',
    note: 'Not',
    confirmNow: 'Şimdi bağışa dönüştür',
    confirmNowHint: 'Kapalıysa yalnızca sayım kaydedilir; bağış sonradan oluşturulur.',
    history: 'Boşaltma Geçmişi',
    historyEmpty: 'Bu kumbara henüz boşaltılmadı.',
    countedBy: 'Sayan',
    donation: 'Bağış',
    notConfirmed: 'Bağışa dönüştürülmedi',
    settings: 'Kumbara Kampanyası',
    settingsHint:
      'Kumbara boşaltmalarının hangi kampanya dönemine işleneceği. Kapsamı en dar olan ayar geçerlidir.',
    settingsEmpty: 'Henüz bir kumbara kampanyası tanımlanmadı.',
    settingScope: 'Kapsam',
    settingNode: 'Kapsam Birimi',
    settingNodeNone: 'Seçiniz',
    settingPeriod: 'Kampanya Dönemi',
    settingSave: 'Ayarı Kaydet',
    settingClear: 'Ayarı Kaldır',
    created: 'Kumbara eklendi',
    updated: 'Kumbara güncellendi',
    placed: 'Kumbara teslim edildi',
    collectedDone: 'Kumbara boşaltıldı',
    retired: 'Kumbara kullanım dışı bırakıldı',
    confirmed: 'Boşaltma bağışa dönüştürüldü',
  },
  scopeFilter: {
    level: 'Seviye',
    node: 'Birim',
    anyNode: 'Tümü',
  },
  reconciliationStatus: {
    pending_approval: 'Onay Bekliyor',
    confirmed: 'Onaylandı',
    rejected: 'Reddedildi',
    reversed: 'Geri Alındı',
  },
  reconciliationMethod: {
    reference_exact: 'Referans kodu (tam)',
    reference_multi: 'Referans kodu (çoklu)',
    reference_amount_mismatch: 'Referans kodu (tutar farklı)',
    reference_corrected: 'Referans kodu (düzeltilmiş)',
    amount_date: 'Tutar ve tarih',
    manual: 'Elle',
    provider: 'Kart sağlayıcısı',
  },
  reconciliationReversalKind: {
    unmatch: 'Eşleştirme kaldırıldı',
    cancel_refund: 'Bağış iptali — iade',
    cancel_reverse: 'Bağış iptali — ters kayıt',
    chargeback: 'Ters ibraz (chargeback)',
    provider_refund: 'Sağlayıcı iadesi',
  },
  allocation: {
    title: 'Tahsilat Eşleştirmeleri',
    subheader: 'Bu bağışa hangi hesap hareketlerinden ne kadar yazıldığı',
    allocate: 'Hareket Eşleştir',
    donationAmount: 'Bağış tutarı',
    outstanding: 'Eşleştirilecek kalan',
    outstandingHint: 'Onaylı ve onay bekleyen eşleştirmeler düşülmüştür.',
    closed: {
      cancelled: 'İptal edilmiş bağış tahsilat beklemez; hareket eşleştirilemez.',
      settled: 'Bağışın tamamı tahsil edildi.',
      refunded: 'Bağışın parası iade edildi; hareket eşleştirilemez.',
      not_charged: 'Bu kampanya ücret almaz; bağışa hareket eşleştirilemez.',
    },
    empty: 'Bu bağışa henüz bir hesap hareketi eşleştirilmedi.',
    candidatesOnly:
      'Veri kapsamınız yalnızca kendi kayıtlarınız olduğu için hesap hareketlerini göremezsiniz; bu bağışa uyan eşleşmemiş hareketlerden birini seçebilirsiniz.',
    column: {
      bookedOn: 'Hareket Tarihi',
      account: 'Hesap',
      transactionAmount: 'Hareketten',
      donationAmount: 'Bağışa Yazılan',
      status: 'Durum',
    },
    rateDate: 'Kur günü {{date}}',
    awaitingSecond: 'Farklı para birimi — ikinci bir yetkilinin onayını bekliyor',
    ownProposal: 'Bu eşleştirmeyi siz önerdiniz; onayı başka bir yetkili vermeli.',
    waitsForMovement:
      'Bu eşleştirme hareketin kuruluşunun ({{organization}}) onayını bekliyor; onaylanana kadar bağış ödenmiş sayılmaz. Bekleyen öneriyi geri çekebilirsiniz.',
    rejectedBecause: 'Red gerekçesi: {{reason}}',
    reversedBecause: '{{kind}}: {{reason}}',
    moreActions: 'Eşleştirme işlemleri',
    action: {
      approve: 'Onayla',
      reject: 'Reddet',
      unmatch: 'Eşleştirmeyi Kaldır',
      reverse: 'Ters İbraz (Chargeback)',
    },
    confirm: {
      approve:
        'Bu eşleştirme onaylansın mı? Onayla birlikte bağışın tahsilat durumu, kampanyanın tahsil edilen toplamı ve defter kaydı güncellenir.',
      approveCrossOrganization:
        'Bu bağış başka bir kuruluşun kayıtlı kurumuna ait; onayladığınızda hareket sizin kuruluşunuzun defterine tahsilat olarak yazılır, bağış ödenmiş sayılır ve makbuzu kesilir. Geri almak için makbuzun önce iptal edilmesi gerekir.',
      reject:
        'Bu eşleştirme reddedilsin mi? Hareketin ayrılan tutarı serbest kalır ve başka bir bağışla eşleştirilebilir.',
      unmatch:
        'Bu eşleştirme kaldırılsın mı? Hareket yeniden eşleşmemiş hareketlere döner, bugünün tarihiyle ters defter kaydı yazılır ve bağışın tahsilat durumu geri alınır.',
      reverse:
        'Banka ters ibraz (chargeback) bildirdi mi? Eşleştirme geri alınır ve bağış “Ters Kayıt” olur; hareket ayrılmış kalır, geri çekilen para kendi hareketiyle gelir. Bağışın başka onaylı eşleştirmesi varsa önce onlar kaldırılmalıdır.',
    },
    done: {
      approve: 'Eşleştirme onaylandı.',
      reject: 'Eşleştirme reddedildi.',
      unmatch: 'Eşleştirme kaldırıldı.',
      reverse: 'Ters ibraz kaydedildi.',
      match: 'Hareket bağışa eşleştirildi.',
      matchPending: 'Eşleştirme kaydedildi; ikinci bir yetkilinin onayını bekliyor.',
      remainderMatched: 'Kalan tutar için yeni bağış oluşturuldu ve hareket kapatıldı.',
      remainderKept: 'Hareket kısmen eşleşti; kalan tutar mutabakat ekranında bekliyor.',
    },
    record: {
      movement: 'Hareket: {{organization}}',
      institution: 'kurum: {{institution}}',
      crossOrganization: 'Başka kuruluşun hareketi',
      rate: '{{currency}} kuru {{rate}}',
      fxDifference: 'Kur farkı: {{amount}} ({{direction}})',
      fxShortfall: 'hareket eksik kaldı',
      fxSurplus: 'hareket fazla geldi',
    },
    remainder: {
      title: 'Kalan tutar',
      question: 'Kalan tutar için aynı bağışçı adına farklı bir kampanyada bağış oluşturulsun mu?',
      detail:
        'Hareketten {{amount}} kaldı. Evet derseniz bu tutar için aynı bağışçı adına, seçeceğiniz serbest tutarlı kampanyada bir bağış açılır ve hareket bu bağışla kapatılır. Hayır derseniz hareket kısmen eşleşmiş olarak mutabakat ekranında kalır.',
      yes: 'Evet, bağış oluştur',
      no: 'Hayır',
      campaign: 'Kampanya',
      source: 'Bağışçı',
      sourceHint:
        'Sepetteki bağışlardan hangisinin bağışçısı adına bağış açılacağını seçin; yeni bağış o bağışın kurumuna ve sahiplik bilgilerine yazılır.',
      campaignHint:
        'Yalnızca serbest tutarlı, şu an bağış kabul eden ve hareketin kalan tutarını bu para biriminde kabul eden kampanyalar listelenir.',
      noCampaign: 'Bağış kabul eden serbest tutarlı kampanya bulunamadı.',
      campaignsFailed: 'Kampanyalar okunamadı. Lütfen tekrar deneyin.',
      noDonor: 'Bağışın bağışçısı bulunmadığı için yeni bağış açılamaz.',
    },
    dialog: {
      title: 'Hareket Eşleştir',
      hint: 'Tüm kurumların ve kuruluşların, tutarı henüz tamamen dağıtılmamış gelen hareketleri. İsim, tutar ve para birimine göre arayın; herhangi bir hareketi seçip bu bağışa yazılacak kısmı girin. Hareket başka bir kuruluşun ya da başka bir para biriminde olabilir; karşılık, hareketin tarihindeki kurla bağışın para birimine çevrilir.',
      select: 'Seç',
      remaining: 'Kalan',
      noLines: 'Eşleştirilebilecek hesap hareketi yok',
      noLinesHint: 'Tüm gelen hareketler dağıtılmış ya da henüz hareket girilmemiş.',
      candidatesHint:
        'Yalnızca bu bağışa uyan, henüz hiç eşleşmemiş hareketler: bağışın para biriminde ve kalan tutarıyla aynı tutarda. Birini seçin; hareketin tamamı bu bağışa yazılır.',
      noCandidates: 'Bu bağışa uyan eşleşmemiş hareket yok',
      noCandidatesHint:
        'Bağışın kalan tutarıyla aynı tutarda ve para biriminde, henüz eşleşmemiş bir gelen hareket bulunamadı.',
      amount: 'Hareketten yazılacak tutar',
      amountHint: 'Hareketin para biriminde. Bağışa yazılacak karşılığı sunucu hesaplar.',
      candidateAmountHint: 'Hareketin tamamı bu bağışa yazılır.',
      amountInvalid: 'Sıfırdan büyük ve hareketin kalanını aşmayan bir tutar girin.',
      crossCurrency:
        'Hareket {{line}}, bağış {{donation}}. Karşılık, hareketin kur gününde dondurulan kurlarla hesaplanır; eşleştirme hemen kesinleşir.',
      conversion: {
        credits: 'Bağışa yazılacak: {{amount}}',
        rate: 'Kur günü {{date}} · hareket {{lineAmount}} → bağış {{donationAmount}}',
        suggested: 'Bağışı tam kapatan tutar yazıldı',
        tolerance:
          'Fark, %{{percent}} kur toleransının içinde: bağış tam kapatılır ve {{amount}} {{direction}} kur farkı olarak kaydedilir.',
        pending:
          'Hareketin döviz karşılıkları henüz hesaplanmadı (Kur bekleniyor); farklı para birimli eşleştirme kurlar gelince yapılabilir.',
        unavailable: 'Hareketin kur gününde bu para birimi için kur yok; eşleştirme yapılamaz.',
      },
      submit: 'Eşleştir',
      pickLine: 'Önce bir hareket seçin.',
    },
  },
  reconciliation: {
    title: 'Mutabakat',
    fxTolerance: {
      action: 'Kur toleransı',
      title: 'Kur toleransı',
      hint: 'Farklı para birimli bir eşleştirmede hareketin çevrilen karşılığı bağışın kalanından bu oranın içinde eksik ya da fazlaysa bağış tam kapatılır ve fark, kur farkı olarak eşleştirmeye yazılır. Oranın dışındaki eksik bağışı kısmen ödenmiş bırakır; fazla ise hareketin kalanı için yeni bağış sorusu sorulur. Aynı para biriminde tolerans yoktur.',
      label: 'Tolerans (%)',
      example: 'Örneğin 1 ya da 0,5. En çok %10.',
      invalid: '0 ile {{max}} arasında, en çok iki ondalıklı bir oran girin.',
      save: 'Kaydet',
      done: 'Kur toleransı güncellendi',
    },
    /**
     * Written by the server into a reversal's reason and a voided receipt's
     * reason when a verified provider callback, not a person, reversed a card
     * capture — the reason a person would otherwise have typed.
     */
    providerReversalReason: {
      chargeback: 'Kart sağlayıcısı ters ibraz (chargeback) bildirdi.',
      refund: 'Kart sağlayıcısı ödemenin tamamının iade edildiğini bildirdi.',
    },
    account: 'Hesap',
    pickAccount: 'Bir hesap seçin',
    pickAccountHint:
      'Motorun önerileri, eşleşmemiş ve hariç tutulan hareketler hesap hesap görüntülenir. Onay bekleyen ve tamamlanan eşleştirmeler tüm hesaplar için birlikte de görülebilir.',
    allAccounts: 'Tüm hesaplar',
    noAccounts: 'Veri kapsamınızın tamamını tuttuğu bir kuruluşun hesabı yok.',
    tab: {
      proposals: 'Öneriler',
      unmatched: 'Eşleşmemiş',
      excluded: 'Hariç Tutulan',
      pending_approval: 'Onay Bekleyen',
      awaiting_bank: 'Banka Hareketi Bekleyen',
      history: 'Tamamlanan',
    },
    history: {
      outcomeLabel: 'Sonuç',
      outcome: {
        confirmed: 'Onaylandı',
        rejected: 'Reddedildi',
        reversed: 'Ters kayıt',
        unmatched: 'Eşleştirme kaldırıldı',
      },
      bookedFrom: 'Hareket tarihi başlangıç',
      bookedTo: 'Hareket tarihi bitiş',
      bookedRange: 'Hareket tarihi',
      search: 'Referans kodu (BT ile ya da BT olmadan) veya bağışçı adı ara…',
      donor: 'Bağışçı',
      transactionCurrency: 'Hareketin para birimi',
      donationCurrency: 'Bağışın para birimi',
      decidedAt: 'Karar zamanı',
      reason: 'Gerekçe',
      exportSelected: 'Seçilenleri CSV olarak indir',
      csvFile: 'eslestirme-gecmisi.csv',
    },
    shortfallsAction: 'Eksik Tahsilatlar',
    basketAction: 'Ödeme Sepeti',
    column: {
      bookedOn: 'Tarih',
      line: 'Hareket',
      amount: 'Tutar',
      remaining: 'Kalan',
      proposal: 'Öneri',
      donations: 'Önerilen bağışlar',
      classification: 'Sınıf',
      excluded: 'Hariç tutulma',
      donation: 'Bağış',
      transactionAmount: 'Hareketten',
      donationAmount: 'Bağışa yazılan',
      proposer: 'Öneren',
    },
    proposal: {
      score: 'Puan {{score}}',
      bulkConfirmable: 'Toplu onaylanabilir',
      rateDay: 'Kur günü {{date}}',
      crossOrganization: 'Başka kuruluşun bağışı · {{institution}}',
      notSelectable: 'Yalnızca tam referans eşleşmeleri toplu onaylanabilir.',
      held: 'Elle kaydedilmiş ödemeyle mahsup bekliyor',
      heldCandidates_one: '{{count}} olası ödeme',
      heldCandidates_other: '{{count}} olası ödeme',
      heldHint:
        'Bu hareket, dekont ya da çekle elle kaydedilip onaylanmış bir ödemenin parası olabilir; o yüzden bağış önerilmiyor. Hareketi açıp ödemeyle eşleştirin.',
    },
    empty: {
      proposals: 'Öneri yok',
      proposalsHint:
        'Bu hesabın eşleşmemiş hareketlerinin hiçbirinde motor bir bağış bulamadı. Eşleşmemiş sekmesinden elle eşleştirin.',
      unmatched: 'Eşleşmemiş hareket yok',
      unmatchedHint: 'Bu hesabın bütün hareketleri eşleştirildi ya da hariç tutuldu.',
      excluded: 'Hariç tutulan hareket yok',
      excludedHint: 'Masraf, virman gibi bağış parası olmayan hareketler burada listelenir.',
      pending: 'Onay bekleyen eşleştirme yok',
      pendingHint:
        'Banka hareketiyle yapılan eşleştirmeler hemen kesinleşir; burada yalnızca bu kuraldan önce kaydedilmiş ve hâlâ karar bekleyen eşleştirmeler görünür.',
      history: 'Bu filtreye uyan eşleştirme yok',
      historyHint:
        'Onaylanan, reddedilen, ters kayda alınan ve kaldırılan eşleştirmeler burada listelenir.',
    },
    bulk: {
      confirm: 'Toplu Onayla',
      title: '{{count}} tam eşleşme onaylansın mı?',
      content:
        'Her hareket önerilen bağışlarla eşleştirilir ve bağışların tahsilat durumu, kampanya toplamları ve defter kayıtları güncellenir. Sunucu her hareketi yeniden okur; bu arada tam eşleşme olmaktan çıkan bir hareket onaylanmaz.',
      done: '{{count}} hareket eşleştirildi.',
      partial: '{{failed}} / {{total}} hareket eşleştirilemedi.',
    },
    action: {
      review: 'İncele ve Eşleştir',
      exclude: 'Hariç Tut',
      include: 'Eşleşmemişlere Geri Al',
      viewLine: 'Hareketi Görüntüle',
      approve: 'Onayla',
      reject: 'Reddet',
      openDonation: 'Bağışı Aç',
      classify: 'Sınıflandır',
      refund: 'İade Talep Et',
      forward: 'Başka Kuruluşa Aktar',
    },
    classify: {
      title: 'Çıkan hareket nedir?',
      hint: 'Bir iade yalnızca iade ödemesi olarak sınıflanmış çıkan bir hareketle ödenir. Bir iadeyi ya da transferi karşılayan hareketin sınıfı sonradan değiştirilemez.',
      classification: 'Hareketin sınıfı',
      pick: 'Bir sınıf seçin.',
      done: 'Hareketin sınıfı kaydedildi.',
      option: {
        refund_payout: {
          title: 'İade ödemesi',
          description: 'Bir bağışçıya geri ödenen para. Onaylanmış bir iade bu hareketle ödenir.',
        },
        internal_transfer: {
          title: 'Virman / fon transferi',
          description: 'Kuruluşun kendi hesapları ya da başka bir kuruluş arasında aktarılan para.',
        },
        fee: {
          title: 'Masraf',
          description: 'Bankanın ya da sağlayıcının kestiği ücret.',
        },
        other: {
          title: 'Diğer',
          description: 'Yukarıdakilerden hiçbiri; hareket sınıflanmamış kalır.',
        },
      },
    },
    exclude: {
      title: 'Hareket hariç tutulsun mu?',
      hint: 'Hariç tutulan hareket bağış parası sayılmaz: eşleşmemiş hareketlerden çıkar ve defter kaydı yazılmaz. Tutarının bir kısmı eşleştirilmiş bir hareket hariç tutulamaz.',
      classification: 'Bu hareket nedir?',
      pickClassification: 'Bir sınıf seçin.',
      reason: 'Gerekçe',
      reasonRequired: 'Bir gerekçe yazın.',
      option: {
        fee: {
          title: 'Banka masrafı',
          description: 'Hesap işletim ücreti, havale masrafı gibi bankanın kestiği bir tutar.',
        },
        internal_transfer: {
          title: 'Virman',
          description: 'Kuruluşun kendi hesapları arasında aktarılan para; bağış değildir.',
        },
        other: {
          title: 'Diğer',
          description: 'Bağış olmayan başka bir hareket. Gerekçede ne olduğunu yazın.',
        },
      },
      done: 'Hareket hariç tutuldu.',
    },
    include: {
      title: 'Hareket eşleşmemişlere geri alınsın mı?',
      content:
        'Gelen bir hareket yeniden bağış ödemesi, giden bir hareket “Diğer” olarak eşleşmemiş hareketlere döner.',
      done: 'Hareket eşleşmemiş hareketlere geri alındı.',
    },
    drawer: {
      title: 'Hareketi Eşleştir',
      remaining: 'Kalan',
      proposal: 'Motorun önerisi',
      noProposal: 'Motor bu hareket için bir öneride bulunmadı.',
      applyProposal: 'Öneriyi Uygula',
      readings: 'Hareketin işaret ettiği bağışlar',
      noReadings:
        'Açıklamada eşleştirilebilir bir referans kodu yok ve tutarı ile tarihi uyan bir bağış bulunmadı.',
      information: 'Eşleştirilemeyecek bağışlar',
      informationHint:
        'Açıklama bu bağışları anıyor ama para bunlara yazılamaz; ne yapılacağına bir yetkili karar verir.',
      search: 'Bağış Ara',
      referenceCode: 'Referans kodu',
      donor: 'Bağışçı',
      minAmount: 'En az kalan',
      maxAmount: 'En çok kalan',
      institution: 'Kurum',
      searchAction: 'Ara',
      noResults: 'Aramaya uyan, ödeme alabilecek bağış yok.',
      add: 'Ekle',
      added: 'Eklendi',
      remove: 'Çıkar',
      allocations: 'Eşleştirilecek bağışlar',
      noAllocations: 'Henüz bağış eklenmedi. Öneriyi uygulayın ya da listelerden bağış ekleyin.',
      amount: 'Hareketten yazılacak',
      outstanding: 'Kalan borç {{amount}}',
      amountInvalid: 'Sıfırdan büyük ve bağışın kalanını aşmayan bir tutar girin.',
      total: 'Toplam {{total}} · hareketin kalanı {{remaining}}',
      overAllocated: 'Toplam, hareketin kalanını aşıyor.',
      conversion: 'Bağışa yazılacak {{amount}} · kur günü {{date}}',
      conversionPending: 'Karşılık hesaplanıyor…',
      crossCurrency:
        'Farklı para birimi: karşılık hareketin kur gününde dondurulan kurlarla hesaplanır; eşleştirme hemen kesinleşir.',
      submit: 'Eşleştir',
      lineChanged:
        'Hareket siz bakarken değişti ve yeniden yüklendi. Tutarları kontrol edip tekrar deneyin.',
      loadFailed: 'Hareket okunamadı.',
      clearing: {
        title: 'Elle kaydedilmiş ödemenin banka hareketi',
        hint: 'Bu hareket, dekont ya da çekle elle kaydedilip onaylanmış bir ödemenin bankaya düşen parası olabilir. O ödeme bağışı zaten ödenmiş saydı; hareketi bir bağışla eşleştirirseniz aynı para iki kez sayılır.',
        suppressed: 'Elle kaydedilmiş bir ödeme bu harekete uyduğu için motor bağış önermiyor.',
        receivedOn: 'Ödeme tarihi {{date}}',
        recordedBy: 'Kaydeden: {{name}}',
        reference: 'Dekont / çek no: {{reference}}',
        exactAmount: 'Tutar tam uyuyor',
        partAmount: 'Hareketin bir kısmı',
        confirm: 'Bu Ödemenin Hareketi',
        confirmTitle: 'Hareket bu ödemenin parası olarak işaretlensin mi?',
        confirmContent:
          'Hareketten {{amount}} bu ödemeye ayrılır. Bağışların tahsilatı, defter ve makbuz değişmez; ödeme onaylandığında zaten sayıldı. Hareketin kalanı varsa başka bir bağışla eşleştirilebilir.',
        done: 'Hareket elle kaydedilmiş ödemenin parası olarak işaretlendi.',
      },
      uncleared: {
        title: 'Bu bağış elle kaydedilmiş bir ödemeyle zaten ödeniyor',
        content:
          'Eklediğiniz bağışlardan en az biri bu hesaba dekont ya da çekle elle kaydedilmiş — onay bekleyen ya da onaylanmış — ve banka hareketi henüz bulunmamış bir ödemeyle ödeniyor. Bu hareket o ödemenin parası olabilir; eşleştirirseniz aynı para iki kez sayılır. Hareket o ödemenin parası değilse yine de eşleştirebilirsiniz.',
        confirm: 'Yine de Eşleştir',
      },
    },
    ownProposal: 'Sizin öneriniz; onayı başka bir yetkili vermeli.',
  },
  notificationSenderProvider: {
    netgsm: 'Netgsm',
    twilio: 'Twilio',
    whatsapp_business: 'WhatsApp Business (Meta)',
    evolution: 'Evolution geçidi',
    smtp: 'Sunucunun e-posta aktarımı',
  },
  cardProvider: {
    nestpay: 'Sanal POS (NestPay)',
    stripe: 'Stripe',
    paypal: 'PayPal',
  },
  payout: {
    title: 'Kart Ödemeleri Mutabakatı',
    tab: {
      pending: 'Bekleyen Ödemeler',
      confirmed: 'Mutabakatı Yapılanlar',
      reversed: 'Geri Alınanlar',
    },
    bankAccount: 'Banka hesabı',
    allBankAccounts: 'Tüm banka hesapları',
    pickBankAccount: 'Bir banka hesabı seçin',
    pickBankAccountHint:
      'Sanal POS ve Stripe aktarımları banka ekstresinde kart ödemesi olarak sınıflanır; mutabakatları hesap hesap yapılır.',
    noBankAccounts: 'Mutabakatını yapabileceğiniz bir banka hesabı yok',
    notDonations:
      'Kart ödemelerinin mutabakatı bağışların tahsilat durumunu değiştirmez: her bağış, tahsilatı doğrulandığında zaten tahsil edilmiştir. Burada yalnızca banka hareketi kapatılır ve sağlayıcının komisyonu deftere yazılır.',
    settlements: {
      title: 'Banka hareketleri',
      subheader: 'Kart ödemesi olarak sınıflanmış, mutabakatı yapılmamış gelen hareketler',
      empty: 'Mutabakat bekleyen kart ödemesi yok',
      emptyHint:
        'Bu hesabın kart ödemesi olarak sınıflanan bütün hareketlerinin mutabakatı yapılmış.',
    },
    captures: {
      title: 'Sağlayıcı tahsilatları',
      subheader: 'Seçilen hesabın, hiçbir mutabakatta yer almayan doğrulanmış tahsilatları',
      account: 'Sanal POS / Stripe hesabı',
      noAccounts: 'Bu kuruluşun sanal POS veya Stripe hesabı yok.',
      pickLine: 'Soldan bir banka hareketi seçin',
      pickLineHint:
        'Tahsilatlar ve komisyon, seçilen banka hareketine göre hesaplanır. Önce hareketin bir gün öncesinin tahsilatları listelenir; aralığı sağlayıcının ödeme günlerine göre değiştirin.',
      empty: 'Bu aralıkta ödenmemiş tahsilat yok',
      emptyHint: 'Tarih aralığını veya hesabı değiştirin.',
      truncated:
        'Bu aralıkta {{total}} tahsilat var; bir mutabakata en çok {{shown}} tahsilat girebilir. Aralığı daraltın.',
      reversed: 'Bu tahsilat {{kind}}; sağlayıcı genellikle ödemeden düşer.',
      window: {
        from: 'Tahsilat başlangıcı',
        to: 'Tahsilat bitişi',
      },
    },
    column: {
      bookedOn: 'Tarih',
      line: 'Hareket',
      amount: 'Tutar',
      transaction: 'Sağlayıcı işlemi',
      donation: 'Bağış',
      provider: 'Sağlayıcı',
      captureCount: 'Tahsilat',
      gross: 'Brüt',
      fee: 'Komisyon',
      deductions: 'Mahsup',
      net: 'Banka hareketi',
      confirmed: 'Onaylayan',
      reversed: 'Geri alan',
    },
    summary: {
      title: 'Mutabakat özeti',
      count: 'Dahil tahsilat',
      gross: 'Brüt tahsilat',
      bank: 'Banka hareketi',
      fee: 'Komisyon',
      deductions: 'Sağlayıcı mahsupları',
      feeHint: 'Brüt tahsilattan banka hareketi düşülerek hesaplanır.',
    },
    report: {
      field: 'Sağlayıcı ödeme no',
      hint: 'Stripe payout kimliği (po_…). Girip raporu okutun.',
      action: 'Raporu Oku',
      done: 'Sağlayıcı raporu okundu; {{count}} mahsup bulundu.',
      none: 'Mahsup yok',
      feeHint:
        'Brüt tahsilattan banka hareketi ve sağlayıcı raporundan okunan mahsuplar düşülerek hesaplanır.',
    },
    confirm: {
      action: 'Mutabakatı Onayla',
      title: 'Ödeme mutabakatı onaylansın mı?',
      content:
        '{{count}} tahsilat bu banka hareketiyle kapatılır ve {{fee}} komisyon kuruluşun defterine yazılır. Bağışların tahsilat durumu değişmez.',
      done: 'Ödeme mutabakatı onaylandı.',
    },
    reverse: {
      action: 'Mutabakatı Geri Al',
      title: 'Ödeme mutabakatı geri alınsın mı?',
      content:
        'Banka hareketi ve tahsilatlar yeniden mutabakat bekler; komisyon bugünün tarihiyle deftere geri yazılır.',
      reason: 'Gerekçe',
      reasonRequired: 'Bir gerekçe yazın.',
      done: 'Ödeme mutabakatı geri alındı.',
    },
    empty: {
      confirmed: 'Mutabakatı yapılmış ödeme yok',
      confirmedHint: 'Onaylanan ödeme mutabakatları burada listelenir.',
      reversed: 'Geri alınmış ödeme mutabakatı yok',
      reversedHint: 'Geri alınan mutabakatlar, gerekçesiyle burada kalır.',
    },
  },
  institutionLedger: {
    title: 'Kurum Cari Hesapları',
    statement: 'Cari Ekstre',
    notice:
      'Bu hesaplar, kurumun kaydettiği bağışlar için onaylanan tahsilatları ve gerçekleşen işler için kurumlar arası borç ve hakedişleri gösterir. Her para birimi ayrı izlenir.',
    statementHint:
      'Filtreler hareketleri daraltır; güncel bakiye ve hareket sonrası bakiye tüm geçmiş üzerinden hesaplanır.',
    debit: 'Borç (−)',
    credit: 'Tahsilat / Hakediş (+)',
    balance: 'Güncel bakiye',
    balanceAfter: 'Hareket sonrası bakiye',
    lastEntryAt: 'Son hareket',
    date: 'İşlem tarihi',
    reference: 'Bağış kodu',
    counter: 'Karşı kurum / banka hareketi',
    kind: 'İşlem',
    units: 'Birim',
    amount: 'Tutar',
    direction: 'Borç / Hakediş',
    from: 'Başlangıç tarihi',
    to: 'Bitiş tarihi',
    minAmount: 'En az tutar',
    maxAmount: 'En çok tutar',
    amountHint: 'Tutarı seçilen para biriminde yazın; ör. 12,50.',
    amountInvalid: 'Sıfır veya pozitif, en çok iki ondalıklı bir tutar girin.',
    search: 'Kurum adı veya kodu',
    empty: 'Cari hareket bulunamadı',
    emptyHint:
      'Kurumun kaydettiği bir bağışın eşleştirmesi onaylandığında ya da birim masraf tanımlı bir iş gerçekleştiğinde hareketleri burada görebilirsiniz.',
    collectionKinds: {
      collection: 'Tahsilat',
      collection_reversal: 'Tahsilat iptali',
    },
    collectionReversals: {
      unmatch: 'Eşleştirme kaldırıldı',
      cancel_refund: 'Bağış iptal edildi, iade edilecek',
      cancel_reverse: 'Bağış iptal edildi, hareket serbest bırakıldı',
      chargeback: 'Ters ibraz',
      provider_refund: 'Ödeme sağlayıcısı iadesi',
    },
    collectionLine: '{{organization}} · {{account}} · {{date}}',
    accountHidden: 'Hesap gösterilmiyor',
    causes: {
      fulfilled: 'Gerçekleşti',
      unfulfilled: 'Gerçekleşme geri alındı',
      cancelled: 'İptal',
      remainder_cancelled: 'Kalan hisseler iptal edildi',
    },
    pending: {
      title: 'Gelen hareketler (mutabakat bekleyen)',
      subheader:
        'Açıklama, gönderen veya referansında bu kurumun kodu geçen ve henüz onaylı eşleştirmelerle tamamen karşılanmamış gelen banka hareketleri',
      summarySubheader:
        'Kurum koduyla sınıflandırılmış, henüz onaylı eşleştirmelerle tamamen karşılanmamış gelen banka hareketleri; kurum ve para birimi başına',
      notice:
        'Bu tutarlar henüz hiçbir cari bakiyeye dahil değildir. Bir eşleştirme onaylandığında eşleşen tutar, bağışın kaydedildiği kurumun cari hesabına Tahsilat olarak geçer ve bu listeden düşer; o kurum bu kurumdan farklı olabilir. İkinci kişinin onayını bekleyen eşleştirmeler burada kalır.',
      totals: 'Para birimine göre bekleyen',
      byOrganization: 'Kuruluşa göre bekleyen',
      currencyCount: '{{currency}} · {{count}} hareket',
      none: 'Bekleyen hareket yok',
      bookedOn: 'Hareket tarihi',
      open: 'Bekleyen tutar',
      description: 'Açıklama',
      account: 'Kuruluş / hesap',
      code: 'Eşleşen kod',
      movementCount: 'Hareket',
      lastBookedOn: 'Son hareket',
      empty: 'Mutabakat bekleyen gelen hareket yok',
      emptyHint:
        'Kurum koduyla sınıflandırılan ve henüz eşleştirilmemiş gelen banka hareketleri burada görünür.',
    },
  },
  finance: {
    organization: 'Kuruluş',
    institution: 'Kurum',
    currency: 'Para birimi',
    allOrganizations: 'Tüm kuruluşlar',
    organizationUnknown:
      'Adresteki kuruluş bulunamadı ya da veri kapsamınız onun tamamını tutmuyor. Listeden bir kuruluş seçin.',
    organizationUnknownClear: 'Seçimi temizle',
    balances: {
      title: 'Bakiyeler',
      asOf: 'Tarih itibarıyla',
      asOfCaption: '{{date}} tarihine kadar deftere geçen kayıtların toplamı',
      notice:
        'Bakiye, eşleştirilmiş bağış paralarının defter kayıtlarından her seferinde yeniden toplanır; banka hesabının bakiyesi değildir. Eşleşmemiş ya da hariç tutulmuş bir hareket deftere girmez.',
      consolidationAction: 'Konsolidasyon Raporu',
      institutionVaults: 'Kurum kasa bakiyesi',
      vaultTransfers: 'Kasa defterine geçen aktarım',
      vaultTransfersHint:
        'Kasa defterine geçen aktarım, kuruluşun kurumların kendi kasalarına aktardığı paradır (kasaların kendi defterinden okunur, bu yüzden Kuruma aktarılan sütunuyla karşılaştırılabilir); geri alınan aktarımlar düşülmüştür ve kasadan yapılan harcamalar yansımaz. Kasada duran para değildir ve kuruluşun bakiyesine eklenmez. Kurumların satırlarındaki Kurum kasa bakiyesi ise o kurumun kasalarında şu an duran paranın tamamıdır (tüm kuruluşların aktarımları, harcamalar dahil); kurumun kuruluş satırlarında aynı rakam tekrar eder ve toplanmaz.',
      byLocation: {
        title: 'Konuma göre kasa bakiyeleri',
        subheader:
          'Kuruluşların hesaplarındaki rakamlar, kuruluşun yerleştirildiği ülke, mıntıka ya da bölgeye göre toplanır',
        groupBy: 'Grupla',
        organizations: 'Kuruluş',
        empty: 'Gösterilecek kuruluş bakiyesi yok',
        emptyHint: 'Filtreleri değiştirin ya da kuruluşlara bir konum atayın.',
        notice:
          'Her satır tek bir para birimidir; farklı para birimleri toplanmaz ve çevrilmez. Konumu atanmamış kuruluşlar ayrı bir grupta toplanır. Yalnızca okuma yetkiniz olan kuruluşlar sayılır.',
      },
      organizations: {
        title: 'Kuruluş toplamları',
        subheader:
          'Kurumların kayıtları ve kuruluş düzeyindeki kayıtlar — masraflar, fon transferleri, bağışsız iadeler — ayrı ayrı',
        institutions: 'Kurum kayıtları',
        organizationLevel: 'Kuruluş düzeyi',
        total: 'Toplam',
        empty: 'Görebileceğiniz bir kuruluş toplamı yok',
        emptyHint:
          'Kuruluş toplamları yalnızca kuruluşun bütün kurumlarını kapsayan bir yetki alanında görünür.',
      },
      institutions: {
        title: 'Kurum bakiyeleri',
        subheader: 'Yetki alanınızdaki kurumların, para birimi başına bakiyesi',
        balance: 'Bakiye',
        empty: 'Bu tarihe kadar kurum bakiyesi yok',
        emptyHint: 'Tarihi ya da filtreleri değiştirin.',
      },
    },
    consolidation: {
      title: 'Konsolidasyon Raporu',
      pickOrganization: 'Bir kuruluş seçin',
      pickOrganizationHint:
        'Rapor, kuruluşun bütün kurumlarını kapsayan yetki alanınızdaki kuruluşlar için alınır.',
      notice:
        'Her günün hareketleri, o günden önceki son kur gününün kuruyla {{base}} karşılığına çevrilir; kuru bulunmayan bir gün tahmini bir kurla çevrilmez.',
      column: {
        currency: 'Para birimi',
        original: 'Tutar',
        entries: 'Kayıt',
        rateDays: 'Kullanılan kur günleri',
        converted: '{{base}} karşılığı',
        baseCurrency: 'Karşılığın para birimi',
      },
      noConversion: 'Çevrilmez',
      unconverted: 'Kuru bulunmadığı için çevrilemedi',
      unconvertedAlert:
        '{{currencies}} için bu dönemde kur bulunmadı. Bu tutarlar toplama katılmadı; tahmini bir kurla çevrilmez.',
      total: 'Toplam ({{base}})',
      empty: 'Bu dönemde defter kaydı yok',
      emptyHint: 'Dönemi ya da kuruluşu değiştirin.',
      csvFile: 'konsolidasyon',
    },
  },
  refund: {
    title: 'İadeler',
    tab: {
      pending: 'Onay Bekleyen',
      approved: 'Ödeme Bekleyen',
      paid: 'Ödenen',
      cancelled: 'Vazgeçilen',
    },
    statuses: {
      pending: 'Onay bekliyor',
      approved: 'Ödeme bekliyor',
      paid: 'Ödendi',
      cancelled: 'Vazgeçildi',
    },
    origins: {
      cancellation: 'Bağış iptali',
      line: 'Fazla ödeme',
      provider: 'Kart sağlayıcısı',
    },
    column: {
      requested: 'Talep',
      organization: 'Kuruluş / bağış',
      donation: 'Bağış',
      origin: 'Kaynak',
      reason: 'Gerekçe',
      money: 'İade',
      currency: 'Para Birimi',
      source: 'Geldiği hareket',
      paid: 'Ödendiği hareket',
      decision: 'Onay',
      status: 'Durum',
    },
    requestedBy: '{{name}} talep etti',
    requestedBySystem: 'Sağlayıcı bildirimi',
    approvedBy: '{{name}} onayladı',
    cancelledBy: '{{name}} vazgeçti',
    waitingApproval: 'İkinci bir kişinin onayını bekliyor',
    notice:
      'Bir iade, talep edenden başka bir yetkili onayladıktan sonra, ekstrede iade ödemesi olarak sınıflanmış çıkan hareketle eşleştirilerek ödenir.',
    secondApprover: 'Bu talebi başka bir yetkili onaylamalı',
    empty: 'İade bulunamadı',
    emptyHint:
      'İptal edilen bağışların iadeleri ve fazla ödemelerden istenen iadeler burada listelenir.',
    csvFile: 'iadeler',
    action: {
      approve: 'Onayla',
      pay: 'Ödemeyi Eşleştir',
      cancel: 'İadeden Vazgeç',
    },
    approve: {
      title: 'İade onaylansın mı?',
      content:
        '{{amount}} tutarındaki iade ödenebilir hale gelir. İadeyi talep eden kişi onaylayamaz.',
      done: 'İade onaylandı.',
    },
    pay: {
      title: 'İade hangi hareketle ödendi?',
      hint: 'İade ödemesi olarak sınıflanmış, iadeyle aynı tutar ve para biriminde, henüz hiçbir şeyi karşılamayan çıkan hareketler listelenir. Seçilen hareket iadeye ayrılır ve iade deftere hareketin tarihiyle yazılır.',
      empty: 'Uygun çıkan hareket yok',
      emptyHint:
        'Ekstrede iadenin çıkan hareketini bulup mutabakat ekranında “İade ödemesi” olarak sınıflandırın.',
      submit: 'Ödendi Olarak Kaydet',
      pickLine: 'Bir hareket seçin.',
      done: 'İade ödendi olarak kaydedildi.',
    },
    cancel: {
      title: 'İadeden vazgeçilsin mi?',
      content:
        'İade için ayrılan tutar hareketin eşleştirilmemiş kalanına geri döner ve bugünün tarihiyle defterden çıkar.',
      reason: 'Gerekçe',
      reasonRequired: 'Bir gerekçe yazın.',
      done: 'İadeden vazgeçildi.',
    },
    request: {
      title: 'İade talebi',
      hint: 'Tutar hareketin eşleştirilmemiş kalanından ayrılır; kimse onu bir bağışa eşleştiremez. İade, talep edenden başka bir yetkili onayladıktan sonra ödenir.',
      remaining: 'Eşleştirilmemiş kalan',
      amount: 'İade tutarı',
      amountInvalid: 'Kalanı aşmayan, sıfırdan büyük bir tutar girin.',
      donation: 'İlgili bağış',
      noDonation: 'Bağış yok — kuruluş düzeyinde',
      reason: 'Gerekçe',
      reasonRequired: 'Bir gerekçe yazın.',
      notRequestable: 'Bu hareketin iade edilebilecek kalanı yok.',
      submit: 'İade Talep Et',
      done: 'İade talep edildi; onay bekliyor.',
    },
  },
  institutionVault: {
    title: 'Kasalar',
    open: 'Kasaları Aç',
    outflow: {
      title: 'Kasadan Çıkışlar',
      subheader: '{{count}} çıkış',
      open: 'Çıkış kaydet',
      empty: 'Bu kasadan henüz çıkış yapılmadı.',
      date: 'Tarih',
      vault: 'Kasa',
      category: 'Kategori',
      description: 'Açıklama',
      amount: 'Tutar',
      recordedBy: 'Kaydeden',
      document: 'Belge',
      status: 'Durum',
      statuses: { recorded: 'Kayıtlı', reversed: 'Geri alındı' },
      reversedBy: 'Geri alan',
      noDocument: 'Belge yok',
      openDocument: 'Belgeyi aç',
      documentPending: 'Tarama bekliyor',
      allVaults: 'Tüm kasalar',
      hint: 'Çıkış tek kişi tarafından kaydedilir ve hemen kasa bakiyesinden düşer. Yanlış kayıt silinmez; geri alınır.',
      action: { reverse: 'Çıkışı Geri Al' },
      record: {
        title: 'Kasadan Çıkış Kaydet',
        hint: 'Kasa bakiyesi sıfırın altına düşürülemez. Kayıt hemen geçerli olur; yanlışsa geri alınır.',
        vault: 'Kasa',
        currency: 'Para birimi',
        currencyHint: 'Yalnızca kasanın bakiyesi olan para birimleri',
        currencyNone: 'Bu kasada harcanabilir bakiye yok',
        balance: 'Kasada: {{amount}}',
        amount: 'Tutar',
        amountInvalid: 'Kasa bakiyesini aşmayan, sıfırdan büyük bir tutar girin',
        category: 'Çıkış kategorisi (Tekdüzen Hesap Planı)',
        categoryRequired: 'Kategori seçin',
        date: 'Çıkış tarihi',
        dateRequired: 'Geçerli bir tarih girin; bugünden sonrası olamaz',
        description: 'Açıklama (isteğe bağlı)',
        document: 'Belge (isteğe bağlı)',
        documentHint: 'Fatura, makbuz ya da dekont — JPEG, PNG veya PDF, en çok 7 MB',
        pick: 'Dosya seç',
        remove: 'Dosyayı kaldır',
        uploading: 'Belge yükleniyor…',
        submit: 'Çıkışı Kaydet',
        done: 'Çıkış kaydedildi',
      },
      reverse: {
        title: 'Çıkışı Geri Al',
        content:
          'Çıkışın tutarı kasaya geri eklenir. Çıkış silinmez; geri alındı olarak kalır ve bir çıkış yalnızca bir kez geri alınır.',
        reason: 'Geri alma gerekçesi',
        reasonRequired: 'Geri alma gerekçesi gerekli',
        done: 'Çıkış geri alındı',
      },
    },
    secondApprover: 'Bu talebi başka bir yetkili onaylamalı',
    cashVault: 'Nakit Kasası',
    kinds: { cash: 'Nakit', bank: 'Banka', other: 'Diğer' },
    statuses: {
      requested: 'Onay bekliyor',
      approved: 'Tamamlanmayı bekliyor',
      completed: 'Tamamlandı',
      cancelled: 'İptal edildi',
      reversed: 'Geri alındı',
    },
    vaults: {
      title: 'Kurumun Kasaları',
      subheader:
        'Kurumun kendi parası. Nakit kasası her kuruma kendiliğinden açılır; banka gibi diğer kasaları yetkili kullanıcılar tanımlar. Her para birimi ayrı izlenir.',
      name: 'Kasa',
      kind: 'Tür',
      balance: 'Bakiye',
      empty: 'Henüz para yok',
      inactive: 'Pasif',
    },
    held: {
      title: 'Kuruluşların Bu Kurum İçin Tuttuğu Para',
      subheader:
        'Mutabakatı yapılmış bağışlardan, kuruma kaydedilen bağışlara ait olan ve henüz kuruma aktarılmamış para. Bu para kuruluşundur; kurumun kendi parası değildir.',
      organization: 'Kuruluş',
      rowName: '{{organization}} bakiyesi',
      collected: 'Mutabakatlı',
      transferred: 'Kuruma aktarılan',
      committed: 'Aktarım bekleyen',
      available: 'Aktarılabilir',
      roomAtInstitution: 'kurumda tutulan {{amount}}',
      transfer: 'Kasaya Aktar',
      empty: 'Bu kurum için mutabakatı yapılmış kuruluş parası yok.',
      notice:
        'Aktarım kuruluşun bakiyesinden düşer ve seçilen kasada kurumun kendi parası olarak görünür. Mutabakat kaydı değişmez; aktarım onaylanmadan ve tamamlanmadan para hareket etmez.',
    },
    transfers: {
      title: 'Kasaya Aktarımlar',
      subheader: '{{count}} aktarım',
      date: 'Talep tarihi',
      vault: 'Kasa',
      amount: 'Tutar',
      reason: 'Gerekçe',
      status: 'Durum',
      empty: 'Henüz aktarım yok.',
      requestedBy: 'Talep eden',
      approvedBy: 'Onaylayan',
      completedBy: 'Tamamlayan',
      cancelledBy: 'İptal eden',
      reversedBy: 'Geri alan',
    },
    action: {
      approve: 'Onayla',
      complete: 'Tamamla',
      cancel: 'Aktarımı İptal Et',
      reverse: 'Geri Al',
    },
    create: {
      open: 'Kasa Tanımla',
      title: 'Kasa Tanımla',
      hint: 'Nakit kasası her kurumda zaten vardır. Banka ya da başka bir kasa tanımlayın.',
      kind: 'Kasa türü',
      name: 'Kasa adı',
      nameRequired: 'Kasa adı gerekli',
      submit: 'Kasayı Oluştur',
      done: 'Kasa oluşturuldu',
    },
    request: {
      title: 'Kuruluş Parasını Kasaya Aktar',
      available: 'Aktarılabilir tutar: {{amount}}',
      availableAccountLimited:
        'Aktarılabilir tutar: {{amount}} — kuruluş hesabının bakiyesi ile sınırlı (kurumda tutulan: {{room}})',
      noRoom:
        'Bu kurum için aktarılabilir tutar yok: kuruluşun tutulan parası aktarılmış ya da aktarım için bekliyor',
      noBalance:
        'Seçilen kuruluş hesabının bakiyesi aktarım için yeterli değil; şu an aktarım talep edilemez',
      unavailable:
        'Aktarılabilir tutar sunucudan alınamadı; şu an aktarım talep edilemez, sayfayı yenileyin',
      vault: 'Aktarılacak kasa',
      amount: 'Tutar',
      amountInvalid: 'Aktarılabilir tutarı aşmayan, sıfırdan büyük bir tutar girin',
      reason: 'Gerekçe',
      required: 'Gerekçe gerekli',
      submit: 'Aktarım Talep Et',
      done: 'Aktarım talep edildi; başka bir yetkilinin onayı bekleniyor',
    },
    approve: {
      title: 'Aktarımı Onayla',
      content:
        'Aktarımı talep eden kişi dışındaki bir yetkili olarak onaylıyorsunuz. Onaydan sonra kurumun yetkilisi aktarımı tamamlayacak.',
      done: 'Aktarım onaylandı',
    },
    complete: {
      title: 'Aktarımı Tamamla',
      content:
        'Tamamlandığında tutar kuruluşun bakiyesinden düşer ve seçilen kasada kurumun parası olarak görünür.',
      done: 'Aktarım tamamlandı',
    },
    cancel: {
      title: 'Aktarımı İptal Et',
      content: 'İptal edilen aktarım kuruluşun aktarılabilir tutarına geri döner.',
      reason: 'İptal gerekçesi',
      reasonRequired: 'İptal gerekçesi gerekli',
      done: 'Aktarım iptal edildi',
    },
    reverse: {
      title: 'Aktarımı Geri Al',
      content:
        'Tutar kasadan düşer ve kuruluşun bakiyesine geri döner. Kasada bu paranın kalmış olması gerekir.',
      reason: 'Geri alma gerekçesi',
      reasonRequired: 'Geri alma gerekçesi gerekli',
      done: 'Aktarım geri alındı',
    },
  },
  fundTransfer: {
    title: 'Fon Transferleri',
    tab: {
      requested: 'Onay Bekleyen',
      approved: 'Tamamlanmayı Bekleyen',
      completed: 'Tamamlanan',
      cancelled: 'İptal Edilen',
    },
    statuses: {
      requested: 'Onay bekliyor',
      approved: 'Hareket bekliyor',
      completed: 'Tamamlandı',
      cancelled: 'İptal edildi',
    },
    shapes: {
      own_funds: 'Kendi fonu',
      pass_through: 'Aracı transfer',
    },
    sides: {
      out: 'Gönderen hareket',
      in: 'Alan hareket',
    },
    directions: {
      out: 'Giden',
      in: 'Gelen',
    },
    organization: 'Kuruluş',
    direction: 'Yön',
    requestedFrom: 'Talep başlangıcı',
    requestedTo: 'Talep bitişi',
    requestedPeriod: 'Talep tarihi',
    column: {
      organizations: 'Kuruluşlar',
      shape: 'Tür',
      requestedAt: 'Talep tarihi',
      amount: 'Tutar',
      currency: 'Para Birimi',
      lines: 'Hareketler',
      actors: 'Talep ve onay',
      status: 'Durum',
    },
    source: 'Aktarılan hareket: {{line}}',
    lineMissing: 'Henüz eşleştirilmedi',
    requestedBy: '{{name}} talep etti',
    approvedBy: '{{name}} onayladı',
    cancelledBy: '{{name}} iptal etti',
    secondApprover: 'Bu talebi başka bir yetkili onaylamalı',
    empty: 'Fon transferi bulunamadı',
    emptyHint: 'Kuruluşlar arasında aktarılan paralar burada, iki yönüyle birlikte listelenir.',
    csvFile: 'fon-transferleri',
    action: {
      create: 'Transfer Talep Et',
      approve: 'Onayla',
      completeOut: 'Gönderen Hareketi Eşleştir',
      completeIn: 'Alan Hareketi Eşleştir',
      cancel: 'Transferi İptal Et',
    },
    create: {
      title: 'Fon transferi talebi',
      hint: 'Transfer, gönderen kuruluşta başka bir yetkili onayladıktan sonra her iki tarafın hareketi eşleştirilerek tamamlanır.',
      passThroughHint:
        'Bu hareketin parası başka bir kuruluşa ait. Tutar hareketin eşleştirilmemiş kalanından ayrılır; transfer iki kuruluşun defterine de yazılmaz, alan kuruluş parayı kendi bağışıyla eşleştirir.',
      from: 'Gönderen kuruluş',
      to: 'Alan kuruluş',
      amount: 'Tutar',
      amountInvalid: 'Sıfırdan büyük bir tutar girin.',
      currency: 'Para birimi',
      reason: 'Gerekçe',
      required: 'Bu alan zorunlu.',
      sameOrganization: 'Alan kuruluş gönderenden farklı olmalı.',
      submit: 'Talep Et',
      done: 'Transfer talep edildi; onay bekliyor.',
    },
    approve: {
      title: 'Transfer onaylansın mı?',
      content:
        '{{from}} kuruluşundan {{to}} kuruluşuna {{amount}} aktarılması onaylanır. Talep eden kişi onaylayamaz.',
      done: 'Transfer onaylandı.',
    },
    complete: {
      title: '{{side}} hangisi?',
      hint: 'Kuruluşun, transferle aynı tutar ve para biriminde, henüz hiçbir şeyi karşılamayan hareketleri listelenir. İki taraf da eşleştirilince transfer tamamlanır.',
      empty: 'Uygun hareket yok',
      emptyHint: 'Transferin hareketi ekstreye henüz gelmemiş olabilir.',
      pickLine: 'Bir hareket seçin.',
      submit: 'Eşleştir',
      done: 'Hareket eşleştirildi.',
      completed: 'Transfer tamamlandı.',
    },
    cancel: {
      title: 'Transfer iptal edilsin mi?',
      content: 'Transferin ayırdığı hareketler serbest kalır; defterde bir şey değişmez.',
      reason: 'Gerekçe',
      reasonRequired: 'Bir gerekçe yazın.',
      done: 'Transfer iptal edildi.',
    },
  },
  candidateReading: {
    reference: 'Referans kodu',
    corrected: 'Tek karakter düzeltmesi',
    amount_date: 'Tutar ve tarih',
  },
  clearingReading: {
    reference: 'Açıklama bağışı ya da dekontu anıyor',
    amount_date: 'Tutar ve tarih',
  },
  informationHitReason: {
    organization_not_linked: 'Kurumu bu kuruluşa bağlı değil',
    other_organization: 'Başka bir kuruluşun bağışı; önce fon transferi gerekir',
    cancelled: 'İptal edilmiş bağış',
    settled: 'Tamamı tahsil edilmiş',
    refunded: 'İade edilmiş',
    not_charged: 'Ücret alınmayan bir talep; para beklemez',
    nothing_outstanding: 'Kalanı onay bekleyen bir eşleştirmede',
    card: 'Kartla ödenmiş; kart ödemesi banka hareketiyle eşleştirilmez',
    manual_payment:
      'Bu bağışa dekont ya da çekle elle bir ödeme kaydedildi; bu hareket o ödemenin bankaya düşen parası olabilir. Başka bir bağışla eşleştirmeyin — aynı para iki kez sayılır.',
  },
  manualPayment: {
    action: 'Ödeme Kaydet',
    title: 'Ödeme kaydet',
    hint: 'Dekontla gelen havale, çek ya da elden alınan nakit (kumbara dahil) için. Kaydettiğiniz ödeme, başka bir yetkili onaylayana kadar bağışı ödenmiş saymaz.',
    method: 'Ödeme şekli',
    methods: {
      bank_transfer: 'Havale / EFT (dekontlu)',
      cheque: 'Çek',
      cash: 'Nakit',
    },
    account: 'Hesap',
    accountKind: { bank: 'Banka hesabı', cash: 'Kasa' },
    noAccount: 'Kuruluşun bu ödeme şekline uygun, kullanımda bir hesabı yok.',
    receivedOn: 'Ödeme tarihi',
    payerName: 'Ödeyen',
    reference: 'Dekont / çek no',
    note: 'Not',
    slip: 'Dekont',
    slipRequired: 'Havale için dekont zorunludur.',
    slipOptional: 'Dekont (isteğe bağlı)',
    slipPick: 'Dosya Seç',
    slipHint: 'JPEG, PNG ya da PDF; en çok 7 MB.',
    slipUploading: 'Dekont yükleniyor…',
    slipRemove: 'Kaldır',
    amounts: 'Bağışlara yazılacak tutarlar',
    outstanding: 'Kalan: {{amount}}',
    amountInvalid: 'Sıfırdan büyük ve kalanı aşmayan bir tutar girin.',
    total: 'Toplam',
    cashOnly: 'Kumbara bağışı yalnızca nakit olarak kaydedilir.',
    submit: 'Ödemeyi Kaydet',
    saved:
      'Ödeme kaydedildi. Bağışın ödenmiş sayılması için başka bir yetkilinin onaylaması gerekiyor.',
    lineExists: {
      title: 'Bu tutarda bir banka hareketi zaten var',
      content:
        'Bu hesapta aynı tutarda, henüz eşleştirilmemiş bir banka hareketi bulunuyor. Para ekstreyle geldiyse ödemeyi elle kaydetmek yerine o hareketi eşleştirin; aksi hâlde aynı para iki kez sayılır.',
      confirm: 'Yine de Kaydet',
    },
    state: {
      pending_approval: 'Onay bekliyor',
      approved: 'Onaylandı',
      void: 'Geçersiz',
    },
    stage: {
      awaiting_approval: 'Onay bekliyor',
      awaiting_bank: 'Banka hareketi bekleniyor',
      cleared: 'Mahsup edildi',
      approved: 'Onaylandı',
      void: 'Geçersiz',
    },
    awaiting: {
      hint: 'Dekont ya da çekle elle kaydedilip onaylanmış, bankaya düşen hareketi henüz bulunmamış ödemeler; en uzun bekleyen önce. {{days}} günden uzun bekleyenler işaretlenir. Hareket bulununca ödemeyle eşleştirin; aynı para iki kez sayılmaz.',
      empty: 'Banka hareketi bekleyen ödeme yok',
      emptyHint:
        'Onaylanan her havale ve çek, bankaya düşen hareketi bulunana kadar burada listelenir. Nakit banka hareketi beklemez.',
      age: 'Bekleme süresi',
      ageBucket: {
        recent: '{{days}} gün ve altı',
        overdue: '{{days}} günden uzun',
      },
      search: 'Bağış kodu, ödeyen ya da dekont / çek no ara…',
      days_one: '{{count}} gündür',
      days_other: '{{count}} gündür',
      uncleared: 'Bulunmamış: {{amount}}',
      recordedBy: 'Kaydeden: {{name}}',
      approvedBy: 'Onaylayan: {{name}}',
      column: {
        age: 'Bekleme (gün)',
        uncleared: 'Bulunmamış tutar',
        currency: 'Para birimi',
        approvedBy: 'Onaylayan',
        people: 'Kaydeden / Onaylayan',
      },
      findBankLine: 'Banka Hareketini Bul',
      withdraw: 'Geri Al',
      withdrawTitle: 'Ödeme geri alınsın mı?',
      withdrawContent:
        'Ödemenin bağışlara yazdığı tutar geri alınır: bağışların tahsilat durumu geri döner ve bugün tarihli ters defter kaydı yazılır. Ödemenin satırı hariç tutulur.',
      receiptActive:
        'Bu ödemenin ödediği bir bağışın geçerli makbuzu var. Geri almadan önce makbuzu iptal edin; aksi hâlde işlem reddedilir.',
      withdrawn: 'Ödeme geri alındı.',
      csvFile: 'banka-hareketi-bekleyen-odemeler',
      exportSelected: 'Seçilenleri CSV Olarak İndir',
    },
    findLine: {
      title: 'Ödemenin banka hareketini bul',
      hint: 'Ödemenin hesabına, ödeme tarihinden 3 gün önce ile 14 gün sonra arasında düşen ve kalanı ödemenin tutarını karşılayan hareketler; ödemeyi anan ya da tutarı tam uyan önce. Birden çok ödemeyi tek havalede taşıyan bir hareketi de seçebilirsiniz. Hareketten ödemenin tutarı ayrılır; bağışların tahsilatı, defter ve makbuz değişmez.',
      empty: 'Uygun banka hareketi yok.',
      emptyHint: 'Ekstre henüz aktarılmamış ya da para başka bir tutarla gelmiş olabilir.',
      unread: 'Ödemeyi anmıyor',
      remaining: 'Kalan: {{amount}}',
      lump: 'tutar ödemeden büyük — birden çok ödemeyi taşıyor olabilir',
      confirm: 'Bu Hareketle Eşleştir',
      done: 'Hareket bu ödemenin parası olarak işaretlendi.',
    },
    picker: {
      title: 'Ödemenin ödediği bağışlar',
      search: 'Bağış kodu ya da bağışçı adı',
      hint: 'En az {{count}} karakter yazın; bulunan bağışı ekleyin.',
      none: 'Eşleşen bağış yok.',
      add: 'Ekle',
      added: 'Eklendi',
      empty: 'Henüz bağış eklenmedi.',
    },
    awaitingApproval: 'Elle kaydedildi — başka bir yetkilinin onayını bekliyor',
    ownAwaiting:
      'Bu ödemeyi siz kaydettiniz; bağışın ödenmiş sayılması için başka bir yetkilinin onaylaması gerekiyor.',
    basketAction: 'Elle Ödeme Kaydet',
    basketHint:
      'Para ekstreye düşmediyse — dekont, çek ya da nakitle geldiyse — sepeti elle ödeme olarak kaydedin.',
    pending: {
      title: 'Elle kaydedilen ödemeler',
      hint: 'Dekont, çek ya da nakitle kaydedilen ödemeler. Onaylandığında bağışlar ödenmiş sayılır ve tamamı ödenen bağışa makbuz kesilir; kaydeden kişi onaylayamaz.',
      empty: 'Onay bekleyen elle kaydedilmiş ödeme yok',
      matchesTitle: 'Önceden kaydedilmiş, onay bekleyen eşleştirmeler',
      column: {
        receivedOn: 'Ödeme Tarihi',
        account: 'Hesap',
        method: 'Şekil',
        donations: 'Bağışlar',
        amount: 'Tutar',
        recordedBy: 'Kaydeden',
        slip: 'Dekont',
      },
      ownRecord: 'Bu ödemeyi siz kaydettiniz; onayı başka bir yetkili vermeli.',
      slipNotClean: 'Dekontun taraması temiz sonuçlanmadan onaylanamaz.',
      openSlip: 'Dekontu Aç',
      noSlip: 'Dekont yok',
      slipScanning: 'Dekont taranıyor',
      slipBlocked: 'Dekont açılamaz',
      approve: 'Onayla',
      reject: 'Reddet',
      confirmApprove:
        'Bu ödeme onaylansın mı? Onayla birlikte bağışların tahsilat durumu, kampanyanın tahsil edilen toplamı ve defter kaydı güncellenir; tamamı ödenen bağışa makbuz kesilir.',
      confirmReject: 'Bu ödeme reddedilsin mi? Bağışlar ödenmemiş kalır ve kayıt geçersiz sayılır.',
      approved: 'Ödeme onaylandı.',
      rejected: 'Ödeme reddedildi.',
    },
  },
  basket: {
    title: 'Ödeme Sepeti',
    hint: 'Bir hareketle birlikte kapatılacak bağışlar. Ödeme bir bağışın yalnızca bir kısmını karşılıyorsa o bağışın tutarını düşürün. Sepet adres çubuğundadır; bağlantıyı paylaşabilirsiniz.',
    donations: 'Sepetteki bağışlar',
    allocation: 'Bu ödemeden',
    allocationHelper: 'Kalan borç {{amount}}',
    allocationInvalid: 'Sıfırdan büyük ve kalan borcu aşmayan bir tutar girin.',
    total: 'Sepet toplamı',
    empty: 'Sepet boş',
    emptyHint: 'Bağış listesinde bağışları seçip “Sepetle Eşleştir” düğmesiyle sepete ekleyin.',
    lines: 'Mutabakatı tamamlanmamış hareketler',
    linesHint:
      'Her kuruluşun, tutarı henüz tamamen dağıtılmamış gelen hareketleri. İsimle arayın, tutara göre süzün; sepet, hangi kuruluşa ait olursa olsun kalanı sepet toplamına eşit veya daha büyük olan bir hareketle eşleştirilir; diğerleri bulmanız için listelenir. Sepetin bağışlarından farklı para birimindeki hareketler, hareketin kendi kur gününde sabitlenen kurla sunucuda çevrilerek denetlenir.',
    noLines: 'Mutabakatı tamamlanmamış hareket yok',
    noLinesHint:
      'Aramanızı ya da tutar süzgecinizi değiştirin; hareket henüz aktarılmamış ya da tamamen eşleştirilmiş olabilir.',
    notOffered: {
      tooSmall: 'Kalanı sepet toplamından az',
      checking: 'Sepete uygunluğu denetleniyor',
      fitFailed: 'Sepete uygunluğu denetlenemedi',
      ratePending: 'Kur bekleniyor',
      rateUnavailable: 'Hareketin kur gününde bağış para birimi için kur yok',
      exceedsOutstanding: 'Çevrilen tutar bir bağışın kalan borcunu aşıyor',
      notMatchable: 'Bu hareket artık eşleştirilemez',
    },
    needs: 'Sepet bu hareketten {{amount}} ister',
    needsHint: 'Hareketin kur gününde ({{date}}) sabitlenen kurla çevrilmiştir.',
    fitError: 'Hareketlerin sepete uygunluğu denetlenemedi.',
    match: 'Bu Hareketle Eşleştir',
    confirmTitle: 'Sepet bu hareketle eşleştirilsin mi?',
    confirmContent:
      '{{count}} bağış, kalanı {{amount}} olan hareketle eşleştirilir; her bağışa sepette yazılan tutar kadar ödeme kaydedilir ve ödeme hemen kesinleşir. Sepet toplamından fazla kalan tutar hareketin üzerinde kalır; sonra kalan tutar için bağış açılması sorulur.',
    confirmForeignContent:
      '{{count}} bağış, kalanı {{remaining}} olan hareketle eşleştirilir; hareketten toplam {{needed}} kullanılır (her bağışa sepette yazılan tutar kadar ödeme kaydedilir ve ödeme hemen kesinleşir). Kalan tutar hareketin üzerinde kalır; sonra kalan tutar için hareketin para biriminde bağış açılması sorulur.',
    done: 'Sepet hareketle eşleştirildi.',
    remove: 'Sepetten çıkar',
    add: 'Sepetle Eşleştir',
    refusal: {
      RECONCILIATION_BASKET_MIXED_CURRENCIES:
        'Sepette farklı para birimleri var; sepetin bağışları tek para biriminde olmalı (hareket başka bir para biriminde olabilir).',
      RECONCILIATION_BASKET_NOT_MATCHABLE:
        'Sepetteki bazı bağışlar ödeme alamaz. Onları sepetten çıkarın.',
      RECONCILIATION_BASKET_EXCEEDS_OUTSTANDING:
        'Bir bağışa yazılan tutar, o bağışın kalan borcunu aşıyor. Tutarı düşürün.',
    },
  },
  shortfall: {
    title: 'Eksik Tahsilatlar',
    hint: 'Kısmen tahsil edilmiş bağışlar. Tolerans yoktur: eksik gelen bir havale, kapatılana kadar burada kalır.',
    closeHow:
      'Bir eksik tahsilat iki yoldan kapanır: kalan para gelince bağışın sayfasında o hareketle eşleştirilir, ya da kuruluş vazgeçer ve bağış iptal edilir; iptalde gelen tutarın iade mi edileceği yoksa geri mi alınacağı seçilir, gerçekleştirilmiş hisseler korunur.',
    cancelNeedsRole:
      'Bağışı iptal ederek kapatmak bağış iptal ve eşleştirme geri alma yetkisi ister; bu yetkiler Genel Yönetici, Bölge Sorumlusu ve Mıntıka Sorumlusu rollerindedir.',
    action: {
      open: 'Bağışı Aç',
      matchRest: 'Kalanı Eşleştir',
      cancel: 'Bağışı İptal Et',
    },
    organization: 'Kuruluş',
    currency: 'Para birimi',
    olderThan: 'Son eşleşme',
    olderThanOption: '{{count}} günden eski',
    column: {
      donation: 'Bağış',
      amount: 'Bağış tutarı',
      collected: 'Tahsil edilen',
      outstanding: 'Eksik',
      lastMatch: 'Son eşleşme',
      matches: 'Hareketler',
    },
    age: '{{count}} gün önce',
    today: 'Bugün',
    matchCount: '{{count}} hareket',
    empty: 'Eksik tahsilat yok',
    emptyHint: 'Bu kuruluşun kısmen tahsil edilmiş bir bağışı yok.',
    pickOrganization: 'Bir kuruluş seçin',
    csvFile: 'eksik-tahsilatlar.csv',
  },
  /**
   * The finance guide (`/help/finance`): how money enters the system, when a
   * donation counts as paid, and which screen each task is on. Every statement
   * here is taken from the decision records 0044–0046, 0053 and 0098–0102 and
   * from the screens themselves; a claim about who may do what is pinned by
   * `finance-roles.test.ts` against the seeded roles.
   */
  financeGuide: {
    title: 'Muhasebe Kılavuzu',
    subtitle:
      'Paranın sisteme nasıl girdiği, bir bağışın ne zaman ödenmiş sayıldığı ve her işin hangi ekranda yapıldığı — adım adım.',
    howItWorks: 'Nasıl çalışır?',
    toc: 'İçindekiler',
    stepCount_one: '{{count}} adım',
    stepCount_other: '{{count}} adım',
    events: 'Seçilecek olaylar (hepsi)',
    devNote: {
      title: 'Geliştirme ortamında deneme verisi',
      body: 'Bu not yalnızca geliştirme ortamında görünür. Veritabanındaki gerçek bağış kodları ve tutarlarıyla deneme ekstresi üretmek için depo kökünde “pnpm db:demo-finance <klasör>” komutunu çalıştırın: klasöre Avrupa EUR (MT940) hesabı için bir MT940 dosyası ve İş Bankası TRY hesabı için bir .xls dosyası yazılır. Dosyaları Ekstreler ekranından yükleyin; önerilerin, eksik tahsilatların ve hariç tutulacak hareketlerin dolduğunu görün. Komut üretim ortamında çalışmayı her zaman reddeder; “btsis” adlı veritabanını ancak “--allow-dev-db” verilirse ve bu bilgisayardaki geliştirme veritabanıysa (localhost:47120) okur — yoksa geçici bir veritabanına yöneltin.',
    },
    roles: {
      action: 'İş',
      allowed: 'Yapabilir',
      notAllowed: 'Yapamaz',
      names: {
        global_admin: 'Genel Yönetici',
        region_manager: 'Bölge Sorumlusu',
        zone_manager: 'Mıntıka Sorumlusu',
        institution_user: 'Kurum Kullanıcısı',
        call_centre: 'Çağrı Merkezi',
        fulfillment_manager: 'Operasyon Sorumlusu',
        accountant: 'Muhasebe',
        finance_approver: 'Muhasebe Onaylayıcı',
        reporter: 'Raporlayıcı',
      },
      actions: {
        statementImport: 'Ekstre yüklemek, aktarmak, ekstre formatı tanımlamak',
        match: 'Hareket eşleştirmek, hariç tutmak, sınıflandırmak, mahsup etmek',
        unmatch: 'Eşleştirmeyi, elle ödemeyi ve mahsubu geri almak',
        approve: 'Elle ödemeyi onaylamak',
        reverse: 'Ters ibraz (chargeback) kaydetmek',
        manualPayment: 'Elle ödeme kaydetmek (dekont, çek, nakit)',
        refundRequest: 'İade talep etmek',
        refundApprove: 'İadeyi onaylamak ve ödemesini eşleştirmek',
        transferCreate: 'Fon transferi talep etmek',
        transferApprove: 'Fon transferini onaylamak',
        transferComplete: 'Fon transferinin hareketlerini eşleştirmek',
        receiptIssue: 'Makbuz ve yıllık özet düzenlemek',
        receiptVoid: 'Makbuz iptal etmek',
        financeView: 'Bakiyeleri ve konsolidasyonu görmek',
        exchangeRate: 'Elle döviz kuru girmek',
        donationCancel: 'Bağışı iptal etmek',
        paymentKeys: 'Hesap eklemek ve ödeme anahtarlarını tanımlamak',
      },
    },
    sections: {
      basics: {
        title: 'Genel mantık: bir bağış ne zaman ödenmiş sayılır?',
        summary:
          'Bir bağış, paranın geldiği kanıtlanmadan ödenmiş sayılmaz. Kanıt üç yoldan gelir ve her yol parayı yalnızca bir kez sayar.',
        steps: {
          statementLine: {
            title: 'Banka ekstresindeki hareket',
            body: 'Bankanın dökümü sisteme aktarılır ve her gelen hareket bir ya da birkaç bağışla eşleştirilir. Sistem yalnızca önerir; eşleştirmeyi her zaman bir kişi onaylar. Onayla birlikte bağışın tahsilat durumu, kampanyanın tahsil edilen toplamı ve defter kaydı aynı anda güncellenir.',
          },
          cardCapture: {
            title: 'Doğrulanmış kart ödemesi',
            body: 'Bağışçı Stripe, PayPal ya da sanal POS ile ödediğinde sağlayıcının imzalı bildirimi doğrulanır ve bağış o anda kendiliğinden tahsil edilmiş olur; kimsenin onaylaması gerekmez. Sağlayıcının sonradan bankaya yatırdığı toplu ödeme yalnızca hesap düzeyinde kapatılır, bağışları ikinci kez saymaz.',
          },
          manualPayment: {
            title: 'İkinci bir kişinin onayladığı elle ödeme',
            body: 'Dekontla gelen havale, çek ya da elden alınan nakit (kumbara dahil) elle kaydedilir. Kayıt tek başına hiçbir şeyi değiştirmez; bağış ancak kaydedenden başka bir yetkili onayladığında ödenmiş sayılır.',
          },
        },
        notes: {
          countedOnce:
            'Aynı para çoğu zaman iki kez görünür: önce dekont, sonra ekstredeki havale; önce kart bildirimi, sonra bankaya yatan toplu ödeme. Sistem parayı ilk kanıtta sayar ve ikinci görünüşü “aynı para” olarak ona bağlar (mahsup). Böylece kampanya toplamları, defter ve makbuzlar yalnızca gerçekten gelen parayı gösterir.',
          noTolerance:
            'Tolerans yoktur. Eksik gelen bir havale bağışı “Kısmen Tahsil Edildi” durumunda bırakır ve Eksik Tahsilatlar listesine düşer; bir eksik hiçbir zaman “tamamı ödendi” sayılarak kapatılmaz.',
          nothingDeleted:
            'Parasal bir kayıt hiçbir zaman silinmez ya da üzerine yazılmaz. Geri alınan bir eşleştirme, geri alındığı günün tarihiyle ters bir defter kaydı yazar; kapanmış bir ayın rakamları bu yüzden değişmez.',
        },
      },
      organizations: {
        title: 'Hesaplar, kuruluşlar ve kimin neyi gördüğü',
        summary:
          'Para bir kuruluşun hesabına gelir. Kuruluş, banka hesaplarının açıldığı tüzel kişiliktir (dernek, vakıf); kurumlar (şubeler) bir kuruluşa bağlıdır ve bir kurumda alınan bağış o kuruluşun bağışıdır.',
        steps: {
          accounts: {
            title: 'Hesaplar kuruluşa aittir',
            body: 'Bir kuruluşun banka, kasa, sanal POS, Stripe ve PayPal hesapları kuruluşun sayfasındaki Hesaplar kartındadır. Ekstre bir banka hesabına yüklenir; nakit bir kasa hesabına, dekont ve çek bir banka hesabına kaydedilir. Hesap eklemek ve IBAN girmek, kuruluş düzenleme yetkisi olan global kapsamdaki bir yöneticinin işidir.',
          },
          sameOrganization: {
            title: 'Para yalnızca kendi kuruluşunun bağışına yazılır',
            body: 'Her kuruluşun gelen hareketleri görünür, ancak bir hesabın hareketi şimdilik başka bir kuruluşun bağışıyla eşleştirilemez: eşleştirme ekranları böyle bir hareketi listeler, ama seçmenize izin vermez. Para yanlış kuruluşun hesabına geldiyse önce bir fon transferiyle doğru kuruluşa aktarılır ve orada eşleştirilir.',
          },
          scope: {
            title: 'Kim neyi görür',
            body: 'Ekranların yetkisi değişmedi, ama gelen hareketler artık kapsama bağlı değildir: ekranı açma yetkisi olan herkes, hangi kuruluşa ait olursa olsun bütün gelen hareketleri görür ve arar. Ekstre aktarma, hariç tutma, iade, transfer ve bakiye bir kuruluşu ancak o kuruluşun bütün kurumları veri kapsamınızdaysa gösterir ve değiştirir; giden hareketler de kapsama bağlı kalır. Eşleştirmeyi kuruluşun bağışlarını görebilen kişi yapar, yoksa yanlış bağışı güvenle önerir.',
          },
        },
        notes: {
          emptyScreens:
            'Ekstre, iade, transfer ve bakiye ekranları size boş geliyorsa sebebi çoğunlukla budur: kuruluşun kurumlarından biri sizin mıntıkanızın ya da bölgenizin dışındadır. Gelen hesap hareketleri bundan etkilenmez; onları her kapsam görür. Eşleştirmeyi ise kuruluşun bütün kurumlarını kapsayan bölge ya da global kapsamdaki biri yapar.',
          ownDonations:
            'Bir kurum kullanıcısı kendi bağışlarının nasıl ödendiğini bağışın sayfasındaki Tahsilat Eşleştirmeleri kartında görür; hesap hareketleri ekranını açma yetkisi varsa gelen hareketleri de görür, ancak eşleştirme yapamaz.',
        },
      },
      statements: {
        title: 'Ekstre yükleme',
        summary:
          'Bankanın dökümü önce okunur ve önizlenir; siz “Hesaba Aktar” demeden hiçbir satır hesaba işlenmez.',
        steps: {
          format: {
            title: 'Dosyanın biçimi',
            body: 'Excel (.xlsx ya da eski .xls), CSV, CAMT.053 (XML) ve MT940 okunur; dosya en çok {{size}} olabilir. Türk bankalarının Excel dökümleri bankanın profiliyle (İş Bankası, Ziraat, Kuveyt Türk), Avrupa bankalarının dosyaları CAMT.053 ya da MT940 profiliyle okunur. Parolalı bir Excel dosyası okunmaz; Excel’de parolasını kaldırıp yeniden kaydedin.',
          },
          defineFormat: {
            title: 'Listede bankanızın biçimi yoksa',
            body: 'Ekstre Formatları ekranında “Ekstre Formatı Tanımla” ile yeni bir biçim tanımlanır: tarih, tutar, açıklama ve referans sütunları seçilir, bir örnek dosya seçilir ve okunan hareketler hemen önizlenir. Örnek dosya tarayıcınızda okunur, sunucuya gönderilmez. Her kayıt yeni bir sürümdür; okunmuş ekstreler okundukları sürüme bağlı kalır. Biçim tanımlamak global kapsam ister, çünkü bir bankanın biçimi her kuruluşun ekstresini etkiler.',
          },
          upload: {
            title: 'Yükleme',
            body: 'Ekstreler ekranında “Ekstre Yükle” ile banka hesabını ve ekstre profilini seçip dosyayı yükleyin. Hesap daha önce hangi bankanın profiliyle okunduysa o profil kendiliğinden önerilir. Dosya önce virüs taramasından geçer, sonra arka planda okunur; ekstrenin sayfası kendini yeniler.',
          },
          preview: {
            title: 'Önizleme',
            body: 'Okunan her satır “Aktarılacak”, “Mükerrer” ya da “Okunamadı” olarak işaretlenir ve nedeni yazılır: dosyada iki kez geçen ya da hesapta zaten kayıtlı satırlar mükerrerdir; hesabın para biriminde olmayan ya da tarihi veya tutarı okunamayan satırlar okunamaz. “Bakiyesi tutmayan” uyarısı ekstrede eksik bir hareket olabileceğini söyler; aktarmadan önce bankanın dökümüyle karşılaştırın.',
          },
          commit: {
            title: 'Hesaba aktarın ya da vazgeçin',
            body: '“Hesaba Aktar” aktarılacak satırları hesap hareketi yapar; aktarılan bir hareket silinemez, yalnızca eşleştirilir ya da hariç tutulur. Yanlış dosyayı ya da yanlış hesabı seçtiyseniz “Vazgeç” deyin: hiçbir satır işlenmez, dosya denetim için saklanır.',
          },
          lines: {
            title: 'Aktarılan hareketler',
            body: 'Hesap Hareketleri ekranı her hesabın aktarılmış hareketlerini eşleşme durumlarıyla listeler. Bir hareketi açtığınızda bankanın satırını ve “Paranın gittiği yer” kartında paranın hangi bağışa, iadeye ya da transfere yazıldığını görürsünüz.',
          },
        },
        notes: {
          ibanMissing:
            'Okunamadı — “hesabın IBAN’ı kayıtlı olmadığı için doğrulanamadı”: CAMT.053 ve MT940 dosyaları hesap numarasını taşır ve sistem dosyanın doğru hesaba yüklendiğini bununla doğrular. Hesabın IBAN’ını kuruluş düzenleme yetkisi olan bir yönetici kuruluşun sayfasında girer; sonra ekstreyi yeniden yükleyin.',
          accountMismatch:
            'Okunamadı — “ekstre başka bir hesaba ait”: dosyadaki hesap numarası seçtiğiniz hesabı göstermiyor. Doğru hesabı seçip yeniden yükleyin.',
          profileMismatch:
            'Okunamadı — “dosya seçilen profile uymuyor”: başka bir bankanın ya da bankanın başka bir ekranının dökümü olabilir. Doğru profili seçin ya da yeni bir ekstre formatı tanımlayın.',
          duplicateFile:
            '“Bu dosya bu hesaba zaten aktarılmış”: aynı ekstre ikinci kez işlenmez. Dönemleri çakışan iki farklı ekstrede ortak satırlar varsa ikincisinde o satırlar “Mükerrer” görünür ve aktarılmaz.',
        },
      },
      matching: {
        title: 'Eşleştirme',
        summary:
          'Mutabakat ekranında bir hesap seçin. Gelen bir hareket bir ya da birkaç bağışa yazılır; bir bağış da birkaç hareketle ödenebilir.',
        steps: {
          proposals: {
            title: 'Öneriler',
            body: '“Öneriler” sekmesi motorun bir bağış bulduğu hareketleri gösterir. Açıklamada geçerli bir bağış kodu (BT-XXXX-XXXX, tireli ya da tiresiz) ve tam tutar varsa öneri “Toplu onaylanabilir” olarak işaretlenir; bunları seçip “Toplu Onayla” ile bir seferde en çok {{bulk}} hareket onaylayabilirsiniz. Sunucu her hareketi yeniden okur; bu arada değişen bir hareket onaylanmaz.',
          },
          review: {
            title: 'İncele ve eşleştir',
            body: 'Diğer her hareket için “İncele ve Eşleştir” çekmecesini açın: motorun önerisi, açıklamanın işaret ettiği bağışlar ve eşleştirilemeyecek olanların nedeni (iptal edilmiş, tamamı tahsil edilmiş, başka kuruluşun bağışı, kartla ödenmiş…) burada görünür. Önerinin dışında bir bağışı referans koduyla, bağışçı adıyla ya da kalan tutar aralığıyla arayıp ekleyebilirsiniz.',
          },
          partial: {
            title: 'Kısmi ve bölünmüş ödeme',
            body: 'Her bağışa hareketten ne kadar yazılacağını siz girersiniz. Bir hareket birkaç bağışı ödeyebilir; toplam hareketin kalanını, bir bağışa yazılan da o bağışın kalan borcunu aşamaz. Eksik ödenen bağış “Kısmen Tahsil Edildi” olur. Hareketin kullanılmayan kalanı görünür kalır; başka bir bağışa yazılabilir ya da iade edilebilir.',
          },
          exclude: {
            title: 'Bağış olmayan hareketler',
            body: 'Banka masrafı, kendi hesaplarınız arasındaki virman gibi bağış parası olmayan bir hareketi “Hariç Tut” ile türünü seçip gerekçesini yazarak hariç tutun; deftere girmez ve eşleşmemişler listesinden çıkar. Yanlışlıkla hariç tutulan hareket “Eşleşmemişlere Geri Al” ile geri gelir. Bir kısmı eşleştirilmiş hareket hariç tutulamaz.',
          },
          basket: {
            title: 'Ödeme sepeti',
            body: 'Tek havaleyle birden çok bağış ödendiyse Bağışlar listesinde bağışları seçip “Sepetle Eşleştir” deyin; seçim sayfalar ve filtreler arasında korunur, sepete en çok {{basket}} bağış girer. Ödeme bir bağışın yalnızca bir kısmını karşılıyorsa o bağışın “Bu ödemeden” tutarını düşürün. Sepet ekranı mutabakatı tamamlanmamış bütün gelen hareketleri listeler; isimle arayın, tutarı özgün para biriminde ya da TL, USD, EUR karşılığıyla süzün. Eşleştirilebilen, aynı para biriminde ve kalanı sepet toplamına eşit veya daha büyük hareketlerdir; hangi kuruluşa ait olduğu önemli değildir. Sepet toplamı hareketten düşülür ve sepetteki her bağış tam kapatılır; toplamdan fazla kalan para hareketin üzerinde durur ve kalan tutar için aynı bağışçı adına bağış açılması sorulur. Bu koşulları karşılamayan hareketler de listelenir; nedeni satırında yazar ve seçilemezler.',
          },
          crossCurrency: {
            title: 'Farklı para birimi',
            body: 'Hareketin ve bağışın para birimi farklıysa karşılık, hareket gününden önceki son kur gününün kuruyla hesaplanır ve eşleştirme hemen kesinleşir; ikinci bir kişinin onayı gerekmez. O gün için kur yoksa öneri yapılmaz.',
          },
        },
        notes: {
          history:
            '“Tamamlanan” sekmesi onaylanan, reddedilen, kaldırılan ve ters kayda alınan eşleştirmeleri kimin ne zaman yaptığıyla listeler; referans koduyla (BT ile ya da BT olmadan) ya da bağışçı adıyla aranır.',
          heldLine:
            'Bir hareketin yanında “Elle kaydedilmiş ödemeyle mahsup bekliyor” yazıyorsa ona bağış önerilmez: bu hareket, daha önce dekont ya da çekle kaydedilmiş bir ödemenin bankaya düşen parası olabilir. Aşağıdaki “Elle ödeme kaydı” bölümüne bakın.',
        },
      },
      manualPayments: {
        title: 'Elle ödeme kaydı (dekont, çek, nakit)',
        summary:
          'Para ekstreyle gelmediyse ya da ekstre henüz gelmediyse ödeme elle kaydedilir. Kaydeden ile onaylayan iki ayrı kişidir.',
        steps: {
          record: {
            title: 'Kaydetmek',
            body: '“Ödeme Kaydet” bağışın sayfasındaki Tahsilat Eşleştirmeleri kartında, Ödeme Sepeti’nde (“Elle Ödeme Kaydet”) ve Hesap Hareketleri ekranında bulunur. Ödeme şeklini (havale/EFT, çek, nakit), parayı alan hesabı, ödeme tarihini, ödeyeni, dekont ya da çek numarasını ve her bağışa yazılacak tutarı girin. Havale ve çek bir banka hesabına, nakit bir kasa hesabına kaydedilir; bağışlar hesabın para biriminde olmalıdır. Gelecek bir tarih girilemez.',
          },
          slip: {
            title: 'Dekont',
            body: 'Havalede dekont zorunludur; çekte ve nakitte isteğe bağlıdır. JPEG, PNG ya da PDF, en çok {{slip}}. Dekont virüs taramasından temiz çıkmadan ödeme onaylanamaz; onaylayacak kişi dekontu “Onay Bekleyen” sekmesinden açar.',
          },
          box: {
            title: 'Kumbara ve kartlı bağışlar',
            body: 'Bir kumbaranın boşaltılmasıyla oluşan bağış yalnızca nakit olarak kaydedilir. Kartla, sanal POS ile ya da PayPal ile ödenen bir bağışa elle ödeme kaydedilemez; o para sağlayıcısından gelir.',
          },
          lineExists: {
            title: '“Bu tutarda bir banka hareketi zaten var” uyarısı',
            body: 'Hesapta aynı tutarda, ödeme gününden 3 gün önce ile 14 gün sonra arasında eşleşmemiş bir banka hareketi varsa sistem uyarır: para ekstreyle geldiyse elle kaydetmek yerine o hareketi eşleştirin, yoksa aynı para iki kez sayılır. Emin olduğunuzda “Yine de Kaydet” diyebilirsiniz.',
          },
          approve: {
            title: 'Onay',
            body: 'Kaydedilen ödeme Mutabakat ekranının “Onay Bekleyen” sekmesine düşer. Kaydeden kişi onaylayamaz; başka bir yetkili onaylayınca bağışlar ödenmiş sayılır ve tamamı ödenen bağışa makbuz kesilir. Reddedilirse bağışlar ödenmemiş kalır ve kayıt geçersiz olur; kaydeden kendi kaydını da reddedebilir.',
          },
          awaitingBank: {
            title: 'Banka hareketini beklemek ve mahsup',
            body: 'Onaylanan havale ve çekler, paranın bankaya düşen hareketi bulunana kadar “Banka Hareketi Bekleyen” sekmesinde kalır; {{days}} günden uzun bekleyenler işaretlenir. Ekstre gelince hareketi açtığınızda “Elle kaydedilmiş ödemenin banka hareketi” bölümünde ödeme önerilir; “Bu Ödemenin Hareketi” ile bağlayın. Aynı işi ödemenin satırındaki “Banka Hareketini Bul” ile ödeme tarafından da yapabilirsiniz; birden çok ödemeyi taşıyan tek bir havale her ödeme için ayrı ayrı seçilebilir. Bu bağlantı (mahsup) parayı ikinci kez saymaz: tahsilat, defter ve makbuz değişmez. Nakit banka hareketi beklemez.',
          },
          withdraw: {
            title: 'Geri almak',
            body: 'Onaylanmış bir ödeme “Geri Al” ile geri alınır: bağışların tahsilatı geri döner, bugünün tarihiyle ters defter kaydı yazılır ve ödemenin satırı hariç tutulur. Ödemenin ödediği bir bağışın geçerli makbuzu varsa önce makbuz iptal edilir; ödeme bir banka hareketiyle bağlanmışsa önce hareketin sayfasında “Bağlantıyı Geri Al” denir.',
          },
        },
      },
      approvals: {
        title: 'Onaylar ve dört göz',
        summary:
          'Parayı kanıtı olmadan sayabilecek ya da bir tüzel kişilikten dışarı çıkarabilecek her iş, isteyenden başka bir kişinin onayını ister. Aynı kişi hem isteyip hem onaylayamaz; bu kural veritabanında da korunur.',
        steps: {
          what: {
            title: 'İkinci kişi isteyen işler',
            body: 'Üç iş ikinci kişi ister: elle kaydedilen ödeme, iade ve fon transferi. Banka hareketiyle yapılan eşleştirmeler — başka kuruluşun hareketi ya da farklı para birimi olsa da, toplu onay ve sepet dahil — tek kişiyle ve hemen kesinleşir; çünkü eşleştiren kişi bankanın satırını görerek karar verir. Geri almayı ise parayı alan kuruluş yapar.',
          },
          who: {
            title: 'Kim onaylar',
            body: 'Elle ödemeyi eşleştirme onay yetkisi olanlar, iadeyi iade onay yetkisi olanlar, fon transferini transfer onay yetkisi olanlar onaylar. Varsayılan rollerde Muhasebe eşleştirmeleri, elle ödemeleri ve iadeleri onaylayabilir ama fon transferi onaylayamaz; transferleri Muhasebe Onaylayıcı, Genel Yönetici, Bölge Sorumlusu ve Mıntıka Sorumlusu onaylar. Muhasebe Onaylayıcı rolü yalnızca onaylar: üç işin hepsini onaylar ya da reddeder, kendisi ödeme kaydetmez, eşleştirmez, talep etmez. Bir kişide hem Muhasebe hem Muhasebe Onaylayıcı rolü olsa da kendi kaydını ya da talebini onaylayamaz. Ayrıntısı “Kim ne yapabilir” tablosundadır.',
          },
          inbox: {
            title: 'Onay bekleyenler nerede',
            body: 'Elle ödemeler Mutabakat ekranının “Onay Bekleyen” sekmesinde, iadeler İadeler ekranının, transferler Fon Transferleri ekranının “Onay Bekleyen” sekmesindedir. Kendi kaydınızın yanında onayı başka bir yetkilinin vermesi gerektiği yazar; onay size açılmaz.',
          },
          withdrawOwn: {
            title: 'Kendi isteğinizden vazgeçmek',
            body: 'Henüz kimse onaylamadıysa kendi isteğinizi geri çekebilirsiniz: iadede “İadeden Vazgeç”, transferde “Transferi İptal Et”, elle ödemede “Reddet”. Onaylanmış bir iadeyi ya da transferi geri çekmek onay yetkisi, onaylanmış bir elle ödemeyi geri almak eşleştirme geri alma yetkisi ister.',
          },
        },
        notes: {
          alone:
            'Tek başına çalışan bir muhasebeci bu üç işi bitiremez; ikinci bir yetkili gerekir. Bu bilinçli bir karardır: parayı sayan ya da çıkaran her adımı iki kişi görür.',
        },
      },
      shortfalls: {
        title: 'Eksik tahsilatlar',
        summary:
          'Kısmen tahsil edilmiş bağışlar Eksik Tahsilatlar listesinde, eksik tutarı ve son eşleşmesinin üzerinden geçen süreyle durur.',
        steps: {
          rest: {
            title: 'Kalan para gelince',
            body: 'Satırın menüsündeki “Kalanı Eşleştir” bağışın sayfasında hareket eşleştirme penceresini açar; kalanı getiren hareketi seçin. Bağış tamamlanınca “Tahsil Edildi” olur ve makbuzu kesilir.',
          },
          giveUp: {
            title: 'Kalan hiç gelmeyecekse',
            body: 'Kuruluş vazgeçerse bağış “Bağışı İptal Et” ile iptal edilir; iptalde gelen paranın iade mi edileceği yoksa geri mi alınacağı seçilir, gerçekleştirilmiş hisseler korunur. Bağış iptali, bağış iptal ve eşleştirme geri alma yetkisi ister; varsayılan rollerde bunlar Genel Yönetici, Bölge Sorumlusu ve Mıntıka Sorumlusu’ndadır, Muhasebe’de değildir.',
          },
        },
      },
      refunds: {
        title: 'İadeler',
        summary:
          'Bağışçıya geri ödenecek para bir iade kaydıdır: talep edilir, başka bir yetkili onaylar, sonra ekstredeki çıkan hareketle eşleştirilerek ödenir.',
        steps: {
          sources: {
            title: 'İade nereden doğar',
            body: 'Üç yoldan: para almış bir bağış iade seçilerek iptal edildiğinde; bir hareketin eşleştirilmemiş fazlası için mutabakatta hareketin menüsünden “İade Talep Et” dendiğinde; ya da kart sağlayıcısı ödemenin tamamını iade ettiğini bildirdiğinde — bu sonuncusu ödenmiş olarak gelir.',
          },
          approve: {
            title: 'Onay',
            body: 'İadeyi talep edenden başka bir yetkili İadeler ekranında “Onayla” der. Talep eden, onaylanmadan önce “İadeden Vazgeç” ile talebini geri çekebilir.',
          },
          pay: {
            title: 'Ödeme',
            body: 'İadenin bankadan çıktığı hareket ekstreyle gelince mutabakatta o çıkan hareketi “Sınıflandır” ile “İade ödemesi” yapın, sonra İadeler ekranında “Ödemeyi Eşleştir” ile o hareketi seçin. İade deftere çıkan hareketin tarihiyle yazılır.',
          },
        },
      },
      fundTransfers: {
        title: 'Fon transferleri',
        summary:
          'İki kuruluş arasında aktarılan para bir fon transferidir: gönderen kuruluşta talep edilir, başka bir yetkili onaylar, sonra iki tarafın hareketi eşleştirilerek tamamlanır.',
        steps: {
          request: {
            title: 'Talep',
            body: 'Fon Transferleri ekranında “Transfer Talep Et” ile gönderen ve alan kuruluşu, tutarı ve gerekçeyi girin. Para yanlış kuruluşun hesabına geldiyse mutabakatta o hareketin menüsünden “Başka Kuruluşa Aktar” deyin: bu bir aracı transferdir; iki kuruluşun defterine de yazılmaz, alan kuruluş parayı kendi bağışıyla eşleştirir.',
          },
          approve: {
            title: 'Onay',
            body: 'Transferi talep edenden başka, transfer onay yetkisi olan biri onaylar. Talep eden onaydan önce “Transferi İptal Et” ile vazgeçebilir.',
          },
          complete: {
            title: 'Tamamlama',
            body: 'Gönderen hesaptan çıkan ve alan hesaba giren hareketler ekstreyle gelince “Gönderen Hareketi Eşleştir” ve “Alan Hareketi Eşleştir” ile seçilir; tutar ve para birimi transferle aynı olmalıdır. İki taraf da eşleşince transfer tamamlanır. Kendi fonunun transferi iki kuruluşun defterine, her biri kendi hareketinin tarihiyle yazılır.',
          },
        },
      },
      cardPayouts: {
        title: 'Kart ödemeleri (sağlayıcı aktarımları)',
        summary:
          'Kartla ödenen bağış, sağlayıcının bildirimiyle zaten tahsil edilmiştir. Sağlayıcı topladığı paradan komisyonunu düşüp bankaya tek bir toplu tutar yatırır; bu ekran yalnızca o banka hareketini kapatır.',
        steps: {
          pick: {
            title: 'Banka hareketi ve tahsilatlar',
            body: 'Kart Ödemeleri ekranında banka hesabını ve kart ödemesi olarak sınıflanmış bir banka hareketini seçin, sonra sanal POS ya da Stripe hesabını ve tahsilat tarih aralığını. Listelenen tahsilatlardan bu ödemeye girenleri işaretleyin.',
          },
          confirm: {
            title: 'Mutabakatı onaylamak',
            body: 'Komisyon, brüt tahsilattan banka hareketi düşülerek hesaplanır ve kuruluşun defterine masraf olarak yazılır; bağışların tahsilat durumu değişmez. İkinci kişi gerekmez. Yanlış bir mutabakat gerekçesiyle “Mutabakatı Geri Al” ile geri alınır.',
          },
        },
        notes: {
          providerReversals:
            'Kart sağlayıcısı bir ödemenin tamamını iade ettiğini ya da ters ibraz (chargeback) bildirdiğinde bağışın tahsilatı ve makbuzu kendiliğinden geri alınır. Kısmi bir iade ya da itiraz kendiliğinden işlenmez; sistem yöneticisine uyarı olarak düşer.',
        },
      },
      balances: {
        title: 'Bakiyeler ve konsolidasyon',
        summary:
          'Bakiye, eşleştirilmiş bağış paralarının defter kayıtlarından her açılışta yeniden toplanır; banka hesabının bakiyesi değildir. Eşleşmemiş ya da hariç tutulmuş bir hareket deftere girmez.',
        steps: {
          balances: {
            title: 'Bakiyeler',
            body: 'Bakiyeler ekranı seçtiğiniz tarihe kadar, para birimi başına kuruluş toplamlarını — kurumların kayıtları ile masraf, transfer ve bağışsız iade gibi kuruluş düzeyindeki kayıtlar ayrı ayrı — ve kapsamınızdaki her kurumun bakiyesini gösterir. Kuruluş toplamını yalnızca kuruluşun bütün kurumlarını kapsayan biri görür.',
          },
          consolidation: {
            title: 'Konsolidasyon raporu',
            body: 'Bir kuruluşun bir dönemdeki hareketlerini ana para birimine çevirir: her günün tutarı o günden önceki son kur gününün kuruyla bir kez çevrilir. Kuru bulunmayan bir para birimi tahmini bir kurla çevrilmez; toplamın dışında bırakılır ve ekranda söylenir. Dönem en çok {{days}} gündür.',
          },
        },
      },
      receipts: {
        title: 'Makbuzlar ve yıllık özetler',
        summary:
          'Makbuz, bağışın kabul edildiğini bildiren belgedir; yasal vergi belgesi değildir.',
        steps: {
          automatic: {
            title: 'Kendiliğinden kesilir',
            body: 'Bir bağış tamamen tahsil edildiği anda — eşleştirme onayıyla, elle ödemenin onayıyla ya da kart bildirimiyle — makbuzu kesilir. Numara kurumun kodu, yıl ve sıra numarasıdır ve her kurumda her yıl boşluksuz ilerler. Kısmi ödemeye ayrı makbuz kesilmez; bağışçısı olmayan bir kumbara bağışına makbuz kesilmez.',
          },
          void: {
            title: 'İptal ve yeniden düzenleme',
            body: 'Makbuz silinmez, numarası tekrar kullanılmaz: gerekçeyle “İptal et” denir, gerekirse “Yeniden düzenle” ile yeni numarayla yerine yenisi kesilir. Ülkenin istediği yasal belge ayrıca düzenlendiyse numarası “Yasal belge no gir” ile makbuza kaydedilir ve PDF’e basılır.',
          },
          annual: {
            title: 'Yıllık özetler',
            body: 'Yıllık Bağış Özetleri ekranında yılı seçin; o yıl geçerli makbuzu olan ve özeti henüz düzenlenmemiş bağışçılar listelenir. Bağışçıları seçip “Yıllık özet düzenle” deyin.',
          },
        },
      },
      exchangeRates: {
        title: 'Döviz kurları',
        summary: 'Kurlar TCMB’nin günlük bülteninden gelir ve hiçbir zaman üzerine yazılmaz.',
        steps: {
          daily: {
            title: 'Günlük bülten',
            body: 'Sistem her iş günü TCMB bültenini kendisi çeker. Bir bağışın TL karşılığı, bağış gününden önce yayımlanmış son bültenle dondurulur ve sonradan değişmez.',
          },
          manual: {
            title: 'Elle kur ve arşiv',
            body: 'Bülten alınamadığında “Kur Gir” ile elle kur girilir; girilen kur değiştirilemez, yanlışsa sonraki gün için düzeltme girilir. Geçmiş günler “Arşivden Doldur” ile TCMB arşivinden çekilir.',
          },
        },
      },
      undo: {
        title: 'Geri alma',
        summary:
          'Parasal bir kayıt silinmez; her geri alma kendi tarihiyle ve gerekçesiyle kayda geçer. Sıra önemlidir.',
        steps: {
          receiptFirst: {
            title: 'Önce makbuz',
            body: 'Geçerli makbuzu olan bir bağışın eşleştirmesi kaldırılamaz, ters kayda alınamaz ve bağış iptal edilemez. Önce Makbuzlar ekranında makbuzu gerekçesiyle iptal edin.',
          },
          unmatch: {
            title: 'Eşleştirmeyi kaldırmak',
            body: 'Yanlış bağışa yazılmış bir hareket, hareketin sayfasında ya da bağışın Tahsilat Eşleştirmeleri kartında “Eşleştirmeyi Kaldır” ile geri alınır: hareket eşleşmemişlere döner, bugünün tarihiyle ters defter kaydı yazılır ve bağışın tahsilat durumu geri döner.',
          },
          reverse: {
            title: 'Ters ibraz (chargeback)',
            body: 'Banka gelen bir havaleyi geri çektiğini bildirdiyse “Ters İbraz (Chargeback)” kullanılır: bağış “Ters Kayıt” olur, hareket ayrılmış kalır ve geri çekilen para kendi hareketiyle gelir. Bir kart ödemesinin eşleştirmesi elle kaldırılamaz; sağlayıcının tam iade ya da ters ibraz bildirimi onu kendiliğinden geri alır.',
          },
          clearing: {
            title: 'Mahsubu ve elle ödemeyi geri almak',
            body: 'Banka hareketiyle bağlanmış bir elle ödeme için önce hareketin sayfasında “Bağlantıyı Geri Al”, sonra “Banka Hareketi Bekleyen” sekmesinde ödemenin “Geri Al” düğmesi kullanılır.',
          },
          payout: {
            title: 'Kart ödemesi mutabakatı',
            body: 'Yanlış bir kart ödemesi mutabakatı Kart Ödemeleri ekranının “Mutabakatı Yapılanlar” sekmesinde “Mutabakatı Geri Al” ile, gerekçesiyle geri alınır; komisyon bugünün tarihiyle deftere geri yazılır.',
          },
        },
      },
      paymentKeys: {
        title: 'Stripe ve PayPal kurulumu, adım adım',
        summary:
          'Kartla ve PayPal ile bağış almak için her kuruluşun kendi Stripe ve PayPal hesabı tanımlanır. Bu işi kuruluş düzenleme yetkisi olan global kapsamdaki bir yönetici yapar. Anahtarlar bir kez girilir, hiçbir ekranda geri gösterilmez; yalnızca yenilenir.',
        steps: {
          account: {
            title: '1. Hesabı ekleyin',
            body: 'Kuruluşlar ekranında kuruluşu açın ve Hesaplar kartında “Hesap Ekle” ile türü Stripe ya da PayPal olan bir hesap ekleyin. Bildirim adresi (webhook URL) hesap oluşturulduğu anda hazırdır; bunun için anahtar gerekmez.',
          },
          openKeys: {
            title: '2. Ödeme Anahtarları kartını açın',
            body: 'Aynı sayfadaki Ödeme Anahtarları kartında hesabın satırında “Anahtarları tanımla” deyin. İlk adım hesabın bildirim adresini ve abone olunacak olayları gösterir; adresi “Adresi kopyala” ile kopyalayın.',
          },
          stripeWebhook: {
            title: '3a. Stripe: webhook oluşturun',
            body: 'Stripe panelinde Developers → Webhooks → “Add endpoint” adımına kopyaladığınız adresi yapıştırın ve aşağıdaki olayların hepsini seçin. Kaydettikten sonra webhook sayfasındaki “Signing secret” değerini (whsec_ ile başlar) kopyalayın.',
          },
          stripeKey: {
            title: '3b. Stripe: gizli anahtar',
            body: 'Developers → API keys bölümündeki “Secret key” değerini (sk_live_ ile başlar) kopyalayın; yayımlanabilir anahtar (pk_…) değil. Kısıtlı bir anahtar (rk_live_…) da kullanılabilir, ama Checkout oturumu oluşturma ile ödeme ve iade okuma izinleri verilmiş olmalıdır; yoksa bağış alınamaz.',
          },
          paypalWebhook: {
            title: '3c. PayPal: webhook oluşturun',
            body: 'PayPal Developer panelinde canlı (Live) ortamda Apps & Credentials → uygulamanız → Webhooks → “Add Webhook” adımına adresi yapıştırın ve aşağıdaki olayların hepsini seçin. Kaydettikten sonra görünen “Webhook ID” değerini kopyalayın — adresin kendisini değil.',
          },
          paypalKeys: {
            title: '3d. PayPal: client ID ve secret',
            body: 'Aynı uygulamanın sayfasından “Client ID” ve “Secret” değerlerini kopyalayın. Üç değer de aynı uygulamadan ve canlı (Live) ortamdan olmalıdır; Sandbox değerleri canlı sistemde reddedilir.',
          },
          paste: {
            title: '4. Yapıştırın ve kaydedin',
            body: '“İleri” ile ikinci adıma geçin ve değerleri yapıştırın. Kaydederken sistem anahtarları ve webhook’u sağlayıcıya sorarak doğrular; geçersiz bir anahtar kaydedilmez. Kart “Yapılandırıldı” dediğinde bu hesapla bağış alınabilir.',
          },
        },
        notes: {
          keyRejected:
            '“Stripe bu anahtarı reddetti” ya da “PayPal bu client ID ve secret çiftini reddetti”: anahtar yanlış hesaptan, eksik ya da iptal edilmiş olabilir; PayPal’da Sandbox değerleri de reddedilir. Sağlayıcının panelinden yeniden kopyalayın.',
          webhookMissing:
            '“Kayıtlı, etkin bir webhook bulunamadı” ya da “webhook şu olaylara abone değil”: webhook hiç oluşturulmamış, başka bir adrese oluşturulmuş ya da olaylardan biri seçilmemiş. Webhook’u bu bölümdeki adres ve olaylarla düzeltip yeniden kaydedin. PayPal’da “webhook ID’yi bulamadı” uyarısı, webhook’un başka bir uygulamada oluşturulduğunu söyler.',
          testKey:
            '“Bu bir Stripe test anahtarı”: canlı sistemde sk_test_ ile başlayan anahtar kabul edilmez; sk_live_ ile başlayanı girin.',
          serverMissing:
            '“Sunucu yöneticisinin tanımlaması gerekiyor” ya da “şifreleme anahtarı tanımlı değil”: eksik olan sizin girdiğiniz bir değer değil, sunucunun bir ayarıdır (bildirim adresi, PayPal bağlantısı ya da anahtar şifreleme anahtarı). Sistem yöneticisine başvurun; bu yapılana kadar anahtarlar kaydedilemez ya da ödemeler sisteme işlenmez.',
          unreachable:
            '“Sağlayıcıya şu anda ulaşılamadı”: anahtar reddedilmedi, yalnızca doğrulanamadı. Birkaç dakika sonra yeniden deneyin.',
        },
      },
      roles: {
        title: 'Kim ne yapabilir',
        summary:
          'Varsayılan rollerin muhasebe işlerindeki yetkileri. Tablo, sistemin kurulumda verdiği rol tanımlarından üretilir.',
        notes: {
          customized:
            'Yöneticiniz Roller ekranında bir rolü değiştirmiş ya da yeni bir rol tanımlamış olabilir; bir düğmeyi göremiyorsanız yetkinizi yöneticinize sorun. Her yetki ayrıca veri kapsamınızla sınırlıdır.',
        },
      },
    },
  },
  upload: {
    title: 'Dosyayı bırakın ya da seçin',
    description: 'Dosyayı buraya sürükleyin ya da',
    browse: 'bilgisayarınızdan seçin',
    remove: 'Dosyayı kaldır',
  },
  statementRemoval: {
    confirm: 'Onayla',
    cancel: 'Ekstreyi İptal Et',
    delete: 'Sil',
    cancelled: 'İptal edildi',
    required: 'İşlem gerekçesi zorunludur.',
    reason: 'İşlem gerekçesi',
    institution: 'Atanan kurum',
    pool: 'Sınıflandırılmamış / Genel Havuz',
    cancelConsequence:
      'Ekstrenin hareketleri kaldırılır; ekstre ve kaynak dosya iptal kaydıyla saklanır. Mali bağlantısı olan hareketler önce serbest bırakılmalıdır. Yalnızca eşleştirilmemişleri kaldırmayı seçerseniz ekstre açık kalır.',
    deleteConsequence:
      'Ekstre, kaynak dosyası ve kullanılmayan hareketleri silinir. Mali geçmiş ve denetim izi saklanır. Mali bağlantısı olan hareketler önce serbest bırakılmalıdır. Yalnızca eşleştirilmemişleri kaldırmayı seçerseniz ekstre açık kalır.',
    lineConsequence:
      'Bu hareket listelerden kaldırılır. Mali bağlantısı varsa önce kaldırılmalıdır. Geçmiş eşleştirmeler ve denetim izi saklanır.',
    unmatchedOnly: 'Korunan hareketler kalsın, yalnızca eşleştirilmemiş hareketleri kaldır',
    done: '{{removedCount}} hareket kaldırıldı; {{protectedCount}} hareket korundu.',
  },
  statementImportStatus: {
    uploaded: 'Yüklendi',
    processing: 'Okunuyor',
    preview: 'Önizleme',
    committed: 'Aktarıldı',
    failed: 'Okunamadı',
    discarded: 'Vazgeçildi',
  },
  attachmentScanStatus: {
    pending: 'Virüs taraması bekleniyor',
    clean: 'Virüs taraması temiz',
    infected: 'Virüslü dosya',
    failed: 'Taranamadı',
  },
  statementFormat: {
    xlsx_mapped: 'Excel (.xlsx / .xls)',
    csv_mapped: 'CSV',
    camt053: 'CAMT.053',
    mt940: 'MT940',
  },
  statementRowOutcome: {
    valid: 'Aktarılacak',
    committed: 'Aktarıldı',
    notCommitted: 'Aktarılmadı',
    duplicate: 'Mükerrer',
    rejected: 'Okunamadı',
  },
  statementRowIssue: {
    ROW_EMPTY: 'Boş satır',
    DATE_MISSING: 'Tarih yok',
    DATE_UNPARSEABLE: 'Tarih okunamadı',
    AMOUNT_MISSING: 'Tutar yok',
    AMOUNT_UNPARSEABLE: 'Tutar okunamadı',
    AMOUNT_ZERO: 'Tutar sıfır',
    AMOUNT_AMBIGUOUS: 'Borç/alacak yönü belirsiz',
    CURRENCY_UNKNOWN: 'Para birimi tanınmadı',
    BALANCE_UNPARSEABLE: 'Bakiye okunamadı',
    ENTRY_NOT_BOOKED: 'Banka henüz kesinleştirmemiş',
    BALANCE_GAP: 'Bakiye önceki satırdan tutmuyor',
    DUPLICATE_IN_FILE: 'Dosyada iki kez var',
    ALREADY_IMPORTED: 'Hesapta zaten kayıtlı',
    DUPLICATE_ON_COMMIT: 'Aktarım sırasında başka bir ekstreyle geldi',
    CURRENCY_NOT_ACCOUNT: 'Hesabın para biriminde değil',
  },
  statementFailure: {
    STATEMENT_UNREADABLE: 'Dosya okunamadı: bozuk ya da desteklenmeyen bir dosya.',
    STATEMENT_PROFILE_MISMATCH:
      'Dosya seçilen profile uymuyor: başka bir bankanın ya da başka bir ekranın dökümü olabilir.',
    STATEMENT_ACCOUNT_MISMATCH:
      'Ekstre başka bir hesaba ait; dosyadaki hesap numarası bu hesabı göstermiyor.',
    STATEMENT_ACCOUNT_IBAN_MISSING:
      'Bu hesabın IBAN’ı kayıtlı olmadığı için ekstrenin bu hesaba ait olduğu doğrulanamadı. Önce hesabın IBAN’ı kuruluşun sayfasından girilmeli — bunu kuruluş düzenleme yetkisi olan bir yönetici yapar — sonra ekstreyi yeniden yükleyin.',
    STATEMENT_TOO_MANY_ROWS: 'Dosyada izin verilenden fazla satır var. Dönemi bölerek yükleyin.',
    STATEMENT_EMPTY: 'Dosyada hiç hesap hareketi yok.',
    STATEMENT_FILE_INFECTED: 'Dosyada virüs bulundu; dosya okunmadı.',
    STATEMENT_FILE_SCAN_FAILED: 'Dosya virüs taramasından geçirilemedi; okunmadı.',
    STATEMENT_FILE_CHANGED: 'Yüklenen dosya depoda değişmiş; güvenlik için okunmadı.',
    STATEMENT_FILE_ENCRYPTED:
      'Dosya parolayla korunuyor; okunamaz. Excel’de açıp parolasını kaldırarak kaydedin ve yeniden yükleyin.',
    STATEMENT_FILE_TOO_COMPLEX:
      'Dosya bir ekstrenin taşıyabileceğinden çok daha fazla metin içeriyor; okunmadı. Bankadan dökümü yeniden alın ya da dönemi bölerek yükleyin.',
    REQUESTER_NOT_FOUND: 'Dosyayı yükleyen kullanıcı artık yok.',
    REQUESTER_INACTIVE: 'Dosyayı yükleyen kullanıcı pasife alınmış.',
    REQUESTER_LACKS_PERMISSION: 'Dosyayı yükleyen kullanıcının ekstre aktarma yetkisi kalmamış.',
    REQUESTER_OUT_OF_SCOPE:
      'Dosyayı yükleyen kullanıcının veri kapsamı bu kuruluşu artık içermiyor.',
  },
  inboundMedia: {
    feedbackAccepted: 'Medyanız alındı, inceleniyor.',
    feedbackRejected: 'Yetkisiz gönderim veya desteklenmeyen dosya formatı.',
    title: 'Gelen Medya',
    staffNotice:
      'Görevlendirmenizdeki bağışlara eşleşmiş, WhatsApp veya Telegram ile gelen fotoğraf ve videolar. Eşleştirme ve arşivleme, eşleşmemiş medyayı gören yetkililerce yapılır.',
    notice:
      'Sahadan WhatsApp veya Telegram ile gönderilen fotoğraf ve videolar önce QR koduna, bulunamazsa yazılı bağış koduna bakılarak okunur. Okunamayanlar burada bir kişinin eşleştirmesini bekler. Eşleştirme bağışa kanıt ekler; bağışın durumunu değiştirmez, gerçekleştirme bağış üzerinden ayrıca yapılır.',
    tab: {
      unmatched: 'Eşleştirme Bekleyen',
      in_flight: 'İşleniyor',
      matched: 'Eşleşen',
      archived: 'Arşiv',
    },
    statuses: {
      received: 'Alındı',
      decoding: 'Okunuyor',
      matched: 'Eşleşti',
      unreadable: 'Okunamadı',
      donation_not_found: 'Bağış bulunamadı',
      donation_not_eligible: 'Bağış uygun değil',
      update_failed: 'İşlenemedi',
    },
    sources: {
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      email: 'E-posta',
      upload: 'Yükleme',
    },
    kinds: {
      image: 'Fotoğraf',
      video: 'Video',
    },
    methods: {
      qr: 'QR kod',
      ocr: 'Yazılı kod',
    },
    column: {
      received: 'Geliş',
      source: 'Kaynak',
      file: 'Dosya',
      reading: 'Okuma',
      donation: 'Bağış kodu',
      share: 'Hisse',
      status: 'Durum',
    },
    status: 'Durum',
    from: 'Geliş başlangıç',
    to: 'Geliş bitiş',
    receivedRange: 'Geliş tarihi',
    search: 'Okunan bağış kodu ile ara',
    archived: 'Arşivlendi',
    frames_one: '{{count}} kare okundu',
    frames_other: '{{count}} kare okundu',
    ocrFrames_one: '{{count}} kare yazı tanımaya gönderildi',
    ocrFrames_other: '{{count}} kare yazı tanımaya gönderildi',
    share: '{{index}}. hisse',
    wholeDonation: 'Bağışın tamamı',
    readCode: 'Okunan kod',
    matchedAuto: '{{method}} ile otomatik eşleşti',
    matchedBy: '{{name}} elle eşleştirdi',
    updateFailed:
      'Otomatik işlem tekrar denemelere rağmen tamamlanamadı. Dosya açılabiliyorsa kodu elle girin.',
    waitingFile: 'Dosya indirilip virüs taramasından geçmeyi bekliyor.',
    reading: 'Otomatik okuma sürüyor.',
    fileDeleted: 'Saklama süresi dolduğu için dosya silindi',
    notFetched: 'Dosya indirilmedi',
    empty: {
      unmatched: 'Eşleştirme bekleyen medya yok',
      in_flight: 'İşlenmekte olan medya yok',
      matched: 'Eşleşen medya yok',
      archived: 'Arşivlenmiş medya yok',
    },
    emptyHint:
      'Bağış kodu okunmuş fotoğraf ve videolar kendiliğinden eşleşir; yalnızca okunamayanlar kişinin önüne gelir.',
    csvFile: 'gelen-medya',
    action: {
      preview: 'Dosyayı Aç',
      match: 'Bağışla Eşleştir',
      archive: 'Arşivle',
    },
    preview: {
      title: 'Gelen medya',
      alt: '{{received}} tarihinde gelen medya',
      unavailable: 'Dosya şu anda gösterilemiyor.',
    },
    match: {
      title: 'Medyayı bağışla eşleştir',
      hint: 'Görüntüdeki bağış kodunu yazın. Yalnızca geçerli bir bağış kodu kabul edilir; eşleştirme bağışa kanıt ekler ve bağışın durumunu değiştirmez.',
      code: 'Bağış kodu',
      codeHint: 'Örnek: BT-7K4Q-9MXS',
      codeRequired: 'Bağış kodunu yazın.',
      share: 'Hisse numarası',
      shareHint: 'Tek bir hisseye aitse',
      shareInvalid: '1 ile {{max}} arasında bir numara yazın.',
      submit: 'Eşleştir',
      done: 'Medya {{code}} koduyla eşleştirildi.',
    },
    archive: {
      title: 'Medya arşivlensin mi?',
      content:
        'Medya eşleştirme kuyruğundan çıkarılır ve bir daha otomatik işlenmez. Dosya kendi saklama süresi dolunca silinir.',
      reason: 'Gerekçe',
      reasonRequired: 'Gerekçeyi yazın.',
      done: 'Medya arşivlendi.',
    },
  },
  inboundMediaFailure: {
    INBOUND_MEDIA_NO_CODE: 'Görüntüde okunabilir bir bağış kodu bulunamadı.',
    INBOUND_MEDIA_SEVERAL_CODES:
      'Görüntüde birden fazla bağışın kodu var; hangisine ait olduğuna otomatik karar verilmez.',
    INBOUND_MEDIA_SENDER_UNAUTHORIZED: 'Gönderen artık aktif saha personeli değil.',
    INBOUND_MEDIA_UNSUPPORTED:
      'Dosya türü okunmuyor: yalnızca JPEG ve PNG fotoğraflar ile MP4 videolar okunur.',
    INBOUND_MEDIA_TOO_LARGE: 'Dosya okunabilecek boyut, çözünürlük ya da süre sınırını aşıyor.',
    INBOUND_MEDIA_DAMAGED: 'Dosya bozuk; açılamadı.',
    INBOUND_MEDIA_BUDGET_EXCEEDED: 'Dosya kendisine ayrılan süre içinde okunamadı.',
    INBOUND_MEDIA_INFECTED: 'Virüs taramasında zararlı içerik bulundu; dosya okunmadı.',
    INBOUND_MEDIA_SCAN_FAILED: 'Dosya virüs taramasından geçirilemedi; okunmadı.',
    INBOUND_MEDIA_MISSING: 'Dosya depoda bulunamadı.',
    INBOUND_MEDIA_DONATION_NOT_FOUND: 'Okunan koda ait bir bağış yok.',
    INBOUND_MEDIA_DONATION_DRAFT: 'Okunan kodun bağışı henüz taslak.',
    INBOUND_MEDIA_DONATION_PENDING_APPROVAL: 'Okunan kodun bağışı henüz onaylanmadı.',
    INBOUND_MEDIA_DONATION_REJECTED: 'Okunan kodun bağışı reddedilmiş.',
    INBOUND_MEDIA_DONATION_CANCELLED: 'Okunan kodun bağışı iptal edilmiş.',
    INBOUND_MEDIA_SHARE_OUT_OF_RANGE: 'Okunan hisse numarası bağışın hisse sayısından büyük.',
  },
  accountTransactionDirection: {
    credit: 'Gelen',
    debit: 'Giden',
  },
  accountTransactionClassification: {
    donor_payment: 'Bağış ödemesi',
    card_settlement: 'Kart (POS) hakedişi',
    fee: 'Masraf',
    refund_payout: 'İade ödemesi',
    internal_transfer: 'Virman',
    other: 'Diğer',
  },
  accountTransactionSource: {
    bank_statement: 'Banka ekstresi',
    nestpay: 'NestPay',
    stripe: 'Stripe',
    paypal: 'PayPal',
    manual_cash: 'Elle kasa girişi',
    manual_bank: 'Elle banka ödemesi (dekont/çek)',
  },
  allocationState: {
    unallocated: 'Eşleşmemiş',
    partial: 'Kısmen eşleşmiş',
    allocated: 'Eşleşmiş',
    excluded: 'Hariç tutulmuş',
  },
  statementProfile: {
    title: 'Ekstre Formatları',
    new: 'Ekstre Formatı Tanımla',
    newVersion: 'Yeni sürüm',
    newVersionTitle: '{{name}} — yeni sürüm',
    caption:
      'Bir bankanın dökümünün nasıl okunacağı. Kayıt her seferinde yeni bir sürüm olur; okunmuş bir ekstre okunduğu sürüme bağlı kalır.',
    bankCode: 'Banka kodu',
    bankCodeHint:
      'Küçük harf, rakam ve tire; örneğin deneme-bankasi. Aynı kodla kaydedilen her format o bankanın yeni sürümüdür.',
    bankCodeFixed: 'Yeni sürüm aynı bankanın kodunu taşır.',
    bankCodeInvalid: 'En az iki karakter: küçük harf, rakam ve tire.',
    name: 'Ad',
    nameHint: 'Yükleme ekranında görünen ad; örneğin “Deneme Bankası — Hesap Hareketleri (Excel)”.',
    nameInvalid: 'Bir ad yazın.',
    format: 'Dosya türü',
    version: 'Sürüm',
    versionLabel: 'v{{version}}',
    latest: 'Güncel',
    createdAt: 'Kaydedildi',
    tabs: { latest: 'Güncel sürümler', all: 'Tüm sürümler' },
    bankCodeFilter: 'Banka kodu',
    empty: 'Ekstre formatı yok',
    emptyHint: 'Bir bankanın dökümünü okumak için bir format tanımlayın.',
    csvFile: 'ekstre-formatlari.csv',
    created: '{{name}} sürüm {{version}} kaydedildi.',
    globalOnly:
      'Ekstre formatlarını yalnızca genel kapsamda çalışan bir kullanıcı tanımlar: bir bankanın formatı her kuruluşun ekstresini etkiler.',
    baseMissing: 'Bu bankanın kayıtlı bir sürümü bulunamadı.',
    settingsTitle: 'Format',
    settingsSubtitle: 'Banka, dosya türü ve satırlar',
    noMapping:
      'CAMT.053 ve MT940 standart biçimlerdir; sütun eşlemesi gerekmez. Örnek dosya yine de aşağıda okunur.',
    rowsTitle: 'Satırlar',
    headerRow: 'Başlık satırı',
    firstDataRow: 'İlk hareket satırı',
    columnsTitle: 'Sütunlar',
    columnsSubtitle:
      'Her alanın dosyadaki sütunu; örnek dosya yüklendiğinde başlıklarıyla birlikte listelenir.',
    noColumn: 'Yok',
    columnOption: '{{letter}} — {{header}}',
    dateColumn: 'İşlem tarihi',
    dateFormat: 'Tarih biçimi',
    valueDateColumn: 'Valör tarihi',
    valueDateFormat: 'Valör tarihi biçimi',
    amountKind: 'Tutar',
    amountKinds: {
      signed: 'Tek sütun, giden eksi işaretli',
      split: 'Borç ve alacak ayrı sütunlarda',
    },
    amountColumn: 'Tutar sütunu',
    debitColumn: 'Borç (giden) sütunu',
    creditColumn: 'Alacak (gelen) sütunu',
    optionalColumns: {
      description: 'Açıklama',
      reference: 'Referans / dekont no',
      counterpartyName: 'Karşı taraf',
      counterpartyIban: 'Karşı taraf IBAN',
      balanceAfter: 'Bakiye',
      currencyColumn: 'Para birimi',
    },
    referenceHint:
      'Yalnızca her harekette benzersiz olan bir numara seçin; tekrar eden bir numara gerçek bir hareketi mükerrer sayar.',
    numbersTitle: 'Sayılar',
    decimalSeparator: 'Ondalık ayırıcı',
    thousandsSeparator: 'Binlik ayırıcı',
    separators: {
      comma: 'Virgül (,)',
      dot: 'Nokta (.)',
      space: 'Boşluk',
      apostrophe: 'Kesme (’)',
      none: 'Yok',
    },
    csvDelimiter: 'CSV ayırıcısı',
    csvDelimiters: {
      auto: 'Başlık satırından anlaşılsın',
      semicolon: 'Noktalı virgül (;)',
      comma: 'Virgül (,)',
      tab: 'Sekme',
      pipe: 'Dikey çizgi (|)',
    },
    checkHeaders: 'Başlıklar doğrulansın',
    checkHeadersHint:
      'Eşlenen sütunların başlığı örnek dosyadakiyle aynı değilse dosya bütünüyle reddedilir; başka bir bankanın dökümü yanlış sütunlarla okunmaz.',
    expectedHeaders: 'Beklenen başlıklar: {{headers}}',
    classificationsTitle: 'Sınıflandırma kuralları',
    classificationsSubtitle:
      'Bir sütun belirli bir metni taşıyorsa hareketin türü. Kural yoksa gelen bağış ödemesi, giden diğer sayılır.',
    addRule: 'Kural ekle',
    removeRule: 'Kuralı kaldır',
    ruleColumn: 'Sütun',
    ruleMatch: 'Eşleşme',
    ruleMatches: { equals: 'Eşittir', contains: 'İçerir' },
    ruleText: 'Metin',
    ruleClassify: 'Tür',
    mappingProblems: 'Kaydetmeden önce düzeltin: {{fields}}',
    mappingFields: {
      mapping: 'Sütun eşlemesi',
      headerRow: 'Başlık satırı',
      firstDataRow: 'İlk hareket satırı',
      date: 'İşlem tarihi',
      valueDate: 'Valör tarihi',
      amount: 'Tutar sütunları',
      decimalSeparator: 'Ondalık ve binlik ayırıcı',
      thousandsSeparator: 'Binlik ayırıcı',
      description: 'Açıklama',
      reference: 'Referans',
      counterpartyName: 'Karşı taraf',
      counterpartyIban: 'Karşı taraf IBAN',
      balanceAfter: 'Bakiye',
      currencyColumn: 'Para birimi',
      csvDelimiter: 'CSV ayırıcısı',
      expectedHeaders: 'Beklenen başlıklar',
      classifications: 'Sınıflandırma kuralları',
    },
    sample: {
      title: 'Örnek dosya ve önizleme',
      subtitle:
        'Dosya tarayıcınızda okunur, sunucuya gönderilmez. Önizleme, ekstre yüklendiğinde kullanılacak okuyucunun aynısıdır.',
      currency: 'Hesabın para birimi',
      currencyHint: 'Önizlemede para birimi sütunu yoksa hareketler bu para biriminde okunur.',
      tooLarge: 'Örnek dosya en çok {{size}} olabilir.',
      reading: 'Okunuyor…',
      kind: 'Dosya türü: {{kind}}',
      kinds: {
        xlsx: 'Excel (.xlsx)',
        xls: 'Eski Excel (.xls)',
        csv: 'CSV',
        xml: 'XML (CAMT.053)',
        mt940: 'MT940',
        unknown: 'Tanınmadı',
      },
      kindMismatch: 'Bu dosya türü seçilen biçimle okunmaz.',
      gridTitle: 'Dosyanın ilk satırları',
      gridHint: 'Mavi satır başlık, yeşil satır ilk hareket satırıdır.',
      rowNumber: 'Satır',
      failed: 'Bu formatla dosya okunamıyor:',
      resultTitle: 'Okunan hareketler',
      counts: '{{valid}} aktarılacak · {{duplicate}} dosyada tekrar · {{rejected}} okunamadı',
      date: 'Tarih',
      direction: 'Yön',
      amount: 'Tutar',
      description: 'Açıklama',
      reference: 'Referans',
      classification: 'Tür',
      outcome: 'Sonuç',
      issues: 'Neden',
      noIssues: '—',
      moreRows: 'İlk {{shown}} hareket gösteriliyor; dosyada {{total}} hareket var.',
      empty: 'Önizleme için bir örnek dosya seçin.',
    },
    saveFailed: 'Format kaydedilemedi.',
  },
  statementImport: {
    title: 'Ekstreler',
    upload: 'Ekstre Yükle',
    file: 'Dosya',
    account: 'Hesap',
    organization: 'Kuruluş',
    profile: 'Profil',
    profileVersion: '{{name}} · sürüm {{version}}',
    format: 'Biçim',
    period: 'Dönem',
    periodFrom: 'Dönem başlangıcı',
    periodTo: 'Dönem sonu',
    status: 'Durum',
    counts: 'Satırlar',
    countsValue: '{{valid}} aktarılacak · {{duplicate}} mükerrer · {{rejected}} okunamadı',
    countsCommitted: '{{valid}} aktarıldı · {{duplicate}} mükerrer · {{rejected}} okunamadı',
    uploadedBy: 'Yükleyen',
    uploadedAt: 'Yüklendiği an',
    committedBy: 'Aktaran',
    committedAt: 'Aktarıldığı an',
    fileSize: 'Boyut',
    scan: 'Virüs taraması',
    failure: 'Okunamama sebebi',
    empty: 'Yüklenmiş ekstre yok',
    emptyHint: 'Bir banka hesabının dökümünü “Ekstre Yükle” ile yükleyin.',
    csvFile: 'ekstreler.csv',
    actions: {
      view: 'Aç',
      commit: 'Hesaba Aktar',
      discard: 'Vazgeç',
      lines: 'Hesap hareketlerini gör',
    },
    uploadDialog: {
      title: 'Ekstre Yükle',
      hint: 'Dosya önce virüs taramasından geçer, sonra seçilen profille okunur. Hiçbir satır, önizlemeyi görüp “Hesaba Aktar” demeden hesaba işlenmez.',
      account: 'Banka hesabı',
      profile: 'Ekstre profili',
      profileHint: 'Dosyanın geldiği banka ve döküm biçimi',
      fileTooLarge: 'Dosya en çok {{size}} olabilir.',
      pickAccount: 'Bir banka hesabı seçin.',
      pickProfile: 'Bir ekstre profili seçin.',
      pickFile: 'Bir dosya seçin.',
      noAccounts: 'Veri kapsamınızda ekstre aktarılabilecek bir banka hesabı yok.',
      submit: 'Yükle',
      uploading: 'Yükleniyor…',
      putFailed: 'Dosya depoya yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.',
      created: 'Ekstre yüklendi; virüs taraması ve okuma arka planda sürüyor.',
      defineProfile: 'Listede bankanızın formatı yok mu? Ekstre formatı tanımlayın',
    },
    detail: {
      back: 'Ekstrelere dön',
      caption: '{{account}} · {{uploadedBy}} · {{uploadedAt}}',
      waiting: 'Dosya virüs taramasından geçiriliyor ve okunuyor. Bu sayfa kendini yeniler.',
      failed: 'Bu ekstre okunamadı.',
      enterIban: 'Kuruluşun sayfasında hesabın IBAN’ını girin',
      discarded: 'Bu ekstreden vazgeçildi; hiçbir satırı hesaba işlenmedi.',
      committed: 'Bu ekstrenin satırları hesaba aktarıldı.',
      summaryTitle: 'Özet',
      fileTitle: 'Dosya ve profil',
      rowCount: 'Toplam satır',
      validCount: 'Aktarılacak',
      committedCount: 'Aktarılan',
      duplicateCount: 'Mükerrer',
      rejectedCount: 'Okunamadı',
      balanceGapCount: 'Bakiyesi tutmayan',
      balanceGapsWarning:
        'Bazı satırlarda bakiye bir önceki satırdan tutmuyor. Ekstrede eksik bir hareket olabilir; aktarmadan önce bankanın dökümüyle karşılaştırın.',
    },
    rows: {
      title: 'Ekstre satırları',
      subheader: 'Dosyadaki her satır, okunduğu hâliyle ve neden aktarılamayacağıyla',
      view: {
        all: 'Tümü',
        valid: 'Aktarılacak',
        committed: 'Aktarılan',
        issues: 'Sorunlu',
        duplicates: 'Mükerrer',
        rejected: 'Okunamayan',
        balanceGaps: 'Bakiyesi tutmayan',
      },
      rowNumber: 'Satır',
      bookedOn: 'Tarih',
      direction: 'Yön',
      amount: 'Tutar',
      description: 'Açıklama',
      classification: 'Sınıf',
      outcome: 'Sonuç',
      issues: 'Sorunlar',
      reference: 'Referans',
      raw: 'Dosyadaki satır',
      expand: 'Dosyadaki satırı göster',
      empty: 'Bu görünümde satır yok',
    },
    commitDialog: {
      title: 'Ekstreyi hesaba aktar',
      content:
        '{{valid}} satır “{{account}}” hesabına hareket olarak işlenecek. {{duplicate}} mükerrer ve {{rejected}} okunamayan satır aktarılmaz. Aktarılan hareketler silinemez; yalnızca eşleştirilir ya da hariç tutulur.',
      done: 'Ekstre aktarıldı: {{inserted}} yeni hareket, {{duplicate}} mükerrer.',
    },
    discardDialog: {
      title: 'Ekstreden vazgeç',
      content:
        'Bu ekstrenin hiçbir satırı hesaba işlenmeyecek. Yüklenen dosya denetim için saklanır.',
      done: 'Ekstreden vazgeçildi.',
    },
  },
  movementEquivalents: {
    column: 'TL / USD / EUR karşılığı',
    detail: 'Karşılıkları',
    csvColumn: '{{currency}} karşılığı',
    rateDateColumn: 'Kur tarihi',
    pending: 'Kur bekleniyor',
    pendingHint:
      'Hareketin günü için TCMB kuru henüz alınmadı. Kur geldiğinde karşılıklar kendiliğinden yazılır ve bir daha değişmez.',
    rateDate:
      'Hareket gününde geçerli kur, yani o günden önce yayımlanan son kurun tarihi: {{date}}. Karşılıklar yazıldığında sabitlenir.',
  },
  movementFilter: {
    search: 'İsim, açıklama veya referans ara…',
    currency: 'Para birimi',
    currencyRequired: 'Özgün tutarda aralık için para birimi seçin.',
    amountNegative: 'Tutar eksi olamaz; aralık uygulanmadı.',
    amountIn: 'Tutar türü',
    ratePending: 'Kur bekleniyor',
    ratePendingBlock: 'Döviz karşılığı',
    basis: {
      original: 'Özgün tutar',
      TRY: 'TL karşılığı',
      USD: 'USD karşılığı',
      EUR: 'EUR karşılığı',
    },
  },
  accountTransaction: {
    title: 'Hesap Hareketleri',
    bookedOn: 'Tarih',
    valueDate: 'Valör',
    account: 'Hesap',
    description: 'Açıklama',
    counterparty: 'Karşı taraf',
    counterpartyEmail: 'Karşı taraf e-postası',
    counterpartyIban: 'Karşı taraf IBAN',
    reference: 'Referans',
    direction: 'Yön',
    amount: 'Tutar',
    currency: 'Para Birimi',
    remaining: 'Eşleşmemiş kalan',
    allocated: 'Eşleşen',
    classification: 'Sınıf',
    allocation: 'Eşleşme',
    source: 'Kaynak',
    balanceAfter: 'İşlem sonrası bakiye',
    statementImport: 'Ekstre',
    fromImport: 'Bir ekstrenin satırları',
    matchedByOtherOrganization: 'Başka kuruluşun eşleştirdiği hareketlerimiz',
    matchedByOtherOrganizationBlock: 'Eşleştirme',
    excludedReason: 'Hariç tutulma gerekçesi',
    bookedFrom: 'Başlangıç',
    bookedTo: 'Bitiş',
    bookedRange: 'Tarih',
    search: 'Açıklama, karşı taraf veya referans ara…',
    empty: 'Hesap hareketi yok',
    emptyHint: 'Filtreleri değiştirin ya da bir ekstre aktarın.',
    csvFile: 'hesap-hareketleri.csv',
    detail: {
      back: 'Hesap hareketlerine dön',
      caption: '{{account}} · {{date}}',
      detailsTitle: 'Hareket',
      rawTitle: 'Bankanın satırı',
      rawSubheader: 'Hareketin geldiği dosyada yazdığı hâliyle',
      openReconciliation: 'Mutabakatta Eşleştir',
    },
    uses: {
      title: 'Paranın gittiği yer',
      subheader:
        'Bu hareketten bağışlara yazılan, iade edilen, aktarılan ve hariç tutulan tutarlar — her biri kendi kaydına bağlı',
      empty: 'Bu hareket henüz hiçbir bağışa, iadeye ya da transfere yazılmadı.',
      loadFailed: 'Hareketin kullanımları okunamadı.',
      matches: 'Bağış eşleştirmeleri',
      refunds: 'İadeler',
      fundTransfers: 'Fon transferleri',
      payouts: 'Kart ödemeleri',
      clearings: 'Elle kaydedilmiş ödemelerin banka hareketi',
      exclusion: 'Hariç tutulma',
      column: {
        donation: 'Bağış',
        transactionAmount: 'Hareketten',
        donationAmount: 'Bağışa yazılan',
        status: 'Durum',
        who: 'Kim, ne zaman',
        what: 'Ne',
        amount: 'Tutar',
        reason: 'Gerekçe',
      },
      matchedBy: '{{name}} eşleştirdi · {{date}}',
      matchedBySystem: 'Kart sağlayıcısı bildirdi · {{date}}',
      confirmedBy: '{{name}} onayladı · {{date}}',
      confirmedAt: 'Onaylandı · {{date}}',
      rejectedAt: 'Reddedildi · {{date}}',
      reversedAt: 'Geri alındı · {{date}}',
      refundRole: {
        source: 'Bu hareketin fazlası iade ediliyor',
        paid: 'Bu hareketle ödendi',
      },
      transferSide: {
        source: 'Başka kuruluşa aktarılmak üzere gelen para',
        out: 'Transferin giden tarafı',
        in: 'Transferin gelen tarafı',
      },
      transferRoute: '{{from}} → {{to}}',
      clearingRole: {
        bank: 'Dekont ya da çekle elle kaydedilmiş bir ödemenin bankaya düşen parası',
        manual: 'Bu ödemenin bankaya düşen parası',
      },
      clearingStatus: { confirmed: 'Bulundu', reversed: 'Geri alındı' },
      clearedBy: '{{name}} işaretledi · {{date}}',
      clearedAt: 'İşaretlendi · {{date}}',
      unclearedBy: '{{name}} geri aldı · {{date}}',
      unclearedBecause: 'Gerekçe: {{reason}}',
      unclear: 'Bağlantıyı Geri Al',
      unclearTitle: 'Bu bağlantı geri alınsın mı?',
      unclearContent:
        'Banka hareketinden {{amount}} serbest kalır ve ödeme yeniden banka hareketini bekler. Bağışların tahsilatı, defter ve makbuz değişmez.',
      unclearDone: 'Bağlantı geri alındı; ödeme yeniden banka hareketini bekliyor.',
      payoutRole: {
        bank: 'Sağlayıcının yatırdığı ödeme',
        capture: 'Bir ödemeyle yatırılan kart tahsilatı',
      },
      payoutStatus: {
        confirmed: 'Mutabakatı yapıldı',
        reversed: 'Geri alındı',
      },
      payoutAmounts: 'Brüt {{gross}} · Kesinti {{fee}}',
      released: 'Ödeme geri alındığı için yeniden eşleştirilebilir',
      excludedBy: '{{name}} hariç tuttu · {{date}}',
      excludedAt: 'Hariç tutuldu · {{date}}',
      openList: 'Listede aç',
      noDonationLink: 'Bağışı görme yetkiniz yok',
    },
    raw: {
      row: 'Satır',
      entry: 'Kayıt',
      transaction: 'İşlem',
      status: 'Banka durumu',
      creditDebit: 'Borç/alacak',
      amount: 'Tutar',
      currency: 'Para birimi',
      bookingDate: 'İşlem tarihi',
      valueDate: 'Valör',
      entryReference: 'Banka referansı',
      transactionReference: 'İşlem referansı',
      endToEndId: 'Uçtan uca referans',
      debtor: 'Gönderen',
      debtorIban: 'Gönderen IBAN',
      creditor: 'Alıcı',
      creditorIban: 'Alıcı IBAN',
      remittance: 'Açıklama',
      additionalInfo: 'Ek bilgi',
      statementLine: ':61: satırı',
      information: ':86: açıklaması',
      enteredByUserId: 'Giren kullanıcı',
      enteredAt: 'Giriş anı',
      direction: 'Yön',
      amountMinor: 'Tutar (kuruş)',
      bookedOn: 'Tarih',
      description: 'Açıklama',
    },
  },
  /**
   * Toplu ekle / güncelle — kullanıcı, kurum ve bağış şablonları. docs/decisions/0125.
   * `columns` anahtarları şablonun sütun anahtarlarıdır; başlık hücresi "Etiket [anahtar]" yazılır.
   */
  bulkChange: {
    menuEntry: 'Toplu Ekle / Güncelle',
    sheetName: 'Şablon',
    active: 'Aktif',
    inactive: 'Pasif',
    yes: 'Evet',
    no: 'Hayır',
    kind: {
      user: 'Kullanıcılar',
      institution: 'Kurumlar',
      donation: 'Bağışlar',
    },
    template: {
      purpose: {
        user: 'Kullanıcı toplu ekleme / güncelleme şablonu. İlk iki satırı değiştirmeyin. Kimlik sütunu dolu bir satır o kullanıcıyı günceller; boş bırakılan satır yeni kullanıcı olarak eklenir ve davet e-postası gönderilir. Parola bu dosyada yer almaz. Sürüm sütununu değiştirmeyin: dosya indirildikten sonra değişen bir kullanıcı güncellenmez.',
        institution:
          'Kurum toplu ekleme / güncelleme şablonu. İlk iki satırı değiştirmeyin. Kimlik sütunu dolu bir satır o kurumu günceller; boş bırakılan satır yeni kurum olarak eklenir. Kurum kodu yalnızca eklerken yazılır, sonradan değiştirilemez. Sürüm sütununu değiştirmeyin: dosya indirildikten sonra değişen bir kurum güncellenmez.',
        donation:
          'Bağış toplu güncelleme şablonu. İlk iki satırı değiştirmeyin. Yalnızca mevcut bağışlar güncellenir; yeni bağış eklemek için Bağış Aktarımı kullanılır. Sürüm sütununu değiştirmeyin: dosya indirildikten sonra değişen bir bağış güncellenmez.',
      },
      purposeDonation:
        '{{campaign}} kampanyası bağış toplu güncelleme şablonu. İlk iki satırı değiştirmeyin; sütunlar bu kampanyanın Bağış Aktarımı şablonuyla aynıdır ve her satır bağışın şimdiki değerleriyle doludur. Yalnızca değiştirdiğiniz hücreler güncellenir; dosyadan sildiğiniz bir sütuna dokunulmaz. Telefonlar maskeli gelir: olduğu gibi bırakılırsa numara değişmez, yeni numarayı tam yazın. Yalnızca mevcut bağışlar güncellenir; yeni bağış için Bağış Aktarımı kullanılır. Sürüm sütununu değiştirmeyin: dosya indirildikten sonra değişen bir bağış güncellenmez.',
      rolesHelp:
        'Roller: “rol_kodu@düzey:kod” biçiminde, birden çoğu “;” ile ayrılır. Düzey global, region, zone, country, institution ya da self olabilir (örn. institution_user@institution:DE-KOLN; global_admin@global). Sütun boş bırakılırsa kullanıcının manuel rolleri kaldırılır; sütunu dosyadan silerseniz roller değişmez.',
      readOnlyHelp: 'Gri başlıklı sütunlar yalnızca bilgi içindir; değiştirilse de okunmaz.',
    },
    columns: {
      id: 'Kimlik',
      name: 'Ad Soyad',
      institution_name: 'Kurum Adı',
      email: 'E-posta',
      phone: 'Telefon',
      telegram_chat_id: 'Telegram Sohbet No',
      institution_code: 'Kurum Kodu',
      roles: 'Roller',
      is_active: 'Durum',
      code: 'Kod',
      country_code: 'Ülke Kodu',
      reference_code: 'Referans Kodu',
      campaign: 'Kampanya',
      donor: 'Bağışçı',
      status: 'Bağış Durumu',
      payment_status: 'Ödeme Durumu',
      currency: 'Para Birimi',
      quantity: 'Adet',
      amount: 'Tutar',
      payment_method: 'Ödeme Şekli',
      payment_reference: 'Ödeme Referansı',
      note: 'Not',
      version: 'Sürüm (değiştirmeyin)',
    },
    action: {
      all: 'Tümü',
      create: 'Eklenecek',
      update: 'Güncellenecek',
      unchanged: 'Değişmeyen',
      rejected: 'Reddedilen',
    },
    result: {
      planned: 'Bekliyor',
      applied: 'Uygulandı',
      refused: 'Reddedildi',
    },
    resultNote: {
      invitation_sent: 'Davet e-postası gönderildi.',
      invitation_not_sent:
        'Davet e-postası gönderilemedi; kullanıcı listesinden yeniden davet edin.',
    },
    status: {
      uploaded: 'Yüklendi',
      processing: 'İnceleniyor',
      preview: 'Önizleme hazır',
      committing: 'Uygulanıyor',
      committed: 'Tamamlandı',
      failed: 'Başarısız',
      discarded: 'Vazgeçildi',
    },
    page: {
      title: 'Toplu Ekle / Güncelle',
      titleFor: '{{kind}} — Toplu Ekle / Güncelle',
      subtitle:
        'Şablonu indirin, doldurun ve yükleyin. Hiçbir şey, önizlemeyi inceleyip onaylamadan değişmez.',
      downloadSection: '1. Şablonu indirin',
      downloadEmpty: 'Boş şablon',
      downloadFiltered: 'Listedeki filtreye göre indir',
      donation: {
        section: '1. Kampanyayı ve bağışları seçin',
        hint: 'Bağış güncelleme şablonu tek bir kampanyaya aittir: sütunlar o kampanyanın Bağış Aktarımı şablonuyla aynıdır ve her satır bağışın şimdiki değerleriyle gelir. Listedeki süzgeçler de uygulanır; aşağıdakilerle daraltabilirsiniz.',
        campaign: 'Kampanya',
        campaignRequired: 'Şablonu indirmek için bir kampanya seçin.',
        zone: 'Mıntıka',
        country: 'Ülke',
        institution: 'Kurum',
        staff: 'Personel',
        staffHint: 'Bağışın kaydedildiği kişi (Kaydeden kişi).',
        any: 'Tümü',
        listFilterNote: 'Listedeki süzgeçler uygulanır: {{count}} süzgeç.',
        listFilterNone: 'Listede ek süzgeç yok.',
        download: 'Seçime göre şablonu hazırla',
      },
      downloadHint:
        'Filtreye göre indirilen dosya, listede o an görünen kayıtları (yetki alanınız içinde) güncelleme şablonu biçiminde verir.',
      preparing: 'Şablon hazırlanıyor…',
      download: 'Şablonu indir',
      uploadSection: '2. Doldurulmuş dosyayı yükleyin',
      uploadHint: 'Excel (.xlsx, .xls) ya da CSV; en çok 5 MB ve 1.000 satır.',
      chooseFile: 'Dosya seç',
      upload: 'Yükle ve önizle',
      uploading: 'Yükleniyor…',
      recent: 'Önceki toplu işlemler',
      noneYet: 'Henüz toplu işlem yok',
      back: 'Listeye dön',
      created: 'Dosya yüklendi; önizleme hazırlanıyor.',
      putFailed: 'Dosya depoya yüklenemedi. Yeniden deneyin.',
      openChange: 'Aç',
      excluded: {
        user: 'Parola, parola özeti, iki adımlı doğrulama, oturum ve davet bağlantıları şablonda yer almaz; kullanıcıyı pasife alma işlemi listeden yapılır.',
        institution:
          'Kurumun bağlı kuruluşları ve genel merkez durumu şablonda yer almaz; onlar Kuruluşlar ekranından yönetilir.',
        donation:
          'Referans kodu, kampanya, bağış durumu ve ödeme durumu yalnızca bilgi içindir; durum geçişleri, ödeme eşleştirmesi ve iptal bu şablonla yapılmaz. Bağışçı ve kişilerin telefonları maskeli gelir.',
      },
    },
    detail: {
      title: 'Toplu işlem',
      fileName: 'Dosya',
      uploadedBy: 'Yükleyen',
      createdAt: 'Yüklenme',
      waiting: 'Dosya inceleniyor, birkaç saniye içinde önizleme hazır olur…',
      applying: 'Değişiklikler uygulanıyor…',
      summary: {
        rows: 'Satır',
        create: 'Eklenecek',
        update: 'Güncellenecek',
        unchanged: 'Değişmeyen',
        rejected: 'Reddedilen',
        applied: 'Uygulanan',
        refused: 'Uygulanamayan',
      },
      commit: 'Değişiklikleri uygula',
      commitHint:
        'Yalnızca eklenecek ve güncellenecek satırlar uygulanır; reddedilen satırlar atlanır.',
      commitConfirmTitle: 'Değişiklikler uygulansın mı?',
      commitConfirm: '{{create}} kayıt eklenecek, {{update}} kayıt güncellenecek.',
      discard: 'Vazgeç',
      discardConfirm: 'Bu önizleme silinsin mi? Hiçbir şey uygulanmadı.',
      nothingToCommit: 'Uygulanacak satır yok.',
      committed: 'Toplu işlem tamamlandı.',
      commitStarted: 'Uygulama başlatıldı; satırlar tek tek işleniyor.',
      row: 'Satır',
      target: 'Kayıt',
      action: 'İşlem',
      details: 'Değişiklikler / neden',
      cellsCleared: 'Bu işlem sona erdiği için satır içerikleri silindi.',
      empty: 'Bu görünümde satır yok',
      from: 'Önceki',
      to: 'Yeni',
      none: '—',
    },
  },

  donationImport: {
    /** A season's import template, drawn in the worker — docs/decisions/0104 §2. */
    template: {
      sheetName: 'Bağışlar',
      optionsSheetName: 'Seçenekler',
      purpose:
        '{{campaign}} — {{season}} için bağış aktarım şablonu. İlk iki satırı değiştirmeyin; her bağışı üçüncü satırdan başlayarak bir satıra yazın. Sütunlar köşeli parantez içindeki anahtarla okunur, sırası değişebilir. Kaydeden kişiyi her satırda açılır listeden seçin; boş bırakırsanız aktarımda seçilen kişi ya da yükleyen kullanılır.',
      closedSeason:
        'Bu sezon kapanmıştır: yüklenen bağışlar kapanmış sezona eklenir ve her satırın bağış tarihi sezonun kendi tarihleri içinde olmalıdır.',
      undatedSeason: 'tarihsiz sezon',
      season: '{{year}} sezonu',
      operatorOptions: 'Kullanıcılar',
      operatorOptionsTruncated:
        'Kullanıcılar listesi ilk {{count}} kişiyi gösterir. Listede olmayan bir kişiyi “Ad Soyad (e-posta)” biçiminde yazabilirsiniz.',
    },
    column: {
      enteredByUserId: 'Kaydeden kişi',
      partyName: 'Ad Soyad',
      partyPhone: 'Telefon',
      payerCountry: 'Telefonun ülkesi (TR, DE…)',
      quantity: 'Adet',
      amount: 'Tutar',
      currency: 'Para birimi',
      yurt: 'Yurt',
      paymentMethod: 'Ödeme şekli',
      paymentReference: 'Ödeme referansı',
      note: 'Not',
      donatedAt: 'Bağış tarihi (GG.AA.YYYY)',
    },
    title: 'Veri Yükleme',
    subtitle: 'Kampanya sezonlarının Excel listelerini bağış olarak aktarın',
    upload: 'Veri Yükle',
    newTitle: 'Yeni Aktarım',
    campaign: 'Kampanya',
    season: 'Sezon',
    selectCampaign: 'Bir kampanya seçin',
    selectSeason: 'Bir sezon seçin',
    closedSeasonChip: 'Kapalı sezon',
    closedSeasonHint:
      'Bu sezon kapanmıştır: yüklenen bağışlar bu sezonun toplamlarına eklenir ve her satırın bağış tarihi sezonun kendi tarihleri içinde olmalıdır.',
    undatedSeason: 'tarihsiz sezon',
    seasonYear: '{{year}} sezonu',
    noImportableTarget: 'Veri kapsamınızda aktarım yapılabilecek bir kampanya sezonu yok.',
    noImportableSeason: 'Bu kampanyanın aktarım yapılabilecek bir sezonu yok.',
    templateCard: {
      recorderTitle: 'Şablonda kaydeden kişi',
      recorderHint:
        'Şablonun “Kaydeden kişi” sütununda her satır için kişiyi Excel’de açılır listeden seçersiniz; liste, Seçenekler sayfasındaki Kullanıcılar sütunudur ve kişileri “Ad Soyad (e-posta)” olarak gösterir. Burada bir kişi seçmek isteğe bağlıdır: seçerseniz tüm satırlara önceden yazılır, satırda değiştirebilirsiniz. Boş bırakılan satır, aktarırken seçilen toplu kişiyi ya da yükleyeni kullanır.',
      recorderScope: 'Kaydeden kapsamı',
      recorderPrefilled:
        '{{name}} şablonun tüm satırlarına önceden yazılır; Excel’de satır satır başka bir kişi seçebilirsiniz.',
      recorderEmpty: 'Kişi seçilmedi; her satırda kişiyi Excel’de listeden seçin.',

      title: 'Şablon',
      hint: 'Önce sezonun şablonunu indirin, kampanyanın formuna göre doldurun, sonra onu buraya yükleyin.',
      request: 'Şablonu Hazırla',
      requesting: 'Hazırlanıyor…',
      download: 'Şablonu İndir',
      pending: 'Şablon hazırlanıyor…',
      failed: 'Şablon hazırlanamadı.',
    },
    uploadCard: {
      title: 'Dosyayı Yükle',
      hint: 'Doldurduğunuz şablonu buraya yükleyin. Hiçbir satır, önizlemeyi görüp “Aktar” demeden bağış olarak kaydedilmez.',
      pickFile: 'Bir dosya seçin.',
      fileTooLarge: 'Dosya en çok {{size}} olabilir.',
      submit: 'Yükle',
      uploading: 'Yükleniyor…',
      putFailed: 'Dosya depoya yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.',
      created: 'Dosya yüklendi; okunması ve önizlemesi arka planda sürüyor.',
    },
    status: 'Durum',
    file: 'Dosya',
    counts: 'Satırlar',
    countsValue: '{{valid}} geçerli · {{refused}} reddedildi · {{created}} oluşturuldu',
    uploadedBy: 'Yükleyen',
    uploadedAt: 'Yüklendiği an',
    committedBy: 'Kaydeden',
    committedAt: 'Kaydedildiği an',
    empty: 'Yapılmış bir veri aktarımı yok',
    emptyHint: '“Veri Yükle” ile bir kampanya sezonunun listesini aktarın.',
    csvFile: 'veri-aktarimlari.csv',
    actions: {
      view: 'Aç',
      commit: 'Aktar',
      discard: 'Vazgeç',
    },
    detail: {
      back: 'Veri yüklemeye dön',
      caption: '{{campaign}} · {{season}} · {{uploadedBy}} · {{uploadedAt}}',
      waiting: 'Dosya okunuyor ve önizleniyor. Bu sayfa kendini yeniler.',
      committing: 'Bağışlar kaydediliyor. Bu sayfa kendini yeniler.',
      failed: 'Bu aktarım okunamadı.',
      discarded: 'Bu aktarımdan vazgeçildi; hiçbir satırı bağış olarak kaydedilmedi.',
      committed: 'Bu aktarımın satırları bağış olarak kaydedildi.',
      rawPurged:
        'Saklama süresi doldu: dosya {{date}} tarihinde silindi ve satırlardaki ad, telefon gibi veriler boşaltıldı. Satırların sonucu, tutarı ve oluşturduğu bağışlar duruyor.',
      summaryTitle: 'Özet',
      campaignTitle: 'Kampanya ve sezon',
      rowCount: 'Toplam satır',
      validCount: 'Geçerli',
      refusedCount: 'Reddedilen',
      createdCount: 'Oluşturulan',
      warningCount: 'Uyarılı',
      totalsTitle: 'Tutarlar',
      noTotals: 'Henüz tutar yok.',
    },
    rows: {
      recorderDefault: 'Toplu kayıt seçimi / yükleyen',
      title: 'Aktarım satırları',
      subheader: 'Dosyadaki her satır, girişin değerlendirdiği hâliyle',
      view: {
        all: 'Tümü',
        valid: 'Geçerli',
        refused: 'Reddedilen',
        created: 'Oluşturulan',
      },
      rowNumber: 'Satır',
      amount: 'Tutar',
      quantity: 'Adet',
      resolution: 'Bağışçı',
      issues: 'Sorunlar',
      empty: 'Bu görünümde satır yok',
      viewDonation: 'Bağışı aç',
    },
    resolution: {
      new: 'Yeni bağışçı',
      existing: 'Mevcut bağışçı',
      sameAsRow: '{{rowNumber}}. satırla aynı',
    },
    duplicateWarning: 'Olası mükerrer',
    commitDialog: {
      title: 'Aktarımı kaydet',
      content:
        '{{valid}} satır bağış olarak kaydedilecek{{duplicateNote}}. Bu aktarım hiçbir bildirim göndermez.',
      duplicateNote: ', bunlardan {{count}} tanesi olası mükerrer uyarısı taşıyor',
      operatorHint:
        'Bu seçim yalnızca kaydeden kişisi boş bırakılmış satırlara uygulanır; listeden kişi seçilmiş satırlar o kişinin adına ve güncel kurumuna kaydedilir. Fiilen yükleyen kişi kayıtçı ve işlem geçmişinin aktörü olarak korunur.',
      confirm: 'Aktar',
      done: 'Aktarım kaydedildi: {{created}} bağış oluşturuldu.',
    },
    discardDialog: {
      title: 'Aktarımdan vazgeç',
      content:
        'Bu aktarımın hiçbir satırı bağış olarak kaydedilmeyecek. Yüklenen dosya denetim için saklanır.',
      done: 'Aktarımdan vazgeçildi.',
    },
  },
  donationImportStatus: {
    uploaded: 'Yüklendi',
    processing: 'Okunuyor',
    preview: 'Önizleme',
    committing: 'Kaydediliyor',
    committed: 'Kaydedildi',
    failed: 'Okunamadı',
    discarded: 'Vazgeçildi',
  },
  queueReport: {
    sheetName: 'Kesim Raporu {{season}}',
    yes: 'Evet',
    no: 'Hayır',
    /** A queued share naming no `fulfillment_institution_id`: nothing is planned yet, so the report says so rather than printing the collecting institution as if the work were planned there. */
    notPlanned: 'Planlanmadı',
    columns: {
      groupNumber: 'Kesim sıra no',
      groupShares: 'Grubun hissesi',
      groupSize: 'Grup büyüklüğü',
      shares: 'Hisse',
      position: 'Sıra no',
      referenceCode: 'Referans kodu',
      donor: 'Bağışçı',
      onBehalfOf: 'Adına',
      place: 'Yurt',
      status: 'Durum',
      amount: 'Tutar',
    },
  },
  printout: {
    donationTitle: 'Bağış Çıktısı',
    queueSheetTitle: 'Grup Çizelgesi',
    queueSheetSubtitle: '{{campaign}} · {{season}} dönemi',
    queueSheetTotals: '{{records}} kayıt, {{shares}} hisse, {{groups}} grup',
    printedAt: 'Çıktı tarihi: {{at}}',
    queuePosition: 'Sıra No',
    answers: 'Form Cevapları',
    onBehalfOf: 'Adına Bağış Yapılan',
    reference: 'Referans Kişi',
    /** The unit label beside the count, never printed raw as the row's own label — docs/plans/10-operational-redesign.md §10.7. */
    quantityWithUnit: '{{quantity}} {{unit}}',
    signature: 'İmza / Teslim Alan',
    evidenceCode: 'Kanıt eşleştirme kodu',
    payerPhone: 'Bağış Yapan Telefonu',
    nothingToPrint: 'Çıktısı alınacak kayıt yok.',
    emptyQueue: 'Bu dönemin sırasında kayıt yok.',
    groupHeading: 'Kesim sıra no {{group}} · {{shares}}/{{units}} hisse',
    ungrouped: 'Sıra',
    columns: {
      position: 'Sıra',
      referenceCode: 'Referans',
      donor: 'Bağışçı',
      place: 'Yurt',
      shares: 'Hisse',
    },
  },

  paymentStatus: {
    unpaid: 'Ödenmedi',
    partially_settled: 'Kısmen Tahsil Edildi',
    settled: 'Tahsil Edildi',
    refunded: 'İade Edildi',
    reversed: 'Ters Kayıt',
    not_charged: 'Ücret Alınmaz',
  },
  scope: {
    self: 'Yalnızca kendisi',
    institution: 'Kurum',
    country: 'Ülke',
    zone: 'Mıntıka',
    region: 'Bölge',
    global: 'Global',
  },
  /**
   * The donor's own copy of what the organization holds — KVKK madde 11, GDPR
   * madde 15. Every string here is read by the donor, not by an operator, so
   * nothing names a column or a status code the way an admin screen may.
   */
  donorData: {
    title: 'Hakkınızda tuttuğumuz bilgiler',
    generatedAt: '{{at}} tarihinde hazırlandı',
    preamble:
      'Bu belge, kuruluşumuzun sizinle ilgili kayıtlarında tuttuğu bilgilerin tamamını içerir. Bağış tutarları, makbuz numaraları ve muhasebe kayıtları yasal saklama yükümlülüğümüz gereği kalır; kişisel bilgilerinizin silinmesini isteyebilirsiniz.',
    empty: 'Bu başlıkta kayıt bulunmuyor.',
    yes: 'Evet',
    no: 'Hayır',
    documentDeleted: 'Belge silindi',
    optedOut: 'vazgeçildi',
    privacyNote:
      'Veri talepleriniz ve bunlara verilen yanıtlar. Silme talebiniz, bağışlarınızın tutarlarını ve makbuz numaralarını kaldırmaz.',
    sections: {
      identity: 'Kimlik bilgileriniz',
      mergedRecords: 'Birleştirilen kayıtlar',
      donations: 'Bağışlarınız',
      donationParties: 'Bağışlarınızdaki kişiler ve kanıt gönderimleri',
      receipts: 'Makbuzlarınız',
      consents: 'İletişim izinleriniz',
      consentHistory: 'İzin geçmişiniz',
      communications: 'Size gönderilen iletiler',
      pledges: 'Düzenli bağış talimatlarınız',
      signIns: 'Hesap girişleriniz',
      privacyRequests: 'Veri talepleriniz',
    },
    fields: {
      id: 'Kayıt numarası',
      kind: 'Kayıt türü',
      name: 'Ad',
      taxId: 'Kimlik / vergi numarası',
      email: 'E-posta',
      phone: 'Telefon',
      address: 'Adres',
      country: 'Ülke',
      institution: 'Kayıtlı olduğunuz kurum',
      isAnonymous: 'Anonim bağışçı',
      isActive: 'Kayıt etkin',
      communicationConsent: 'İletişim izni',
      consentRecordedAt: 'İznin kaydedildiği an',
      consentSource: 'İznin kaynağı',
      createdAt: 'Kaydın oluşturulduğu an',
      updatedAt: 'Kaydın son güncellendiği an',
      erasedAt: 'Kişisel bilgilerin silindiği an',
    },
    columns: {
      record: 'Kayıt',
      name: 'Ad',
      at: 'Tarih',
      reference: 'Referans',
      campaign: 'Kampanya',
      amount: 'Tutar',
      quantity: 'Adet',
      status: 'Durum',
      receiptNo: 'Makbuz no',
      channel: 'Kanal',
      granted: 'İzin',
      grantedAt: 'İzin tarihi',
      withdrawnAt: 'Geri alma tarihi',
      source: 'Kaynak',
      action: 'İşlem',
      detail: 'Ayrıntı',
      event: 'Olay',
      subject: 'Konu',
      destination: 'Gönderilen adres',
      phone: 'Telefon',
      note: 'Not',
      frequency: 'Sıklık',
      email: 'E-posta',
      address: 'Adres',
      ip: 'IP adresi',
      userAgent: 'Tarayıcı',
      kind: 'Talep türü',
      onBehalfOf: 'Adına bağış yapılan',
      referencePerson: 'Referans',
      evidenceTo: 'Bildirim gönderilecekler',
    },
  },
  error: {
    ORGANIZATION_LOGO_INVALID:
      'Logo yüklemesi geçersiz. En fazla 5 MB boyutunda bir PNG veya JPEG seçin.',
    DONOR_ERASURE_ALREADY_ERASED: 'Bu bağışçının kişisel bilgileri zaten silinmiş.',
    DONOR_ERASURE_ALREADY_PROPOSED: 'Bu bağışçı için bekleyen bir silme talebi zaten var.',
    DONOR_ERASURE_NOT_PROPOSED: 'Bu silme talebi artık beklemede değil.',
    DONOR_ERASURE_NEEDS_A_SECOND_PERSON:
      'Bir silme talebini, onu açan kişi uygulayamaz. İkinci bir yetkili uygulamalıdır.',
    DONOR_ERASURE_NAME_MISMATCH: 'Yazdığınız ad bu bağışçının adıyla aynı değil.',
    DONOR_ERASURE_NOT_THE_ROOT_DONOR:
      'Silme, birleştirilmiş kayıtların tamamı için ana kayıt üzerinden yapılır.',
    NOTIFICATION_CHANNEL_UNSUPPORTED:
      'Bu bildirim bu kanaldan gönderilemez; başka bir kanal seçin.',
    NOTIFICATION_CHANNEL_NO_DESTINATION:
      'Bu kanal için kayıtlı bir adres yok. Önce bağışçının e-posta adresini veya telefon numarasını girin.',
    UNAUTHENTICATED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
    INVALID_CREDENTIALS: 'E-posta veya parola hatalı.',
    ACCOUNT_LOCKED:
      'Hesabınız çok sayıda hatalı denemeden dolayı geçici olarak kilitlendi. Lütfen daha sonra tekrar deneyin.',
    TOO_MANY_REQUESTS: 'Çok fazla deneme yapıldı. Lütfen biraz bekleyip tekrar deneyin.',
    CSRF_FAILED: 'Oturum doğrulaması başarısız. Sayfayı yenileyip tekrar deneyin.',
    TWO_FACTOR_REQUIRED: 'Rolünüz iki adımlı doğrulama gerektiriyor.',
    ARTIFACT_HOLDS_REAL_NAMES:
      'Bu dosya gerçek adlarla hazırlanmış. Okumak için önce Profil menüsünden “Rumuzları Çöz” ile gerçek adları açın.',
    REVEAL_REQUIRED:
      'Adlar rumuzlu görünürken bu alan değiştirilemez. Önce Profil menüsünden “Rumuzları Çöz” ile gerçek adları açın.',
    BAD_REQUEST: 'Girilen bilgiler geçersiz.',
    PERMISSION_DENIED: 'Bu işlem için yetkiniz yok. Erişim gerekiyorsa yöneticinizle görüşün.',
    forbiddenTitle: 'Erişim yetkiniz yok',
    backToDashboard: 'Genel Bakış’a dön',
    OUT_OF_SCOPE: 'Bu kayıt veri kapsamınızın dışında.',
    NOT_FOUND: 'Kayıt bulunamadı.',
    CONFLICT: 'Bu değerlere sahip bir kayıt zaten var.',
    JOB_FAILURE_NOT_OPEN:
      'Bu başarısız iş zaten yeniden denenmiş ya da kapatılmış. Listeyi yenileyip tekrar bakın.',
    SCHEDULED_JOB_ALREADY_RUNNING:
      'Bu işin bugünkü çalışması zaten sürüyor ya da kuyrukta bekliyor. Bitmesini bekleyin.',
    SCHEDULED_JOB_ALREADY_SUCCEEDED:
      'Bu işin bugünkü çalışması zaten başarıyla tamamlandı. Aynı gün için ikinci kez çalıştırılamaz.',
    JOB_FAILURE_NOT_RETRIABLE:
      'Bu iş yeniden denenemez: işi ya da kimlikleri artık geçerli değil. Yalnızca kapatılabilir.',
    EXCHANGE_RATE_ALREADY_ENTERED:
      'Bu para birimi için bu güne zaten elle bir kur girilmiş. Düzeltme için sonraki bir güne kur girin.',
    EXCHANGE_RATE_DAY_IN_FUTURE:
      'Kur günü bugünden sonra olamaz. Kurlar değiştirilemediği için ileri tarihli bir kur geri alınamaz.',
    VALIDATION_FAILED: 'Girilen bilgiler geçersiz.',
    LIST_VIEW_LIMIT_REACHED:
      'Bu liste için kayıtlı görünüm sınırına ulaştınız. Yeni bir tane eklemek için önce birini silin.',
    INVALID_STATUS_TRANSITION: 'Bu durum değişikliğine izin verilmiyor.',
    DONATION_BOX_CODE_TAKEN: 'Bu kumbara numarası zaten kullanılıyor.',
    DONATION_BOX_INVALID_TRANSITION: 'Kumbaranın mevcut durumunda bu işlem yapılamaz.',
    DONATION_BOX_CAMPAIGN_NOT_CONFIGURED:
      'Bu kumbara için bir kampanya dönemi tanımlanmamış. Önce kumbara kampanyasını ayarlayın.',
    DONATION_BOX_COLLECTION_ALREADY_CONFIRMED: 'Bu boşaltma zaten bir bağışa dönüştürülmüş.',
    DONATION_BOX_RETIRED: 'Kullanım dışı bırakılmış bir kumbara değiştirilemez.',
    DONATION_BOX_CHANGED_SINCE_READ:
      'Bu kumbara, siz düzenlerken başka biri tarafından değiştirildi. Değişikliklerinizi kaydetmeden önce güncel hâlini yükleyin.',
    CURRENCY_MISMATCH: 'Farklı para birimleri birleştirilemez.',
    NEGATIVE_AMOUNT: 'Tutar negatif olamaz.',
    SELF_DEACTIVATION: 'Kendi hesabınızı pasife alamazsınız.',
    SELF_EMAIL_CHANGE:
      'Kendi e-posta adresinizi buradan değiştiremezsiniz. Profilinizden isteyin; değişiklik yeni adrese gönderilen bağlantıyla tamamlanır.',
    ROLE_IS_SYSTEM: 'Sistem rolleri silinemez.',
    ROLE_IN_USE: 'Bu rolü taşıyan kullanıcılar var. Önce rolü onlardan kaldırın.',
    ROLE_SELF_LOCKOUT: 'Bu değişiklik kendi rol yönetim yetkinizi kaldırırdı.',
    PERMISSION_NOT_HELD: 'Kendinizde olmayan bir yetkiyi bir role veremezsiniz.',
    ROLE_NOT_GRANTABLE: 'Kendinizde olmayan yetkiler içeren bir rolü atayamazsınız.',
    USER_NOT_MANAGEABLE:
      'Sizde olmayan yetkilere sahip bir kullanıcı üzerinde değişiklik yapamazsınız.',
    USER_PHONE_INVALID:
      'Telefon numarasını ülke koduyla yazın; örneğin +905321234567. Numarayı silmek için alanı boş bırakın.',
    USER_TELEGRAM_CHAT_ID_TAKEN: 'Bu Telegram sohbet kimliği başka bir kullanıcıda kayıtlı.',
    USER_PHONE_TAKEN: 'Bu telefon numarası başka bir kullanıcıya kayıtlı.',
    PHONE_INVALID:
      'Bu telefon numarası geçerli değil. Ülkeyi listeden seçip numarayı eksiksiz yazın.',
    INTEGRATION_SENDER_UNKNOWN:
      'Bu telefon numarası hiçbir aktif kullanıcıya kayıtlı değil. Kullanıcı kartına numarayı ekleyin.',
    INTEGRATION_SENDER_PHONE_INVALID:
      'Gönderen numarasını ülke koduyla yazın; örneğin +905321234567.',
    INTEGRATION_SENDER_OUT_OF_SCOPE: 'Bu kullanıcı, entegrasyonun kapsamı dışında.',
    INTEGRATION_SENDER_MAY_NOT_ENTER: 'Bu kullanıcının bağış girme yetkisi yok.',
    INTEGRATION_CLIENT_UNSEALABLE:
      'Entegrasyonun imza anahtarı açılamadı. Anahtarı yeniden oluşturun.',
    UNKNOWN_PERMISSION: 'Tanınmayan yetki kodu.',
    CATEGORY_ORDER_INCOMPLETE:
      'Sıralama isteği kategorilerin tamamını içermiyor. Sayfayı yenileyip tekrar deneyin.',
    CAMPAIGN_PRICING_MODE_LOCKED:
      'Bir dönem taslaktan çıktığı için fiyatlandırma biçimi değiştirilemez.',
    CAMPAIGN_NO_CHARGE_HAS_PRICES:
      'Ücret almayan bir kampanyanın fiyatı olmaz. Önce dönemlerdeki fiyatları kaldırın.',
    CAMPAIGN_PRICE_NOT_CHARGED: 'Bu kampanya ücret almaz; fiyat tanımlanamaz.',
    CAMPAIGN_OWNER_SCOPE_NODE_REQUIRED: 'Global dışındaki bir kapsam için birim seçin.',
    CAMPAIGN_PERIOD_NOT_OPEN: 'Bu dönem şu anda bağış kabul etmiyor.',
    PORTAL_BASKET_CURRENCY_UNSUPPORTED:
      'Bu kampanya seçtiğiniz para biriminde bağış kabul etmiyor. Sepetinizden çıkarın veya para birimini değiştirin.',
    PORTAL_CAMPAIGN_FORM_UNPUBLISHED: 'Bu kampanyanın bağış formu henüz yayınlanmamış.',
    PORTAL_CAMPAIGN_NOT_CHARGED:
      'Bu hizmet için ücret alınmaz; sepete eklenemez. Talebiniz için kuruluşumuzla iletişime geçin.',
    PORTAL_CAMPAIGN_CHARGES_MONEY:
      'Bu kampanya ücretlendirilir; talep olarak gönderilemez, sepete ekleyin.',
    PORTAL_DONOR_EMAIL_REQUIRED: 'Bağışınızı isminizle yapmak için e-posta adresi gerekiyor.',
    PORTAL_DONOR_NAME_REQUIRED: 'Ad soyad girin veya isimsiz bağış yapmayı seçin.',
    EVIDENCE_LINK_UNAVAILABLE:
      'Bu bağlantı artık açılmıyor. Süresi dolmuş, geri alınmış ya da hiç geçerli olmamış olabilir.',
    PORTAL_ACCOUNT_LINK_INVALID:
      'Bu giriş bağlantısı geçersiz, kullanılmış ya da süresi dolmuş. Yeni bir bağlantı isteyin.',
    PORTAL_ACCOUNT_PRIVACY_REQUEST_OPEN:
      'Bu türde bir talebiniz zaten değerlendiriliyor. Sonuçlandığında size e-posta ile dönüş yapılacak.',
    PORTAL_ACCOUNT_RECEIPT_NOT_READY:
      'Makbuzunuzun PDF’i henüz hazır değil. Birkaç dakika sonra yeniden deneyin.',
    CAMPAIGN_IMAGE_UPLOAD_INVALID: 'Görsel yükleme isteği geçersiz. Yeniden deneyin.',
    CAMPAIGN_IMAGE_UPLOAD_EXPIRED: 'Görsel yükleme süresi doldu. Yeniden deneyin.',
    CAMPAIGN_IMAGE_UPLOAD_MISSING: 'Yüklenen dosya bulunamadı. Yeniden deneyin.',
    CAMPAIGN_IMAGE_TOO_LARGE: 'Görsel dosyası izin verilen boyutun üzerinde.',
    CAMPAIGN_IMAGE_TYPE_UNSUPPORTED: 'Yalnızca JPEG veya PNG görsel yüklenebilir.',
    CAMPAIGN_IMAGE_DAMAGED: 'Görsel dosyası okunamadı.',
    CAMPAIGN_IMAGE_TOO_LARGE_TO_DRAW: 'Görselin çözünürlüğü işlenebilir sınırların üzerinde.',
    CAMPAIGN_PRINTOUT_TEMPLATE_UNKNOWN:
      'Seçilen çıktı şablonu bulunamadı ya da kuruluşu yetki alanınızın tamamen içinde değil.',
    CAMPAIGN_STAFF_ASSIGNMENT_TAKEN:
      'Bu kampanya bu kurumda zaten görevlendirilmiş. Var olan görevlendirmeyi düzenleyin.',
    CAMPAIGN_STAFF_USER_INACTIVE: 'Pasif bir kullanıcı görevlendirilemez.',
    CAMPAIGN_STAFF_USER_DUPLICATE: 'Aynı kullanıcı birden fazla kez seçildi.',
    CAMPAIGN_STAFF_INSTITUTION_DUPLICATE: 'Aynı kurum birden fazla kez seçildi.',
    CAMPAIGN_STAFF_CAMPAIGN_ARCHIVED: 'Arşivlenmiş bir kampanyaya görevlendirme yapılamaz.',
    CAMPAIGN_STAFF_WINDOW_INVALID: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır.',
    CAMPAIGN_STAFF_PENDING_DONATIONS:
      'Bu kampanyanın bu kurumda gerçekleştirilmeyi bekleyen {{pendingDonations}} bağışı var. Devam etmek için bunu gördüğünüzü onaylayın.',
    PRINTOUT_TEMPLATE_IN_USE:
      'Bu şablonu kullanan kampanyalar var. Önce o kampanyalarda başka bir şablon seçin.',
    PRINTOUT_TEMPLATE_NAME_TAKEN: 'Bu kuruluşun aynı adda bir şablonu zaten var.',
    PRINTOUT_TEMPLATE_REQUIRED_BLOCK_MISSING: 'Şablonda görünür bir bağış kodu bulunmalıdır.',
    PRINTOUT_TEMPLATE_OCR_UNSAFE:
      'Bağış kodu en az 18 pt olmalı, arka planla en az 7:1 kontrast sağlamalı ve filigran üzerinde düz bir arka plan kullanmalıdır.',
    PRINTOUT_TEMPLATE_LAYOUT_INVALID:
      'Sayfa kenar boşluklarını, sütunları ve blok konumlarını kontrol edin; bloklar yazdırılabilir alana sığmalıdır.',
    PRINTOUT_TEMPLATE_MEDIA_INVALID:
      'Yalnızca en fazla 5 MB boyutunda PNG veya JPEG görseller yüklenebilir.',
    PRINTOUT_TEMPLATE_MEDIA_UNAVAILABLE:
      'Görsel bu kuruluşa ait değil, güvenlik taramasından geçmedi veya artık kullanılamıyor.',
    PRINTOUT_TEMPLATE_BLOCK_REPEATED: 'Aynı blok şablonda birden fazla kez yer alamaz.',
    PRINTOUT_TEMPLATE_BLOCK_TOO_SMALL:
      'Bağış kodu küçük boyutta basılamaz; fotoğraftan okunabilmesi gerekir.',
    CAMPAIGN_PERIOD_WINDOW_INVALID: 'Dönemin bitişi başlangıcından sonra olmalıdır.',
    CAMPAIGN_PERIOD_OVERLAPS_OPEN_PERIOD:
      'Bu kampanyanın aktif veya duraklatılmış başka bir dönemi bu tarihlerle çakışıyor. Önce açık dönemin bitiş tarihini kısaltın.',
    CAMPAIGN_PERIOD_FIELD_LOCKED: 'Dönemin mevcut durumunda bu alanlar değiştirilemez.',
    CAMPAIGN_PERIOD_PRICES_LOCKED:
      'Kapanmış bir dönemin fiyat listesine fiyat eklenemez, fiyat değiştirilemez veya silinemez.',
    CAMPAIGN_PERIOD_BACKDATE_ONLY_ON_CLOSE:
      'Geriye dönük kayıt son tarihi yalnızca dönem kapatılırken belirlenir.',
    CAMPAIGN_PERIOD_BACKDATE_BEFORE_CLOSE:
      'Geriye dönük kayıt son tarihi kapanış anından önce olamaz.',
    CAMPAIGN_PERIOD_ASSIGNMENTS_LOCKED: 'Kapanmış bir dönemin görevlendirmeleri değiştirilemez.',
    CAMPAIGN_PERIOD_ASSIGNMENT_WITHOUT_PRIMARY:
      'Dönem taslaktan çıkarılamaz: {{count}} aktif yurdun birincil görevlisi yok. Kampanya Görevlendirmeleri ekranından her aktif yurda, aktif bir görevlendirmede en az bir birincil görevli atayın.',
    CAMPAIGN_ASSIGNMENT_INSTITUTION_TAKEN: 'Bu kurum bu dönemde zaten görevlendirilmiş.',
    CAMPAIGN_ASSIGNMENT_INSTITUTION_INACTIVE: 'Pasif bir kurum görevlendirilemez.',
    CAMPAIGN_ASSIGNMENT_IN_USE:
      'Bu dönemde bu yurdu seçen bağışlar var (çöp kutusundakiler ve iptal edilenler dahil), bu yüzden görevlendirme kaldırılamaz. Kaldırmak yerine görevlendirmeyi pasife alın.',
    CAMPAIGN_ASSIGNMENT_COPY_SAME_PERIOD: 'Bir dönem kendi görevlendirmelerini kopyalayamaz.',
    CAMPAIGN_ASSIGNMENT_COPY_OTHER_CAMPAIGN:
      'Görevlendirmeler yalnızca aynı kampanyanın başka bir döneminden kopyalanabilir.',
    CAMPAIGN_CAPABILITY_DUPLICATE: 'Aynı yetkinlik birden fazla kez işaretlenmiş.',
    CAMPAIGN_CAPABILITY_FIELD_UNKNOWN:
      'Filtre alanı kampanyanın yayımlanmış bir seçim alanı değil. Formu yayımlayın veya başka bir alan seçin.',
    CAMPAIGN_GROUPING_FIELD_UNKNOWN:
      '“{{fieldKey}}” kampanyanın yayımlanmış formunda gruplamaya uygun bir alan değil ya da iki kez seçilmiş. Gruplama cevabı yalnızca yayımlanmış bir seçim, seçenek düğmesi veya onay kutusu olabilir ve her biri bir kez seçilir.',
    CAMPAIGN_GROUPING_FIELDS_LOCKED:
      'Bu kampanyada gerçekleştirilmiş bir hisse var; gruplama cevapları artık değiştirilemez, çünkü değişiklik kesilmiş hayvanların gruplarını yeniden çizer.',
    CAMPAIGN_PRICE_FIELD_UNKNOWN:
      '“{{fieldKey}}” kampanyanın yayımlanmış formunda fiyatı belirleyebilecek bir alan değil ya da iki kez seçilmiş. Fiyatı belirleyen cevap yalnızca yayımlanmış bir seçim, seçenek düğmesi veya onay kutusu olabilir ve her biri bir kez seçilir.',
    CAMPAIGN_PRICE_FIELDS_IN_USE:
      'Bu kampanyanın dönemlerinde cevaba göre girilmiş fiyatlar var; fiyatı belirleyen alanlar değiştirilemez. Önce Dönemler sekmesinden bu fiyatları kaldırın.',
    CAMPAIGN_PRICE_CONDITION_INVALID:
      'Bu fiyat, kampanyanın fiyatı belirleyen alanlarının her birine o alanın sunduğu bir cevapla bağlanmalı. Cevap kombinasyonunu formdaki seçeneklerden seçin.',
    CAMPAIGN_PRICE_ANSWER_IN_USE:
      'Bir dönemin fiyatı “{{fieldKey}}” alanının bu cevabına bağlı; form bu cevabı kaldıramaz ya da alanın türünü değiştiremez. Önce o fiyatı kaldırın.',
    CAMPAIGN_GROUP_SIZE_FIELD_UNKNOWN:
      '“{{fieldKey}}” kampanyanın yayımlanmış formunda bir seçim ya da seçenek düğmesi değil. Grup büyüklüğü yalnızca seçenekleri olan bir alanın cevabına göre belirlenebilir.',
    CAMPAIGN_GROUP_SIZE_FIELD_NOT_GROUPED:
      '“{{fieldKey}}” grup büyüklüğünü belirliyorsa kesim gruplamasında da seçili olmalı ve kampanyanın grup başına birimi girilmiş olmalı; böylece bir hayvan iki farklı büyüklükte hisse taşımaz.',
    CAMPAIGN_GROUP_SIZE_OPTION_UNKNOWN:
      '“{{fieldKey}}” alanında “{{option}}” diye bir seçenek yok; grup büyüklüğü yalnızca alanın kendi seçeneklerine verilebilir.',
    CAMPAIGN_READINESS_FIELD_UNKNOWN:
      '“{{fieldKey}}” kampanyanın yayımlanmış formunda bir onay kutusu değil. Sıraya alma koşulu yalnızca yayımlanmış bir onay kutusu olabilir; formu yayımlayın veya koşulu kaldırın.',
    CAMPAIGN_CAPABILITY_FIELD_OPTION_NOT_A_TAG:
      'Yurt filtrelemede kullanılan “{{fieldKey}}” alanının “{{option}}” seçeneği bir yetkinlik olamaz: yetkinlik değeri küçük harfle başlar ve yalnızca küçük harf, rakam ve alt çizgi içerir. Seçenek değerini değiştirin veya alanı yurt filtrelemeden çıkarın.',
    CAMPAIGN_ASSIGNMENT_CAPABILITY_MISSING:
      'Seçilen yurt formdaki cevapları yürütemiyor. Yurdu veya cevabı değiştirin.',
    CAMPAIGN_PRICE_DEFAULT_REQUIRED:
      'Her dönemin bir varsayılan fiyatı olmalıdır. Önce başka bir fiyatı varsayılan yapın.',
    CAMPAIGN_PRICE_UNIT_REQUIRED: 'Birim fiyatlı kampanyada sıfırdan büyük bir birim fiyatı girin.',
    CAMPAIGN_PRICE_SUGGESTED_REQUIRED: 'Önerilen tutarlı kampanyada en az bir tutar girin.',
    CAMPAIGN_PRICE_SUGGESTED_OUT_OF_BOUNDS:
      'Önerilen tutarlar en az ve en çok tutar arasında olmalıdır.',
    CAMPAIGN_PRICE_BOUNDS_INVALID: 'En az tutar, en çok tutardan büyük olamaz.',
    CAMPAIGN_PRICE_INVALID: 'Fiyat satırı bu fiyatlandırma biçimine uymuyor.',
    DONOR_NAME_REQUIRED: 'Anonim olmayan bir bağışçının adı girilmelidir.',
    DONOR_SIGNAL_INCOMPLETE:
      'Sorgu için e-posta adresinin veya telefon numarasının tamamı girilmelidir.',
    DONOR_ALREADY_MERGED: 'Bu kayıt zaten başka bir kayda birleştirilmiş.',
    DONOR_SURVIVOR_ALREADY_MERGED:
      'Kalan kayıt kendisi de birleştirilmiş. Önce onun birleştirmesini geri alın.',
    DONOR_MERGE_SAME_ROW: 'Bir kayıt kendisiyle birleştirilemez.',
    DONOR_NOT_MERGED: 'Bu kayıt birleştirilmemiş.',
    DONOR_LINK_REQUEST_CLOSED: 'Bu bağlantı talebi zaten yanıtlanmış veya süresi dolmuş.',
    DONOR_REPORT_SCOPE_TOO_NARROW:
      'Mükerrer raporu en az mıntıka kapsamındaki kullanıcılar tarafından çalıştırılabilir.',
    DONOR_PAYER_PHONE_INCOMPLETE:
      'Telefon numarasının tamamını girin; alan kodu olmadan numara eşleştirilemez.',
    DONOR_PAYER_AMBIGUOUS:
      'Bu telefon numarası birden fazla bağışçıda kayıtlı. Listeden doğru bağışçıyı seçin.',
    CAMPAIGN_FORM_VERSION_STALE:
      'Form siz düzenlerken yeniden yayımlandı. Sayfayı yenileyip değişikliklerinizi güncel sürüm üzerinde yapın.',
    FORM_FIELD_KEY_INVALID:
      'Alan anahtarı küçük harfle başlamalı; yalnızca küçük harf, rakam ve alt çizgi içerebilir (en çok 40 karakter).',
    FORM_FIELD_KEY_DUPLICATE: 'Bu alan anahtarı formda birden fazla kez kullanılmış.',
    FORM_VISIBLE_ON_SELF_REFERENCE: 'Bir alanın görünürlüğü kendisine bağlanamaz.',
    FORM_VISIBLE_ON_UNKNOWN_FIELD: 'Görünürlük koşulu formda bulunmayan bir alana bağlı.',
    FORM_VISIBLE_ON_NOT_ONE_LEVEL:
      'Görünürlük koşulu, kendisi de koşula bağlı olan bir alana bağlanamaz.',
    FORM_PATTERN_TOO_LONG: 'Desen en çok 200 karakter olabilir.',
    FORM_PATTERN_UNCOMPILABLE: 'Desen geçerli bir düzenli ifade değil.',
    FORM_DATE_INVALID: 'Tarih YYYY-AA-GG biçiminde olmalıdır.',
    FORM_FIELD_REQUIRED: 'Bu alan zorunludur.',
    FORM_VALUE_TOO_SHORT: 'En az {{minLength}} karakter olmalıdır.',
    FORM_VALUE_TOO_LONG: 'En çok {{maxLength}} karakter olabilir.',
    FORM_VALUE_PATTERN: 'Değer beklenen biçime uymuyor.',
    FORM_VALUE_NOT_AN_EMAIL: 'Geçerli bir e-posta adresi girin.',
    FORM_VALUE_NOT_A_PHONE:
      'Geçerli bir telefon numarası girin. Ülkeyi listeden seçip numarayı eksiksiz yazın.',
    FORM_VALUE_NOT_INTEGER: 'Tam sayı girin.',
    FORM_VALUE_TOO_SMALL: 'En az {{min}} olmalıdır.',
    FORM_VALUE_TOO_LARGE: 'En çok {{max}} olabilir.',
    FORM_VALUE_OFF_STEP: 'Değer {{step}} adımlarla girilmelidir.',
    FORM_VALUE_NOT_A_DATE: 'Geçerli bir tarih girin.',
    FORM_VALUE_BEFORE_MIN_DATE: 'Tarih {{minDate}} veya sonrası olmalıdır.',
    FORM_VALUE_AFTER_MAX_DATE: 'Tarih {{maxDate}} veya öncesi olmalıdır.',
    FORM_VALUE_MUST_BE_ACCEPTED: 'Devam etmek için bu kutuyu işaretleyin.',
    FORM_VALUE_TOO_FEW_SELECTED: 'En az {{minSelected}} seçim yapın.',
    FORM_VALUE_TOO_MANY_SELECTED: 'En çok {{maxSelected}} seçim yapabilirsiniz.',
    FORM_VALUE_NOT_A_FILE: 'Bu alan için geçerli bir dosya seçilmedi.',
    FORM_VALUE_TOO_MANY_FILES: 'En çok {{maxCount}} dosya eklenebilir.',
    FORM_VALUE_NOT_AN_OPTION: 'Listedeki seçeneklerden birini seçin.',
    PRICING_VIOLATION: {
      AMOUNT_REQUIRED: 'Lütfen bağış tutarını girin.',
      AMOUNT_NOT_CHARGED: 'Bu kampanya ücret almaz; bir tutar girilemez.',
      AMOUNT_BELOW_MINIMUM: 'Bağış tutarı en az {{minAmount}} olmalıdır.',
      AMOUNT_ABOVE_MAXIMUM: 'Bağış tutarı en çok {{maxAmount}} olabilir.',
      AMOUNT_OUT_OF_RANGE: 'Bağış tutarı kabul edilebilir aralığın dışında.',
      CURRENCY_UNSUPPORTED: 'Bu dönemde {{currency}} ile bağış alınmıyor.',
      QUANTITY_INVALID: 'Adet 1 veya daha büyük bir tam sayı olmalıdır.',
      UNIT_PRICE_MISSING: 'Bu para birimi için birim fiyatı tanımlanmamış.',
    },
    DONATION_DATE_OUTSIDE_PERIOD:
      'Bağış tarihi seçilen dönemin tarih aralığının dışında. Tarihi düzeltin veya bağışı ait olduğu döneme girin.',
    DONATION_DATE_IN_FUTURE: 'Bağış tarihi ileri bir tarih olamaz.',
    DONATION_BACKDATE_NOT_PERMITTED:
      'Geçmiş bir güne bağış girmek için “geriye dönük kayıt” yetkisi gerekir.',
    CAMPAIGN_PERIOD_CLOSED:
      'Bu dönem kapandı ve geriye dönük kayıt süresi doldu. Bağışı ait olduğu döneme girin.',
    COLLECTION_NOT_PERMITTED: 'Bu kampanya için bağış toplamaya yetkili bir kurum değilsiniz.',
    CAMPAIGN_INSTITUTION_NOT_ASSIGNED:
      'Seçilen kurum bu dönemde görevlendirilmiş değil; fiyat hesaplanamaz.',
    CAMPAIGN_INSTITUTION_NOT_ON_FORM:
      'Seçilen kurum bu dönemde bağış formlarında gösterilmiyor; başka bir yurt/kurum seçin.',
    DONATION_DONOR_REQUIRED: 'Bağış için bir bağışçı seçin.',
    DONATION_RECORDING_INSTITUTION_LOCKED:
      'Kayıt kurumunu değiştirmeden önce bağışın gerçekleşme kayıtlarını geri alın.',
    DONATION_RECORDING_PRINTOUT_LIST_ACTIVE:
      'Kayıt kurumunu değiştirmeden önce bağışı etkin PDF listesinden çıkarın veya listeyi iptal edin. Kurumu düzelttikten sonra yeni bir liste oluşturun.',
    DONATION_RECORDING_PAYMENT_LINK_ACTIVE:
      'Etkin ödeme bağlantısı varken kayıt kurumu değiştirilemez. Bağlantının süresi dolduktan sonra tekrar deneyin.',
    DONATION_NOT_EDITABLE:
      'Bu bağış bu durumdayken düzenlenemez. İptal edilmiş bir bağış düzeltilemez.',
    DONATION_EDIT_REQUIRES_UNPAID:
      'Bu bağışa para girişi yapılmış. Tutar, adet, yurt ve fiyatı belirleyen cevaplar değiştirilemez; önce eşleştirmeyi geri alın. Diğer alanlar düzenlenebilir.',
    DONATION_EDIT_LOCKED_LISTED:
      'Bu bağış bir PDF listesinde. Listedeki bir bağışı yalnızca kilitli bağışları düzenleme yetkisi olan bir yönetici düzenleyebilir.',
    DONATION_EDIT_LOCKED_FULFILLED:
      'Bu bağış gerçekleşti. Gerçekleşmiş bir bağışı yalnızca kilitli bağışları düzenleme yetkisi olan bir yönetici düzenleyebilir.',
    DONATION_FULFILLED_FINANCIAL_LOCKED:
      'Gerçekleşmiş bir bağışın tutarı, adedi, dönemi, tarihi, yurdu ve fiyatı belirleyen cevapları değiştirilemez. Önce gerçekleşmeyi geri alın.',
    DONATION_FULFILLED_GROUPING_LOCKED:
      'Gerçekleşmiş bir bağışın gruplamayı belirleyen cevapları değiştirilemez; hayvanı bu cevaplarla kesildi. Önce gerçekleşmeyi geri alın.',
    DONATION_PARTLY_FULFILLED_LOCKED:
      'Bu bağışın bazı hisseleri kesildi; adedi, dönemi, yurdu ve fiyatı, yurdu ya da gruplamayı belirleyen cevapları değiştirilemez. Önce gerçekleşmeyi geri alın veya kalan hisseleri iptal edin.',
    DONATION_EDIT_PRINTOUT_LIST_ACTIVE:
      'Bu bağış etkin bir PDF listesinde; yurdu ve dönemi değiştirilemez. Önce bağışı listeden çıkarın veya listeyi iptal edin, düzelttikten sonra yeni bir liste oluşturun.',
    DONATION_DONOR_RECEIPT_ACTIVE:
      'Bu bağışın geçerli makbuzu bağışçının adını taşıyor; ödeme yapan kişi değiştirilemez. Önce makbuzu iptal edip yeniden düzenleyin. Diğer alanlar düzenlenebilir.',
    DONATION_CHANGED_SINCE_READ:
      'Bu bağış, siz düzenlerken başka biri tarafından değiştirildi. Değişikliklerinizi kaydetmeden önce güncel hâlini yükleyin.',
    DONATION_PERIOD_CAMPAIGN_MISMATCH:
      'Seçilen dönem başka bir kampanyaya ait. Bağış yalnızca kendi kampanyasının dönemleri arasında taşınabilir.',
    DONATION_INVALID_TRANSITION: 'Bu bağış bulunduğu durumdan bu işleme geçemez.',
    DONATION_CANCEL_REQUIRES_REVERSAL:
      'Tahsilatı olan bir bağışı iptal etmek için “mutabakat ters kaydı” yetkisi gerekir.',
    DONATION_CANCEL_OUTCOME_REQUIRED:
      'Tahsilatı olan bir bağış iptal edilirken paranın ne olacağı seçilmelidir: bağışçıya iade mi, yoksa ters kayıtla eşleşmeden çıkarılması mı.',
    RECONCILIATION_LINE_CHANGED:
      'Bu hareket siz görüntüledikten sonra başka biri tarafından eşleştirildi. Hareketi yeniden yükleyip tekrar deneyin.',
    RECONCILIATION_LINE_NOT_MATCHABLE:
      'Yalnızca hariç tutulmamış, bağış ödemesi olarak sınıflanmış gelen hareketler bağışlarla eşleştirilebilir.',
    RECONCILIATION_DONATION_NOT_MATCHABLE:
      'Bu bağış şu anki durumunda ödeme alamaz (taslak, reddedilmiş, iptal edilmiş, tahsil edilmiş veya iade edilmiş).',
    RECONCILIATION_OVER_ALLOCATED: 'Dağıtılan tutar, hareketin kalan tutarını aşıyor.',
    RECONCILIATION_EXCEEDS_OUTSTANDING: 'Dağıtılan tutar, bağışın kalan borcunu aşıyor.',
    RECONCILIATION_BASKET_LINE_MISMATCH:
      'Kalan tutar için açılan bağışın tutarı hareketin kalan tutarına eşit değil; hareketi yeniden okuyup tekrar deneyin.',
    RECONCILIATION_BASKET_LINE_TOO_SMALL:
      'Hareketin kalan tutarı sepetin toplamından az; sepet toplamına eşit veya daha büyük bir hareket seçin.',
    RECONCILIATION_BASKET_NEEDS_DONATION_AMOUNTS:
      'Hareketle farklı para biriminde olan bir sepet, her bağışa alınacak tutarla eşleştirilir; ekranı yenileyip tekrar deneyin.',
    RECONCILIATION_ORGANIZATION_NOT_LINKED:
      'Bu bağışın kurumu, hareketin ait olduğu hesabın tüzel kişiliğine bağlı değil; eşleştirilemez.',
    RECONCILIATION_ORGANIZATION_MISMATCH:
      'Bu bağış, hareketin ait olduğu hesabın tüzel kişiliğine ait değil. Önce parayı doğru tüzel kişiliğe aktarın.',
    RECONCILIATION_RATE_UNAVAILABLE:
      'Hareketin kur gününde bağışın para birimi için kur bulunamadı; farklı para birimli eşleştirme yapılamaz.',
    RECONCILIATION_MOVEMENT_RATE_PENDING:
      'Hareketin döviz karşılıkları henüz hesaplanmadı (Kur bekleniyor). Farklı para birimli eşleştirme, kurlar gelip hareket karşılıklarını aldıktan sonra yapılabilir.',
    RECONCILIATION_REMAINDER_NOTHING_LEFT: 'Hareketten kalan tutar yok.',
    RECONCILIATION_REMAINDER_NO_DONOR:
      'Bağışın bağışçısı bulunmadığı için kalan tutara yeni bağış açılamaz.',
    RECONCILIATION_REMAINDER_CAMPAIGN_NOT_FREE:
      'Kalan tutar yalnızca serbest tutarlı bir kampanyada bağışa dönüştürülebilir.',
    RECONCILIATION_REMAINDER_NOT_MATCHED:
      'Kalan tutar için bağış oluşturuldu ancak hareketle eşleştirilemedi. Bağış, bağışçının açık bağışı olarak duruyor; sayfasından hareketle eşleştirebilir ya da silebilirsiniz.',
    DONATION_MAIN_ORGANIZATION_INACTIVE: 'Pasif bir kuruluş ana kuruluş olarak seçilemez.',
    DONATION_MAIN_ORGANIZATION_NOT_ALLOWED:
      'Ana kuruluş, bağışın kurumuna bağlı bir kuruluş ya da bağışa onaylanmış eşleştirmesi olan bir hareketin kuruluşu olmalıdır.',
    DONATION_MAIN_ORGANIZATION_RECEIPT_ACTIVE:
      'Bağış için geçerli bir makbuz kesilmiş ve makbuz başka bir kuruluş adına düzenlenmiş. Ana kuruluşu değiştirmeden önce makbuzu iptal edip yeniden kesin.',
    RECONCILIATION_REMAINDER_ALREADY_OPENED:
      'Bu hareketin kalan tutarı için bağış zaten açılmış. Hareketi yeniden yükleyip kalan tutarı kontrol edin.',
    RECONCILIATION_REMAINDER_SOURCE_NOT_MATCHED:
      'Kaynak bağış, bu hareketle onaylanmış ya da onay bekleyen bir eşleştirmeye sahip değil; kalan tutar için yeni bağış yalnızca hareketi kapatan bağışın bağışçısı adına açılabilir.',
    RECONCILIATION_ALREADY_REVERSED: 'Bu eşleştirme zaten geri alınmış.',
    RECONCILIATION_NOT_CONFIRMED: 'Yalnızca onaylanmış bir eşleştirme geri alınabilir.',
    RECONCILIATION_NOT_PENDING: 'Bu eşleştirme onay beklemiyor.',
    RECONCILIATION_PROVIDER_MATCH_LOCKED:
      'Kartla alınan bir ödemenin eşleştirmesi geri alınamaz; yalnızca iade veya ters ibraz (chargeback) ile düzeltilir.',
    RECONCILIATION_PROVIDER_ACCOUNT_MISMATCH:
      'Kart ödemesinin bildirildiği hesap bu ödeme sağlayıcısına ait değil ya da para birimi farklı; ödeme kaydedilmedi.',
    RECONCILIATION_PROVIDER_AMOUNT_MISMATCH:
      'Kart ödemesinin tutarı veya para birimi bağışınkiyle aynı değil; ödeme kaydedilmedi.',
    RECONCILIATION_PROVIDER_TRANSACTION_CONFLICT:
      'Bu sağlayıcı işlem numarası başka bir hesapta, tutarda veya bağışta zaten kayıtlı; bildirim kaydedilmedi.',
    RECONCILIATION_PROVIDER_PAYMENT_UNKNOWN:
      'Geri alınmak istenen kart ödemesi henüz kaydedilmemiş. Sağlayıcı bildirimi yeniden gönderdiğinde işlenecek.',
    RECONCILIATION_PROVIDER_PARTIAL_REVERSAL:
      'Kart ödemesinin kısmi iadesi veya kısmi ters ibrazı otomatik işlenmez; bir yetkilinin incelemesi gerekir.',
    RECONCILIATION_PROVIDER_CARD_NUMBER_UNMASKED:
      'Kart numarası maskelenmemiş geldi; kart numarası sisteme kaydedilmez ve ödeme kaydedilmedi.',
    RECONCILIATION_PROVIDER_PAYMENT_METHOD_MISMATCH:
      'Kart ödemesi, ödeme yöntemi kart olmayan bir bağışa bildirildi; ödeme kaydedilmedi.',
    PAYOUT_BANK_LINE_NOT_SETTLEMENT:
      'Yalnızca hariç tutulmamış, kart ödemesi (POS/Stripe aktarımı) olarak sınıflanmış gelen bir banka hareketinin mutabakatı yapılabilir.',
    PAYOUT_BANK_LINE_RECONCILED:
      'Bu banka hareketinin mutabakatı zaten yapılmış. Değiştirmek için önce o mutabakatı geri alın.',
    PAYOUT_CAPTURE_ACCOUNT_NOT_PROVIDER:
      'Kart tahsilatları yalnızca bir sanal POS veya Stripe hesabından okunur.',
    PAYOUT_CAPTURE_NOT_ELIGIBLE:
      'Seçilen tahsilatlar bu banka hareketine ait olamaz: hepsi aynı sanal POS veya Stripe hesabından, banka hareketiyle aynı tüzel kişilik ve para biriminde doğrulanmış kart tahsilatları olmalıdır.',
    PAYOUT_CAPTURE_ALREADY_PAID_OUT:
      'Seçilen tahsilatlardan biri başka bir onaylı ödeme mutabakatında yer alıyor. Listeyi yenileyip tekrar deneyin.',
    PAYOUT_AMOUNT_MISMATCH:
      'Seçilen tahsilatların toplamından komisyon ve sağlayıcının mahsup ettiği iade, itiraz ve itiraz ücretleri düşüldüğünde banka hareketinin tutarı çıkmıyor. Listeyi yenileyip tahsilatları kontrol edin.',
    PAYOUT_NO_CAPTURES: 'Mutabakat için en az bir tahsilat seçilmelidir.',
    PAYOUT_TOO_MANY_CAPTURES:
      'Bu tarih aralığında bir mutabakata sığmayacak kadar çok tahsilat var. Aralığı daraltın.',
    PAYOUT_WINDOW_INVALID:
      'Tarih aralığı geçersiz: bitiş başlangıçtan önce olamaz ve aralık {{maxDays}} günden uzun olamaz.',
    PAYOUT_NOT_CONFIRMED: 'Yalnızca onaylı bir ödeme mutabakatı geri alınabilir.',
    PAYOUT_REPORT_UNAVAILABLE:
      'Ödeme sağlayıcısının hesap dökümüne şu anda ulaşılamıyor. Komisyon ve mahsupları elle girebilir ya da sonra tekrar deneyebilirsiniz.',
    PAYOUT_REPORT_REFUSED:
      'Ödeme sağlayıcısı hesap dökümü isteğini reddetti. Kuruluşun sağlayıcı anahtarını kontrol edin.',
    PAYOUT_REPORT_UNREADABLE:
      'Ödeme sağlayıcısının hesap dökümü okunamadı; tutarlar tek para biriminde ve eksiksiz olmalıdır.',
    PAYOUT_DEDUCTION_NOT_A_REVERSAL:
      'Ödemeden düşülen bir iade ya da itiraz, bu hesaba ait ve gerçekten ters kaydedilmiş bir tahsilatı göstermelidir.',
    PAYOUT_DEDUCTION_ALREADY_TAKEN:
      'Bu iade ya da itiraz başka bir onaylı ödeme mutabakatından düşülmüş. Listeyi yenileyip tekrar deneyin.',
    RECONCILIATION_DONATION_REFUNDED: 'Bu bağışın parası iade sürecinde; eşleştirme geri alınamaz.',
    RECONCILIATION_SELF_APPROVAL:
      'Onay bekleyen bir eşleştirmeyi ya da elle kaydedilmiş bir ödemeyi kaydeden kişi onaylayamaz; onayı başka bir yetkili vermelidir.',
    RECONCILIATION_REVERSE_OTHER_MATCHES:
      'Bu bağışın başka onaylı eşleştirmeleri var. Ters kayıttan önce onları geri alın.',
    RECONCILIATION_RECEIPT_ACTIVE:
      'Bu bağışın geçerli bir makbuzu var. Parayı geri almadan önce makbuzu iptal edin; makbuz iptali ayrıca kayda geçen bir işlemdir.',
    DONATION_CANCEL_RECEIPT_ACTIVE:
      'Geçerli makbuzu olan bir bağış iptal edilemez. Önce makbuzu iptal edin; makbuz iptali ayrıca kayda geçen bir işlemdir.',
    DONATION_CANCEL_FULLY_FULFILLED:
      'Bu bağışın bütün hisseleri kesildi; gerçekleştirilmiş bir bağış iptal edilemez.',
    DONATION_CANCEL_REMAINDER_UNPRICED:
      'Bu bağışın hisse başına fiyatı yok; kesilen hisseler bir birim fiyatla bırakılıp kalanı iptal edilemez.',
    DONATION_CANCEL_REMAINDER_NOT_SPLITTABLE:
      'Kesilmeyen hisselerin iadesi bir kart tahsilatının ya da farklı para birimindeki bir eşleşmenin yalnızca bir kısmını geri almayı gerektiriyor; bu kısmi iade otomatik yapılamaz.',
    DONATION_ALREADY_DELETED: 'Bu bağış zaten silinmiş; Silinen Kayıtlar listesinde.',
    DONATION_DELETION_REASON_REQUIRED: 'Silme gerekçesi en az 10 karakter olmalıdır.',
    DONATION_UNFULFILL_REASON_REQUIRED: 'Geri alma gerekçesi en az 10 karakter olmalıdır.',
    DONATION_UNFULFILL_REMAINDER_CANCELLED:
      'Bu bağışın kesilmeyen hisseleri iptal edilmiş; tutarı yapılan işe göre düşürüldüğü için gerçekleşti işareti geri alınamaz.',
    DONATION_UNFULFILL_EVIDENCE_OFFERED:
      'Bu bağışın kanıtı bir kişiye gönderildi ya da gönderilmek üzere; gerçekleşti işareti artık geri alınamaz.',
    DONATION_ANIMAL_NOT_QUEUED:
      'Bu hisse henüz sıraya alınmadı; hayvanıyla birlikte gerçekleşebilmesi için önce sıraya alın.',
    UNCHANGED: 'Zaten bu durumdaydı.',
    DONATION_DELETE_NOT_ALLOWED:
      'Yalnızca bekleyen ya da sıraya alınmış bir bağış silinebilir. Gerçekleşmiş bir bağış silinmez, iptal edilir.',
    DONATION_DELETE_HAS_PAYMENT:
      'Bu bağışa ödeme ulaşmış; silinemez. Kaydı geri çekmek için iptal edin.',
    DONATION_DELETE_HAS_RECONCILIATION:
      'Bu bağışa bir banka hareketi eşleştirilmiş ya da önerilmiş; silinemez. Kaydı geri çekmek için iptal edin.',
    DONATION_DELETE_HAS_RECEIPT: 'Bu bağış için makbuz düzenlenmiş; silinemez.',
    DONATION_DELETE_PAYMENT_LINK_OPEN:
      'Bu bağış için açık ya da ödenmiş bir ödeme bağlantısı var; silinemez.',
    DONATION_DELETE_SHARES_CARRIED_OUT:
      'Bu bağışın bazı hisseleri kesilmiş bir hayvana kaydedildi; silinemez.',
    DONATION_DELETE_PRINTED:
      'Bu bağışın sayfası yazdırılıp sahaya verildi; silinemez. Gerekirse iptal edin.',
    DONATION_DELETE_HAS_EVIDENCE: 'Bu bağış için kanıt (fotoğraf ya da video) gelmiş; silinemez.',
    DONATION_DELETE_BOX_COLLECTION:
      'Bu bağış bir kumbara boşaltmasının kaydı; sayılan nakit silinemez, iptal edilir.',
    DONATION_NOT_DELETED: 'Bu bağış silinmemiş.',
    DONATION_RESTORE_PERIOD_CLOSED: 'Bağışın dönemi kapanmış; silinen kayıt geri alınamaz.',
    DONATION_RESTORE_ASSIGNMENT_INACTIVE:
      'Bağışın yurdu artık bu döneme atanmış değil; silinen kayıt geri alınamaz.',
    RECEIPT_DONATION_NOT_SETTLED:
      'Makbuz yalnızca tahsilatı tamamlanmış bir bağış için düzenlenir.',
    RECEIPT_DONATION_NO_DONOR:
      'Bağışçısı olmayan bir bağış (kumbara boşaltması) için makbuz düzenlenmez.',
    RECEIPT_ALREADY_ISSUED: 'Bu bağışın zaten geçerli bir makbuzu var.',
    RECEIPT_REISSUE_REQUIRED:
      'Bu bağışın makbuzu iptal edilmiş. Yeni makbuz, iptal edilen makbuz yeniden düzenlenerek verilir.',
    RECEIPT_ALREADY_VOIDED: 'Bu makbuz zaten iptal edilmiş.',
    RECEIPT_NOT_VOIDED: 'Yalnızca iptal edilmiş bir makbuz yeniden düzenlenebilir.',
    RECEIPT_ALREADY_REPLACED:
      'Bu makbuz zaten yeniden düzenlenmiş; bir makbuzun yerine yalnızca bir kez yenisi düzenlenir.',
    RECEIPT_NOT_ISSUED: 'Yasal belge numarası yalnızca geçerli bir makbuza kaydedilir.',
    RECEIPT_ON_CERTIFICATE:
      'Bu makbuz geçerli bir yıllık bağış özetinde listeleniyor. Önce yıllık özeti iptal edin.',
    RECEIPT_CERTIFICATE_EXISTS: 'Bu bağışçının o yıl için zaten geçerli bir yıllık özeti var.',
    RECEIPT_CERTIFICATE_EMPTY: 'Bağışçının o yıl düzenlenmiş geçerli bir makbuzu yok.',
    RECEIPT_CERTIFICATE_ORGANIZATION_REQUIRED:
      'Bağışçının o yılki makbuzları birden fazla kuruluşa ait. Yıllık belge tek bir kuruluş için düzenlenir; kuruluşu seçin.',
    RECEIPT_ORGANIZATION_UNKNOWN:
      'Kurum henüz bir tüzel kişiliğe bağlı değil; makbuz düzenlenemez.',
    RECEIPT_NOT_RENDERED: 'Makbuzun PDF’i henüz hazır değil. Birkaç saniye sonra tekrar deneyin.',
    GENERATED_FILE_NOT_READY:
      'Dosya henüz hazır değil. Hazır olduğunda listede indirilebilir hale gelir.',
    GENERATED_FILE_FAILED:
      'Dosya oluşturulamadı. Filtreyi daraltıp yeniden isteyin; sorun sürerse yöneticinize bildirin.',
    GENERATED_FILE_EXPIRED:
      'Dosyanın saklama süresi doldu ve silindi. Aynı filtreyle yeniden isteyebilirsiniz.',
    GENERATED_FILE_NOT_REQUESTER:
      'Bu dosya sizin için oluşturulmadı. Bir dışa aktarma bağlantısı paylaşılarak devredilemez; kendi dosyanızı isteyin.',
    GENERATED_FILE_TOO_MANY_ROWS:
      'Filtre bir dosyanın alabileceğinden çok kayıt getiriyor. Tarih aralığını ya da diğer filtreleri daraltın.',
    GENERATED_FILE_REQUESTER_REFUSED:
      'Dosya hazırlanırken yetkiniz artık yeterli değildi. Yetkileriniz değiştiyse yöneticinize danışın.',
    DONATION_PRINTOUT_EMPTY:
      'Çıktısı istenen kayıtların hiçbiri artık size görünmüyor. Listeden yeniden seçin.',
    PRINTOUT_LIST_DONATION_LISTED:
      'Seçilen bağışlardan {{count}} tanesi zaten etkin bir PDF listesinde {{numbers}}. Bir bağış aynı anda tek bir listede olabilir: o listeyi PDF Yönetimi’nden yeniden oluşturun, ya da bağışı listeden çıkarın veya listeyi iptal edip yeniden çıktı alın.',
    PRINTOUT_LIST_MIXED_CAMPAIGNS:
      'Bir PDF listesi tek bir kampanyanın bağışlarından oluşur. Seçimi tek kampanyaya indirin.',
    PRINTOUT_LIST_VOIDED:
      'Bu PDF listesi iptal edilmiş. İptal edilen liste yeniden oluşturulamaz ve değiştirilemez.',
    PRINTOUT_LIST_DONATION_NOT_LISTED: 'Bu bağış artık bu PDF listesinde değil.',
    PRINTOUT_LIST_REASON_REQUIRED: 'Gerekçe en az 10 karakter olmalıdır.',
    PRINTOUT_LIST_INSTITUTION_NOT_ASSIGNED:
      'Seçilen kurum, listedeki bağışların dönemlerinde aktif bir görevlendirme değil.',
    PRINTOUT_LIST_WORK_NOT_MOVABLE:
      'Listedeki {{count}} bağış artık beklemede değil ({{codes}}); yürütücü kurum değiştirilemez. Önce bu bağışları listeden çıkarın.',
    QUEUE_SHEET_PERIOD_NOT_FOUND: 'Çizelgesi istenen dönem bulunamadı.',
    DONATION_IMPORT_FORM_NEEDS_FILE:
      'Bu kampanyanın formunda her bağışta zorunlu bir dosya alanı var; bir dosya Excel satırına yazılamadığı için bu kampanyaya toplu aktarım yapılamaz.',
    DONATION_IMPORT_UPLOAD_INVALID:
      'Yükleme doğrulanamadı. Dosyayı bu sezon için yeniden seçip tekrar yükleyin.',
    DONATION_IMPORT_UPLOAD_EXPIRED: 'Yüklemenin süresi doldu. Dosyayı yeniden yükleyin.',
    DONATION_IMPORT_UPLOAD_MISSING: 'Dosya depoya ulaşmadı. Tekrar yükleyin.',
    DONATION_IMPORT_FILE_TOO_LARGE: 'Dosya izin verilen boyuttan (5 MB) büyük.',
    DONATION_IMPORT_FILE_TYPE_UNSUPPORTED:
      'Bu dosya bir Excel dosyası değil. Sezonun şablonunu doldurup .xlsx veya .xls olarak yükleyin; CSV kabul edilmez.',
    DONATION_IMPORT_ALREADY_COMMITTED:
      'Bu dosya bu sezona zaten aktarılmış; aynı liste ikinci kez aktarılmaz.',
    DONATION_IMPORT_NOT_UPLOADER:
      'Bu aktarım üzerinde yalnızca dosyayı yükleyen kişi işlem yapabilir.',
    DONATION_IMPORT_NOT_DISCARDABLE: 'Bu aktarımdan şu anki durumunda vazgeçilemez.',
    DONATION_IMPORT_NOT_IN_PREVIEW: 'Yalnızca önizlemesi hazır bir aktarım kaydedilebilir.',
    DONATION_IMPORT_CHANGED_SINCE_READ:
      'Aktarım siz incelerken değişti. Sayfayı yenileyip yeniden deneyin.',
    DONATION_IMPORT_ROW_NOT_OPEN: 'Bu satırdan bağış zaten oluşturuldu ya da aktarım tamamlandı.',
    DONATION_IMPORT_ROW_KEY_TAKEN:
      'Bu satırın anahtarı aktarım dışında girilmiş başka bir bağışta kullanılmış; satır kaydedilmedi.',
    DONATION_IMPORT_OPERATOR_UNKNOWN:
      'Kaydeden kişi bulunamadı: parantez içindeki e-posta, kapsamınızdaki hiçbir kullanıcıya ait değil. Kişiyi şablonun Kullanıcılar listesinden seçin.',
    DONATION_IMPORT_OPERATOR_AMBIGUOUS:
      'Parantez içindeki e-posta birden çok kullanıcıyla eşleşiyor; kişiyi kullanıcı ID’siyle yazın.',
    DONATION_IMPORT_FORM_CHANGED:
      'Kampanyanın formu bu şablon hazırlandıktan sonra değişti. Güncel şablonu indirip listeyi ona aktarın.',
    DONATION_IMPORT_UPLOADER_REFUSED:
      'Dosyayı yükleyen kullanıcı pasife alınmış ya da bağış aktarma yetkisi kalmamış.',
    DONATION_IMPORT_UPLOADER_MOVED:
      'Dosyayı yükleyen kullanıcı başka bir birime taşınmış; aktarımı yeni biriminden yeniden yüklemesi gerekir.',
    DONATION_IMPORT_FILE_INFECTED: 'Dosyada virüs bulundu; dosya okunmadı.',
    DONATION_IMPORT_FILE_SCAN_FAILED: 'Dosya virüs taramasından geçirilemedi; okunmadı.',
    DONATION_IMPORT_FILE_CHANGED: 'Yüklenen dosya depoda değişmiş; güvenlik için okunmadı.',
    DONATION_IMPORT_FILE_ENCRYPTED:
      'Dosya parolayla korunuyor; okunamaz. Excel’de açıp parolasını kaldırarak kaydedin ve yeniden yükleyin.',
    DONATION_IMPORT_UNREADABLE: 'Dosya okunamadı: bozuk ya da desteklenmeyen bir dosya.',
    DONATION_IMPORT_TOO_MANY_ROWS:
      'Dosyada 2.000’den fazla bağış satırı var. Listeyi bölerek ayrı dosyalar hâlinde yükleyin.',
    DONATION_IMPORT_EMPTY: 'Dosyada hiç bağış satırı yok.',
    DONATION_IMPORT_TEMPLATE_UNRECOGNISED:
      'Bu dosya bir bağış aktarım şablonu değil ya da ilk hücresi değiştirilmiş. Sezonun şablonunu indirip onu doldurun.',
    DONATION_IMPORT_TEMPLATE_OTHER_PERIOD:
      'Bu şablon başka bir sezon için hazırlanmış. Seçtiğiniz sezonun şablonunu indirip onu doldurun.',
    DONATION_IMPORT_TEMPLATE_STALE:
      'Kampanyanın formu bu şablon hazırlandıktan sonra değişti. Güncel şablonu indirip listeyi ona aktarın.',
    DONATION_IMPORT_COLUMN_UNKNOWN:
      'Dosyada bu şablonda olmayan bir sütun anahtarı var ({{column}}). Sütun başlıklarındaki köşeli parantezleri değiştirmeyin.',
    DONATION_IMPORT_COLUMN_MISSING:
      'Zorunlu bir sütun dosyada yok ({{column}}). Şablondaki sütunu silmeyin.',
    DONATION_IMPORT_COLUMN_DUPLICATE: 'Aynı sütun dosyada iki kez var ({{column}}).',
    DONATION_IMPORT_CELL_REQUIRED: 'Bu hücre boş bırakılamaz.',
    DONATION_IMPORT_CELL_NOT_AN_OPTION: 'Bu değer seçeneklerden biri değil.',
    DONATION_IMPORT_CELL_NOT_A_NUMBER: 'Bu hücre bir tam sayı ya da sayı olmalı.',
    DONATION_IMPORT_CELL_NOT_A_DATE: 'Tarih GG.AA.YYYY biçiminde yazılmalı.',
    DONATION_IMPORT_CELL_NOT_AN_AMOUNT: 'Tutar 1234,50 ya da 1.234,50 biçiminde yazılmalı.',
    DONATION_IMPORT_CELL_NOT_A_USER_ID:
      'Kaydeden kişiyi şablondaki Kullanıcılar listesinden seçin (“Ad Soyad (e-posta)”) ya da bir kullanıcı ID’si yazın.',
    DONATION_IMPORT_CELL_NOT_A_COUNTRY: 'Ülke iki harfli kodla yazılmalı (TR, DE…).',
    DONATION_IMPORT_CELL_TOO_LONG: 'Bu hücre en fazla {{maxLength}} karakter olabilir.',
    DONATION_IMPORT_PAYER_PHONE_MISSING:
      'Bağış yapanın telefonu yazılmamış; telefonu olmayan bir bağış aktarılmaz.',
    DONATION_IMPORT_POSSIBLE_DUPLICATE:
      'Bu bağışçının bu sezonda aynı gün, aynı tutarda bir bağışı zaten var; bu satır onun tekrarı olabilir.',
    BULK_CHANGE_UPLOAD_INVALID:
      'Yükleme bu toplu işlem için kullanılamaz. Dosyayı yeniden yükleyin.',
    BULK_CHANGE_UPLOAD_EXPIRED: 'Yüklemenin süresi doldu. Dosyayı yeniden yükleyin.',
    BULK_CHANGE_UPLOAD_MISSING: 'Dosya depoya ulaşmadı. Tekrar yükleyin.',
    BULK_CHANGE_FILE_TOO_LARGE: 'Dosya izin verilen boyuttan (5 MB) büyük.',
    BULK_CHANGE_FILE_TYPE_UNSUPPORTED:
      'Bu dosya Excel ya da CSV değil. Şablonu doldurup .xlsx, .xls veya .csv olarak yükleyin.',
    BULK_CHANGE_ALREADY_COMMITTED: 'Bu toplu işlem zaten uygulanmış ya da uygulanıyor.',
    BULK_CHANGE_NOT_UPLOADER:
      'Bu toplu işlem üzerinde yalnızca dosyayı yükleyen kişi işlem yapabilir.',
    BULK_CHANGE_NOT_DISCARDABLE: 'Bu toplu işlemden şu anki durumunda vazgeçilemez.',
    BULK_CHANGE_NOT_IN_PREVIEW: 'Yalnızca önizlemesi hazır bir toplu işlem uygulanabilir.',
    BULK_CHANGE_CHANGED_SINCE_READ:
      'Toplu işlem siz incelerken değişti. Sayfayı yenileyip yeniden deneyin.',
    BULK_CHANGE_KIND_NOT_PERMITTED: 'Bu tür toplu işlem için yetkiniz yok.',
    BULK_CHANGE_ID_INVALID: 'Kimlik hücresi geçerli bir kimlik değil. Yeni kayıt için boş bırakın.',
    BULK_CHANGE_DUPLICATE_ID:
      'Aynı kimlik dosyada {{rowNumber}}. satırda da geçiyor; bir kayıt bir kez güncellenir.',
    BULK_CHANGE_DUPLICATE_KEY:
      'Aynı e-posta, telefon, Telegram sohbet no ya da kod dosyada {{rowNumber}}. satırda da geçiyor; ikincisi reddedildi.',
    BULK_CHANGE_CELL_REQUIRED: 'Bu hücre boş bırakılamaz.',
    BULK_CHANGE_CELL_INVALID: 'Bu hücredeki değer geçerli değil.',
    BULK_CHANGE_CODE_IMMUTABLE: 'Kurum kodu sonradan değiştirilemez.',
    BULK_CHANGE_REFERENCE_UNKNOWN: 'Bu hücredeki ad ya da kod hiçbir kayıtla eşleşmiyor.',
    BULK_CHANGE_REFERENCE_AMBIGUOUS: 'Bu hücredeki kod birden çok kayıtla eşleşiyor.',
    BULK_CHANGE_CREATE_NOT_SUPPORTED:
      'Bu şablonla yeni bağış eklenemez; yeni bağışlar Bağış Aktarımı ile girilir. Kimlik hücresi boş olamaz.',
    BULK_CHANGE_AMOUNT_DERIVED:
      'Bu kampanyada tutar adetten hesaplanır; yazdığınız tutar kaydedilecek tutarla uyuşmuyor. Adedi değiştirin.',
    BULK_CHANGE_ROW_ALREADY_APPLIED: 'Bu satır zaten uygulandı.',
    BULK_CHANGE_VERSION_MISSING:
      'Bu satırın Sürüm değeri yok: dosya eski bir şablonla hazırlanmış ya da Sürüm hücresi silinmiş. Satır uygulanmadı; güncel şablonu yeniden indirip değişikliklerinizi onun üzerinde yapın.',
    BULK_CHANGE_OTHER_CAMPAIGN:
      'Bu bağış, şablonun hazırlandığı kampanyaya ait değil. Her kampanyanın şablonu ayrıdır; bu bağışın kampanyası için ayrı bir şablon indirin.',
    BULK_CHANGE_PAYER_PHONE_REQUIRED:
      'Bağışçıyı değiştirmek için telefon numarasını tam olarak yazın; bağışçı telefona göre bulunur. Numara maskeli olduğu için olduğu gibi bırakılırsa bağışçı değişmez.',
    BULK_CHANGE_ANSWER_NOT_KEPT:
      'Bu cevap bağışın kayıtlı formunda yer almıyor ya da başka cevaplar nedeniyle gizli; kaydedilemez.',
    BULK_CHANGE_TEMPLATE_STALE_ROW:
      'Şablonun kampanyası ya da formu artık bulunamıyor veya erişiminiz yok. Şablonu yeniden indirin.',
    BULK_CHANGE_ROW_PARTLY_APPLIED:
      'Satırın bağış düzeltmesi kaydedildi, ancak kaydı yapan kullanıcı değişikliği reddedildi. Bağış yarı uygulanmış durumda; nedeni sonraki satırda yazıyor, kullanıcıyı bağışın sayfasından değiştirin.',
    BULK_CHANGE_TEMPLATE_STALE:
      'Bu şablon eski bir düzende ya da artık bulunmayan bir kampanya için hazırlanmış. Bağış listesinden kampanyayı seçip güncel şablonu yeniden indirin.',
    BULK_CHANGE_UNREADABLE: 'Dosya okunamadı: bozuk ya da desteklenmeyen bir dosya.',
    BULK_CHANGE_FILE_ENCRYPTED:
      'Dosya parolayla korunuyor; okunamaz. Parolasını kaldırarak kaydedin ve yeniden yükleyin.',
    BULK_CHANGE_TOO_MANY_ROWS:
      'Dosyada 1.000’den fazla satır var. Listeyi bölerek ayrı dosyalar hâlinde yükleyin.',
    BULK_CHANGE_TEMPLATE_UNRECOGNISED:
      'Bu dosya bir toplu işlem şablonu değil ya da ilk hücresi değiştirilmiş. Şablonu indirip onu doldurun.',
    BULK_CHANGE_TEMPLATE_OTHER_KIND:
      'Bu şablon başka türde kayıtlar için hazırlanmış. Doğru şablonu indirip onu doldurun.',
    BULK_CHANGE_COLUMN_UNKNOWN:
      'Dosyada bu şablonda olmayan bir sütun anahtarı var ({{column}}). Sütun başlıklarındaki köşeli parantezleri değiştirmeyin.',
    BULK_CHANGE_COLUMN_DUPLICATE: 'Aynı sütun dosyada iki kez var ({{column}}).',
    BULK_CHANGE_COLUMN_MISSING: 'Kimlik sütunu dosyada yok. Şablondaki sütunu silmeyin.',
    BULK_CHANGE_EMPTY: 'Dosyada hiç satır yok.',
    BULK_CHANGE_UPLOADER_REFUSED:
      'Dosyayı yükleyen kullanıcı pasife alınmış ya da bu işlem için yetkisi kalmamış.',
    BULK_CHANGE_UPLOADER_MOVED:
      'Dosyayı yükleyen kullanıcı başka bir birime taşınmış; dosyayı yeni biriminden yeniden yüklemesi gerekir.',
    BULK_CHANGE_FILE_INFECTED: 'Dosyada virüs bulundu; dosya okunmadı.',
    BULK_CHANGE_SCAN_FAILED: 'Dosya virüs taramasından geçirilemedi; okunmadı.',
    BULK_CHANGE_FILE_CHANGED: 'Yüklenen dosya depoda değişmiş; güvenlik için okunmadı.',
    USER_EMAIL_TAKEN: 'Bu e-posta adresi başka bir kullanıcıya kayıtlı.',
    USER_CHANGED_SINCE_READ:
      'Bu kullanıcı, şablon indirildikten sonra değiştirilmiş. Üzerine yazılmadı; güncel şablonu yeniden indirip değişikliğinizi onun üzerinde yapın.',
    INSTITUTION_CHANGED_SINCE_READ:
      'Bu kurum, şablon indirildikten sonra değiştirilmiş. Üzerine yazılmadı; güncel şablonu yeniden indirip değişikliğinizi onun üzerinde yapın.',
    INSTITUTION_CODE_TAKEN: 'Bu kod başka bir kuruma ait.',
    DONATION_IMPORT_SHARES_NEW_DONOR:
      'Bu telefon {{rowNumber}}. satırda da geçiyor; aktarımda iki satır aynı yeni bağışçıya bağlanır.',
    GENERATED_FILE_BUILD_FAILED:
      'Dosya hazırlanırken beklenmeyen bir hata oluştu. Yeniden isteyin.',
    CONTACT_LOG_OUTCOME_NEEDS_DONATION:
      'Bu görüşme sonucu bir bağışı gösterir; önce görüşmeyi bağışın referans koduna bağlayın.',
    CONTACT_LOG_DONATION_ALREADY_LINKED:
      'Bu görüşme başka bir bağışa bağlı. Bir görüşme yalnızca bir bağışa bağlanabilir.',
    CONTACT_LOG_REFERENCE_CODE_INVALID: 'Bu bir bağış referans kodu değil. Kodu kontrol edin.',
    CONTACT_LOG_RANGE_REVERSED: 'Tarih aralığının bitişi başlangıcından önce olamaz.',
    PRODUCT_CODE_TAKEN: 'Bu ürün kodu başka bir üründe kullanılıyor.',
    ORGANIZATION_CODE_TAKEN: 'Bu kuruluş kodu başka bir kuruluşta kullanılıyor.',
    INSTITUTION_ORGANIZATION_HAS_DONATIONS:
      'Bu kurumun bağışlarından biri bu kuruluşa yazılmış ya da bu kuruluşun hesabında etkin bir ödeme bağlantısı var; bağlantı kaldırılamaz. Bağışlar başka bir tüzel kişiliğe kendiliğinden aktarılmaz; para taşınacaksa fon transferiyle yapılır.',
    INSTITUTION_ORGANIZATION_INACTIVE: 'Pasif bir kuruluşa kurum bağlanamaz.',
    INSTITUTION_HEADQUARTERS_NEEDS_ORGANIZATION:
      'Genel merkez, bu kuruluşa bağlı ve aktif bir kurum olmalıdır. Kurumu önce bu kuruluşa bağlayın.',
    INSTITUTION_ORGANIZATION_NOT_LINKED:
      'Bu kuruluş kuruma bağlı değil. Önce kuruluşu kuruma bağlayın.',
    INSTITUTION_PRIMARY_ORGANIZATION_REQUIRED:
      'Kurumun birincil kuruluşu, başka kuruluşlar bağlıyken kaldırılamaz. Önce başka bir kuruluşu birincil yapın.',
    INSTITUTION_ORGANIZATION_IS_HEADQUARTERS:
      'Bu kurum kuruluşun genel merkezi. Bağlantıyı kaldırmadan önce genel merkez seçimini kaldırın.',
    ORGANIZATION_SITE_HOST_INVALID:
      'Alan adı yalnızca ad olarak yazılır; şema (https://), port ya da yol içeremez.',
    ORGANIZATION_SITE_HOST_TAKEN:
      'Bu alan adı başka bir kuruluşun bağış sitesinde kullanılıyor. Bir alan adı yalnızca bir kuruluşa bakabilir.',
    ORGANIZATION_SITE_NO_HEADQUARTERS:
      'Kuruluşun genel merkezi belirlenmeden bağış sitesi açılamaz; site ödeme alsa bile alınan ödeme bağışa dönüştürülemez. Önce Bağlı Kurumlar kartından genel merkezi belirleyin.',
    TWO_FACTOR_REQUIRED_BY_ROLE: 'Rolünüz iki adımlı doğrulama gerektirdiği için kapatılamaz.',
    TWO_FACTOR_NOT_ENABLED: 'Bu hesapta iki adımlı doğrulama kurulu değil.',
    PSEUDONYM_REVEAL_NEEDS_TWO_FACTOR:
      'Rumuzları çözmek için iki adımlı doğrulama gerekir. Önce Profil sayfasından iki adımlı doğrulamayı kurun.',
    PSEUDONYM_TAKEN:
      'Aynı üst birimdeki başka bir kayıt bu rumuzu zaten kullanıyor. Farklı bir rumuz yazın.',
    PSEUDONYM_SAME_AS_NAME: 'Rumuz, kaydın kendi adıyla aynı olamaz; hiçbir şeyi gizlemez.',
    PSEUDONYM_REVEAL_IMPERSONATING: 'Destek oturumunda rumuzlar çözülemez.',
    PSEUDONYM_CODE_REPLAYED:
      'Bu kod daha önce kullanıldı. Doğrulama uygulamanızda yeni kodun görünmesini bekleyin.',
    TWO_FACTOR_CODE_INVALID:
      'Girdiğiniz kod doğru değil. Doğrulama uygulamanızdaki güncel kodu ya da kullanılmamış bir kurtarma kodunu girin.',
    TWO_FACTOR_ENROLMENT_EXPIRED: 'Yeniden kurulumun süresi doldu ya da geçersiz. Baştan başlayın.',
    TWO_FACTOR_RESET_SELF:
      'Kendi iki adımlı doğrulamanızı buradan sıfırlayamazsınız. Profilinizden yeniden kurun.',
    TWO_FACTOR_RESET_IMPERSONATING:
      'Taklit oturumunda iki adımlı doğrulama sıfırlanamaz. Admin hesabınıza dönün.',
    PASSWORD_UNCHANGED: 'Yeni parola mevcut parolanızla aynı olamaz.',
    IMPERSONATION_EXPIRED: 'Taklit oturumunun süresi doldu. Admin hesabınıza dönün.',
    IMPERSONATION_ACTION_BLOCKED:
      'Bu işlem taklit oturumunda kullanılamaz. Admin hesabınıza dönün.',
    IMPERSONATION_SUPPORT_REQUIRED:
      'Kullanıcı taklidi yalnızca taklit yetkisi olan, global kapsamlı ve iki adımlı doğrulaması tamamlanmış etkin bir yöneticiye açıktır.',
    IMPERSONATION_NESTED:
      'Taklit oturumundayken başka bir kullanıcıyı taklit edemezsiniz. Önce admin hesabınıza dönün.',
    IMPERSONATION_TARGET_UNAVAILABLE:
      'Bu kullanıcı taklit edilemez: hesap pasif, kilitli ya da bulunamadı veya kendi hesabınız.',
    IMPERSONATION_TARGET_IMPERSONATOR:
      'Bu kullanıcı da kullanıcı taklit etme yetkisine sahip bir yönetici; yöneticiler birbirini taklit edemez.',
    IMPERSONATION_TARGET_NOT_SUBORDINATE:
      'Bu kullanıcının yetkileri sizinkiyle aynı ya da sizde olmayan bir yetki içeriyor; yalnızca sizden daha az yetkili kullanıcılar taklit edilebilir.',
    CURRENT_PASSWORD_INVALID: 'Mevcut parolanız hatalı.',
    EMAIL_UNCHANGED: 'Bu zaten giriş yaptığınız e-posta adresi.',
    EMAIL_CHANGE_LINK_INVALID:
      'Bu onay bağlantısı geçersiz, kullanılmış ya da süresi dolmuş. Değişikliği profilinizden yeniden isteyin.',
    EMAIL_ADDRESS_IN_USE:
      'Bu e-posta adresi artık başka bir hesapta kullanılıyor; değişiklik yapılamadı.',
    ORG_UNIT_HAS_ACTIVE_CHILDREN:
      'Altında aktif birimler bulunan bir birim pasifleştirilemez. Önce alt birimleri pasifleştirin.',
    ORG_UNIT_PARENT_INACTIVE:
      'Üst birimi pasif olan bir birim oluşturulamaz, oraya taşınamaz ve etkinleştirilemez.',
    ORG_UNIT_REFERENCED:
      'Bu birime bağlı kayıtlar olduğu için silinemez. Silmek yerine pasifleştirin.',
    SCOPE_NODE_INACTIVE: 'Bu birim pasif olduğu için altında yeni işlem yapılamaz.',
    CAMPAIGN_NO_ACTIVE_PERIOD:
      'Bu kampanyanın şu anda bağış kabul eden aktif bir dönemi yok. Dönemi kampanya ekranından açın.',
    DONATION_REFERENCE_PERSON_INCOMPLETE:
      'Referans telefonu yazıldıysa referans kişinin adı soyadı da girilmelidir.',
    DONATION_REFERENCE_PHONE_INCOMPLETE:
      'Referans telefonu eksik ya da hatalı. Ülke koduyla birlikte tam numarayı girin (ör. +90 532 …).',
    DONATION_ON_BEHALF_OF_PERSON_INCOMPLETE:
      'Bağış sahibinin telefonu yazıldıysa ya da kayıtlı bir kişi seçildiyse adı soyadı da girilmelidir.',
    DONATION_ON_BEHALF_OF_DONOR_AND_PHONE:
      'Bağış sahibi ya listeden seçilen kişidir ya da yazılan telefonla bulunur; ikisi birden gönderilemez.',
    DONATION_PAYER_DONOR_AND_PHONE:
      'Bağış yapan ya listeden seçilen kişidir ya da yazılan telefonla bulunur; ikisi birden gönderilemez.',
    DONATION_EVIDENCE_RECIPIENT_UNAVAILABLE:
      'Bu bağışta seçilen kişi kayıtlı değil; ona bildirim gönderilemez.',
    DONATION_EVIDENCE_RECIPIENT_DUPLICATE: 'Aynı kişi için aynı bildirim bir kez seçilir.',
    DONATION_NOTICE_CHOICE_OFFERED:
      'Bu kişiye kanıt bağlantısı zaten sunuldu; seçimi kaldırmak yerine Kanıt Alıcıları’ndan “Vazgeç” ile bağlantıyı kapatın.',
    DONATION_EVIDENCE_RECIPIENT_OPTED_OUT:
      'Bu kişi kanıt almak istemediğini bildirdi; bağlantı ona yeniden gönderilmez.',
    DONATION_EVIDENCE_DONOR_ERASED:
      'Bağışçının verileri silindi; bu bağışın kanıtı artık kimseye gönderilmez.',
    DONATION_EVIDENCE_NOT_READY:
      'Bu bağışın gösterilebilecek bir kanıtı yok: bağış gerçekleşmiş durumda değil ya da temiz bir fotoğraf veya video kalmamış.',
    DONATION_EVIDENCE_SEND_IN_FLIGHT:
      'Bu kişiye giden bir kanıt mesajı hâlâ gönderimde. Sonuçlanmasını bekleyin.',
    DONATION_OPERATOR_INACTIVE: 'Pasif bir kullanıcı adına bağış kaydı girilemez.',
    DONATION_NOT_STAFF_ENTERED:
      'Bu bağışı bir personel girmedi (bağış sitesinden geldi); değiştirilecek bir kaydı giren yok.',
    DONATION_ENTRY_CURRENCY_UNSUPPORTED:
      'Bağış yalnızca TRY, USD veya EUR ile girilir. Başka bir para biriminde kayıtlı bir bağış kendi para biriminde kalarak düzeltilebilir.',
    ORGANIZATION_ACCOUNT_IBAN_NOT_BANK:
      'IBAN yalnızca banka hesabına girilir; kasa, sanal POS, Stripe ve PayPal hesaplarının IBAN’ı olmaz.',
    ORGANIZATION_ACCOUNT_IBAN_LOCKED:
      'Bu hesaba ekstre aktarılmış ya da hareket kaydedilmiş, bu yüzden IBAN’ı değiştirilemez. IBAN yanlışsa hesabı pasife alıp doğru IBAN ile yeni bir hesap ekleyin.',
    IBAN_MALFORMED:
      'IBAN iki harfli ülke kodu, iki kontrol hanesi ve ardından harf ya da rakamlardan oluşmalıdır.',
    IBAN_COUNTRY_UNKNOWN: '“{{country}}” IBAN kullanan bir ülkenin kodu değil.',
    IBAN_LENGTH_MISMATCH:
      '{{country}} IBAN’ı {{expectedLength}} karakterdir; girilen {{length}} karakter.',
    IBAN_CHECKSUM_FAILED:
      'IBAN’ın kontrol haneleri tutmuyor; bir hane yanlış yazılmış ya da iki hane yer değiştirmiş olabilir.',
    MERCHANDISE_ORDER_NOT_EDITABLE: 'Yalnızca taslak bir sipariş düzenlenebilir.',
    MERCHANDISE_ORDER_INVALID_TRANSITION: 'Sipariş bulunduğu durumdan bu işleme geçemez.',
    MERCHANDISE_ORDER_EMPTY: 'Siparişte en az bir ürün satırı olmalıdır.',
    MERCHANDISE_PRODUCT_UNAVAILABLE:
      'Bu ürün sipariş edilemiyor: pasife alınmış ya da bulunamadı. Siparişten çıkarın.',
    MERCHANDISE_ORDER_MIXED_CURRENCY:
      'Farklı para birimlerinde fiyatlanan ürünler aynı siparişte olamaz; ayrı sipariş alın.',
    MONTHLY_TARGET_TURNOVER_IS_AMOUNT:
      'Tüm kampanyaların ciro hedefi tutar olarak girilir; adet hedefi yalnızca bir kampanya için verilir.',
    RECEIPT_ALREADY_RENDERED: 'Makbuzun PDF’i hazır; yeniden hazırlamaya gerek yok.',
    RECEIPT_RENDER_IN_PROGRESS:
      'Makbuzun PDF’i hâlâ hazırlanıyor olabilir. Yeniden hazırlama, hazırlama başarısız olduğunda ya da {{staleMinutes}} dakikadan uzun sürdüğünde istenebilir.',
    RECONCILIATION_NOT_BULK_CONFIRMABLE:
      'Bu hareket artık tam bir referans eşleşmesi değil; toplu onaylanamaz. İnceleyip elle eşleştirin.',
    ACCOUNT_TRANSACTION_ALLOCATED:
      'Tutarının bir kısmı bağışlara eşleştirilmiş bir hareket hariç tutulamaz. Önce eşleştirmeleri kaldırın.',
    ACCOUNT_TRANSACTION_ALREADY_EXCLUDED: 'Bu hareket zaten hariç tutulmuş.',
    ACCOUNT_TRANSACTION_NOT_EXCLUDED: 'Bu hareket hariç tutulmamış.',
    ACCOUNT_TRANSACTION_NOT_OUTGOING:
      'Yalnızca çıkan (borç) bir hareketin sınıfı elle belirlenir; gelen bir hareket ödediği şeye göre sınıflanır.',
    ACCOUNT_TRANSACTION_CLASSIFICATION_LOCKED:
      'Bu hareket bir iadeyi ya da transferi zaten karşılıyor; sınıfı değiştirilemez.',
    REFUND_LINE_NOT_REFUNDABLE:
      'İade yalnızca hariç tutulmamış, bağışçı ödemesi olarak sınıflanmış gelen bir hareketten istenebilir.',
    REFUND_CURRENCY_MISMATCH: 'İade, hareketin para biriminde istenir.',
    REFUND_EXCEEDS_REMAINDER:
      'Hareketin eşleştirilmemiş kalanı ({{remainingAmount}}) istenen iadeden az. Listeyi yenileyip tutarı kontrol edin.',
    REFUND_NOT_PENDING: 'Bu iade onay beklemiyor.',
    REFUND_SELF_APPROVAL: 'İadeyi talep eden kişi onaylayamaz; onayı başka bir yetkili vermelidir.',
    REFUND_NOT_APPROVED: 'Yalnızca onaylanmış bir iade ödenebilir.',
    REFUND_PAYOUT_LINE_NOT_ELIGIBLE:
      'İade yalnızca aynı kuruluşun, hariç tutulmamış ve iade ödemesi olarak sınıflanmış çıkan bir hareketiyle ödenir.',
    REFUND_PAYOUT_AMOUNT_MISMATCH:
      'Seçilen çıkan hareketin tutarı veya para birimi iadeninkiyle aynı değil.',
    REFUND_PAYOUT_LINE_ALLOCATED:
      'Seçilen çıkan hareket başka bir iadeyi ya da transferi zaten karşılıyor. Listeyi yenileyin.',
    REFUND_NOT_CANCELLABLE: 'Yalnızca onay veya ödeme bekleyen bir iadeden vazgeçilebilir.',
    REFUND_CANCEL_NOT_REQUESTER:
      'Bu iade talebinden yalnızca talebi yapan kişi ya da iade onay yetkisi olan bir yetkili vazgeçebilir.',
    REFUND_CANCEL_APPROVED:
      'Bu iade onaylandı; artık talep eden geri çekemez. Vazgeçmek için iade onay yetkisi olan bir yetkiliye başvurun.',
    FINANCE_PERIOD_TOO_LONG:
      'Konsolidasyon raporu en fazla {{maxDays}} günlük bir dönem için alınır.',
    REPORT_PERIOD_TOO_LONG: 'Rapor en fazla {{maxDays}} günlük bir dönem için alınır.',
    REPORT_TOO_MANY_ROWS:
      'Bu rapor {{rows}} satır döndürüyor; ekranda en fazla {{maxRows}} satır gösterilir. Filtreyi daraltın ya da raporu dışa aktarın.',
    FUND_TRANSFER_SAME_ORGANIZATION: 'Transfer iki farklı kuruluş arasında yapılır.',
    FUND_TRANSFER_ORGANIZATION_INACTIVE: 'Transfer yalnızca aktif kuruluşlar arasında yapılır.',
    FUND_TRANSFER_SOURCE_NOT_ELIGIBLE:
      'Aracı transfer yalnızca gönderen kuruluşun hesabına gelmiş, hariç tutulmamış ve transferle aynı para biriminde bir bağışçı ödemesinden yapılır.',
    FUND_TRANSFER_SOURCE_EXCEEDS_REMAINDER:
      'Seçilen hareketin eşleştirilmemiş kalanı ({{remainingAmount}}) transfer tutarından az.',
    FUND_TRANSFER_NOT_REQUESTED: 'Bu transfer onay beklemiyor.',
    FUND_TRANSFER_SELF_APPROVAL:
      'Transferi talep eden kişi onaylayamaz; onayı başka bir yetkili vermelidir.',
    FUND_TRANSFER_NOT_APPROVED: 'Yalnızca onaylanmış bir transferin hareketi eşleştirilebilir.',
    FUND_TRANSFER_SIDE_MATCHED:
      'Transferin bu tarafının hareketi zaten eşleştirilmiş. Listeyi yenileyin.',
    FUND_TRANSFER_LINE_NOT_ELIGIBLE:
      'Seçilen hareket transferin bu tarafını karşılayamaz: gönderen tarafta gönderen kuruluşun çıkan, alan tarafta alan kuruluşun gelen hareketi olmalı ve hariç tutulmamış olmalıdır.',
    FUND_TRANSFER_LINE_AMOUNT_MISMATCH:
      'Seçilen hareketin tutarı veya para birimi transferinkiyle aynı değil.',
    FUND_TRANSFER_LINE_ALLOCATED:
      'Seçilen hareket başka bir bağışı, iadeyi ya da transferi zaten karşılıyor. Listeyi yenileyin.',
    FUND_TRANSFER_LINE_IN_USE:
      'Seçilen hareket başka bir transferde kullanılıyor. Listeyi yenileyin.',
    FUND_TRANSFER_NOT_CANCELLABLE: 'Tamamlanmış ya da iptal edilmiş bir transfer iptal edilemez.',
    FUND_TRANSFER_CANCEL_NOT_REQUESTER:
      'Bu transfer talebini yalnızca talebi yapan kişi ya da fon transferi onay yetkisi olan bir yetkili iptal edebilir.',
    FUND_TRANSFER_CANCEL_APPROVED:
      'Bu transfer onaylandı; artık talep eden geri çekemez. İptal için fon transferi onay yetkisi olan bir yetkiliye başvurun.',
    INSTITUTION_VAULT_NAME_TAKEN: 'Bu kurumda aynı adlı bir kasa zaten var. Başka bir ad seçin.',
    INSTITUTION_VAULT_CASH_IS_FIXED:
      'Nakit kasası her kurumun kendiliğinden açılan kasasıdır; adı değiştirilemez ve pasifleştirilemez.',
    INSTITUTION_VAULT_HAS_BALANCE:
      'İçinde para olan ya da açık aktarımı bulunan kasa pasifleştirilemez. Önce aktarımları bitirin.',
    INSTITUTION_VAULT_INACTIVE: 'Pasif bir kasaya aktarım yapılamaz.',
    INSTITUTION_TRANSFER_INSTITUTION_INACTIVE: 'Pasif bir kuruma yeni iş açılamaz.',
    INSTITUTION_TRANSFER_ORGANIZATION_INACTIVE:
      'Aktarım yalnızca aktif bir kuruluştan yapılabilir.',
    INSTITUTION_TRANSFER_EXCEEDS_RECONCILED:
      'Kuruluşun bu kurum için mutabakatı yapılmış parası bu tutarı karşılamıyor. Bekleyen aktarımlar da bu paradan düşülür.',
    INSTITUTION_TRANSFER_EXCEEDS_BALANCE:
      'Seçilen kuruluş hesabının bakiyesi bu tutarı karşılamıyor.',
    INSTITUTION_TRANSFER_NOT_REQUESTED: 'Yalnızca talep aşamasındaki aktarım onaylanır.',
    INSTITUTION_TRANSFER_SELF_APPROVAL:
      'Aktarımı talep eden kişi onaylayamaz; başka bir yetkili onaylamalı.',
    INSTITUTION_TRANSFER_SELF_REVERSAL:
      'Aktarımı talep eden ya da tamamlayan kişi geri alamaz; geri almayı başka bir yetkili yapmalı.',
    INSTITUTION_TRANSFER_NOT_APPROVED: 'Yalnızca onaylanmış aktarım tamamlanır.',
    INSTITUTION_TRANSFER_NOT_COMPLETED: 'Yalnızca tamamlanmış aktarım geri alınır.',
    INSTITUTION_TRANSFER_NOT_CANCELLABLE:
      'Tamamlanmış, iptal edilmiş ya da geri alınmış aktarım iptal edilemez.',
    INSTITUTION_TRANSFER_VAULT_SHORT: 'Kasada bu aktarımın parası artık yok; geri alınamaz.',
    INSTITUTION_TRANSFER_CANCEL_NOT_REQUESTER:
      'Bu aktarım talebini yalnızca talebi yapan kişi ya da fon transferi onay yetkisi olan bir yetkili iptal edebilir.',
    INSTITUTION_TRANSFER_CANCEL_APPROVED:
      'Bu aktarım onaylandı; artık talep eden geri çekemez. İptal için fon transferi onay yetkisi olan bir yetkiliye başvurun.',
    INSTITUTION_VAULT_OUTFLOW_EXCEEDS_BALANCE:
      'Kasanın bu para birimindeki bakiyesi bu tutarı karşılamıyor. Kasa sıfırın altına düşürülemez.',
    INSTITUTION_VAULT_OUTFLOW_IN_FUTURE: 'Çıkış tarihi bugünden sonra olamaz.',
    INSTITUTION_VAULT_OUTFLOW_CATEGORY_UNKNOWN:
      'Seçilen çıkış kategorisi bulunamadı ya da pasif. Listeden yeniden seçin.',
    INSTITUTION_VAULT_OUTFLOW_VAULT_INACTIVE:
      'Pasif bir kasadan çıkış yapılamaz ve bu kasaya çıkış geri alınamaz.',
    INSTITUTION_VAULT_OUTFLOW_INSTITUTION_INACTIVE: 'Pasif bir kuruma yeni iş açılamaz.',
    INSTITUTION_VAULT_OUTFLOW_ALREADY_REVERSED:
      'Bu çıkış zaten geri alınmış; bir çıkış yalnızca bir kez geri alınır.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_UPLOAD_INVALID:
      'Belge yüklemesi kullanılamıyor. Dosyayı yeniden seçin.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_UPLOAD_EXPIRED:
      'Belge yüklemesinin süresi doldu. Dosyayı yeniden seçin.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_UPLOAD_MISSING: 'Belge yüklenmemiş. Dosyayı yeniden seçin.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_TOO_LARGE: 'Belge dosyası çok büyük; en çok 7 MB olabilir.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_DAMAGED: 'Belge dosyası bozuk; yeniden tarayıp yükleyin.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_TYPE_UNSUPPORTED: 'Belge JPEG, PNG ya da PDF olmalıdır.',
    INSTITUTION_VAULT_OUTFLOW_DOCUMENT_UNAVAILABLE:
      'Belge açılamıyor: virüs taraması bitmemiş olabilir ya da dosya saklama süresi dolduğu için silinmiş olabilir.',
    RECONCILIATION_MONEY_TRANSFERRED:
      'Bu eşleştirmenin parası, kurumun kasasına yapılan veya bekleyen bir aktarımda duruyor. Önce aktarımı iptal edin ya da geri alın.',
    FUND_TRANSFER_CHANGED:
      'Transfer siz bakarken değişti: bir tarafının hareketi eşleştirildi. Listeyi yenileyip tekrar deneyin.',
    REFUND_OWED_BY_CANCELLATION:
      'İptal edilen bir bağışın iadesinden vazgeçilemez; bağışçıya borç olarak kalır.',
    MANUAL_PAYMENT_SLIP_REQUIRED:
      'Havale ile gelen bir ödeme dekontuyla kaydedilir; dekontu ekleyin.',
    MANUAL_PAYMENT_DONATION_NOT_ELIGIBLE:
      'Bu bağış kart, POS ya da PayPal ile ödenir; parası sağlayıcıdan gelir ve elle kaydedilmez.',
    MANUAL_PAYMENT_DONATION_CLOSED:
      'Bu bağış ödeme almaz: iptal edilmiş, tamamı tahsil edilmiş, iade edilmiş ya da ücret almayan bir talep.',
    MANUAL_PAYMENT_NOTHING_OUTSTANDING:
      'Bu bağışın ödenecek kalanı yok; kalanı onay bekleyen bir eşleştirmede olabilir.',
    MANUAL_PAYMENT_BOX_CASH_ONLY: 'Kumbara bağışı yalnızca nakit olarak kaydedilir.',
    MANUAL_PAYMENT_ACCOUNT_KIND:
      'Bu ödeme şeklinin parası bu hesapta tutulmaz: havale ve çek banka hesabına, nakit kasaya kaydedilir.',
    MANUAL_PAYMENT_ACCOUNT_INACTIVE: 'Bu hesap kullanımda değil; başka bir hesap seçin.',
    MANUAL_PAYMENT_LINE_EXISTS:
      '{{accountLabel}} hesabında aynı tutarda, henüz eşleştirilmemiş {{lineCount}} banka hareketi var. Para ekstreyle geldiyse ödemeyi elle kaydetmek yerine o hareketi eşleştirin; aksi hâlde aynı para iki kez sayılır.',
    MANUAL_PAYMENT_SLIP_NOT_CLEAN:
      'Dekontun virüs taraması temiz sonuçlanmadan ödeme onaylanamaz. Tarama bitince yeniden deneyin; dosya temiz bulunmadıysa ödemeyi reddedin.',
    MANUAL_PAYMENT_RECEIVED_IN_FUTURE: 'Ödeme tarihi bugünden sonra olamaz.',
    MANUAL_PAYMENT_NOT_PENDING:
      'Bu ödeme artık onay beklemiyor; başka bir yetkili karar vermiş olabilir. Listeyi yenileyin.',
    MANUAL_PAYMENT_NOT_APPROVED:
      'Yalnızca onaylanmış bir ödeme geri alınır; onay bekleyen bir ödeme reddedilir.',
    MANUAL_PAYMENT_ACTS_ON_LINE:
      'Elle kaydedilmiş bir ödemenin eşleştirmeleri tek tek değil, ödemenin tamamıyla onaylanır, reddedilir ya da geri alınır. Onay Bekleyenler sekmesini kullanın.',
    MANUAL_PAYMENT_SLIP_UNAVAILABLE:
      'Dekont açılamıyor: virüs taraması henüz bitmedi ya da dosya temiz bulunmadı.',
    MANUAL_PAYMENT_SLIP_UPLOAD_INVALID: 'Dekont yüklemesi kullanılamıyor. Dosyayı yeniden seçin.',
    MANUAL_PAYMENT_SLIP_UPLOAD_EXPIRED: 'Dekont yüklemesinin süresi doldu. Dosyayı yeniden seçin.',
    MANUAL_PAYMENT_SLIP_UPLOAD_MISSING: 'Dekont yüklenmemiş. Dosyayı yeniden seçin.',
    MANUAL_PAYMENT_SLIP_TOO_LARGE: 'Dekont dosyası çok büyük; en çok 7 MB olabilir.',
    MANUAL_PAYMENT_SLIP_TYPE_UNSUPPORTED: 'Dekont JPEG, PNG ya da PDF olmalıdır.',
    MANUAL_PAYMENT_SLIP_DAMAGED: 'Dekont dosyası bozuk; yeniden tarayıp yükleyin.',
    MANUAL_PAYMENT_NOT_CLEARABLE:
      'Nakit ödeme kasaya girer ve bir banka hareketi beklemez; yalnızca havale ve çek banka hareketinde bulunur.',
    MANUAL_PAYMENT_ALREADY_CLEARED: 'Bu ödemenin banka hareketi zaten bulundu.',
    MANUAL_PAYMENT_CLEARING_SHORT:
      'Hareketin kalanı ödemenin tutarından az. Ödeme eksik geldiyse ödemeyi geri alıp hareketi bağışla eşleştirin; eksik kalan tutar kısmi tahsilat olarak görünür.',
    MANUAL_PAYMENT_CLEARING_ACCOUNT:
      'Ödeme yalnızca kaydedildiği hesabın banka hareketinde bulunabilir.',
    MANUAL_PAYMENT_CLEARING_LINE:
      'Ödeme yalnızca ekstreden gelen, bağış ödemesi olarak sınıflanmış ve hariç tutulmamış bir gelen harekette bulunabilir.',
    MANUAL_PAYMENT_CLEARING_REVERSED: 'Bu eşleştirme zaten geri alındı.',
    MANUAL_PAYMENT_CLEARED:
      'Bu ödemenin banka hareketi bulundu. Önce hareket bağlantısını geri alın, sonra ödemeyi geri alın.',
    MANUAL_PAYMENT_UNCLEARED:
      'Bu bağış, bu hesaba dekont ya da çekle elle kaydedilmiş — onay bekleyen ya da onaylanmış — ve banka hareketi henüz bulunmamış bir ödemeyle zaten ödeniyor. Bu hareket o ödemenin parası olabilir; eşleştirirseniz aynı para iki kez sayılır.',
    MANUAL_PAYMENT_MIXED_ORGANIZATIONS:
      'Seçilen bağışlar farklı kuruluşlara ait; bir ödeme yalnızca tek kuruluşun bağışlarını kapatır.',
    MANUAL_PAYMENT_MIXED_CURRENCIES:
      'Seçilen bağışlar farklı para birimlerinde; bir ödeme tek para biriminde kaydedilir.',
    MANUAL_PAYMENT_NO_ORGANIZATION:
      'Bağışın kurumu bir kuruluşa bağlı olmadığı için ödeme kaydedilemez.',
    INBOUND_MEDIA_CODE_INVALID:
      'Bu bir bağış referans kodu değil. Kod BT ile başlar ve on karakterdir (örneğin BT-7K4Q-9MXS); bağış numarası ya da bağlantı kabul edilmez.',
    INBOUND_MEDIA_DONATION_NOT_ELIGIBLE:
      'Bu bağışa kanıt eklenemez: yalnızca onaylanmış, sıraya alınmış ya da gerçekleştirilmiş bir bağışa eklenir.',
    INBOUND_MEDIA_SHARE_NOT_IN_DONATION: 'Bağışta bu numarada bir hisse yok.',
    INBOUND_MEDIA_ALREADY_MATCHED: 'Bu medya zaten bir bağışla eşleştirilmiş.',
    INBOUND_MEDIA_ARCHIVED: 'Bu medya arşivlenmiş.',
    INBOUND_MEDIA_NOT_MATCHABLE:
      'Bu medyanın eşleştirilecek bir dosyası yok: dosya indirilemedi, virüs taramasından geçmedi ya da saklama süresi dolduğu için silindi.',
    INBOUND_MEDIA_MATCHED_NOT_ARCHIVABLE:
      'Eşleştirilmiş medya bir bağışın kanıtıdır ve arşivlenmez.',
    INBOUND_MEDIA_PREVIEW_UNAVAILABLE:
      'Dosya gösterilemiyor: henüz indirilmedi, virüs taramasından geçmedi ya da saklama süresi dolduğu için silindi.',
    STATEMENT_ACCOUNT_NOT_IMPORTABLE: 'Ekstre yalnızca aktif bir banka hesabına aktarılabilir.',
    STATEMENT_ALREADY_IMPORTED:
      'Bu dosya bu hesaba zaten aktarılmış; aynı ekstre ikinci kez işlenmez.',
    STATEMENT_UPLOAD_INVALID: 'Yükleme doğrulanamadı. Dosyayı yeniden seçip tekrar yükleyin.',
    STATEMENT_UPLOAD_EXPIRED: 'Yüklemenin süresi doldu. Dosyayı yeniden yükleyin.',
    STATEMENT_UPLOAD_MISSING: 'Dosya depoya ulaşmadı. Tekrar yükleyin.',
    STATEMENT_FILE_TOO_LARGE: 'Dosya izin verilen boyuttan büyük.',
    STATEMENT_FILE_TYPE_UNSUPPORTED:
      'Bu dosya bir ekstre değil. Excel (.xlsx veya .xls), CSV, CAMT.053 (XML) veya MT940 dosyası yükleyin.',
    STATEMENT_FILE_TYPE_MISMATCH: 'Dosya, seçilen profilin okuduğu biçimde değil.',
    STATEMENT_NOT_IN_PREVIEW: 'Yalnızca önizlemesi hazır bir ekstre hesaba aktarılabilir.',
    STATEMENT_ALREADY_COMMITTED: 'Bu ekstre zaten hesaba aktarıldı.',
    STATEMENT_MATCHED_LINES:
      '{{protectedCount}} hareketin mali bağlantısı var. Önce eşleştirmeleri kaldırın veya yalnızca eşleştirilmemişleri kaldırmayı seçin.',
    STATEMENT_REMOVAL_STATE:
      'İşlenmekte olan ekstre kaldırılamaz. İptal için aktarılmış bir ekstre seçin.',
    STATEMENT_LINE_SOURCE: 'Yalnızca ekstreden gelen banka hareketleri silinebilir.',
    STATEMENT_NOT_DISCARDABLE: 'Bu ekstreden şu anki durumunda vazgeçilemez.',
    STATEMENT_PROFILE_MAPPING_INVALID: 'Sütun eşlemesi geçerli değil.',
    STATEMENT_PROFILE_VERSION_TAKEN:
      'Bu profilin yeni sürümünü başka biri sizden önce kaydetti. Sayfayı yenileyip tekrar deneyin.',
    STORAGE_UNAVAILABLE: 'Dosya deposu yapılandırılmamış; dosya yüklenemez.',
    NOTIFICATION_SENDER_SEALING_UNCONFIGURED:
      'Şifreleme anahtarı tanımlı değil; gönderim hesabı kaydedilemez. Sunucu ayarlarında PAYMENT_CREDENTIALS_KEY tanımlanmalıdır.',
    NOTIFICATION_SENDER_FIELDS_INCOMPLETE:
      'Gönderim hesabı, sağlayıcının tam olarak kendi alanlarıyla tanımlanır; eksik ya da fazla alan var.',
    NOTIFICATION_SENDER_GATEWAY_NOT_PRIVATE:
      'Resmî olmayan WhatsApp geçidine yalnızca https ile ya da kurulum içindeki bir adrese düz http ile erişilebilir.',
    NOTIFICATION_SENDER_NOT_CONFIGURED:
      'Bu kuruluşta bu sağlayıcı için kaldırılacak bir gönderim hesabı yok.',
    NOTIFICATION_SENDER_ORGANIZATION_INACTIVE: 'Pasif kuruluşa gönderim hesabı tanımlanamaz.',
    PAYMENT_CREDENTIALS_UNCONFIGURED:
      'Ödeme anahtarı şifreleme anahtarı tanımlı değil; anahtar kaydedilemez. Sunucu ayarlarında PAYMENT_CREDENTIALS_KEY tanımlanmalıdır.',
    PAYMENT_CREDENTIAL_ACCOUNT_KIND_MISMATCH:
      'Bu sağlayıcının anahtarları yalnızca kendi türündeki bir hesaba tanımlanabilir.',
    PAYMENT_CREDENTIAL_ACCOUNT_INACTIVE: 'Pasif hesaba ödeme anahtarı tanımlanamaz.',
    PAYMENT_CREDENTIAL_NOT_CONFIGURED: 'Bu hesapta pasife alınacak bir ödeme anahtarı yok.',
    PAYMENT_CREDENTIAL_PROVIDER_NOT_WIRED:
      'Sunucuda bu sağlayıcının bağlantısı tanımlı değil; anahtarlar doğrulanamaz ve kaydedilemez. Sunucu yöneticisinin tanımlaması gerekiyor.',
    PAYMENT_CREDENTIAL_PROVIDER_UNREACHABLE:
      'Sağlayıcıya şu anda ulaşılamadı; anahtarlar doğrulanamadığı için kaydedilmedi. Birkaç dakika sonra yeniden deneyin.',
    PAYMENT_CREDENTIAL_FIELD_REQUIRED: 'Bu alan zorunludur.',
    PAYMENT_CREDENTIAL_FIELD_WHITESPACE:
      'Anahtarın içinde boşluk var; kopyalarken araya girmiş olabilir. Anahtarı sağlayıcının panelinden yeniden kopyalayın.',
    PAYMENT_CREDENTIAL_FIELD_TOO_SHORT:
      'Bu değer bir anahtar için fazla kısa; eksik kopyalanmış olabilir.',
    PAYMENT_CREDENTIAL_FIELD_TOO_LONG:
      'Bu değer bir anahtar için fazla uzun; yanına başka bir metin de kopyalanmış olabilir.',
    PAYMENT_CREDENTIAL_FIELD_FOREIGN: 'Bu alan seçilen sağlayıcıya ait değil.',
    STRIPE_SECRET_KEY_PUBLISHABLE:
      'Bu, Stripe’ın yayımlanabilir anahtarı (pk_…). Gizli anahtar gerekiyor: sk_live_ ile başlar.',
    STRIPE_SECRET_KEY_SHAPE:
      'Stripe gizli anahtarı sk_live_ ya da sk_test_ ile başlar (kısıtlı anahtar: rk_live_ ya da rk_test_).',
    STRIPE_WEBHOOK_SECRET_SHAPE:
      'Stripe bildirim imza anahtarı whsec_ ile başlar. Oluşturduğunuz webhook’un sayfasındaki “Signing secret” değerini yapıştırın.',
    PAYPAL_WEBHOOK_ID_SHAPE:
      'PayPal webhook ID yalnızca harf ve rakamdan oluşur (ör. 8PT597110X687430LKGECATA). Adresi değil, PayPal’ın verdiği kimliği yapıştırın.',
    STRIPE_TEST_KEY_IN_PRODUCTION:
      'Bu bir Stripe test anahtarı; canlı sistemde test anahtarıyla ödeme alınamaz. sk_live_ ile başlayan canlı anahtarı girin.',
    STRIPE_KEY_REJECTED:
      'Stripe bu anahtarı reddetti. Anahtarın doğru hesaptan, eksiksiz kopyalandığını ve iptal edilmediğini kontrol edin.',
    STRIPE_WEBHOOK_ENDPOINT_MISSING:
      'Bu Stripe hesabında {{webhookUrl}} adresine kayıtlı, etkin bir webhook bulunamadı. Önce 1. adımdaki adresle webhook’u oluşturun.',
    STRIPE_WEBHOOK_EVENTS_MISSING:
      'Stripe webhook’u şu olaylara abone değil: {{events}}. Webhook’un ayarlarından bu olayları ekleyin.',
    PAYPAL_CREDENTIALS_REJECTED:
      'PayPal bu client ID ve secret çiftini reddetti. İkisinin de aynı uygulamadan ve sunucunun kullandığı PayPal ortamından (canlı sistemde Live) kopyalandığını kontrol edin.',
    PAYPAL_WEBHOOK_ID_UNKNOWN:
      'PayPal bu webhook ID’yi bu uygulamada bulamadı. Webhook’u bu client ID’nin uygulamasında oluşturduğunuzdan emin olun.',
    PAYPAL_WEBHOOK_URL_MISMATCH:
      'Bu PayPal webhook’u başka bir adrese gönderiyor. Adresini {{webhookUrl}} olarak düzeltin ya da bu adresle yeni bir webhook oluşturun.',
    PAYPAL_WEBHOOK_EVENTS_MISSING:
      'PayPal webhook’u şu olaylara abone değil: {{events}}. Webhook’un ayarlarından bu olayları ekleyin.',
    PAYMENT_CALLBACK_LINK_UNKNOWN:
      'Sağlayıcıdan gelen tahsilat, sistemde karşılığı olmayan bir ödeme oturumunu gösteriyor; hiçbir kayıt değiştirilmedi.',
    PAYMENT_CALLBACK_ACCOUNT_MISMATCH:
      'Tahsilat, bağlantının oluşturulduğu hesaptan başka bir hesabın bildirim adresine geldi; hiçbir kayıt değiştirilmedi.',
    PAYMENT_CALLBACK_AMOUNT_MISMATCH:
      'Tahsilat tutarı, ödeme bağlantısının tutarıyla aynı değil; hiçbir kayıt değiştirilmedi.',
    PAYMENT_CALLBACK_LINK_HAS_NO_DONATION:
      'Ödeme bağlantısı bir bağışa bağlı değil, bu yüzden tahsilat bir bağışa işlenemedi.',
    PAYMENT_CALLBACK_LENT_LINK_HAS_NO_OPERATOR:
      'Başka bir kuruluşun hesabına oluşturulan bir bağlantıyı bir kullanıcının oluşturmuş olması gerekir; aktarım talebini açacak kişi bulunamadı.',
    PAYMENT_CALLBACK_LINK_HAS_NO_SUBJECT:
      'Ödeme bağlantısı ne bir bağışa ne de bir bağış siparişine bağlı; tahsilat hiçbir kayda işlenemedi.',
    PORTAL_ORDER_NO_HEADQUARTERS_INSTITUTION:
      'Kuruluş bir genel merkez belirlemediği için bağış sitesinden gelen ödeme bağışa dönüştürülemedi. Kuruluşun kurumlarından biri genel merkez olarak işaretlenmelidir.',
    PORTAL_ORDER_NO_SITE_ORGANIZATION:
      'Bağış siparişi hangi kuruluşun sitesinde verildiğini taşımıyor, bu yüzden hangi kurumun tahsil ettiği belirlenemedi.',
    PORTAL_ORDER_PERIOD_CLOSED:
      'Bağışın yapıldığı dönem ödeme onaylanmadan önce kapandığı için tahsilat bağışa dönüştürülemedi.',
    PLEDGE_CAMPAIGN_NOT_RECURRING:
      'Bu kampanya için düzenli bağış alınmıyor. Düzenli bağış, kampanya ayarlarında açıkça izin verilen kampanyalar için geçerlidir.',
    PLEDGE_CAMPAIGN_FORM_UNPUBLISHED:
      'Kampanyanın bağış formu henüz yayımlanmadığı için düzenli bağış başlatılamaz.',
    PLEDGE_PERIOD_NOT_OPEN:
      'Kampanyanın bu dönemi şu anda bağış kabul etmiyor, bu yüzden düzenli bağış başlatılamaz.',
    PLEDGE_CURRENCY_UNSUPPORTED: 'Bu kampanya seçilen para biriminde bağış kabul etmiyor.',
    PLEDGE_DONOR_EMAIL_REQUIRED:
      'Düzenli bağış için e-posta adresi gerekir: bağışı daha sonra durdurabilmeniz için hesabınıza bu adresle giriyorsunuz.',
    PLEDGE_DONOR_NAME_REQUIRED: 'İlk kez bağış yapanlar için ad soyad gerekir.',
    PLEDGE_NO_PROVIDER_ACCOUNT:
      'Bu para biriminde ödeme alabilecek aktif bir sağlayıcı hesabı yok, bu yüzden düzenli bağış başlatılamaz.',
    PLEDGE_BENEFICIARY_REF_REQUIRED:
      'Bu kampanyada düzenli bağış bir yararlanıcıya bağlanır; formdaki yararlanıcı numarası boş bırakılamaz.',
    PLEDGE_NOT_CHANGEABLE: 'İptal edilmiş bir düzenli bağış değiştirilemez.',
    PLEDGE_ALREADY_ENDED: 'Bu düzenli bağış artık bulunmuyor.',
    PLEDGE_NOT_PAUSED: 'Yalnızca duraklatılmış bir düzenli bağış yeniden başlatılabilir.',
    PLEDGE_NOT_ACTIVE: 'Yalnızca etkin bir düzenli bağış duraklatılabilir.',
    PLEDGE_CANCEL_REASON_REQUIRED: 'İptal için bir gerekçe yazılması gerekir.',
    PAYMENT_NO_PROVIDER_ACCOUNT:
      'Bu para biriminde ödeme alabilecek aktif bir sağlayıcı hesabı yok. Bağlantı oluşturulabilmesi için ilgili kuruluşa Stripe veya PayPal hesabı ve anahtarı tanımlanmalıdır.',
    PAYMENT_LINK_DONATION_NOT_PAYABLE:
      'Bu bağış ödeme alabilecek durumda değil; yalnızca ödenmemiş ve iptal edilmemiş bir bağış için bağlantı oluşturulabilir.',
    PAYMENT_LINK_ORGANIZATION_UNKNOWN:
      'Bağışın bağlı olduğu kuruluş belli değil, bu yüzden parayı hangi hesabın tahsil edeceği de belli değil.',
    PAYMENT_LINK_ACCOUNT_CURRENCY_MISMATCH:
      'Ödeme bağlantısı bağışın kendi para biriminde oluşturulur; seçilen hesap başka bir para biriminde.',
    PAYMENT_LINK_PERIOD_ENDED: 'Kampanya dönemi kapandığı için ödeme bağlantısı oluşturulamaz.',
    PAYMENT_LINK_NONE_LIVE: 'Yenilenecek geçerli bir ödeme bağlantısı yok.',
    PAYMENT_LINK_BASE_URL_UNCONFIGURED:
      'Ödeme bağlantısının dönüş adresi tanımlı değil; sunucu ayarlarında PAYMENT_LINK_BASE_URL tanımlanmalıdır.',
    PAYMENT_CHECKOUT_UNAVAILABLE:
      'Ödeme sağlayıcısına şu anda ulaşılamıyor. Birkaç dakika sonra tekrar deneyin.',
    PAYMENT_CHECKOUT_REFUSED:
      'Ödeme sağlayıcısı ödeme oturumu açmadı. Kuruluşun anahtarlarını kontrol edip tekrar deneyin.',
    PAYMENT_PROVIDER_ENVIRONMENT_MISMATCH:
      'Kuruluşun PayPal anahtarları sunucunun bağlandığı PayPal ortamına ait değil (canlı yerine test ya da tersi).',
    ACCOUNT_CURRENCY_MISMATCH: 'Kasa hareketi, hesabın para biriminde girilmelidir.',
    DONATION_REASON_REQUIRED: 'Gerekçe girilmelidir.',
    DONATION_QUEUE_LOCKED:
      'Bu dönemde gerçekleştirilmiş kayıt var; sıra artık yeniden düzenlenemez. Yeniden sıralamak, sahaya verilmiş listeyi değiştirir.',
    DONATION_NOT_READY_FOR_QUEUE:
      'Bu bağış gerçekleştirme sırasına alınamaz: kampanyanın sıraya alma koşulu olan onay kutusu (örneğin “Vekalet alındı”) bu bağışta işaretli değil.',
    DONATION_QUEUE_SORT_FIELD_UNKNOWN:
      '“{{fieldKey}}” bu kampanyanın gruplama cevaplarından biri değil. Sıra yalnızca sabit ölçütlere veya kampanyanın Form sekmesinde seçilen gruplama cevaplarına göre sıralanabilir.',
    DONATION_QUEUE_ORDER_INCOMPLETE:
      'Sıralama, dönemin tamamını içermelidir. Filtreleri temizleyip yeniden deneyin.',
    DONATION_GROUP_EMPTY: 'Bu grupta sırada bekleyen hisse yok.',
    DONATION_GROUP_ALREADY_FULFILLED: 'Bu hayvan zaten kesildi olarak kaydedilmiş.',
    DONATION_FULFILLMENT_PLACE_REQUIRED:
      'Gerçekleşme kaydı, işin nerede yapıldığını belirtmelidir.',
    DONATION_FULFILLED_AT_IN_FUTURE: 'Gerçekleşme tarihi gelecekte olamaz.',
    DONATION_CLIENT_REQUEST_REUSED:
      'Bu işlem anahtarı başka bir kayıt için kullanılmış. Uygulamayı yenileyip yeniden deneyin.',
    DONATION_EVIDENCE_UPLOAD_INVALID:
      'Yükleme geçersiz. Fotoğrafı veya videoyu yeniden çekip gönderin.',
    DONATION_EVIDENCE_UPLOAD_EXPIRED: 'Yüklemenin süresi doldu. Yeniden gönderin.',
    DONATION_EVIDENCE_UPLOAD_MISSING: 'Dosya sunucuya ulaşmadı. Yeniden gönderin.',
    DONATION_EVIDENCE_TOO_LARGE: 'Dosya izin verilen boyutun üzerinde.',
    DONATION_EVIDENCE_TYPE_UNSUPPORTED:
      'Kanıt olarak yalnızca JPEG, PNG fotoğraf veya MP4 video saklanır.',
    DONATION_EVIDENCE_DAMAGED: 'Dosya okunamadı. Yeniden çekip gönderin.',
    DONATION_EVIDENCE_UNAVAILABLE:
      'Dosya henüz gösterilemiyor; virüs taraması tamamlanmamış olabilir.',
    CAMPAIGN_UNITS_PER_GROUP_LOCKED:
      'Bu kampanyada sıraya alınmış hisse var; grup büyüklüğü artık değiştirilemez. Değiştirmek, sahaya verilmiş grupları yeniden böler.',
    CAMPAIGN_FORM_FILE_UPLOAD_INVALID: 'Yükleme geçersiz. Dosyayı yeniden seçip gönderin.',
    CAMPAIGN_FORM_FILE_UPLOAD_EXPIRED: 'Yüklemenin süresi doldu. Dosyayı yeniden gönderin.',
    CAMPAIGN_FORM_FILE_UPLOAD_MISSING: 'Dosya sunucuya ulaşmadı. Yeniden gönderin.',
    CAMPAIGN_FORM_FILE_TOO_LARGE: 'Dosya izin verilen boyutun üzerinde.',
    CAMPAIGN_FORM_FILE_TYPE_UNSUPPORTED:
      'Bu alana yalnızca JPEG, PNG veya PDF dosyası yüklenebilir.',
    CAMPAIGN_FORM_FILE_DAMAGED: 'Dosya okunamadı. Yeniden oluşturup gönderin.',
    CAMPAIGN_FORM_FILE_FIELD_UNKNOWN:
      'Bu alan kampanyanın formunda yok; form yenilenmiş olabilir. Sayfayı yenileyin.',
    CAMPAIGN_FORM_FILE_UNAVAILABLE: 'Dosyanın saklama süresi doldu ve içeriği silindi.',
    CAMPAIGN_FORM_FILE_NOT_ON_CAMPAIGN: 'Bu dosya başka bir kampanyaya ait.',
    CAMPAIGN_FORM_FILE_NOT_SCANNED: 'Dosya henüz gösterilemiyor; virüs taraması tamamlanmadı.',
    INTERNAL_SERVER_ERROR: 'Sunucu hatası. Lütfen tekrar deneyin.',
    NETWORK: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.',
  },
  dynamicForm: {
    submit: 'Doğrula',
    reset: 'Sıfırla',
    selectPlaceholder: 'Seçin',
    removedField: 'kaldırılmış alan',
    fieldLocked: 'Bu cevap bu kayıtta değiştirilemez.',
    fileUploadUnavailable: 'Bu önizlemede dosya yüklenemez.',
    fileChoose: 'Dosya seç',
    fileUploading: 'Yükleniyor…',
    fileRemove: 'Dosyayı kaldır',
    fileScanPending: 'Dosya virüs taramasından geçiyor; tarama bitmeden görüntülenemez.',
    fileTooLarge: 'Dosya en çok {{max}} olabilir.',
    fileTooMany_one: 'En çok {{count}} dosya eklenebilir.',
    fileTooMany_other: 'En çok {{count}} dosya eklenebilir.',
    fileUploadFailed: 'Dosya yüklenemedi. Lütfen tekrar deneyin.',
    yes: 'Evet',
    no: 'Hayır',
    emptyValue: '—',
    fileCount_one: '{{count}} dosya',
    fileCount_other: '{{count}} dosya',
    noFields: 'Bu formda henüz alan yok.',
  },
  pledge: {
    list: {
      title: 'Düzenli Bağışlar',
      empty: 'Düzenli bağış bulunamadı',
      emptyHint:
        'Düzenli bağışlar kuruluş düzeyinde okunur: yalnızca bir kuruluşun tümünü kapsayan bir yetki alanı bu kayıtları görür.',
    },
    filter: { beneficiary: 'Yararlanıcı numarasına göre ara' },
    column: {
      campaign: 'Kampanya',
      organization: 'Kuruluş',
      amount: 'Tutar',
      nextDueOn: 'Sonraki tahsilat',
      beneficiary: 'Yararlanıcı',
      method: 'Ödeme yöntemi',
      status: 'Durum',
      failures: 'Başarısız deneme',
    },
    frequency: { monthly: 'Her ay', quarterly: 'Her üç ayda', yearly: 'Her yıl' },
    status: {
      awaiting_mandate: 'İlk ödeme bekleniyor',
      active: 'Etkin',
      paused: 'Duraklatıldı',
      payment_failed: 'Ödeme alınamıyor',
      cancelled: 'İptal edildi',
    },
    method: {
      authorizing: 'Henüz kaydedilmedi',
      active: 'Kayıtlı',
      revoked: 'İptal edildi',
      failed: 'Kaydedilemedi',
    },
    donorPending: 'Bağışçı ilk tahsilatta eşleştirilecek',
    action: { pause: 'Duraklat', resume: 'Devam ettir', cancel: 'İptal et' },
    cancel: {
      title: 'Düzenli bağış iptal edilsin mi?',
      reason: 'İptal gerekçesi',
    },
  },
  portal: {
    donationPayment: {
      title: 'Bağış Ödemesi',
      remaining: 'Kalan tutar',
      paid: 'Borcunuz yoktur. Bağışınız için teşekkür ederiz.',
      unavailable: 'Bu bağış için şu anda ödeme alınamıyor.',
      takenBy:
        'Bu bağışın ödemesi {{organization}} tarafından alınıyor; bu sayfadan ödeme yapılamıyor.',
      select: 'Ödeme yöntemi seçin',
      pay: '{{provider}} ile öde',
      reference: 'Bağış kodu: {{reference}}',
      notFound: 'Bağış bulunamadı.',
    },
    pledge: {
      title: 'Düzenli bağışlarım',
      empty: 'Henüz düzenli bir bağışınız yok.',
      setupTitle: 'Düzenli bağış',
      setupHint:
        'İlk ödemeyi şimdi sağlayıcının kendi sayfasında yaparsınız; sonraki dönemler aynı yöntemle otomatik tahsil edilir. İstediğiniz zaman hesabınızdan durdurabilirsiniz.',
      submit: 'Düzenli bağışı başlat',
      formFirst: 'Önce yukarıdaki bağış formunu doldurup gönderin.',
      emailHint: 'Bağışınızı durdurmak için bu adresle hesabınıza giriş yaparsınız.',
      unconfigured:
        'Bu site şu anda ödeme alamıyor. Düzenli bağış kaydınız oluşturuldu ancak henüz hiçbir tahsilat yapılmadı.',
      frequencyLabel: 'Sıklık',
      dayLabel: 'Ayın günü',
      frequency: { monthly: 'Her ay', quarterly: 'Her üç ayda', yearly: 'Her yıl' },
      status: {
        awaiting_mandate: 'İlk ödeme bekleniyor',
        active: 'Etkin',
        paused: 'Duraklatıldı',
        payment_failed: 'Ödeme alınamıyor',
        cancelled: 'İptal edildi',
      },
      line: '{{amount}} · {{frequency}}',
      nextDue: 'Sonraki tahsilat: {{date}}',
      ended: 'Bu bağış sona erdi.',
      beneficiary: 'Yararlanıcı: {{reference}}',
      failed:
        'Son tahsilat alınamadı ve bu bağış durduruldu. Yeniden başlatmak için kampanya sayfasından yeni bir düzenli bağış başlatın.',
      retrying: 'Tahsilat {{date}} tarihinde yeniden denenecek.',
      pause: 'Duraklat',
      resume: 'Devam ettir',
      cancel: 'İptal et',
      cancelTitle: 'Düzenli bağış iptal edilsin mi?',
      cancelBody:
        '{{campaign}} için düzenli bağışınız durur ve kayıtlı ödeme yönteminiz sağlayıcıda iptal edilir. Bugüne kadar yapılan bağışlarınız değişmez.',
    },
    brand: 'BTSis Bağış',
    nav: {
      campaigns: 'Kampanyalar',
      account: 'Bağışçı hesabım',
      basket: 'Bağış sepeti',
    },
    footer: {
      note: 'Bağışlarınız gönüllü ekiplerimizce sahada gerçekleştirilir.',
    },
    index: {
      title: 'Bağış kampanyaları',
      subtitle: 'Açık olan kampanyalardan birini seçin ve bağışınızı oluşturun.',
      allCategories: 'Tümü',
      resultCount_one: '{{count}} kampanya',
      resultCount_other: '{{count}} kampanya',
      empty: 'Şu anda açık kampanya yok',
      emptyHint: 'Yeni bir dönem açıldığında kampanyalar burada listelenir.',
      error: 'Kampanyalar yüklenemedi',
      donate: 'Bağış yap',
    },
    card: {
      unitPrice: '{{amount}} / {{unit}}',
      fromAmount: '{{amount}} ve üzeri',
      freeAmount: 'Dilediğiniz tutarda',
      noCharge: 'Ücretsiz hizmet',
      unitsPerGroup: '{{count}} hisselik',
    },
    detail: {
      notFound: 'Kampanya bulunamadı',
      notFoundHint: 'Bu bağlantı geçersiz olabilir veya kampanya yayından kaldırılmış olabilir.',
      backToIndex: 'Kampanyalara dön',
      error: 'Kampanya yüklenemedi',
      season: '{{year}} dönemi',
      formTitle: 'Bağış bilgileri',
      formEmpty: 'Bu kampanya için ek bilgi istenmiyor.',
      amountTitle: 'Bağış tutarı',
      total: 'Toplam',
      submit: 'Sepete ekle',
      currency: 'Para birimi',
      pricing: 'Fiyatlandırma',
      window: '{{start}} – {{end}}',
      progressTitle: 'Kampanya ilerlemesi',
      noChargeTitle: 'Bu hizmet için ücret alınmaz',
      noChargeHint: 'Talebiniz ödeme adımı olmadan kuruluşumuz tarafından alınır.',
      requestContinue: 'Devam et',
      requestSubmit: 'Talebi gönder',
    },
    amount: {
      quantity: 'Adet',
      quantityUnit: '{{unit}} adedi',
      decrease: 'Adedi azalt',
      increase: 'Adedi artır',
      unitPrice: 'Birim fiyat',
      custom: 'Başka tutar',
      customPlaceholder: 'Tutar girin',
      bounds: 'En az {{min}}, en çok {{max}}',
      minOnly: 'En az {{min}}',
      maxOnly: 'En çok {{max}}',
      pricing: 'Tutar hesaplanıyor…',
      unavailable: 'Bu kampanya için bu para biriminde fiyat tanımlı değil.',
      closed: 'Bu dönem şu anda bağış almıyor.',
    },
    basket: {
      title: 'Bağış sepetiniz',
      add: 'Sepete ekle',
      goTo_one: 'Sepete git ({{count}} kampanya)',
      goTo_other: 'Sepete git ({{count}} kampanya)',
      empty: 'Sepetiniz boş',
      emptyHint: 'Bir kampanya seçip bağışınızı sepete ekleyin.',
      remove: 'Sepetten çıkar',
      clear: 'Sepeti boşalt',
      addMore: 'Başka kampanya ekle',
      checkout: 'Bağışı tamamla',
      quantityLine_one: '{{count}} {{unit}}',
      quantityLine_other: '{{count}} {{unit}}',
      amountLine: 'Serbest tutar',
      refused: {
        full: 'Sepette en fazla 20 kampanya olabilir.',
        other_currency:
          'Sepetinizdeki bağışlar tek para biriminde olmalı. Önce sepeti tamamlayın veya boşaltın.',
      },
    },
    checkout: {
      title: 'Bağışı tamamla',
      donorTitle: 'Bağışçı bilgileri',
      donorHint: 'Bağışınızın kime ait olduğunu nasıl kaydedelim?',
      kind: {
        new: {
          label: 'İlk kez bağış yapıyorum',
          description: 'Adınızı ve e-posta adresinizi alalım; makbuzunuz oraya gönderilecek.',
        },
        returning: {
          label: 'Daha önce bağış yaptım',
          description:
            'E-posta adresinizi yazmanız yeterli. Kayıtlarınız bağışçı hesabınızdan görüntülenir.',
        },
        anonymous: {
          label: 'İsimsiz bağış',
          description: 'Hiçbir kişisel bilgi kaydedilmez. Makbuz gönderilemez.',
        },
      },
      name: 'Ad Soyad',
      email: 'E-posta',
      emailHint: 'Bağış kaydınız ve makbuzunuz bu adrese bağlanır.',
      phone: 'Telefon (isteğe bağlı)',
      consent: 'Kampanyalardan e-posta ile haberdar olmak istiyorum',
      summary: 'Bağış özeti',
      submit: 'Bağışı tamamla',
      back: 'Sepete dön',
    },
    order: {
      title: 'Bağışınız alındı',
      subtitle: 'Bağışınız kaydedildi. Ödeme adımı için aşağıdaki nota bakın.',
      pay: 'Ödemeye geç',
      loading: 'Bağışınız getiriliyor…',
      notFound: 'Bağış kaydı bulunamadı',
      notFoundHint:
        'Bu bağlantı geçersiz olabilir veya bağış başka bir derneğin sitesinde yapılmış olabilir.',
      awaitingTitle: 'Ödeme bekleniyor',
      awaiting:
        'Bağışınız kaydedildi. Aşağıdaki düğmeyle ödeme sayfasına geçerek bağışınızı tamamlayabilirsiniz.',
      cancelledTitle: 'Ödeme tamamlanmadı',
      cancelled:
        'Ödeme sayfasından ayrıldınız ve hesabınızdan hiçbir tutar çekilmedi. Dilerseniz aynı bağış için ödemeye yeniden geçebilirsiniz.',
      expiredTitle: 'Ödeme bağlantısının süresi doldu',
      expired:
        'Bu bağış için verilen ödeme bağlantısı artık geçerli değil ve hesabınızdan hiçbir tutar çekilmedi. Bağışınızı yeniden oluşturabilirsiniz.',
      paidTitle: 'Bağışınız için teşekkür ederiz',
      paidSubtitle: 'Ödemeniz alındı ve bağışınız kaydedildi.',
      paidAlertTitle: 'Ödeme alındı',
      references: 'Bağış numaranız: {{codes}}',
      paidNoReference: 'Bağış kaydınız oluşturuluyor; makbuzunuz e-posta adresinize gönderilecek.',
      requestedTitle: 'Talebiniz alındı',
      requestedSubtitle: 'Bu hizmet için ücret alınmaz; ödeme beklemenize gerek yok.',
      requestedAlertTitle: 'Talep kaydedildi',
      requestedNoReference: 'Talebiniz kaydediliyor.',
      paymentPendingTitle: 'Ödeme adımı henüz açık değil',
      paymentPending:
        'Bağışınız kaydedildi, ancak çevrimiçi ödeme henüz devreye alınmadı. Ödeme açıldığında bağışınız aynı kayıt üzerinden tamamlanacaktır.',
    },
    account: {
      channels: {
        title: 'Bildirim tercihlerim',
        subtitle:
          'Hangi kanaldan haber almak istediğinizi buradan seçin. Kapatmak açmak kadar kolaydır: kapattığınız anda o kanaldan size başka bir şey gönderilmez.',
        email: 'E-posta',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        noAddress: 'Bu kanal için kayıtlı bir adresiniz yok.',
        never: 'Henüz seçim yapmadınız.',
        since: '{{date}} tarihinde açtınız.',
        stopped: '{{date}} tarihinde kapattınız.',
      },
      title: 'Bağışçı hesabım',
      subtitle: '{{organization}} kayıtlarınız',
      signOut: 'Çıkış yap',
      error: 'Hesabınız yüklenemedi',
      signIn: {
        title: 'Bağışçı hesabınıza giriş',
        subtitle:
          'E-posta adresinizi yazın; bağışlarınızı görebilmeniz için size bir giriş bağlantısı gönderelim.',
        email: 'E-posta adresiniz',
        submit: 'Giriş bağlantısı gönder',
        noPassword:
          'Bağışçı hesabının parolası yoktur. Her girişte e-posta adresinize tek kullanımlık bir bağlantı gönderilir.',
        sentTitle: 'Bağlantı gönderildi',
        sent: 'Bu adrese bağlı bir bağış kaydı varsa giriş bağlantısı gönderildi. Gelen kutunuzu ve gereksiz posta klasörünüzü kontrol edin.',
        confirmTitle: 'Girişi tamamlayın',
        confirmHint:
          'Bağışçı hesabınıza girmek için aşağıdaki düğmeye basın. Bağlantı yalnızca bir kez kullanılabilir.',
        confirm: 'Hesabıma gir',
        refused: 'Giriş yapılamadı',
        askAgain: 'Yeni bağlantı iste',
      },
      history: {
        title: 'Bağışlarım',
        loading: 'Bağışlarınız getiriliyor…',
        empty: 'Bu sitede kayıtlı bir bağışınız görünmüyor.',
        line: '{{reference}} · {{date}} · {{year}} dönemi',
      },
      state: {
        requested: 'Talep alındı',
        awaiting_payment: 'Ödeme bekleniyor',
        received: 'Alındı',
        fulfilled: 'Gerçekleştirildi',
        refunded: 'İade edildi',
        cancelled: 'İptal edildi',
      },
      receipt: {
        download: 'Makbuzu indir',
        pending: 'Makbuz hazırlanıyor',
      },
      evidence: {
        show: 'Kanıtları gör',
        title: 'Bağışımın kanıtları',
        back: 'Hesabıma dön',
        loading: 'Kanıtlar getiriliyor…',
        empty:
          'Bu bağış için henüz bir fotoğraf ya da video eklenmedi. Eklendiğinde burada göreceksiniz.',
        notFound: 'Bu bağış bulunamadı',
      },
      receipts: {
        title: 'Makbuzlarım ve yıllık belgelerim',
        subtitle:
          'Bu belgeler bağışınızın alındığını bildirir; vergi mevzuatı gereği düzenlenen yasal belge değildir.',
        empty: 'Henüz düzenlenmiş bir makbuzunuz yok.',
        issued: '{{date}} tarihinde düzenlendi',
        certificate: '{{year}} yılı bağış özeti',
      },
      profile: {
        title: 'Bilgilerim',
        email: 'E-posta adresi',
        emailHint:
          'Giriş bağlantısı bu adrese gönderildiği için adres buradan değiştirilemez. Değişmesi gerekiyorsa bizimle iletişime geçin.',
        name: 'Ad Soyad',
        phone: 'Telefon',
        address: 'Adres',
        consentIsPerChannel:
          'İletişim izninizi yukarıdaki “Bildirim Kanalları” kartından kanal kanal verebilir ve geri alabilirsiniz.',
        save: 'Kaydet',
        saved: 'Bilgileriniz güncellendi.',
      },
      privacy: {
        title: 'Kişisel verileriniz',
        subtitle:
          'KVKK kapsamında hakkınızda tutulan verilerin bir kopyasını isteyebilir ya da silinmesini talep edebilirsiniz. Talebiniz kaydedilir ve bir yetkili tarafından yanıtlanır.',
        requestExport: 'Verilerimin kopyasını iste',
        requestErasure: 'Verilerimin silinmesini iste',
        open: '{{kind}} talebiniz {{date}} tarihinde alındı ve değerlendiriliyor.',
        kind: {
          export: 'Veri kopyası',
          erasure: 'Veri silme',
        },
        erasureTitle: 'Verilerinizin silinmesini istiyor musunuz?',
        erasureBody:
          'Talebiniz kaydedilir ve bir yetkili tarafından değerlendirilir. Mevzuat gereği saklanması zorunlu olan bağış kayıtları, makbuzlar ve muhasebe verileri silinemez; bunun dışındaki bilgileriniz için talebiniz işleme alınır.',
        erasureConfirm: 'Talebi gönder',
        cancel: 'Vazgeç',
      },
    },
    evidence: {
      title: 'Gerçekleştirme kanıtı',
      loading: 'Kanıtlar getiriliyor…',
      reference: 'Referans numarası: {{reference}}',
      onBehalfOf: '{{name}} adına',
      fulfilledOn: '{{date}} tarihinde gerçekleştirildi',
      empty: 'Bu bağış için henüz gösterilecek bir fotoğraf ya da video yok.',
      photo: 'Kanıt fotoğrafı {{number}}',
      video: 'Kanıt videosu {{number}}',
      fileUnavailable:
        'Bazı dosyalar yüklenemedi. Dosya bağlantıları güvenlik için bir dakika geçerlidir; sayfayı yenileyerek yeniden deneyebilirsiniz.',
      reload: 'Yenile',
      unavailableTitle: 'Bu bağlantı açılmıyor',
      optOutTitle: 'Artık kanıt almak istemiyor musunuz?',
      optOutHint:
        'Bu bağış için size bundan sonra kanıt gönderilmez ve bu bağlantı hemen kapanır. Bu işlem geri alınamaz.',
      optOut: 'Kanıt almak istemiyorum',
      optOutConfirmTitle: 'Kanıt gönderimini durdurmak istiyor musunuz?',
      optOutConfirmBody:
        'Onayladığınızda bu bağlantı kapanır ve bu bağışla ilgili size başka kanıt gönderilmez.',
      optOutConfirm: 'Durdur',
      cancel: 'Vazgeç',
      optedOutTitle: 'Tercihiniz kaydedildi',
      optedOut: 'Bu bağış için size bundan sonra kanıt gönderilmeyecek. Bağlantı kapatıldı.',
    },
    state: {
      open: 'Bağışa açık',
      upcoming: 'Yakında',
      ended: 'Sona erdi',
      paused: 'Duraklatıldı',
      upcomingHint: 'Bu dönem {{date}} tarihinde açılacak.',
      endedHint: 'Bu dönem {{date}} tarihinde sona erdi.',
      pausedHint: 'Bu dönem geçici olarak bağış almıyor.',
    },
  },
  field: {
    brand: 'BTSis Saha',
    placeholder: 'Bu uygulama henüz geliştirilmedi — Faz 6 — Saha Uygulaması.',
    signIn: {
      title: 'Saha girişi',
      subtitle: 'Kurumunuza atanmış işleri görmek için giriş yapın.',
      email: 'E-posta',
      password: 'Parola',
      submit: 'Giriş yap',
      twoFactorTitle: 'Doğrulama kodu',
      twoFactorHint: 'Uygulamanızdaki altı haneli kodu girin.',
      code: 'Kod',
      verify: 'Doğrula',
      twoFactorEnrolment:
        'Rolünüz iki adımlı doğrulama istiyor. Kurulum yönetim panelinden yapılır.',
      noFulfilmentPermission:
        'Bu hesapta saha yetkisi yok. Saha uygulaması yalnızca gerçekleştirme yetkisi olan hesaplar içindir.',
    },
    nav: {
      inbox: 'İşler',
      scan: 'Karekod',
      sync: 'Gönderim',
      signOut: 'Çıkış',
    },
    inbox: {
      title: 'Bekleyen işler',
      subtitle: '{{institution}} için gerçekleştirilecek kayıtlar',
      allCampaigns: 'Tüm kampanyalar',
      empty: 'Bekleyen iş yok.',
      emptyFiltered: 'Bu kampanyada bekleyen iş yok.',
      loadMore: 'Daha fazla',
      selected: '{{count}} kayıt seçildi',
      selectAll: 'Sayfayı seç',
      clearSelection: 'Seçimi bırak',
      completeSelected: 'Seçilenleri tamamla',
      search: 'Referans veya bağışçı ara',
    },
    record: {
      title: 'Kayıt',
      notFound: 'Bu kayıt bulunamadı ya da yetkiniz dışında.',
      donor: 'Bağışçı',
      anonymous: 'Anonim',
      campaign: 'Kampanya',
      amount: 'Tutar',
      quantity: 'Adet',
      place: 'Yapılacağı yer',
      placeDone: 'Yapıldığı yer',
      queuePosition: 'Sıra',
      unassigned: 'Belirtilmemiş',
      queue: 'Sıraya al',
      complete: 'Tamamla',
      completed: 'Tamamlandı',
      openRecord: 'Kaydı aç',
    },
    fulfil: {
      title: 'Gerçekleştirme',
      one: 'Bu kaydı tamamla',
      many: '{{count}} kaydı birlikte tamamla',
      place: 'Yapıldığı yer',
      placeHint: 'Boş bırakılırsa kaydın planlanan yeri kullanılır.',
      cost: 'Gerçek maliyet',
      currency: 'Para birimi',
      costHint: 'Harcanan tutar. Bilinmiyorsa boş bırakın.',
      confirm: 'Tamamlandı olarak işaretle',
      queued: 'Gönderim kuyruğuna alındı.',
      done: 'Kayıt tamamlandı.',
      doneMany: '{{count}} kayıt tamamlandı.',
      partial: '{{done}} kayıt tamamlandı, {{failed}} kayıt reddedildi.',
    },
    evidence: {
      title: 'Kanıt',
      capture: 'Fotoğraf veya video çek',
      choose: 'Dosyadan seç',
      uploading: 'Yükleniyor…',
      pending: 'Virüs taraması bekleniyor',
      view: 'Aç',
      remove: 'Kaldır',
      empty: 'Henüz kanıt yok.',
      added: 'Kanıt eklendi.',
      removed: 'Kanıt kaldırıldı.',
      neverCompletes:
        'Kanıt eklemek kaydı tamamlamaz. Tamamlandı bilgisini her zaman bir kişi girer.',
      offline: 'Kanıt yüklemek için bağlantı gerekir. Bağlanınca yeniden deneyin.',
    },
    scan: {
      title: 'Karekod okut',
      hint: 'Kamerayı kaydın karekoduna tutun.',
      start: 'Kamerayı aç',
      stop: 'Kamerayı kapat',
      denied: 'Kamera izni verilmedi. Referans kodunu elle yazabilirsiniz.',
      unsupported: 'Bu cihazda kamera kullanılamıyor. Referans kodunu elle yazın.',
      manual: 'Referans kodu',
      search: 'Kaydı bul',
      notFound: 'Bu koda ait kayıt bulunamadı ya da yetkiniz dışında.',
      unreadable: 'Karekod okundu ama geçerli bir referans kodu taşımıyor.',
      offline: 'Kayıt aramak için bağlantı gerekir.',
    },
    sync: {
      title: 'Gönderim kuyruğu',
      empty: 'Gönderilmemiş işlem yok.',
      pending: '{{count}} işlem gönderilmeyi bekliyor',
      online: 'Çevrimiçi',
      offline: 'Çevrimdışı — işlemler cihazda bekliyor',
      sendNow: 'Şimdi gönder',
      sending: 'Gönderiliyor…',
      failed: 'Reddedildi',
      discard: 'Kuyruktan çıkar',
      retry: 'Yeniden dene',
      queuedAt: 'Kuyruğa alındı',
      actionFulfill: 'Tamamlama',
      actionQueue: 'Sıraya alma',
      sent: '{{count}} işlem gönderildi.',
      staleReads: 'Liste en son {{at}} tarihinde güncellendi.',
    },
  },
  gallery: {
    stepWizard: {
      title: 'Adımlı form ve segment seçici (StepWizard, Field.SegmentedControl)',
      description:
        'Kitin ödeme adımları: adım göstergesi, solda adımın kartları ve Geri, sağda özet ve tek birincil eylem. İleri geçersiz bir adımda durur ve hatayı o adımın alanlarında gösterir; adımlar geri dönüldüğünde cevaplarını korur.',
      steps: {
        campaign: 'Kampanya',
        parties: 'Taraflar',
        notify: 'Bildirim',
      },
      disabledCurrency: 'Devre dışı segment seçici',
      disabledHint: 'Form devre dışıyken segmentler de devre dışıdır.',
      notify: 'Kanıt görselini bağışçıya gönder',
      summary: 'Özet',
      complete: 'Tamamla',
      completed: 'Üç adım da geçerli',
    },
    phoneInput: {
      title: 'Telefon girişi (Field.Phone)',
      description:
        'Ülke seçici ve numara. Varsayılan ülke Türkiye; liste ad, kod ya da +90 gibi arama koduyla aranır. Değer E.164 olarak tutulur ve kayıtlı numara kendi ülkesiyle açılır.',
      empty: 'Yeni numara (Türkiye)',
      german: 'Kayıtlı Alman numarası',
      disabled: 'Devre dışı',
      value: 'Tutulan değer: {{value}}',
    },
    numberInput: {
      title: 'Adet girişi (NumberInput)',
      description:
        'Portalda birim fiyatlı kampanyaların adet kontrolü. Değer her yolda alt ve üst sınıra kırpılır; alan boşaltıldığında alt sınıra döner.',
      quantity: 'Adet',
      bounded: 'Sınırlı (1–10)',
      disabled: 'Devre dışı',
    },
    campaignProgress: {
      title: 'Kampanya ilerlemesi (CampaignProgress)',
      description:
        'Tahsil edilen hedefe karşı düz çubukta, girilen arkasında açık renkte. Üç ölçü her zaman adıyla gösterilir; hedef para birimi dışındaki tutarlar kur olmadan çevrilmez.',
      compact:
        'Kart görünümü (compact): portalda kullanılan, harcanan ve para birimi tablosu olmadan',
      samples: {
        over: 'Hedef aşıldı',
        underway: 'Devam ediyor',
        multiCurrency: 'Birden fazla para birimi',
        noGoal: 'Hedefsiz dönem',
        empty: 'Henüz toplam yok',
      },
    },
    details: {
      title: 'Detay ekranı (DetailsToolbar, DetailsList, DetailsSummary, ChoiceCards)',
      description:
        'Kitin sipariş detayı düzeni: geri bağlantısı, durum etiketleri ve eylemleriyle başlık; etiket–değer satırları; zaman çizelgesinin yanındaki kesik çizgili özet; ve her seçeneğin sonucunu bir cümleyle anlatan kart seçim grubu.',
      back: 'Galeriye dön',
      caption: 'Gönüllü Kurban · 13 Eyl 2026',
    },
    historyTimeline: {
      title: 'Geçmiş zaman çizelgesi (HistoryTimeline)',
      description:
        'Kitin sipariş geçmişi bileşeni. En yeni kayıt birincil renkte; her kaydın başlığı, açıklaması, içeriği ve yanında bir eylemi olabilir.',
    },
    dynamicForm: {
      title: 'Dinamik form (DynamicForm)',
      description:
        'Kampanya formu şemadan çizilir. Görünürlük koşulu ve doğrulama sunucuyla aynı fonksiyonlardan gelir. Okuma kipi tanınmayan alan türlerini ve şemadan kaldırılmış değerleri hata vermeden gösterir.',
      samples: {
        simple: 'Basit',
        conditional: 'Koşullu görünürlük',
        qurbani: 'Vacip Kurban (seed)',
        lenient: 'Esnek okuma',
      },
      modes: {
        label: 'Kip',
        edit: 'Düzenleme',
        readonly: 'Okuma',
      },
      audiences: {
        label: 'Hedef kitle',
        admin: 'Yönetim paneli',
        portal: 'Portal',
      },
      valid: 'Form geçerli',
    },
  },
  validation: {
    required: 'Bu alan zorunludur',
    email: 'Geçerli bir e-posta adresi girin',
    min: 'En az {{count}} karakter olmalıdır',
    nameTooShort: 'En az 2 karakter olmalıdır',
    tooShort: 'Çok kısa',
    institutionRequired: 'Kurum seçin',
    roleCode: 'Yalnızca küçük harf, rakam ve alt çizgi kullanın',
    slug: 'Yalnızca küçük harf, rakam ve tire kullanın',
    upperCode: 'Yalnızca büyük harf, rakam ve tire kullanın',
    countryRequired: 'Ülke seçin',
  },
} as const;

export type TranslationTree = typeof tr;
